/**
 * Created by jordan on 1/08/2016.
 */
var AngularFunc = (function() {
    return {
        OFFSET: {
            TOP:0,
            CENTER:0.5,
            BOTTOM:1
        },
        
        /**
         * Gets an element's offset from the absolute top of the page
         * @param element
         * @returns {number}
         */
        pageTopOffset : function(element) {
            var de = document.documentElement;
            var box = element.getBoundingClientRect();
            var top = box.top + window.pageYOffset - de.clientTop;
            return top;
        },

        /**
         * Gets an element's offset from the current top of the window
         * -ve -> element below
         * +ve -> element above
         * @param element
         * @param {int} offsetType - from AngularFunc.OFFSET
         */
        windowOffset: function(element, offsetType) {
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
            var screenOffset = $(window).height() * offsetType;

            var elementOffset = AngularFunc.pageTopOffset(element);

            var height = element.clientHeight ? element.clientHeight : $(element).children().first().height();
            var heightOffset = height / 2;
            
            //console.log(element);
            //window.element = element;
            //console.log("scrollTop:" + scrollTop + " elementOffset:" + elementOffset);
            return scrollTop + screenOffset - elementOffset - heightOffset;
        },

        /**
         * Scroll to middle of element
         * @param element
         * @param onComplete
         */
        scrollToMiddle: function(element, onComplete) {
            $('html, body').animate({
                scrollTop: element.offset().top - $(window).height()*0.3,
            }, 600 , onComplete);
        },

        /**
         * Get all watchers on screen
         * @param root
         * @returns {*}
         */
        getWatchers:function(root) {
            root = angular.element(root || document.documentElement);
            var watcherCount = 0;

            function getElemWatchers(element) {
                var isolateWatchers = getWatchersFromScope(element.data().$isolateScope);
                var scopeWatchers = getWatchersFromScope(element.data().$scope);
                var watchers = scopeWatchers.concat(isolateWatchers);
                angular.forEach(element.children(), function (childElement) {
                    watchers = watchers.concat(getElemWatchers(angular.element(childElement)));
                });
                return watchers;
            }

            function getWatchersFromScope(scope) {
                if (scope) {
                    return scope.$$watchers || [];
                } else {
                    return [];
                }
            }

            return getElemWatchers(root);
        }
    };

    
})();
var Config = {
	SMALL_MOBILE_WIDTH:480,
	MOBILE_WIDTH:800,
	DESKTOP_WIDTH:992
};

function fancyboxDefaults() {
	return {
		overlay: {
			css: {'background': 'rgba(0,0,0, 0.9)'}
		},
		type: 'iframe',
		iframe: {preload: false},
		padding: [0, 0, 0, 0],
	}
}

function fancyboxSharePhotoConfig() {
	var config = {
		closeBtn:false,
		padding: 0,
		margin: 2,
		helpers: {
			title: {
				type: 'inside'
			}
		}
	};
	if(isMobileOrTablet()) {
		config.openEffect = 'fade';
		config.closeEffect = 'fade';
		config.prevEffect = 'none';
		config.nextEffect = 'none';
	}
	return config;
};

var fancyboxDesktop = fancyboxDefaults();
fancyboxDesktop.width = '80%';
fancyboxDesktop.height = '80%';

var fancyboxMobile = fancyboxDefaults();
fancyboxMobile.width = '100%';
fancyboxMobile.padding = 0;
fancyboxMobile.margin = 0;
fancyboxMobile.height = '70%';


Config.fancybox = {
	desktop: fancyboxDesktop,
	mobile: fancyboxMobile
};

Config.addPhotoEmail = 'photos@northsouth.co';

Config.getFancyboxSettings = function() {
	if($(window).width() < Config.MOBILE_WIDTH) {
		return Config.fancybox.mobile;
	} else {
		return Config.fancybox.desktop;
	}
};
/* global google */
/** Elevation profile to be used in graphs
*
**/
var ElevationProfile  = function(elevationDiv) {
	this.elevationDiv = elevationDiv;
	
	var div = $("#" + elevationDiv);
	div.width(ElevationProfile.WIDTH);

};
ElevationProfile.AXIS_WIDTH = 50;
ElevationProfile.X_AXIS_HEIGHT = 25;
ElevationProfile.GRAPH_WIDTH = 1000;
ElevationProfile.HEIGHT = 220;
ElevationProfile.WIDTH = "98.5%";
ElevationProfile.LINE_WIDTH = 4;
ElevationProfile.OPACITY = 0.5;
ElevationProfile.PADDING = 15;
ElevationProfile.TEXT_COLOUR = '#333';

//Create a new elevation profile graph
/** xAxisMax - maximum x distance set to the last row
**/
ElevationProfile.prototype.create = function(rows, cols, onGraphHover, showXAxis, xMax, map) {
	function mouseMoveHandler(e) {
		var layout = self.chart.getChartLayoutInterface();
		var hPos = layout.getHAxisValue(e.x);
		var xVal;

		//If showing x-axis, need to adjust which point is selected by the mouseMoveHandler
		if(showXAxis) {
			xVal = KmlVisualizationMapper.MAX_POINTS * hPos / xMax;
		} else {
			xVal = hPos;
		}
		
		if(xVal < 0) {
			xVal = 0;
		}

		xVal = Math.floor(xVal);

		self.chart.setSelection([{row:xVal, column:1}]);
		onGraphHover(xVal, map);
	}




	var self = this;

	self.onGraphHover = onGraphHover;
	self.chart = new google.visualization.AreaChart(document.getElementById(this.elevationDiv));

	self.data = new google.visualization.DataTable(
		{cols: cols, 
		 rows: rows});

	var options = {
    backgroundColor:'transparent',
		legend: 'none',
		width: ElevationProfile.WIDTH,
		height: ElevationProfile.HEIGHT,
		vAxis: {
			title: 'Elevation (m)',
      titleTextStyle: {color:ElevationProfile.TEXT_COLOUR},
      textStyle: {color:ElevationProfile.TEXT_COLOUR}
		},
		lineWidth: ElevationProfile.LINE_WIDTH,
		dataOpacity: ElevationProfile.OPACITY,
		colors: ['#6184AB'],
		hAxis: {
			title: 'Distance (km)',
      titleTextStyle: {color:ElevationProfile.TEXT_COLOUR},
      textStyle: {color:ElevationProfile.TEXT_COLOUR}
		},
		chartArea: {
		    left: ElevationProfile.AXIS_WIDTH,
		    top: ElevationProfile.PADDING,
		    width: ElevationProfile.GRAPH_WIDTH,
		    height: ElevationProfile.HEIGHT - 2*ElevationProfile.PADDING - ElevationProfile.X_AXIS_HEIGHT*showXAxis
		},
		tooltip: { trigger: 'selection' }
	};


	self.chart.draw(self.data, options);

	google.visualization.events.removeAllListeners(self.chart);
	google.visualization.events.addListener(self.chart, 'onmousemove', mouseMoveHandler);

};
/*global geoXML3, google, ElevationProfile */

var GPS = function() {};


GPS.kmlParser = null;
GPS.kmlDocument = null;
GPS.markers = [];

GPS.kmlMap = function(mapDiv, src, onComplete) {

	function initMapAndKml() {
		var isDraggable = true;
		if($(window).width() < Config.MOBILE_WIDTH) {
			isDraggable = false;
		}
		var map = new google.maps.Map(document.getElementById(mapDiv), {
			center: new google.maps.LatLng(-19.257753, 146.823688),
			zoom: 2,
			scrollwheel: false,
			draggable: isDraggable
		});

		loadKmlLayer(src, map, onComplete);
	}

	function loadKmlLayer(src, map, afterParse) {
		var parser = new geoXML3.parser({
			map: map,
			suppressInfoWindows: true,
			afterParse: function(data) {
				afterParse(data, map);
			},
		});
		parser.parse(src);
	}

	var self = this;
	initMapAndKml();

};

GPS.addMarker = function(latLng, title, markerImage, map) {
	var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: markerImage,
      title: title	});
	GPS.markers.push(marker);
	
	return marker;
};

//Returns the 'coordinates' node of a kml file
GPS.getCoords = function(kml) {
	var coords = $(kml).find('coordinates');
	return coords[0].firstChild;
};

/**
 * Created by jordan on 22/09/2015.
 * Bug: This plugin causes a second 'not found' request to appear - tries to GET /event/null for some reason
 */

//Controls event gallery on details page
var GalleryController = function() {
	var options = {
		$DragOrientation: 3,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)
		$ArrowNavigatorOptions: {                       //[Optional] Options to specify and enable arrow navigator or not
			$Class: $JssorArrowNavigator$,              //[Requried] Class to create arrow navigator instance
			$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
			$AutoCenter: 0,                                 //[Optional] Auto center arrows in parent container, 0 No, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
			$Steps: 1                                       //[Optional] Steps to go for each navigation request, default value is 1
		},
		$BulletNavigatorOptions: {
			$Class: $JssorBulletNavigator$,
			$SpacingX: 1,
			$SpacingY: 1
		}

	};

	var jssor_slider1 = new $JssorSlider$("gallery", options);

	jssor_slider1.$On($JssorSlider$.$EVT_LOAD_END,function(slideIndex, progress){
		loadDataImage($('.gallery-image')[slideIndex]);
	});
	
	$(".jssora03l, .jssora03r, .jssorb03").click(function() {
		jssor_slider1.$Pause();
	});
	$(".left.arrow").click(function() {
		jssor_slider1.$Prev();
	});
	$(".right.arrow").click(function() {
		jssor_slider1.$Next();
	});

	//responsive code begin
	//you can remove responsive code if you don't want the slider scales while window resizes
	function ScaleSlider() {
		//reserve blank width for margin+padding: margin+padding-left (10) + margin+padding-right (10)
		var paddingWidth = 0;
		//minimum width should reserve for text
		var minReserveWidth = 0;
		var parentElement = jssor_slider1.$Elmt.parentNode;
		//evaluate parent container width
		var parentWidth = parentElement.clientWidth;
		if (parentWidth) {
			//exclude blank width
			var availableWidth = parentWidth;
			var sliderWidth = parentWidth;
			//slider width is maximum 1200
			sliderWidth = Math.min(sliderWidth, 1200);
			//slider width is minimum 800
			sliderWidth = Math.max(sliderWidth, 700);
			var clearFix = "none";
			//evaluate free width for text, if the width is less than minReserveWidth then fill parent container
			if (availableWidth - sliderWidth < minReserveWidth) {
				//set slider width to available width
				sliderWidth = availableWidth;
				//slider width is minimum 800
				sliderWidth = Math.max(sliderWidth, 700);
				clearFix = "both";
			}
			jssor_slider1.$ScaleWidth(sliderWidth);

			var $arrows = $(".gallery-holder .arrows");
			if($arrows.hasClass('hide')) {
				$arrows.fadeIn(400);
				//$(".gallery-holder #loading").fadeOut(400);
			}

		}


		else
			window.setTimeout(ScaleSlider, 30);
	}

	ScaleSlider();
	$(window).bind("load", ScaleSlider);
	$(window).bind("resize", ScaleSlider);
	$(window).bind("orientationchange", ScaleSlider);

	return jssor_slider1;
};


var KmlVisualizationMapper = function() {

};
KmlVisualizationMapper.MAX_POINTS = 320;	//Max amount of points to use in heightmap 

/** Create rows for visualization graph **/
KmlVisualizationMapper.prototype.createRows = function(data, xDistance) {

	var rows = [];
	var points = data[0].placemarks[0].LineString[0].coordinates;

	//Display only every nth point to ensure MAX_POINTS is not exceeded
	var nthPoint = Math.ceil(points.length/KmlVisualizationMapper.MAX_POINTS);
	if(nthPoint < 1) {
		nthPoint == 1;
	}

	//Incremental x distance for each point 
	if(xDistance == 0) {
		//X distance not set
		deltaX = 1;
	} else {
		var deltaX = xDistance/KmlVisualizationMapper.MAX_POINTS;
	}

	//Add each point to array for the map
	var index=0;
	for(var i=0; i<points.length; i+=nthPoint) {

		//Ignore heights of '0m' - this is a GPS error
		if(points[i].alt !== 0) {
			var tooltip = points[i].alt + "m";
			var row = 	{c:[
							{v:index * deltaX}, 
							{v:points[i].alt}, 
							{v:tooltip},
							{v:points[i].lat},
							{v:points[i].lng}
						]};
			rows.push(row);
			index++;
		}
	}
	return rows;

};

/** Create column names for visualization graph **/
KmlVisualizationMapper.prototype.createCols = function(data) {
	var cols = [{id: 'x', label: 'X', type: 'number'},
                {id: 'position', label: 'Pos', type: 'number'},
                {id: 'tool', label: 'Tool', type: 'string', role: 'tooltip'},
                {id: 'lat', label: 'Lat', type: 'number', role:'none'},
                {id: 'lng', label: 'Lng', type: 'number', role:'null'}];

    return cols;
}
/**
 * Created by jordan on 28/11/2016.
 */

// Loads a photo lightbox, if a URL and event name is specified
// Requires fancybox, jQuery, PhotoShareLinks and fancyboxSharePhotoConfig
var PhotoLightbox = function(photoId, photoUrl, eventName) {
    if (photoUrl) {
        var fancyboxConfig = fancyboxSharePhotoConfig();
        fancyboxConfig.type = 'image';
        // fancyboxConfig.afterLoad = function() {
        //     this.title = '<div class="share-icons">' + PhotoShareLinks.socialButtons(true)+'</div>';
        // };
        // fancyboxConfig.afterShow = function() {
        //     PhotoShareLinks.init(window.location.href, eventName, photoId);
        // };
        $.fancybox(photoUrl, fancyboxConfig);
    }
};


/**
 * Created by jordan on 18/06/2016.
 * Share links for the photos lightbox
 */
var PhotoShareLinks = (function() {
    //Triggers an event in the Angular controller
    var showEmailDialog = function(photoId) {
        $('.email-share-photo').trigger('show', photoId);
    };

	var showPrintMenu = function(photoId) {
		console.log("Showing options");
		$('.fancy-menu').trigger('showPrintMenu', photoId);
	};
    
    var socialButtons = function(hideDownload, showPrint) {
        var facebook = '<a class="facebook facebook-photo-share" title="Share via Facebook">Facebook</a>';
        // var twitter = '<a class="twitter twitter-photo-share" title="Share via Twitter">Twitter</a>';
        var email = '<a class="email email-photo-share" title="Share via Email">Email</a>';
		var print = '<a class="show-print-menu print" title="Buy Prints">Buy Prints</a>';
		var download = '<a class="social-download" title="Save Photo to Computer">Download</a>';
        
		  	var buttons = facebook + /* twitter + */email;
		  	
		  	if(showPrint) {
				  buttons += print;
		  	}
			if(!hideDownload) {
				buttons += download;
			}
		  	return buttons;
    }; 
    
    var addPhotoAction = function(photoId, actionType) {
        var urlPrefix = window.location.protocol + "//" + window.location.host;
        $.post(urlPrefix + "/api/photo-actions/add", {photoId: photoId, actionType: actionType}, function() {
            console.log([urlPrefix + "/api/photo-actions/add", {photoId: photoId, actionType: actionType}]);
        }); 
        
    };
    
	var downloadPhoto = function(photoId, participantId, eventId) {
		var link = '/photos/serve/' + photoId + '/' + eventId;
		if(participantId) {
			link += '/' +participantId;
		}

		if(isMobileOrTablet()) {
			window.location.href = link;
		} else {
			window.open(link, '_blank');
		}
	};

	/**
	 * 
	 * @param url
	 * @param name
	 * @param photoId
	 * @param eventId (Optional) - only if download link to be displayed
	 * @param participantId (Optional) - only if download link to be displayed
	 */
	var init = function(url, name, photoId, eventId, participantId) {
			$(".facebook-photo-share").unbind();
			$(".twitter-photo-share").unbind();
			$(".email-photo-share").unbind();

			$(".facebook-photo-share").click(function() {
				$('body').trigger('showSignUpTrigger', function() {
					$('body').trigger('showAgreeTrigger', function () {
						addPhotoAction(photoId, 'Facebook');
						ShareLinks.showFacebook(url, name, name, photoId);
					});
				});
			});

			$(".twitter-photo-share").click(function() {
				$('body').trigger('showSignUpTrigger', function() {
					$('body').trigger('showAgreeTrigger', function() {
						addPhotoAction(photoId, 'Twitter');
						ShareLinks.showTwitter(url, "My photo from " + name, name, photoId);
					});
				});
			});

			$(".email-photo-share").click(function() {
				$('body').trigger('showSignUpTrigger', function() {
					$('body').trigger('showAgreeTrigger', function() {
						addPhotoAction(photoId, 'Email');
						ShareLinks.logEvent('email-share', name, photoId);
						showEmailDialog(photoId);
					});
				});
			});

			$(".show-print-menu").click(function() {
				showPrintMenu(photoId);
			});

			if(eventId) {
			  $(".social-download").click(function() {
					$('body').trigger('showSignUpTrigger', function() {
						$('body').trigger('showAgreeTrigger', function() {
							downloadPhoto(photoId, participantId, eventId);
						});
					});


			  })
		  }
        
    };

    return {
        socialButtons:socialButtons,
        showEmailDialog:showEmailDialog,
        init:init,
    };
})();

/**
 * Created by jordan on 4/07/2015.
 */
var RideMap = function() {};

RideMap.heightMarker = null;

/**
 * Creates a new ride map
 * Does not show altitude profile if distance is set to 0
 * @param srcKml
 * @param distance
 * @param div
 */
RideMap.create = function(srcKml, distance, div) {
	var elevation;
	var startMarker, endMarker;
	var showXAxis;

	if(distance == 0) {
		showXAxis = false;
	} else {
		showXAxis = true;
	}


	if(srcKml !== '') {
		//CreateMap with KML file
		GPS.kmlMap(div, srcKml, function(data, map) {
			if(distance != 0) {
				//Tabulate data
				var mapper = new KmlVisualizationMapper();
				var rows = mapper.createRows(data, distance);
				var cols = mapper.createCols(data);

				//Elevation profile
				elevation = new ElevationProfile('elevation');
				elevation.create(rows, cols, onChartHover, showXAxis, distance, map);
				$("#elevation").fadeTo(200,1);
				
				//Clear moveable marker if necessary
				RideMap.heightMarker = null;
			} else {
				$("#elevation").fadeTo(200, 0);
			}


			//Add markers to map
			var points = data[0].placemarks[0].LineString[0].coordinates;
			var start = new google.maps.LatLng(points[0].lat, points[0].lng);
			var end = new google.maps.LatLng(points[points.length-1].lat, points[points.length-1].lng);

			startMarker = GPS.addMarker(end, 'End', '/img/marker-red.png', map);
			endMarker = GPS.addMarker(start, 'Start', '/img/marker-green.png', map);
		});

	}

	//Behaviour for when you hover over the chart, given an x position and map data
	function onChartHover(x, map) {
		var LAT_COLUMN = 3;
		var LNG_COLUMN = 4;

		if(x < elevation.data.getNumberOfRows() && x >= 0) {

			var lat = elevation.data.getValue(x, LAT_COLUMN);
			var lng = elevation.data.getValue(x, LNG_COLUMN);
			var latLng = new google.maps.LatLng(lat, lng);

			if(!RideMap.heightMarker) {
				RideMap.heightMarker = new google.maps.Marker({
					position: latLng,
					map: map});
			} else {
				RideMap.heightMarker.setPosition(latLng);
			}
		}
	}

};
/**
 * Created by jordan on 18/06/2016.
 */
var ShareLinks = (function() {
    var VIA = "NORTHSOUTH";
    
    var init = function($facebook, $twitter, $email, link, text) {
        $facebook.click(function() { showFacebook(link, text, text, 'event'); });
        $twitter.click(function() { showTwitter(link, text, text, 'event'); });
        $email.click(function() { showEmail(link, text, text, 'event'); });
    };

    var logEvent = function(eventAction, eventName, label) {
        ga('send', 'event', eventName, eventAction, label);
    };

    var showTwitter = function(link, text, logName, logLabel) {
        popupWindow("https://twitter.com/share?url=" + link + "&text= " + text + ":&via=" + VIA, 'Twitter');
        logEvent('twitter-share', logName, logLabel);
    };
    var showFacebook = function(link, text, logName, logLabel) {
        popupWindow("http://www.facebook.com/share.php?u=" + link + "&href=" + link, 'Facebook');
        logEvent('facebook-share', logName, logLabel);
    };
    var showEmail = function(link, text, logName, logLabel) {
        var subject = text  + ' - ' + VIA;
        var body = text  + ' - ' + VIA + "%0D%0A" + link;
        window.location = "mailto:?subject=" + subject + "&body=" + body;
        logEvent('email-share', logName, logLabel);
    };
    
    
    return {
        logEvent: logEvent,
        init: init,
        showFacebook:showFacebook,
        showTwitter: showTwitter,
        showEmail: showEmail
    }
})();
/**
 * Created by jordan on 24/09/2015.
 */
var UrlHelper = {};
UrlHelper.getUrlVars = function() {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value;
	});
	return vars;
};
/* 
 t.kumpanenko@gmail.com
 JQuery Accordion Plugin v 1.1
 */

 (function($) {

  var defaultSetting = {
    customClass: {
      openClass: 'accordion-open',
      headerClass: '',
      contentClass: ''
    },
    animation: {
      duration: 500
    },
    onLoad: 'allOpen', //allClose, firstOpen, allOpen, '#id'
    onLoadError: 'allClose', //allClose, firstOpen, allOpen Якщо нема відкриваємо за id i отримуємо пустий обєкт
    onlyOneOpen: 'false'
  };

  var methods = {
    init: function(options) {
      var obj = this;
      var setting = $.extend(true, defaultSetting, options);

      $(obj).data('AccordionSetting', setting);
      var _openClass = $(obj).data('AccordionSetting').customClass.openClass;
      var _onLoad = String($(obj).data('AccordionSetting').onLoad);
      var _onLoadError = String($(obj).data('AccordionSetting').onLoadError);
      var $accordionContent = getParam(obj).content;
      var $accordionHeader = getParam(obj).header;
      
      switch (_onLoad) {
        case 'allClose':
        $accordionContent.hide();
        break;
        case 'firstOpen':
        $accordionContent.not(':first').hide();
        
        $(obj).filter(':first').addClass(_openClass);
        break;
        case 'allOpen':
        $accordionContent.show();
        break;
        default:
        if (!$(_onLoad).length == 0) {
          obj.not(_onLoad).find($accordionContent).hide();
        }
        else {
          switch (_onLoadError) {
            case 'allClose':
            $accordionContent.hide();
            break;
            case 'allOpen':
            $accordionContent.show();
            break;
            case 'firstOpen':
            $accordionContent.not(':first').hide();
            $(obj).filter(':first').addClass(_openClass);
            break;
          }
        }
        break;
      }
      ;

      $($accordionHeader).click(function() {
        
        toogleAccordion($(this).closest(obj), obj);
        return false;
      });

    },
    close: function() {
      closeAccordion(this);
    },
    open: function() {
      openAccordion(this);
    }


  };

  //функції


  var getParam = function(curr) {
    var setting = $(curr).data('AccordionSetting');
    if (!setting.customClass.headerClass ) {
      
      $Header = $(curr).children().filter(':first-child');
      
    }
    else
    {
      $Header = $(setting.customClass.headerClass);
      
    }
    if (!setting.customClass.contentClass) {
      $Content = $(curr).children().filter(':nth-child(2)');
    }
    else
    {
      $Content = $(setting.customClass.contentClass);
    }

    return  {'header': $Header, 'content': $Content};


  };
//

var toogleAccordion = function(current, obj) {
  var _onlyOneOpen = String($(obj).data('AccordionSetting').onlyOneOpen);
  var _openClass = $(obj).data('AccordionSetting').customClass.openClass;
  var $accordionContent = getParam(obj).content;
  var $closestAccordionItemContent = $(current).find($accordionContent);
  var duration = $(obj).data('AccordionSetting').animation.duration;
  $(current).find($accordionContent).stop(true, true).slideToggle(duration);
  $(current).toggleClass(_openClass);

  if (_onlyOneOpen == 'true') {
    $(obj).find($accordionContent).not($closestAccordionItemContent).slideUp(duration);
    $(obj).not(current).removeClass(_openClass);
  }
};

var closeAccordion = function(obj) {

  var duration = $(obj).data('AccordionSetting').animation.duration;
  getParam(obj).content.slideUp(duration);
  obj.removeClass($(obj).data('AccordionSetting').customClass.openClass);
};

var openAccordion = function(obj) {
  var duration = $(obj).data('AccordionSetting').animation.duration;
  getParam(obj).content.slideDown(duration);
  obj.addClass($(obj).data('AccordionSetting').customClass.openClass);
};

$.fn.Accordion = function(method) {
  var obj = this;
  if ($(obj).length > 0){
    if (methods[method]) {
      return methods[ method ].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(method + '  is undefined');
    }
  }else{
    console.log('Accordion init, but items not found ');
  }
};
window.jQuery2 = $;
}(jQuery));

var SportEventApp = {
	isMobile:function(){
		if ($('.menu-nav:visible').size()>0) {
			return true;
		}
		else{
			return false;
		}
	}
}
 
;$(function() {
	'use strict';

	var Cord = {};
	var topMargin = 25;
	var $el = {};

	var arrowClasses = {
		arrowLeft: 'arrow-left',
		arrowBottom: 'arrow-bottom-center'
	}

	var $dropdown = $.extend($('.drop-down-item'),true,{
		hideDropDown: function(){
			$dropdown.removeAttr('style');
			$dropdown.hide();
		},
		getPosition: function(el){
			var $self = $(this);
			Cord = {
				top: $(el).offset().top + $(el).outerHeight() + topMargin,
				left: $(el).offset().left - $dropdown.outerWidth()/2 + $(el).outerWidth()/2
			};
			if (Cord.left < 0){
				$self.addClass(arrowClasses.arrowLeft);
				Cord.left = $(el).offset().left;
			}
			if (Cord.top + $dropdown.height() > $('#wrapper').height()){
				$self.addClass(arrowClasses.arrowBottom);
				Cord.top = $(el).offset().top - $dropdown.outerHeight() - topMargin;
			}
			$self.offset({'top':Cord.top,'left':Cord.left});
		},
		showDropDown: function(el){
			var $self = $(this);
			$self.removeClass(arrowClasses.arrowLeft).removeClass(arrowClasses.arrowBottom);
			$dropdown.getPosition(el);
			$self.show();
			return false;
		},
	});

	$('body').click(function(e){
		if ($dropdown.filter(':visible') && (!SportEventApp.isMobile())) {
			if (!($(e.target).is($dropdown) || $(e.target).is($dropdown.find('*')))){
			 $dropdown.hideDropDown();
		 }
	 }
 });


	/*$('.JS-cart-item a.select').magnificPopup({
		type: 'inline',
		preloader: false,
		closeOnBgClick:true,
		showCloseBtn:false,
		disableOn: function() {
			if( !SportEventApp.isMobile() ) {
				return false;
			} else{
				$dropdown.removeAttr('style');
				return true;
			}
		},
		callbacks:{
			resize:function() {
				if( !SportEventApp.isMobile() ) {
					$.magnificPopup.instance.close(); 
				}
			}
		}
	});*/
	
	// show dropdown
	/*$('.JS-cart-item a.select').click(function(event){
		if( !SportEventApp.isMobile() ) {
			$dropdown.showDropDown(this);
			console.log('here');
		}
		return false;
	});
*/
});


/* 
 t.kumpanenko@gmail.com
 */


;'use scrict';

var EventTabs = {
	hasInit:false,
	selector:{
		wrapper: '.JS-tabs-wrap',
		button: '.JS-tab-button',
		panel: '.JS-tab-panel',
	},
	tabActiveClass: 'active',
	init:function(){
		if(!this.hasInit) {
			var _self = this;
			var $button = $(_self.selector.button);
			var $panel = $(_self.selector.panel);
			var tabActiveClass = _self.tabActiveClass;
			//init 
			$panel.not(':first').hide();
			$button.find('li').filter(':first').addClass(tabActiveClass);
			_self.setDataAttrs();

			$button.find('li').click(function(ev){
				$button.find('li').removeClass(tabActiveClass);
				$panel.hide();
				$(this).addClass(tabActiveClass);
				$panel.filter('[data-index='+$(this).attr('data-index')+']').show();
				ev.preventDefault();
			});
			this.hasInit = true;
		}
	},
	setDataAttrs:function(){
		var _self = this;
		var $panel = $(_self.selector.panel);
		var $button = $(_self.selector.button);

		$panel.each(function(index){
			$(this).attr('data-index',index);
		});

		$button.find('li').each(function(index){
			$(this).attr('data-index',index);
		});
	},
	destroy:function(){
		if(this.hasInit) {
			var _self = this;
			var $button = $(_self.selector.button);
			var $panel = $(_self.selector.panel);
			var tabActiveClass = _self.tabActiveClass;
			$panel.removeAttr('data-index').removeAttr('style');
			$button.find('li').removeClass(tabActiveClass).removeAttr('data-index');
			this.hasInit = false;
		}
		
	}
}


$(document).ready(function(){
	if ($('.JS-accordion').size() > 0){
		$('.JS-accordion').Accordion({
			customClass:{
				headerClass: '.JS-accordion-header',
				contentClass:'.JS-accordion-content'
			},
			onLoad:'allOpen'}
			);
	}

	$('.JS-refine-btn').click(function(){
		$('.event-filter').addClass('event-filter-show');
		$('body').addClass('pull-wrapper');
	});

	var $SortByDropDown = $('.JS-sort-by').find('.select');
	
	$SortByDropDown.find('ul').hide();
	$SortByDropDown.click(function(){
		$SortByDropDown.find('ul').toggle();
	});
	$('body').click(function(e){
		if ($SortByDropDown) {
			if (!($(e.target).is($SortByDropDown) || $(e.target).is($SortByDropDown.find('*')))) {
				$SortByDropDown.find('ul').hide();
			}
		}
	});

});
window.fbAsyncInit = function() {
	FB.init({
		appId      : '1560259407581227',
		xfbml      : true,
		version    : 'v2.3'
	});
};
(function(d, s, id){
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) {return;}
	js = d.createElement(s); js.id = id;
	js.src = "//connect.facebook.net/en_US/sdk.js";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk')); 
/**
 * Created by jordan on 21/10/2015.
 */
//Featured Films jQuery gallery
var NEXT_FILM_INTERVAL = 3500;
var FilmGallery = function() {
	function nextFilm() {
		var $nextFilm = $currentFilm.next();

		$currentFilm.fadeOut(100, function() {
			if($nextFilm.length) {
				$nextFilm.fadeIn(200);
			}
			else {
				$nextFilm = $(".films-holder #films").children().first();
				$nextFilm.fadeIn(200);
			}
			$currentFilm = $nextFilm;
		});
	}
	
	function prevFilm() {
		var $nextFilm = $currentFilm.prev();

		$currentFilm.fadeOut(100, function() {
			if($nextFilm.length) {
				$nextFilm.fadeIn(200);
			}
			else {
				$nextFilm = $(".films-holder #films").children().last();
				$nextFilm.fadeIn(200);
			}
			$currentFilm = $nextFilm;
		});
	}
	
	
	var $currentFilm = $(".films-holder #films").children().first();
	$currentFilm.show();

	$(".films-holder .right").click(function() {
		clearInterval(changeFilms);
		nextFilm();
	});

	$(".films-holder .left").click(function() {
		clearInterval(changeFilms);
		prevFilm();
	});
	
	var changeFilms = setInterval(function() {
		nextFilm();
	}, NEXT_FILM_INTERVAL);


};
// Footer accordion initialization for mobile
$(document).ready(function() {
    
    function initFooterAccordion() {
        if(window.didInitFooter) {
            return;
        }
        // Only initialize accordion on tablet and mobile (768px and below)
        if (window.innerWidth <= 768) {
            jQuery2('.footer-accordion').Accordion({
                customClass: {
                    openClass: 'accordion-open',
                    headerClass: '.footer-accordion-header',
                    contentClass: '.footer-accordion-content'
                },
                animation: {
                    duration: 250
                },
                onLoad: 'allClose',
                onlyOneOpen: 'true'
            });
        }
        window.didInitFooter = true;
    }

    // Initialize on page load
    initFooterAccordion();

    // Reinitialize on window resize
    var resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Destroy existing accordion instance if it exists
            if (window.innerWidth > 768) {
                $('.footer-accordion').removeClass('accordion-open');
                $('.footer-accordion-content').show().css('display', 'block');
            } else {
                // Reset any inline styles that might cause jumping
                $('.footer-accordion-content').removeAttr('style');
                initFooterAccordion();
            }
        }, 250);
    });
});
//Return modulus of a number, including negative numbers
function mod(n, m) {
    return ((n % m) + m) % m;
}

//Detects if device is touch
function isTouchDevice() {
    return 'ontouchstart' in window        // works on most browsers 
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
};

function fancybox(url, settings) {
    if(!settings) {
        settings = {};
    }
    if($(window).width() < Config.MOBILE_WIDTH) {
        settings = Config.fancybox.mobile;
    } else {
        settings = Config.fancybox.desktop;
    }

    settings.href = url;
    $.fancybox( settings );
}
 
/**
 * Loads an image that has had its src placed in 'data-src' to avoid it pre-loading
 * @param img
 */
function loadDataImage(img) {
    if(img) {
        img.src = img.getAttribute("data-src");
        //console.log(img);
    }
}

function isMobileOrTablet() {
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {

        return true;
    }
    return false;
}
function queryString() {
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
}

/*
    geoxml3.js

    Renders KML on the Google Maps JavaScript API Version 3 
    http://code.google.com/p/geoxml3/

   Copyright 2010 Sterling Udell, Larry Ross

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

*/
/**
 * A MultiGeometry object that will allow multiple polylines in a MultiGeometry
 * containing LineStrings to be treated as a single object
 *
 * @param {MutiGeometryOptions} anonymous object.  Available properties:
 * map: The map on which to attach the MultiGeometry
 * paths: the individual polylines
 * polylineOptions: options to use when constructing all the polylines
 *
 * @constructor
 */
// only if Google Maps API included
if (!!window.google && !! google.maps) { 
function MultiGeometry(multiGeometryOptions) {
   function createPolyline(polylineOptions, mg) {
     var polyline = new google.maps.Polyline(polylineOptions);
     google.maps.event.addListener(polyline,'click', function(evt) { google.maps.event.trigger(mg,'click',evt);});
     google.maps.event.addListener(polyline,'dblclick', function(evt) { google.maps.event.trigger(mg, 'dblclick', evt);});
     google.maps.event.addListener(polyline,'mousedown', function(evt) { google.maps.event.trigger(mg, 'mousedown', evt);});
     google.maps.event.addListener(polyline,'mousemove', function(evt) { google.maps.event.trigger(mg, 'mousemove', evt);});
     google.maps.event.addListener(polyline,'mouseout', function(evt) { google.maps.event.trigger(mg, 'mouseout', evt);});
     google.maps.event.addListener(polyline,'mouseover', function(evt) { google.maps.event.trigger(mg, 'mouseover', evt);});
     google.maps.event.addListener(polyline,'mouseup', function(evt) { google.maps.event.trigger(mg, 'mouseup', evt);});
     google.maps.event.addListener(polyline,'rightclick', function(evt) { google.maps.event.trigger(mg, 'rightclick', evt);});
     return polyline;
   }
   this.setValues(multiGeometryOptions);
   this.polylines = [];

   for (i=0; i<this.paths.length;i++) {
     var polylineOptions = multiGeometryOptions;
     polylineOptions.path = this.paths[i];
     var polyline = createPolyline(polylineOptions,this);
     // Bind the polyline properties to the MultiGeometry properties
     this.polylines.push(polyline);
   }
}
MultiGeometry.prototype = new google.maps.MVCObject();
MultiGeometry.prototype.changed = function(key) {
    // alert(key+" changed");
    if (this.polylines) {
	for (var i=0; i<this.polylines.length; i++) {
	    this.polylines[i].set(key,this.get(key));
	}
    }
};
MultiGeometry.prototype.setMap = function(map) { this.set('map',map); };
MultiGeometry.prototype.getMap = function() { return this.get('map'); };
}

// Extend the global String object with a method to remove leading and trailing whitespace
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// Declare namespace
geoXML3 = window.geoXML3 || {instances: []};

// Constructor for the root KML parser object
geoXML3.parser = function (options) {
  // Inherit from Google MVC Object to include event handling   
  google.maps.MVCObject.call(this);   

  // Private variables
  var parserOptions = geoXML3.combineOptions(options, {
    singleInfoWindow: false,
    processStyles: true,
    zoom: true
  });
  var docs = []; // Individual KML documents
  var lastPlacemark;
  var parserName;
  if (typeof parserOptions.suppressInfoWindows == "undefined") parserOptions.suppressInfoWindows = false;
  if (!parserOptions.infoWindow && parserOptions.singleInfoWindow && !!window.google && !!google.maps)
    parserOptions.infoWindow = new google.maps.InfoWindow();

  geoXML3.xhrTimeout = 60000;
  if (!!parserOptions.xhrTimeout) geoXML3.xhrTimeout = parserOptions.xhrTimeout; 

  var parseKmlString = function (kmlString, docSet) {
    // Internal values for the set of documents as a whole
    var internals = {
      parser: this,
      docSet: docSet || [],
      remaining: 1,
      parseOnly: !(parserOptions.afterParse || parserOptions.processStyles)
    };
    thisDoc = new Object();
    thisDoc.internals = internals;
    internals.docSet.push(thisDoc);
    render(geoXML3.xmlParse(kmlString),thisDoc);
  }

  var parse = function (urls, docSet) {
    // Process one or more KML documents
    if (!parserName) {
      parserName = 'geoXML3.instances[' + (geoXML3.instances.push(this) - 1) + ']';
    }
    
    if (typeof urls === 'string') {
      // Single KML document
      urls = [urls];
    }

    // Internal values for the set of documents as a whole
    var internals = {
      parser: this,
      docSet: docSet || [],
      remaining: urls.length,
      parseOnly: !(parserOptions.afterParse || parserOptions.processStyles)
    };
    var thisDoc, j;
    for (var i = 0; i < urls.length; i++) {
      var baseUrl = urls[i].split('?')[0];
      for (j = 0; j < docs.length; j++) {
        if (baseUrl === docs[j].baseUrl) {
          // Reloading an existing document
          thisDoc = docs[j];
          thisDoc.reload    = true;
          break;
        }
      }
      if (j >= docs.length) {
        thisDoc = new Object();
        thisDoc.baseUrl = baseUrl;
        internals.docSet.push(thisDoc);
      }
      thisDoc.url       = urls[i];
      thisDoc.internals = internals;
      var url = thisDoc.url;
      if (parserOptions.proxy) url = parserOptions.proxy+thisDoc.url; 
      fetchDoc(url, thisDoc);
    }
  };

  function fetchDoc(url, doc) {
      geoXML3.fetchXML(url, function (responseXML) { render(responseXML, doc);})
  }

  var hideDocument = function (doc) {
    if (!doc) doc = docs[0];
    // Hide the map objects associated with a document 
    var i;
    if (!!window.google && !!google.maps) {
      if (!!doc.markers) {
        for (i = 0; i < doc.markers.length; i++) {
          if(!!doc.markers[i].infoWindow) doc.markers[i].infoWindow.close();
          doc.markers[i].setVisible(false);
        }
      }
      if (!!doc.ggroundoverlays) {
        for (i = 0; i < doc.ggroundoverlays.length; i++) {
          doc.ggroundoverlays[i].setOpacity(0);
        }
      }
      if (!!doc.gpolylines) {
        for (i=0;i<doc.gpolylines.length;i++) {
          if(!!doc.gpolylines[i].infoWindow) doc.gpolylines[i].infoWindow.close();
          doc.gpolylines[i].setMap(null);
        }
      }
      if (!!doc.gpolygons) {
        for (i=0;i<doc.gpolygons.length;i++) {
          if(!!doc.gpolygons[i].infoWindow) doc.gpolygons[i].infoWindow.close();
         doc.gpolygons[i].setMap(null);
        }
      }
    }
  };
  
  
  var showDocument = function (doc) {
    if (!doc) doc = docs[0];
    // Show the map objects associated with a document 
    var i;
    if (!!window.google && !!google.maps) {
      if (!!doc.markers) {
        for (i = 0; i < doc.markers.length; i++) {
          doc.markers[i].setVisible(true);
        }
      }
      if (!!doc.ggroundoverlays) {
        for (i = 0; i < doc.ggroundoverlays.length; i++) {
          doc.ggroundoverlays[i].setOpacity(doc.ggroundoverlays[i].percentOpacity_);
        }
      }
      if (!!doc.gpolylines) {
        for (i=0;i<doc.gpolylines.length;i++) {
          doc.gpolylines[i].setMap(parserOptions.map);
        }
      }
      if (!!doc.gpolygons) {
        for (i=0;i<doc.gpolygons.length;i++) {
          doc.gpolygons[i].setMap(parserOptions.map);
        }
      }
    }
  };

  //JY added remove document functionality
  var removeDocument = function (doc) {

    if (!doc) doc = docs[0];

    // Hide the map objects associated with a document
    var i;
    if (!!doc.markers) {
      for (i = 0; i < doc.markers.length; i++) {
        if(!!doc.markers[i].infoWindow) doc.markers[i].infoWindow.close();
        //doc.markers[i].setVisible(false);
        doc.markers[i].setMap(null);
      }
    }
    if (!!doc.ggroundoverlays) {
      for (i = 0; i < doc.ggroundoverlays.length; i++) {
        //doc.ggroundoverlays[i].setOpacity(0);
        doc.ggroundoverlays[i].setMap(null);
      }
    }
    if (!!doc.gpolylines) {
      for (i=0;i<doc.gpolylines.length;i++) {
        if(!!doc.gpolylines[i].infoWindow) doc.gpolylines[i].infoWindow.close();
        doc.gpolylines[i].setMap(null);
      }
    }
    if (!!doc.gpolygons) {
      for (i=0;i<doc.gpolygons.length;i++) {
        if(!!doc.gpolygons[i].infoWindow) doc.gpolygons[i].infoWindow.close();
        doc.gpolygons[i].setMap(null);
      }
    }

    /*kmlMetaData[doc.baseUrl] = null;
    styles[doc.baseUrl] = null;
    docsByUrl[doc.baseUrl] = null;*/
    doc = null;
  };

var defaultStyle = {
  color: "ff000000", // black
  colorMode: "normal",
  width: 1,
  fill: true,
  outline: true,
  fillcolor: "3fff0000" // blue
};

function processStyle(thisNode, styles, styleID) {
      var nodeValue  = geoXML3.nodeValue;
      styles[styleID] = styles[styleID] || clone(defaultStyle);
      var styleNodes = thisNode.getElementsByTagName('IconStyle');
      if (!!styleNodes && !!styleNodes.length && (styleNodes.length > 0)) {
        styles[styleID].scale = parseFloat(nodeValue(styleNodes[0].getElementsByTagName('scale')[0]));
      }
      if (isNaN(styles[styleID].scale)) styles[styleID].scale = 1.0;
      styleNodes = thisNode.getElementsByTagName('Icon');
      if (!!styleNodes && !!styleNodes.length && (styleNodes.length > 0)) {
        styles[styleID].href = nodeValue(styleNodes[0].getElementsByTagName('href')[0]);
      }
      styleNodes = thisNode.getElementsByTagName('LineStyle');
      if (!!styleNodes && !!styleNodes.length && (styleNodes.length > 0)) {
        styles[styleID].color = nodeValue(styleNodes[0].getElementsByTagName('color')[0],defaultStyle.color);
        styles[styleID].colorMode = nodeValue(styleNodes[0].getElementsByTagName('colorMode')[0], defaultStyle.colorMode);
        styles[styleID].width = nodeValue(styleNodes[0].getElementsByTagName('width')[0],defaultStyle.width);
      }
      styleNodes = thisNode.getElementsByTagName('PolyStyle');
      if (!!styleNodes && !!styleNodes.length && (styleNodes.length > 0)) {
        styles[styleID].outline   = getBooleanValue(styleNodes[0].getElementsByTagName('outline')[0],defaultStyle.outline);
        styles[styleID].fill      = getBooleanValue(styleNodes[0].getElementsByTagName('fill')[0],defaultStyle.fill);
        styles[styleID].colorMode = nodeValue(styleNodes[0].getElementsByTagName('colorMode')[0], defaultStyle.colorMode);
        styles[styleID].fillcolor = nodeValue(styleNodes[0].getElementsByTagName('color')[0],defaultStyle.fillcolor);
      }
      return styles[styleID];
}

// from http://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-clone-a-javascript-object
// http://keithdevens.com/weblog/archive/2007/Jun/07/javascript.clone
  function clone(obj){
      if(obj == null || typeof(obj) != 'object') return obj;
      var temp = new obj.constructor(); 
      for(var key in obj) temp[key] = clone(obj[key]);
      return temp;
  }

function processStyleMap(thisNode, styles, styleID) {
  var nodeValue  = geoXML3.nodeValue;
  var pairs = thisNode.getElementsByTagName('Pair');
  var map = new Object();
  // add each key to the map
  for (var pr=0;pr<pairs.length;pr++) {
    var pairkey = nodeValue(pairs[pr].getElementsByTagName('key')[0]);
    var pairstyle = nodeValue(pairs[pr].getElementsByTagName('Style')[0]);
    var pairstyleurl = nodeValue(pairs[pr].getElementsByTagName('styleUrl')[0]);
    if (!!pairstyle) {
      processStyle(pairstyle, map[pairkey], styleID);
    } else if (!!pairstyleurl && !!styles[pairstyleurl]) {
      map[pairkey] = clone(styles[pairstyleurl]);
    }
  }
  if (!!map["normal"]) {
    styles[styleID] = clone(map["normal"]);
  } else {
    styles[styleID] =  clone(defaultStyle);
  }      
  if (!!map["highlight"] && !!parserOptions.processStyles) {
    processStyleID(map["highlight"]);
  }
  styles[styleID].map = clone(map);
}

function getBooleanValue(node) {
  var nodeContents = geoXML3.nodeValue(node);
  if (!nodeContents) return true;
  if (nodeContents) nodeContents = parseInt(nodeContents);
  if (isNaN(nodeContents)) return true;
  if (nodeContents == 0) return false;
  else return true;
}   

function processPlacemarkCoords(node, tag) {
   var parent = node.getElementsByTagName(tag);
var coordListA = [];
  for (var i=0; i<parent.length; i++) {
  var coordNodes = parent[i].getElementsByTagName('coordinates')
  if (!coordNodes) {
    if (coordListA.length > 0) {
      break;
    } else {
      return [{coordinates: []}];
    }
  }

  for (var j=0; j<coordNodes.length;j++) { 
    var coords = geoXML3.nodeValue(coordNodes[j]).trim();
    coords = coords.replace(/,\s+/g, ',');
    var path = coords.split(/\s+/g);
    var pathLength = path.length;
    var coordList = [];
    for (var k = 0; k < pathLength; k++) {
      coords = path[k].split(',');
      if (!isNaN(coords[0]) && !isNaN(coords[1])) {
        coordList.push({
          lat: parseFloat(coords[1]), 
          lng: parseFloat(coords[0]), 
          alt: parseFloat(coords[2])
        });
      }
    }
    coordListA.push({coordinates: coordList});
  }
}
  return coordListA;
}

  var render = function (responseXML, doc) {
    // Callback for retrieving a KML document: parse the KML and display it on the map
    if (!responseXML) {
      // Error retrieving the data
      geoXML3.log('Unable to retrieve ' + doc.url);
      if (parserOptions.failedParse) {
        parserOptions.failedParse(doc);
      }
    } else if (!doc) {
      throw 'geoXML3 internal error: render called with null document';
    } else { //no errors
      var i;
      var styles = {};
      doc.placemarks     = [];
      doc.groundoverlays = [];
      doc.ggroundoverlays = [];
      doc.networkLinks   = [];
      doc.gpolygons      = [];
      doc.gpolylines     = [];
      doc.markers        = [];

    // Declare some helper functions in local scope for better performance
    var nodeValue  = geoXML3.nodeValue;

    // Parse styles
    var styleID, styleNodes;
    nodes = responseXML.getElementsByTagName('Style');
    nodeCount = nodes.length;
    for (i = 0; i < nodeCount; i++) {
      thisNode = nodes[i];
      var thisNodeId = thisNode.getAttribute('id');
      if (!!thisNodeId) {
        styleID    = '#' + thisNodeId;
        processStyle(thisNode, styles, styleID);
      }
    }
    // rudamentary support for StyleMap
    // use "normal" mapping only
    nodes = responseXML.getElementsByTagName('StyleMap');
    for (i = 0; i < nodes.length; i++) {
      thisNode = nodes[i];
      var thisNodeId = thisNode.getAttribute('id');
      if (!!thisNodeId) {
        styleID    = '#' + thisNodeId;
	processStyleMap(thisNode, styles, styleID);
      }
    }
    doc.styles = styles;
      if (!!parserOptions.processStyles || !parserOptions.createMarker) {
        // Convert parsed styles into GMaps equivalents
        processStyles(doc);
      }

      // Parse placemarks
      if (!!doc.reload && !!doc.markers) {
        for (i = 0; i < doc.markers.length; i++) {
          doc.markers[i].active = false;
        }
      }
      var placemark, node, coords, path, marker, poly;
      var placemark, coords, path, pathLength, marker, polygonNodes, coordList;
      var placemarkNodes = responseXML.getElementsByTagName('Placemark');
      for (pm = 0; pm < placemarkNodes.length; pm++) {
        // Init the placemark object
        node = placemarkNodes[pm];
        placemark = {
          name:  geoXML3.nodeValue(node.getElementsByTagName('name')[0]),
          description: geoXML3.nodeValue(node.getElementsByTagName('description')[0]),
          styleUrl: geoXML3.nodeValue(node.getElementsByTagName('styleUrl')[0]),
          id: node.getAttribute('id')
        };
        placemark.style = doc.styles[placemark.styleUrl] || clone(defaultStyle);
        // inline style overrides shared style
        var inlineStyles = node.getElementsByTagName('Style');
        if (inlineStyles && (inlineStyles.length > 0)) {
          var style = processStyle(node,doc.styles,"inline");
	  processStyleID(style);
	  if (style) placemark.style = style;
        }
        if (/^https?:\/\//.test(placemark.description)) {
          placemark.description = ['<a href="', placemark.description, '">', placemark.description, '</a>'].join('');
        }

        // process MultiGeometry
        var GeometryNodes = node.getElementsByTagName('coordinates');
        var Geometry = null;
	if (!!GeometryNodes && (GeometryNodes.length > 0)) {
          for (var gn=0;gn<GeometryNodes.length;gn++) {
             if (!GeometryNodes[gn].parentNode ||
                 !GeometryNodes[gn].parentNode.nodeName) {

             } else { // parentNode.nodeName exists
               var GeometryPN = GeometryNodes[gn].parentNode;
               Geometry = GeometryPN.nodeName;
       
        // Extract the coordinates
        // What sort of placemark?
        switch(Geometry) {
          case "Point":
            placemark.Point = processPlacemarkCoords(node, "Point")[0]; 
            if (!!window.google && !!google.maps)
              placemark.latlng = new google.maps.LatLng(placemark.Point.coordinates[0].lat, placemark.Point.coordinates[0].lng);
            pathLength = 1;
            break;
          case "LinearRing":
            // Polygon/line
            polygonNodes = node.getElementsByTagName('Polygon');
            // Polygon
            if (!placemark.Polygon)
              placemark.Polygon = [{
                outerBoundaryIs: {coordinates: []},
                innerBoundaryIs: [{coordinates: []}]
              }];
            for (var pg=0;pg<polygonNodes.length;pg++) {
               placemark.Polygon[pg] = {
                 outerBoundaryIs: {coordinates: []},
                 innerBoundaryIs: [{coordinates: []}]
               }
               placemark.Polygon[pg].outerBoundaryIs = processPlacemarkCoords(polygonNodes[pg], "outerBoundaryIs");
               placemark.Polygon[pg].innerBoundaryIs = processPlacemarkCoords(polygonNodes[pg], "innerBoundaryIs");
            }
            coordList = placemark.Polygon[0].outerBoundaryIs;
            break;

          case "LineString":
            pathLength = 0;
            placemark.LineString = processPlacemarkCoords(node,"LineString");
            break;

          default:
            break;
      }
      } // parentNode.nodeName exists
      } // GeometryNodes loop
      } // if GeometryNodes 
      // call the custom placemark parse function if it is defined
      if (!!parserOptions.pmParseFn) parserOptions.pmParseFn(node, placemark);
      doc.placemarks.push(placemark);
      if (!!window.google && !!google.maps) {
       if (placemark.Point) {
          if (!!window.google && !!google.maps) {
            doc.bounds = doc.bounds || new google.maps.LatLngBounds();
            doc.bounds.extend(placemark.latlng);
          }

          if (!!parserOptions.createMarker) {
            // SocialUser-defined marker handler
            parserOptions.createMarker(placemark, doc);
          } else { // !user defined createMarker
            // Check to see if this marker was created on a previous load of this document
            var found = false;
            if (!!doc) {
              doc.markers = doc.markers || [];
              if (doc.reload) {
                for (var j = 0; j < doc.markers.length; j++) {
                    if ((doc.markers[j].id == placemark.id) ||
			// if no id, check position
                        (!doc.markers[j].id && 
                         (doc.markers[j].getPosition().equals(placemark.latlng)))) {
                    found = doc.markers[j].active = true;
                    break;
                  }
                }
              } 
            }

            if (!found) {
              // Call the built-in marker creator
              marker = createMarker(placemark, doc);
              if (marker) { 
                marker.active = true;
                marker.id = placemark.id;
              }
            }
          }
         }
         if (placemark.Polygon) { // poly test 2
          if (!!doc) {
           doc.gpolygons = doc.gpolygons || [];
          }

          if (!!parserOptions.createPolygon) {
           // SocialUser-defined polygon handler
            poly = parserOptions.createPolygon(placemark, doc);
          } else {  // ! user defined createPolygon
           // Check to see if this marker was created on a previous load of this document
           poly = createPolygon(placemark,doc);
           poly.active = true;
          }
          if (!!window.google && !!google.maps) {
           doc.bounds = doc.bounds || new google.maps.LatLngBounds();
           doc.bounds.union(poly.bounds);
          }
         } 
         if (placemark.LineString) { // polyline
          if (!!doc) {
           doc.gpolylines = doc.gpolylines || [];
          }
          if (!!parserOptions.createPolyline) {
           // SocialUser-defined polyline handler
           poly = parserOptions.createPolyline(placemark, doc);
          } else { // ! user defined createPolyline
           // Check to see if this marker was created on a previous load of this document
           poly = createPolyline(placemark,doc);
           poly.active = true;
          }
          if (!!window.google && !!google.maps) {
           doc.bounds = doc.bounds || new google.maps.LatLngBounds();
           doc.bounds.union(poly.bounds);
          }
         }
       }
      } // placemark loop

      if (!!doc.reload && !!doc.markers) {
        for (i = doc.markers.length - 1; i >= 0 ; i--) {
          if (!doc.markers[i].active) {
            if (!!doc.markers[i].infoWindow) {
              doc.markers[i].infoWindow.close();
            }
            doc.markers[i].setMap(null);
            doc.markers.splice(i, 1);
          }
        }
      }

      // Parse ground overlays
      if (!!doc.reload && !!doc.groundoverlays) {
        for (i = 0; i < doc.groundoverlays.length; i++) {
          doc.groundoverlays[i].active = false;
        }
      }

      if (!!doc) {
        doc.groundoverlays = doc.groundoverlays || [];
      }
      // doc.groundoverlays =[];
      var groundOverlay, color, transparency, overlay;
      var groundNodes = responseXML.getElementsByTagName('GroundOverlay');
      for (i = 0; i < groundNodes.length; i++) {
        node = groundNodes[i];
        
        // Init the ground overlay object
        groundOverlay = {
          name:        geoXML3.nodeValue(node.getElementsByTagName('name')[0]),
          description: geoXML3.nodeValue(node.getElementsByTagName('description')[0]),
          icon: {href: geoXML3.nodeValue(node.getElementsByTagName('href')[0])},
          latLonBox: {
            north: parseFloat(geoXML3.nodeValue(node.getElementsByTagName('north')[0])),
            east:  parseFloat(geoXML3.nodeValue(node.getElementsByTagName('east')[0])),
            south: parseFloat(geoXML3.nodeValue(node.getElementsByTagName('south')[0])),
            west:  parseFloat(geoXML3.nodeValue(node.getElementsByTagName('west')[0]))
          }
        };
        if (!!window.google && !!google.maps) {
          doc.bounds = doc.bounds || new google.maps.LatLngBounds();
          doc.bounds.union(new google.maps.LatLngBounds(
            new google.maps.LatLng(groundOverlay.latLonBox.south, groundOverlay.latLonBox.west),
            new google.maps.LatLng(groundOverlay.latLonBox.north, groundOverlay.latLonBox.east)
          ));
        }

        // Opacity is encoded in the color node
        var colorNode = node.getElementsByTagName('color');
        if ( colorNode && colorNode.length && (colorNode.length > 0)) {
         groundOverlay.opacity = geoXML3.getOpacity(nodeValue(colorNode[0]));
        } else {
         groundOverlay.opacity = 0.45;
        }

        doc.groundoverlays.push(groundOverlay);
        if (!!window.google && !!google.maps) {
         if (!!parserOptions.createOverlay) {
          // SocialUser-defined overlay handler
          parserOptions.createOverlay(groundOverlay, doc);
         } else { // ! user defined createOverlay
          // Check to see if this overlay was created on a previous load of this document
          var found = false;
          if (!!doc) {
            doc.groundoverlays = doc.groundoverlays || [];
            if (!!window.google && !!google.maps && doc.reload) {
                overlayBounds = new google.maps.LatLngBounds(
                  new google.maps.LatLng(groundOverlay.latLonBox.south, groundOverlay.latLonBox.west),
                  new google.maps.LatLng(groundOverlay.latLonBox.north, groundOverlay.latLonBox.east));
              var overlays = doc.groundoverlays;
              for (i = overlays.length; i--;) {
                if ((overlays[i].bounds().equals(overlayBounds)) &&
                    (overlays.url_ === groundOverlay.icon.href)) {
                  found = overlays[i].active = true;
                  break;
                }
              }
            } 
          }
  
          if (!found) {
            // Call the built-in overlay creator
            overlay = createOverlay(groundOverlay, doc);
            overlay.active = true;
          }
	 }
         if (!!doc.reload && !!doc.groundoverlays && !!doc.groundoverlays.length) {
          var overlays = doc.groundoverlays;
          for (i = overlays.length; i--;) {
           if (!overlays[i].active) {
            overlays[i].remove();
            overlays.splice(i, 1);
           }
          }
          doc.groundoverlays = overlays;
	 }
	}
      }
      // Parse network links
      var networkLink;
      var docPath = document.location.pathname.split('/');
      docPath = docPath.splice(0, docPath.length - 1).join('/');
      var linkNodes = responseXML.getElementsByTagName('NetworkLink');
      for (i = 0; i < linkNodes.length; i++) {
        node = linkNodes[i];
        
        // Init the network link object
        networkLink = {
          name: geoXML3.nodeValue(node.getElementsByTagName('name')[0]),
          link: {
            href:        geoXML3.nodeValue(node.getElementsByTagName('href')[0]),
            refreshMode:     geoXML3.nodeValue(node.getElementsByTagName('refreshMode')[0])
          }
        };
        
        // Establish the specific refresh mode 
        if (networkLink.link.refreshMode === '') {
          networkLink.link.refreshMode = 'onChange';
        }
        if (networkLink.link.refreshMode === 'onInterval') {
          networkLink.link.refreshInterval = parseFloat(geoXML3.nodeValue(node.getElementsByTagName('refreshInterval')[0]));
          if (isNaN(networkLink.link.refreshInterval)) {
            networkLink.link.refreshInterval = 0;
          }
        } else if (networkLink.link.refreshMode === 'onChange') {
          networkLink.link.viewRefreshMode = geoXML3.nodeValue(node.getElementsByTagName('viewRefreshMode')[0]);
          if (networkLink.link.viewRefreshMode === '') {
            networkLink.link.viewRefreshMode = 'never';
          }
          if (networkLink.link.viewRefreshMode === 'onStop') {
            networkLink.link.viewRefreshTime = geoXML3.nodeValue(node.getElementsByTagName('refreshMode')[0]);
            networkLink.link.viewFormat =      geoXML3.nodeValue(node.getElementsByTagName('refreshMode')[0]);
            if (networkLink.link.viewFormat === '') {
              networkLink.link.viewFormat = 'BBOX=[bboxWest],[bboxSouth],[bboxEast],[bboxNorth]';
            }
          }
        }

        if (!/^[\/|http]/.test(networkLink.link.href)) {
          // Fully-qualify the HREF
          networkLink.link.href = docPath + '/' + networkLink.link.href;
        }

        // Apply the link
        if ((networkLink.link.refreshMode === 'onInterval') && 
            (networkLink.link.refreshInterval > 0)) {
          // Reload at regular intervals
          setInterval(parserName + '.parse("' + networkLink.link.href + '")', 
                      1000 * networkLink.link.refreshInterval); 
        } else if (networkLink.link.refreshMode === 'onChange') {
          if (networkLink.link.viewRefreshMode === 'never') {
            // Load the link just once
            doc.internals.parser.parse(networkLink.link.href, doc.internals.docSet);
          } else if (networkLink.link.viewRefreshMode === 'onStop') {
            // Reload when the map view changes
            
          }
        }
      }
}

      if (!!doc.bounds && !!window.google && !!google.maps) {
        doc.internals.bounds = doc.internals.bounds || new google.maps.LatLngBounds();
        doc.internals.bounds.union(doc.bounds); 
      }
      if (!!doc.markers || !!doc.groundoverlays || !!doc.gpolylines || !!doc.gpolygons) {
        doc.internals.parseOnly = false;
      }

      doc.internals.remaining -= 1;
      if (doc.internals.remaining === 0) {
        // We're done processing this set of KML documents
        // Options that get invoked after parsing completes
	  if (parserOptions.zoom && !!doc.internals.bounds &&
	      !doc.internals.bounds.isEmpty() && !!parserOptions.map) {
          parserOptions.map.fitBounds(doc.internals.bounds); 
        }
        if (parserOptions.afterParse) {
          parserOptions.afterParse(doc.internals.docSet);
        }

        if (!doc.internals.parseOnly) {
          // geoXML3 is not being used only as a real-time parser, so keep the processed documents around
            for (var i=0;i<doc.internals.docSet.length;i++) {
              docs.push(doc.internals.docSet[i]);
            }
        }
        google.maps.event.trigger(doc.internals.parser, 'parsed');   
      }
  };

  var kmlColor = function (kmlIn, colorMode) {
    var kmlColor = {};
    kmlIn = kmlIn || 'ffffffff';  // white (KML 2.2 default)

    var aa = kmlIn.substr(0,2);
    var bb = kmlIn.substr(2,2);
    var gg = kmlIn.substr(4,2);
    var rr = kmlIn.substr(6,2);

    kmlColor.opacity = parseInt(aa, 16) / 256;
    kmlColor.color   = (colorMode === 'random') ? randomColor(rr, gg, bb) : '#' + rr + gg + bb;
    return kmlColor;
  };

  // Implemented per KML 2.2 <ColorStyle> specs
  var randomColor = function(rr, gg, bb) {
    var col = { rr: rr, gg: gg, bb: bb };
    for (var k in col) {
      var v = col[k];
      if (v == null) v = 'ff';

      // RGB values are limiters for random numbers (ie: 7f would be a random value between 0 and 7f)
      v = Math.round(Math.random() * parseInt(rr, 16)).toString(16);
      if (v.length === 1) v = '0' + v;
      col[k] = v;
    }

    return '#' + col.rr + col.gg + col.bb;
  };

  var processStyleID = function (style) {
    if (!!window.google && !!google.maps) {
      var zeroPoint = new google.maps.Point(0,0);
      if (!!style.href) {
        var markerRegEx = /\/(red|blue|green|yellow|lightblue|purple|pink|orange|pause|go|stop)(-dot)?\.png/;
        if (markerRegEx.test(style.href)) {
         //bottom middle
	  var anchorPoint = new google.maps.Point(16*style.scale, 32*style.scale);
	} else {
	  var anchorPoint = new google.maps.Point(16*style.scale, 16*style.scale);
	}
        // Init the style object with a standard KML icon
        style.icon =  new google.maps.MarkerImage(
          style.href,
          new google.maps.Size(32*style.scale, 32*style.scale),
          zeroPoint,
          // bottom middle 
          anchorPoint,
          new google.maps.Size(32*style.scale, 32*style.scale)

        );

        // Look for a predictable shadow
        var stdRegEx = /\/(red|blue|green|yellow|lightblue|purple|pink|orange)(-dot)?\.png/;
        var shadowSize = new google.maps.Size(59, 32);
	var shadowPoint = new google.maps.Point(16,32);
        if (stdRegEx.test(style.href)) {
          // A standard GMap-style marker icon
          style.shadow = new google.maps.MarkerImage(
              'http://maps.google.com/mapfiles/ms/micons/msmarker.shadow.png',
              shadowSize,
              zeroPoint,
              shadowPoint,
              shadowSize);
        } else if (style.href.indexOf('-pushpin.png') > -1) {
          // Pushpin marker icon
          style.shadow = new google.maps.MarkerImage(
            'http://maps.google.com/mapfiles/ms/micons/pushpin_shadow.png',
            shadowSize,
            zeroPoint,
            shadowPoint,
            shadowSize);
        } else {
          // Other MyMaps KML standard icon
          style.shadow = new google.maps.MarkerImage(
            style.href.replace('.png', '.shadow.png'),	      		   
            shadowSize,	   					   
            zeroPoint,					
            shadowPoint,
            shadowSize);
        }
      }
    }
  }
    
  var processStyles = function (doc) {
    for (var styleID in doc.styles) {
      processStyleID(doc.styles[styleID]);
    }
  };

  var createMarker = function (placemark, doc) {
    // create a Marker to the map from a placemark KML object

    // Load basic marker properties
    var markerOptions = geoXML3.combineOptions(parserOptions.markerOptions, {
      map:      parserOptions.map,
      position: new google.maps.LatLng(placemark.Point.coordinates[0].lat, placemark.Point.coordinates[0].lng),
      title:    placemark.name,
      zIndex:   Math.round(placemark.Point.coordinates[0].lat * -100000)<<5,
      icon:     placemark.style.icon,
      shadow:   placemark.style.shadow 
    });
  
    // Create the marker on the map
    var marker = new google.maps.Marker(markerOptions);
    if (!!doc) {
      doc.markers.push(marker);
    }

    // Set up and create the infowindow if it is not suppressed
    if (!parserOptions.suppressInfoWindows) {
      var infoWindowOptions = geoXML3.combineOptions(parserOptions.infoWindowOptions, {
        content: '<div class="geoxml3_infowindow"><h3>' + placemark.name + 
                 '</h3><div>' + placemark.description + '</div></div>',
        pixelOffset: new google.maps.Size(0, 2)
      });
      if (parserOptions.infoWindow) {
        marker.infoWindow = parserOptions.infoWindow;
      } else {
        marker.infoWindow = new google.maps.InfoWindow(infoWindowOptions);
      }
      marker.infoWindowOptions = infoWindowOptions;
      
      // Infowindow-opening event handler
      google.maps.event.addListener(marker, 'click', function() {
        this.infoWindow.close();
        marker.infoWindow.setOptions(this.infoWindowOptions);
        this.infoWindow.open(this.map, this);
      });
    }
    placemark.marker = marker;
    return marker;
  };
  
  var createOverlay = function (groundOverlay, doc) {
    // Add a ProjectedOverlay to the map from a groundOverlay KML object

    if (!window.ProjectedOverlay) {
      throw 'geoXML3 error: ProjectedOverlay not found while rendering GroundOverlay from KML';
    }

    var bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(groundOverlay.latLonBox.south, groundOverlay.latLonBox.west),
        new google.maps.LatLng(groundOverlay.latLonBox.north, groundOverlay.latLonBox.east)
    );
    var overlayOptions = geoXML3.combineOptions(parserOptions.overlayOptions, {percentOpacity: groundOverlay.opacity*100});
    var overlay = new ProjectedOverlay(parserOptions.map, groundOverlay.icon.href, bounds, overlayOptions);
    
    if (!!doc) {
      doc.ggroundoverlays = doc.ggroundoverlays || [];
      doc.ggroundoverlays.push(overlay);
    }

    return overlay;
  };

// Create Polyline
var createPolyline = function(placemark, doc) {
  var paths = [];
  var bounds = new google.maps.LatLngBounds();
  for (var j=0; j<placemark.LineString.length; j++) {
    var path = [];
    var coords = placemark.LineString[j].coordinates;
    for (var i=0;i<coords.length;i++) {
      var pt = new google.maps.LatLng(coords[i].lat, coords[i].lng);
      path.push(pt);
      bounds.extend(pt);
    }
    paths.push(path);
  }
    
  // point to open the infowindow if triggered 
  var point = paths[0][Math.floor(path.length/2)];
  // Load basic polyline properties
  var kmlStrokeColor = kmlColor(placemark.style.color,placemark.style.colorMode);
  var polyOptions = geoXML3.combineOptions(parserOptions.polylineOptions, {
    map:      parserOptions.map,
    strokeColor: kmlStrokeColor.color,
    strokeWeight: placemark.style.width,
    strokeOpacity: kmlStrokeColor.opacity,
    title:    placemark.name
  });
  if (paths.length > 1) {
    polyOptions.paths = paths;
    var p = new MultiGeometry(polyOptions);
  } else {
    polyOptions.path = paths[0];
    var p = new google.maps.Polyline(polyOptions);
  }
  p.bounds = bounds;
  // setup and create the infoWindow if it is not suppressed
  if (!parserOptions.suppressInfoWindows) {
    var infoWindowOptions = geoXML3.combineOptions(parserOptions.infoWindowOptions, {
      content: '<div class="geoxml3_infowindow"><h3>' + placemark.name + 
               '</h3><div>' + placemark.description + '</div></div>',
      pixelOffset: new google.maps.Size(0, 2)
    });
    if (parserOptions.infoWindow) {
      p.infoWindow = parserOptions.infoWindow;
    } else {
      p.infoWindow = new google.maps.InfoWindow(infoWindowOptions);
    }
    p.infoWindowOptions = infoWindowOptions;
    // Infowindow-opening event handler
    google.maps.event.addListener(p, 'click', function(e) {
      p.infoWindow.close();
      p.infoWindow.setOptions(p.infoWindowOptions);
      if (e && e.latLng) {
        p.infoWindow.setPosition(e.latLng);
      } else {
        p.infoWindow.setPosition(point);
      }
      p.infoWindow.open(p.map || p.polylines[0].map);
    });
  }
  if (!!doc) doc.gpolylines.push(p);
  placemark.polyline = p;
  return p;
}

// Create Polygon
var createPolygon = function(placemark, doc) {
  var bounds = new google.maps.LatLngBounds();
  var pathsLength = 0;
  var paths = [];
  for (var polygonPart=0;polygonPart<placemark.Polygon.length;polygonPart++) {
    for (var j=0; j<placemark.Polygon[polygonPart].outerBoundaryIs.length; j++) {
      var coords = placemark.Polygon[polygonPart].outerBoundaryIs[j].coordinates;
      var path = [];
      for (var i=0;i<coords.length;i++) {
        var pt = new google.maps.LatLng(coords[i].lat, coords[i].lng);
        path.push(pt);
        bounds.extend(pt);
      }
      paths.push(path);
      pathsLength += path.length;
    }
    for (var j=0; j<placemark.Polygon[polygonPart].innerBoundaryIs.length; j++) {
      var coords = placemark.Polygon[polygonPart].innerBoundaryIs[j].coordinates;
      var path = [];
      for (var i=0;i<coords.length;i++) {
        var pt = new google.maps.LatLng(coords[i].lat, coords[i].lng);
        path.push(pt);
        bounds.extend(pt);
      }
      paths.push(path);
      pathsLength += path.length;
    }
  }

  // Load basic polygon properties
  var kmlStrokeColor = kmlColor(placemark.style.color,placemark.style.colorMode);
  var kmlFillColor = kmlColor(placemark.style.fillcolor,placemark.style.colorMode);
  if (!placemark.style.fill) kmlFillColor.opacity = 0.0;
  var strokeWeight = placemark.style.width;
  if (!placemark.style.outline) {
    strokeWeight = 0;
    kmlStrokeColor.opacity = 0.0;
  }
  var polyOptions = geoXML3.combineOptions(parserOptions.polygonOptions, {
    map:      parserOptions.map,
    paths:    paths,
    title:    placemark.name,
    strokeColor: kmlStrokeColor.color,
    strokeWeight: strokeWeight,
    strokeOpacity: kmlStrokeColor.opacity,
    fillColor: kmlFillColor.color,
    fillOpacity: kmlFillColor.opacity
  });
  var p = new google.maps.Polygon(polyOptions);
  p.bounds = bounds;
  if (!parserOptions.suppressInfoWindows) {
    var infoWindowOptions = geoXML3.combineOptions(parserOptions.infoWindowOptions, {
      content: '<div class="geoxml3_infowindow"><h3>' + placemark.name + 
               '</h3><div>' + placemark.description + '</div></div>',
      pixelOffset: new google.maps.Size(0, 2)
    });
    if (parserOptions.infoWindow) {
      p.infoWindow = parserOptions.infoWindow;
    } else {
      p.infoWindow = new google.maps.InfoWindow(infoWindowOptions);
    }
    p.infoWindowOptions = infoWindowOptions;
    // Infowindow-opening event handler
    google.maps.event.addListener(p, 'click', function(e) {
      p.infoWindow.close();
      p.infoWindow.setOptions(p.infoWindowOptions);
      if (e && e.latLng) {
        p.infoWindow.setPosition(e.latLng);
      } else {
        p.infoWindow.setPosition(p.bounds.getCenter());
      }
      p.infoWindow.open(this.map);
    });
  }
  if (!!doc) doc.gpolygons.push(p);
  placemark.polygon = p;
  return p;
}

  return {
    // Expose some properties and methods

    options: parserOptions,
    docs:    docs,
    
    parse:          parse,
    render:         render,
    parseKmlString: parseKmlString,
    hideDocument:   hideDocument,
    showDocument:   showDocument,
    removeDocument: removeDocument,
    processStyles:  processStyles, 
    createMarker:   createMarker,
    createOverlay:  createOverlay,
    createPolyline: createPolyline,
    createPolygon:  createPolygon
  };
};
// End of KML Parser

// Helper objects and functions
geoXML3.getOpacity = function (kmlColor) {
  // Extract opacity encoded in a KML color value. Returns a number between 0 and 1.
  if (!!kmlColor &&
      (kmlColor !== '') &&
      (kmlColor.length == 8)) {
    var transparency = parseInt(kmlColor.substr(0, 2), 16);
    return transparency / 255;
  } else {
    return 1;
  }
};

// Log a message to the debugging console, if one exists
geoXML3.log = function(msg) {
  if (!!window.console) {
    console.log(msg);
  } else { alert("log:"+msg); }
};

// Combine two options objects: a set of default values and a set of override values 
geoXML3.combineOptions = function (overrides, defaults) {
  var result = {};
  if (!!overrides) {
    for (var prop in overrides) {
      if (overrides.hasOwnProperty(prop)) {
        result[prop] = overrides[prop];
      }
    }
  }
  if (!!defaults) {
    for (prop in defaults) {
      if (defaults.hasOwnProperty(prop) && (result[prop] === undefined)) {
        result[prop] = defaults[prop];
      }
    }
  }
  return result;
};

// Retrieve an XML document from url and pass it to callback as a DOM document
geoXML3.fetchers = [];

// parse text to XML doc
/**
 * Parses the given XML string and returns the parsed document in a
 * DOM data structure. This function will return an empty DOM node if
 * XML parsing is not supported in this browser.
 * @param {string} str XML string.
 * @return {Element|Document} DOM.
 */
geoXML3.xmlParse = function (str) {
  if (typeof ActiveXObject != 'undefined' && typeof GetObject != 'undefined') {
    var doc = new ActiveXObject('Microsoft.XMLDOM');
    doc.loadXML(str);
    return doc;
  }

  if (typeof DOMParser != 'undefined') {
    return (new DOMParser()).parseFromString(str, 'text/xml');
  }

  return createElement('div', null);
}

geoXML3.fetchXML = function (url, callback) {
  function timeoutHandler() {
    geoXML3.log('XHR timeout');
    callback();
  };

  var xhrFetcher = new Object();
  if (!!geoXML3.fetchers.length) {
    xhrFetcher = geoXML3.fetchers.pop();
  } else {
    if (!!window.XMLHttpRequest) {
      xhrFetcher.fetcher = new window.XMLHttpRequest(); // Most browsers
    } else if (!!window.ActiveXObject) {
      xhrFetcher.fetcher = new window.ActiveXObject('Microsoft.XMLHTTP'); // Some IE
    }
  }

  if (!xhrFetcher.fetcher) {
    geoXML3.log('Unable to create XHR object');
    callback(null);
  } else {
      xhrFetcher.fetcher.open('GET', url, true);
      if (xhrFetcher.fetcher.overrideMimeType) {
        xhrFetcher.fetcher.overrideMimeType('text/xml');
      }
      xhrFetcher.fetcher.onreadystatechange = function () {
      if (xhrFetcher.fetcher.readyState === 4) {
        // Retrieval complete
        if (!!xhrFetcher.xhrtimeout)
          clearTimeout(xhrFetcher.xhrtimeout);
        if (xhrFetcher.fetcher.status >= 400) {
          geoXML3.log('HTTP error ' + xhrFetcher.fetcher.status + ' retrieving ' + url);
          callback();
        } else {
          // Returned successfully
          var xml = geoXML3.xmlParse(xhrFetcher.fetcher.responseText);
          if (xml.parseError && (xml.parseError.errorCode != 0)) {
           geoXML3.log("XML parse error "+xml.parseError.errorCode+", "+xml.parseError.reason+"\nLine:"+xml.parseError.line+", Position:"+xml.parseError.linepos+", srcText:"+xml.parseError.srcText);
          }
          callback(xml);
        }
        // We're done with this fetcher object
        geoXML3.fetchers.push(xhrFetcher);
      }
    };
    xhrFetcher.xhrtimeout = setTimeout(timeoutHandler, geoXML3.xhrTimeout);
    xhrFetcher.fetcher.send(null);
  }
};

//nodeValue: Extract the text value of a DOM node, with leading and trailing whitespace trimmed
geoXML3.nodeValue = function(node, defVal) {
  var retStr="";
  if (!node) {
    return (typeof defVal === 'undefined' || defVal === null) ? '' : defVal;
  }
   if(node.nodeType==3||node.nodeType==4||node.nodeType==2){
      retStr+=node.nodeValue;
   }else if(node.nodeType==1||node.nodeType==9||node.nodeType==11){
      for(var i=0;i<node.childNodes.length;++i){
         retStr+=arguments.callee(node.childNodes[i]);
      }
   }
   return retStr;
};

/*!
 * fancyBox - jQuery Plugin
 * 
 * Modified by Jordan Yim 8/10/16
 * 
 * version: 2.1.5 (Fri, 14 Jun 2013)
 * @requires jQuery v1.6 or later
 *
 * Examples at http://fancyapps.com/fancybox/
 * License: www.fancyapps.com/fancybox/#license
 *
 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
 *
 */

(function (window, document, $, undefined) {
	"use strict";

	var H = $("html"),
		W = $(window),
		D = $(document),
		F = $.fancybox = function () {
			F.open.apply( this, arguments );
		},
		IE =  navigator.userAgent.match(/msie/i),
		didUpdate	= null,
		isTouch		= document.createTouch !== undefined,

		isQuery	= function(obj) {
			return obj && obj.hasOwnProperty && obj instanceof $;
		},
		isString = function(str) {
			return str && $.type(str) === "string";
		},
		isPercentage = function(str) {
			return isString(str) && str.indexOf('%') > 0;
		},
		isScrollable = function(el) {
			return (el && !(el.style.overflow && el.style.overflow === 'hidden') && ((el.clientWidth && el.scrollWidth > el.clientWidth) || (el.clientHeight && el.scrollHeight > el.clientHeight)));
		},
		getScalar = function(orig, dim) {
			var value = parseInt(orig, 10) || 0;

			if (dim && isPercentage(orig)) {
				value = F.getViewport()[ dim ] / 100 * value;
			}

			return Math.ceil(value);
		},
		getValue = function(value, dim) {
			return getScalar(value, dim) + 'px';
		};

	$.extend(F, {
		// The current version of fancyBox
		version: '2.1.5',

		defaults: {
			padding : 15,
			margin  : 20,

			width     : 800,
			height    : 600,
			minWidth  : 100,
			minHeight : 100,
			maxWidth  : 9999,
			maxHeight : 9999,
			pixelRatio: 1, // Set to 2 for retina display support

			autoSize   : true,
			autoHeight : false,
			autoWidth  : false,

			autoResize  : true,
			autoCenter  : !isTouch,
			fitToView   : true,
			aspectRatio : false,
			topRatio    : 0.5,
			leftRatio   : 0.5,

			scrolling : 'auto', // 'auto', 'yes' or 'no'
			wrapCSS   : '',

			arrows     : true,
			closeBtn   : true,
			closeClick : false,
			nextClick  : false,
			mouseWheel : true,
			autoPlay   : false,
			playSpeed  : 3000,
			preload    : 3,
			modal      : false,
			loop       : true,

			ajax  : {
				dataType : 'html',
				headers  : { 'X-fancyBox': true }
			},
			iframe : {
				scrolling : 'auto',
				preload   : true
			},
			swf : {
				wmode: 'transparent',
				allowfullscreen   : 'true',
				allowscriptaccess : 'always'
			},

			keys  : {
				next : {
					13 : 'left', // enter
					34 : 'up',   // page down
					39 : 'left', // right arrow
					40 : 'up'    // down arrow
				},
				prev : {
					8  : 'right',  // backspace
					33 : 'down',   // page up
					37 : 'right',  // left arrow
					38 : 'down'    // up arrow
				},
				close  : [27], // escape key
				play   : [32], // space - start/stop slideshow
				toggle : [70]  // letter "f" - toggle fullscreen
			},

			direction : {
				next : 'left',
				prev : 'right'
			},

			scrollOutside  : true,

			// Override some properties
			index   : 0,
			type    : null,
			href    : null,
			content : null,
			title   : null,

			// HTML templates
			tpl: {
				wrap     : '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
				image    : '<img class="fancybox-image" src="{href}" alt="" />',
				iframe   : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (IE ? ' allowtransparency="true"' : '') + '></iframe>',
				error    : '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
				closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
				next     : '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
				prev     : '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
			},

			// Properties for each animation type
			// Opening fancyBox
			openEffect  : 'fade', // 'elastic', 'fade' or 'none'
			openSpeed   : 250,
			openEasing  : 'swing',
			openOpacity : true,
			openMethod  : 'zoomIn',

			// Closing fancyBox
			closeEffect  : 'fade', // 'elastic', 'fade' or 'none'
			closeSpeed   : 250,
			closeEasing  : 'swing',
			closeOpacity : true,
			closeMethod  : 'zoomOut',

			// Changing next gallery item
			nextEffect : 'elastic', // 'elastic', 'fade' or 'none'
			nextSpeed  : 250,
			nextEasing : 'swing',
			nextMethod : 'changeIn',

			// Changing previous gallery item
			prevEffect : 'elastic', // 'elastic', 'fade' or 'none'
			prevSpeed  : 250,
			prevEasing : 'swing',
			prevMethod : 'changeOut',

			// Enable default helpers
			helpers : {
				overlay : true,
				title   : true
			},

			// Callbacks
			onCancel     : $.noop, // If canceling
			beforeLoad   : $.noop, // Before loading
			afterLoad    : $.noop, // After loading
			beforeShow   : $.noop, // Before changing in current item
			afterShow    : $.noop, // After opening
			beforeChange : $.noop, // Before changing gallery item
			beforeClose  : $.noop, // Before closing
			afterClose   : $.noop  // After closing
		},

		//Current state
		group    : {}, // Selected group
		opts     : {}, // Group options
		previous : null,  // Previous element
		coming   : null,  // Element being loaded
		current  : null,  // Currently loaded element
		isActive : false, // Is activated
		isOpen   : false, // Is currently open
		isOpened : false, // Have been fully opened at least once

		wrap  : null,
		skin  : null,
		outer : null,
		inner : null,

		player : {
			timer    : null,
			isActive : false
		},

		// Loaders
		ajaxLoad   : null,
		imgPreload : null,

		// Some collections
		transitions : {},
		helpers     : {},

		/*
		 *	Static methods
		 */

		open: function (group, opts) {
			if (!group) {
				return;
			}

			if (!$.isPlainObject(opts)) {
				opts = {};
			}

			// Close if already active
			if (false === F.close(true)) {
				return;
			}

			// Normalize group
			if (!$.isArray(group)) {
				group = isQuery(group) ? $(group).get() : [group];
			}

			// Recheck if the type of each element is `object` and set content type (image, ajax, etc)
			$.each(group, function(i, element) {
				var obj = {},
					href,
					title,
					content,
					type,
					rez,
					hrefParts,
					selector;

				if ($.type(element) === "object") {
					// Check if is DOM element
					if (element.nodeType) {
						element = $(element);
					}

					if (isQuery(element)) {
						obj = {
							href    : element.data('fancybox-href') || element.attr('href'),
							title   : element.data('fancybox-title') || element.attr('title'),
							isDom   : true,
							element : element
						};

						if ($.metadata) {
							$.extend(true, obj, element.metadata());
						}

					} else {
						obj = element;
					}
				}

				href  = opts.href  || obj.href || (isString(element) ? element : null);
				title = opts.title !== undefined ? opts.title : obj.title || '';

				content = opts.content || obj.content;
				type    = content ? 'html' : (opts.type  || obj.type);

				if (!type && obj.isDom) {
					type = element.data('fancybox-type');

					if (!type) {
						rez  = element.prop('class').match(/fancybox\.(\w+)/);
						type = rez ? rez[1] : null;
					}
				}

				if (isString(href)) {
					// Try to guess the content type
					if (!type) {
						if (F.isImage(href)) {
							type = 'image';

						} else if (F.isSWF(href)) {
							type = 'swf';

						} else if (href.charAt(0) === '#') {
							type = 'inline';

						} else if (isString(element)) {
							type    = 'html';
							content = element;
						}
					}

					// Split url into two pieces with source url and content selector, e.g,
					// "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
					if (type === 'ajax') {
						hrefParts = href.split(/\s+/, 2);
						href      = hrefParts.shift();
						selector  = hrefParts.shift();
					}
				}

				if (!content) {
					if (type === 'inline') {
						if (href) {
							content = $( isString(href) ? href.replace(/.*(?=#[^\s]+$)/, '') : href ); //strip for ie7

						} else if (obj.isDom) {
							content = element;
						}

					} else if (type === 'html') {
						content = href;

					} else if (!type && !href && obj.isDom) {
						type    = 'inline';
						content = element;
					}
				}

				$.extend(obj, {
					href     : href,
					type     : type,
					content  : content,
					title    : title,
					selector : selector
				});

				group[ i ] = obj;
			});

			// Extend the defaults
			F.opts = $.extend(true, {}, F.defaults, opts);

			// All options are merged recursive except keys
			if (opts.keys !== undefined) {
				F.opts.keys = opts.keys ? $.extend({}, F.defaults.keys, opts.keys) : false;
			}

			F.group = group;

			return F._start(F.opts.index);
		},

		// Cancel image loading or abort ajax request
		cancel: function () {
			var coming = F.coming;

			if (!coming || false === F.trigger('onCancel')) {
				return;
			}

			F.hideLoading();

			if (F.ajaxLoad) {
				F.ajaxLoad.abort();
			}

			F.ajaxLoad = null;

			if (F.imgPreload) {
				F.imgPreload.onload = F.imgPreload.onerror = null;
			}

			if (coming.wrap) {
				coming.wrap.stop(true, true).trigger('onReset').remove();
			}

			F.coming = null;

			// If the first item has been canceled, then clear everything
			if (!F.current) {
				F._afterZoomOut( coming );
			}
		},

		// Start closing animation if is open; remove immediately if opening/closing
		close: function (event) {
			F.cancel();

			if (false === F.trigger('beforeClose')) {
				return;
			}

			F.unbindEvents();

			if (!F.isActive) {
				return;
			}

			if (!F.isOpen || event === true) {
				$('.fancybox-wrap').stop(true).trigger('onReset').remove();

				F._afterZoomOut();

			} else {
				F.isOpen = F.isOpened = false;
				F.isClosing = true;

				$('.fancybox-item, .fancybox-nav').remove();

				F.wrap.stop(true, true).removeClass('fancybox-opened');

				F.transitions[ F.current.closeMethod ]();
			}
		},

		// Manage slideshow:
		//   $.fancybox.play(); - toggle slideshow
		//   $.fancybox.play( true ); - start
		//   $.fancybox.play( false ); - stop
		play: function ( action ) {
			var clear = function () {
					clearTimeout(F.player.timer);
				},
				set = function () {
					clear();

					if (F.current && F.player.isActive) {
						F.player.timer = setTimeout(F.next, F.current.playSpeed);
					}
				},
				stop = function () {
					clear();

					D.unbind('.player');

					F.player.isActive = false;

					F.trigger('onPlayEnd');
				},
				start = function () {
					if (F.current && (F.current.loop || F.current.index < F.group.length - 1)) {
						F.player.isActive = true;

						D.bind({
							'onCancel.player beforeClose.player' : stop,
							'onUpdate.player'   : set,
							'beforeLoad.player' : clear
						});

						set();

						F.trigger('onPlayStart');
					}
				};

			if (action === true || (!F.player.isActive && action !== false)) {
				start();
			} else {
				stop();
			}
		},

		// Navigate to next gallery item
		next: function ( direction ) {
			F.trigger("onNext");
			var current = F.current;

			if (current) {
				if (!isString(direction)) {
					direction = current.direction.next;
				}

				F.jumpto(current.index + 1, direction, 'next');
			}
		},

		// Navigate to previous gallery item
		prev: function ( direction ) {
			F.trigger("onPrev");
			var current = F.current;

			if (current) {
				if (!isString(direction)) {
					direction = current.direction.prev;
				}

				F.jumpto(current.index - 1, direction, 'prev');
			}
		},

		// Navigate to gallery item by index
		jumpto: function ( index, direction, router ) {
			var current = F.current;

			if (!current) {
				return;
			}

			index = getScalar(index);

			F.direction = direction || current.direction[ (index >= current.index ? 'next' : 'prev') ];
			F.router    = router || 'jumpto';

			if (current.loop) {
				if (index < 0) {
					index = current.group.length + (index % current.group.length);
				}

				index = index % current.group.length;
			}

			if (current.group[ index ] !== undefined) {
				F.cancel();

				F._start(index);
			}
		},

		// Center inside viewport and toggle position type to fixed or absolute if needed
		reposition: function (e, onlyAbsolute) {
			var current = F.current,
				wrap    = current ? current.wrap : null,
				pos;

			if (wrap) {
				pos = F._getPosition(onlyAbsolute);

				if (e && e.type === 'scroll') {
					delete pos.position;

					wrap.stop(true, true).animate(pos, 200);

				} else {
					wrap.css(pos);

					current.pos = $.extend({}, current.dim, pos);
				}
			}
		},

		update: function (e) {
			var type = (e && e.type),
				anyway = !type || type === 'orientationchange';

			if (anyway) {
				clearTimeout(didUpdate);

				didUpdate = null;
			}

			if (!F.isOpen || didUpdate) {
				return;
			}

			didUpdate = setTimeout(function() {
				var current = F.current;

				if (!current || F.isClosing) {
					return;
				}

				F.wrap.removeClass('fancybox-tmp');

				if (anyway || type === 'load' || (type === 'resize' && current.autoResize)) {
					F._setDimension();
				}

				if (!(type === 'scroll' && current.canShrink)) {
					F.reposition(e);
				}

				F.trigger('onUpdate');

				didUpdate = null;

			}, (anyway && !isTouch ? 0 : 300));
		},

		// Shrink content to fit inside viewport or restore if resized
		toggle: function ( action ) {
			if (F.isOpen) {
				F.current.fitToView = $.type(action) === "boolean" ? action : !F.current.fitToView;

				// Help browser to restore document dimensions
				if (isTouch) {
					F.wrap.removeAttr('style').addClass('fancybox-tmp');

					F.trigger('onUpdate');
				}

				F.update();
			}
		},

		hideLoading: function () {
			D.unbind('.loading');

			$('#fancybox-loading').remove();
		},

		showLoading: function () {
			var el, viewport;

			F.hideLoading();

			el = $('<div id="fancybox-loading"><div></div></div>').click(F.cancel).appendTo('body');

			// If user will press the escape-button, the request will be canceled
			D.bind('keydown.loading', function(e) {
				if ((e.which || e.keyCode) === 27) {
					e.preventDefault();

					F.cancel();
				}
			});

			if (!F.defaults.fixed) {
				viewport = F.getViewport();

				el.css({
					position : 'absolute',
					top  : (viewport.h * 0.5) + viewport.y,
					left : (viewport.w * 0.5) + viewport.x
				});
			}
		},

		getViewport: function () {
			var locked = (F.current && F.current.locked) || false,
				rez    = {
					x: W.scrollLeft(),
					y: W.scrollTop()
				};

			if (locked) {
				rez.w = locked[0].clientWidth;
				rez.h = locked[0].clientHeight;

			} else {
				// See http://bugs.jquery.com/ticket/6724
				rez.w = isTouch && window.innerWidth  ? window.innerWidth  : W.width();
				rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height();
			}

			return rez;
		},

		// Unbind the keyboard / clicking actions
		unbindEvents: function () {
			if (F.wrap && isQuery(F.wrap)) {
				F.wrap.unbind('.fb');
			}

			D.unbind('.fb');
			W.unbind('.fb');
		},

		bindEvents: function () {
			var current = F.current,
				keys;

			if (!current) {
				return;
			}

			// Changing document height on iOS devices triggers a 'resize' event,
			// that can change document height... repeating infinitely
			W.bind('orientationchange.fb' + (isTouch ? '' : ' resize.fb') + (current.autoCenter && !current.locked ? ' scroll.fb' : ''), F.update);

			keys = current.keys;

			if (keys) {
				D.bind('keydown.fb', function (e) {
					var code   = e.which || e.keyCode,
						target = e.target || e.srcElement;

					// Skip esc key if loading, because showLoading will cancel preloading
					if (code === 27 && F.coming) {
						return false;
					}

					// Ignore key combinations and key events within form elements
					if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || $(target).is('[contenteditable]')))) {
						$.each(keys, function(i, val) {
							if (current.group.length > 1 && val[ code ] !== undefined) {
								F[ i ]( val[ code ] );

								e.preventDefault();
								return false;
							}

							if ($.inArray(code, val) > -1) {
								F[ i ] ();

								e.preventDefault();
								return false;
							}
						});
					}
				});
			}

			if ($.fn.mousewheel && current.mouseWheel) {
				F.wrap.bind('mousewheel.fb', function (e, delta, deltaX, deltaY) {
					var target = e.target || null,
						parent = $(target),
						canScroll = false;

					while (parent.length) {
						if (canScroll || parent.is('.fancybox-skin') || parent.is('.fancybox-wrap')) {
							break;
						}

						canScroll = isScrollable( parent[0] );
						parent    = $(parent).parent();
					}

					if (delta !== 0 && !canScroll) {
						if (F.group.length > 1 && !current.canShrink) {
							if (deltaY > 0 || deltaX > 0) {
								F.prev( deltaY > 0 ? 'down' : 'left' );

							} else if (deltaY < 0 || deltaX < 0) {
								F.next( deltaY < 0 ? 'up' : 'right' );
							}

							e.preventDefault();
						}
					}
				});
			}
		},

		trigger: function (event, o) {
			var ret, obj = o || F.coming || F.current;

			if (!obj) {
				return;
			}

			if ($.isFunction( obj[event] )) {
				ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1));
			}

			if (ret === false) {
				return false;
			}

			if (obj.helpers) {
				$.each(obj.helpers, function (helper, opts) {
					if (opts && F.helpers[helper] && $.isFunction(F.helpers[helper][event])) {
						F.helpers[helper][event]($.extend(true, {}, F.helpers[helper].defaults, opts), obj);
					}
				});
			}

			D.trigger(event);
		},

		isImage: function (str) {
			return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
		},

		isSWF: function (str) {
			return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i);
		},

		_start: function (index) {
			var coming = {},
				obj,
				href,
				type,
				margin,
				padding;

			index = getScalar( index );
			obj   = F.group[ index ] || null;

			if (!obj) {
				return false;
			}

			coming = $.extend(true, {}, F.opts, obj);

			// Convert margin and padding properties to array - top, right, bottom, left
			margin  = coming.margin;
			padding = coming.padding;

			if ($.type(margin) === 'number') {
				coming.margin = [margin, margin, margin, margin];
			}

			if ($.type(padding) === 'number') {
				coming.padding = [padding, padding, padding, padding];
			}

			// 'modal' propery is just a shortcut
			if (coming.modal) {
				$.extend(true, coming, {
					closeBtn   : false,
					closeClick : false,
					nextClick  : false,
					arrows     : false,
					mouseWheel : false,
					keys       : null,
					helpers: {
						overlay : {
							closeClick : false
						}
					}
				});
			}

			// 'autoSize' property is a shortcut, too
			if (coming.autoSize) {
				coming.autoWidth = coming.autoHeight = true;
			}

			if (coming.width === 'auto') {
				coming.autoWidth = true;
			}

			if (coming.height === 'auto') {
				coming.autoHeight = true;
			}

			/*
			 * Add reference to the group, so it`s possible to access from callbacks, example:
			 * afterLoad : function() {
			 *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
			 * }
			 */

			coming.group  = F.group;
			coming.index  = index;

			// Give a chance for callback or helpers to update coming item (type, title, etc)
			F.coming = coming;

			if (false === F.trigger('beforeLoad')) {
				F.coming = null;

				return;
			}

			type = coming.type;
			href = coming.href;

			if (!type) {
				F.coming = null;

				//If we can not determine content type then drop silently or display next/prev item if looping through gallery
				if (F.current && F.router && F.router !== 'jumpto') {
					F.current.index = index;

					return F[ F.router ]( F.direction );
				}

				return false;
			}

			F.isActive = true;

			if (type === 'image' || type === 'swf') {
				coming.autoHeight = coming.autoWidth = false;
				coming.scrolling  = 'visible';
			}

			if (type === 'image') {
				coming.aspectRatio = true;
			}

			if (type === 'iframe' && isTouch) {
				coming.scrolling = 'scroll';
			}

			// Build the neccessary markup
			coming.wrap = $(coming.tpl.wrap).addClass('fancybox-' + (isTouch ? 'mobile' : 'desktop') + ' fancybox-type-' + type + ' fancybox-tmp ' + coming.wrapCSS).appendTo( coming.parent || 'body' );

			$.extend(coming, {
				skin  : $('.fancybox-skin',  coming.wrap),
				outer : $('.fancybox-outer', coming.wrap),
				inner : $('.fancybox-inner', coming.wrap)
			});

			$.each(["Top", "Right", "Bottom", "Left"], function(i, v) {
				coming.skin.css('padding' + v, getValue(coming.padding[ i ]));
			});

			F.trigger('onReady');

			// Check before try to load; 'inline' and 'html' types need content, others - href
			if (type === 'inline' || type === 'html') {
				if (!coming.content || !coming.content.length) {
					return F._error( 'content' );
				}

			} else if (!href) {
				return F._error( 'href' );
			}

			if (type === 'image') {
				F._loadImage();

			} else if (type === 'ajax') {
				F._loadAjax();

			} else if (type === 'iframe') {
				F._loadIframe();

			} else {
				F._afterLoad();
			}
		},

		_error: function ( type ) {
			$.extend(F.coming, {
				type       : 'html',
				autoWidth  : true,
				autoHeight : true,
				minWidth   : 0,
				minHeight  : 0,
				scrolling  : 'no',
				hasError   : type,
				content    : F.coming.tpl.error
			});

			F._afterLoad();
		},

		_loadImage: function () {
			// Reset preload image so it is later possible to check "complete" property
			var img = F.imgPreload = new Image();

			img.onload = function () {
				this.onload = this.onerror = null;

				F.coming.width  = this.width / F.opts.pixelRatio;
				F.coming.height = this.height / F.opts.pixelRatio;

				F._afterLoad();
			};

			img.onerror = function () {
				this.onload = this.onerror = null;

				F._error( 'image' );
			};

			img.src = F.coming.href;

			if (img.complete !== true) {
				F.showLoading();
			}
		},

		_loadAjax: function () {
			var coming = F.coming;

			F.showLoading();

			F.ajaxLoad = $.ajax($.extend({}, coming.ajax, {
				url: coming.href,
				error: function (jqXHR, textStatus) {
					if (F.coming && textStatus !== 'abort') {
						F._error( 'ajax', jqXHR );

					} else {
						F.hideLoading();
					}
				},
				success: function (data, textStatus) {
					if (textStatus === 'success') {
						coming.content = data;

						F._afterLoad();
					}
				}
			}));
		},

		_loadIframe: function() {
			var coming = F.coming,
				iframe = $(coming.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
					.attr('scrolling', isTouch ? 'auto' : coming.iframe.scrolling)
					.attr('src', coming.href);

			// This helps IE
			$(coming.wrap).bind('onReset', function () {
				try {
					$(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
				} catch (e) {}
			});

			if (coming.iframe.preload) {
				F.showLoading();

				iframe.one('load', function() {
					$(this).data('ready', 1);

					// iOS will lose scrolling if we resize
					if (!isTouch) {
						$(this).bind('load.fb', F.update);
					}

					// Without this trick:
					//   - iframe won't scroll on iOS devices
					//   - IE7 sometimes displays empty iframe
					$(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();

					F._afterLoad();
				});
			}

			coming.content = iframe.appendTo( coming.inner );

			if (!coming.iframe.preload) {
				F._afterLoad();
			}
		},

		_preloadImages: function() {
			var group   = F.group,
				current = F.current,
				len     = group.length,
				cnt     = current.preload ? Math.min(current.preload, len - 1) : 0,
				item,
				i;

			for (i = 1; i <= cnt; i += 1) {
				item = group[ (current.index + i ) % len ];

				if (item.type === 'image' && item.href) {
					new Image().src = item.href;
				}
			}
		},

		_afterLoad: function () {
			var coming   = F.coming,
				previous = F.current,
				placeholder = 'fancybox-placeholder',
				current,
				content,
				type,
				scrolling,
				href,
				embed;

			F.hideLoading();

			if (!coming || F.isActive === false) {
				return;
			}

			if (false === F.trigger('afterLoad', coming, previous)) {
				coming.wrap.stop(true).trigger('onReset').remove();

				F.coming = null;

				return;
			}

			if (previous) {
				F.trigger('beforeChange', previous);

				previous.wrap.stop(true).removeClass('fancybox-opened')
					.find('.fancybox-item, .fancybox-nav')
					.remove();
			}

			F.unbindEvents();

			current   = coming;
			content   = coming.content;
			type      = coming.type;
			scrolling = coming.scrolling;

			$.extend(F, {
				wrap  : current.wrap,
				skin  : current.skin,
				outer : current.outer,
				inner : current.inner,
				current  : current,
				previous : previous
			});

			href = current.href;

			switch (type) {
				case 'inline':
				case 'ajax':
				case 'html':
					if (current.selector) {
						content = $('<div>').html(content).find(current.selector);

					} else if (isQuery(content)) {
						if (!content.data(placeholder)) {
							content.data(placeholder, $('<div class="' + placeholder + '"></div>').insertAfter( content ).hide() );
						}

						content = content.show().detach();

						current.wrap.bind('onReset', function () {
							if ($(this).find(content).length) {
								content.hide().replaceAll( content.data(placeholder) ).data(placeholder, false);
							}
						});
					}
				break;

				case 'image':
					content = current.tpl.image.replace('{href}', href);
				break;

				case 'swf':
					content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
					embed   = '';

					$.each(current.swf, function(name, val) {
						content += '<param name="' + name + '" value="' + val + '"></param>';
						embed   += ' ' + name + '="' + val + '"';
					});

					content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + '></embed></object>';
				break;
			}

			if (!(isQuery(content) && content.parent().is(current.inner))) {
				current.inner.append( content );
			}

			// Give a chance for helpers or callbacks to update elements
			F.trigger('beforeShow');

			// Set scrolling before calculating dimensions
			current.inner.css('overflow', scrolling === 'yes' ? 'scroll' : (scrolling === 'no' ? 'hidden' : scrolling));

			// Set initial dimensions and start position
			F._setDimension();

			F.reposition();

			F.isOpen = false;
			F.coming = null;

			F.bindEvents();

			if (!F.isOpened) {
				$('.fancybox-wrap').not( current.wrap ).stop(true).trigger('onReset').remove();

			} else if (previous.prevMethod) {
				F.transitions[ previous.prevMethod ]();
			}

			F.transitions[ F.isOpened ? current.nextMethod : current.openMethod ]();

			F._preloadImages();
		},

		_setDimension: function () {
			var viewport   = F.getViewport(),
				steps      = 0,
				canShrink  = false,
				canExpand  = false,
				wrap       = F.wrap,
				skin       = F.skin,
				inner      = F.inner,
				current    = F.current,
				width      = current.width,
				height     = current.height,
				minWidth   = current.minWidth,
				minHeight  = current.minHeight,
				maxWidth   = current.maxWidth,
				maxHeight  = current.maxHeight,
				scrolling  = current.scrolling,
				scrollOut  = current.scrollOutside ? current.scrollbarWidth : 0,
				margin     = current.margin,
				wMargin    = getScalar(margin[1] + margin[3]),
				hMargin    = getScalar(margin[0] + margin[2]),
				wPadding,
				hPadding,
				wSpace,
				hSpace,
				origWidth,
				origHeight,
				origMaxWidth,
				origMaxHeight,
				ratio,
				width_,
				height_,
				maxWidth_,
				maxHeight_,
				iframe,
				body;

			// Reset dimensions so we could re-check actual size
			wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');

			wPadding = getScalar(skin.outerWidth(true)  - skin.width());
			hPadding = getScalar(skin.outerHeight(true) - skin.height());

			// Any space between content and viewport (margin, padding, border, title)
			wSpace = wMargin + wPadding;
			hSpace = hMargin + hPadding;

			origWidth  = isPercentage(width)  ? (viewport.w - wSpace) * getScalar(width)  / 100 : width;
			origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;

			if (current.type === 'iframe') {
				iframe = current.content;

				if (current.autoHeight && iframe.data('ready') === 1) {
					try {
						if (iframe[0].contentWindow.document.location) {
							inner.width( origWidth ).height(9999);

							body = iframe.contents().find('body');

							if (scrollOut) {
								body.css('overflow-x', 'hidden');
							}

							origHeight = body.outerHeight(true);
						}

					} catch (e) {}
				}

			} else if (current.autoWidth || current.autoHeight) {
				inner.addClass( 'fancybox-tmp' );

				// Set width or height in case we need to calculate only one dimension
				if (!current.autoWidth) {
					inner.width( origWidth );
				}

				if (!current.autoHeight) {
					inner.height( origHeight );
				}

				if (current.autoWidth) {
					origWidth = inner.width();
				}

				if (current.autoHeight) {
					origHeight = inner.height();
				}

				inner.removeClass( 'fancybox-tmp' );
			}

			width  = getScalar( origWidth );
			height = getScalar( origHeight );

			ratio  = origWidth / origHeight;

			// Calculations for the content
			minWidth  = getScalar(isPercentage(minWidth) ? getScalar(minWidth, 'w') - wSpace : minWidth);
			maxWidth  = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, 'w') - wSpace : maxWidth);

			minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, 'h') - hSpace : minHeight);
			maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, 'h') - hSpace : maxHeight);

			// These will be used to determine if wrap can fit in the viewport
			origMaxWidth  = maxWidth;
			origMaxHeight = maxHeight;

			if (current.fitToView) {
				maxWidth  = Math.min(viewport.w - wSpace, maxWidth);
				maxHeight = Math.min(viewport.h - hSpace, maxHeight);
			}

			maxWidth_  = viewport.w - wMargin;
			maxHeight_ = viewport.h - hMargin;

			if (current.aspectRatio) {
				if (width > maxWidth) {
					width  = maxWidth;
					height = getScalar(width / ratio);
				}

				if (height > maxHeight) {
					height = maxHeight;
					width  = getScalar(height * ratio);
				}

				if (width < minWidth) {
					width  = minWidth;
					height = getScalar(width / ratio);
				}

				if (height < minHeight) {
					height = minHeight;
					width  = getScalar(height * ratio);
				}

			} else {
				width = Math.max(minWidth, Math.min(width, maxWidth));

				if (current.autoHeight && current.type !== 'iframe') {
					inner.width( width );

					height = inner.height();
				}

				height = Math.max(minHeight, Math.min(height, maxHeight));
			}

			// Try to fit inside viewport (including the title)
			if (current.fitToView) {
				inner.width( width ).height( height );

				wrap.width( width + wPadding );

				// Real wrap dimensions
				width_  = wrap.width();
				height_ = wrap.height();

				if (current.aspectRatio) {
					while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight) {
						if (steps++ > 19) {
							break;
						}

						height = Math.max(minHeight, Math.min(maxHeight, height - 10));
						width  = getScalar(height * ratio);

						if (width < minWidth) {
							width  = minWidth;
							height = getScalar(width / ratio);
						}

						if (width > maxWidth) {
							width  = maxWidth;
							height = getScalar(width / ratio);
						}

						inner.width( width ).height( height );

						wrap.width( width + wPadding );

						width_  = wrap.width();
						height_ = wrap.height();
					}

				} else {
					width  = Math.max(minWidth,  Math.min(width,  width  - (width_  - maxWidth_)));
					height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)));
				}
			}

			if (scrollOut && scrolling === 'auto' && height < origHeight && (width + wPadding + scrollOut) < maxWidth_) {
				width += scrollOut;
			}

			inner.width( width ).height( height );

			wrap.width( width + wPadding );

			width_  = wrap.width();
			height_ = wrap.height();

			canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
			canExpand = current.aspectRatio ? (width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight) : ((width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight));

			$.extend(current, {
				dim : {
					width	: getValue( width_ ),
					height	: getValue( height_ )
				},
				origWidth  : origWidth,
				origHeight : origHeight,
				canShrink  : canShrink,
				canExpand  : canExpand,
				wPadding   : wPadding,
				hPadding   : hPadding,
				wrapSpace  : height_ - skin.outerHeight(true),
				skinSpace  : skin.height() - height
			});

			if (!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand) {
				inner.height('auto');
			}
		},

		_getPosition: function (onlyAbsolute) {
			var current  = F.current,
				viewport = F.getViewport(),
				margin   = current.margin,
				width    = F.wrap.width()  + margin[1] + margin[3],
				height   = F.wrap.height() + margin[0] + margin[2],
				rez      = {
					position: 'absolute',
					top  : margin[0],
					left : margin[3]
				};

			if (current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w) {
				rez.position = 'fixed';

			} else if (!current.locked) {
				rez.top  += viewport.y;
				rez.left += viewport.x;
			}

			rez.top  = getValue(Math.max(rez.top,  rez.top  + ((viewport.h - height) * current.topRatio)));
			rez.left = getValue(Math.max(rez.left, rez.left + ((viewport.w - width)  * current.leftRatio)));

			return rez;
		},

		_afterZoomIn: function () {
			var current = F.current;

			if (!current) {
				return;
			}

			F.isOpen = F.isOpened = true;

			F.wrap.css('overflow', 'visible').addClass('fancybox-opened');

			F.update();

			// Assign a click event
			if ( current.closeClick || (current.nextClick && F.group.length > 1) ) {
				F.inner.css('cursor', 'pointer').bind('click.fb', function(e) {
					if (!$(e.target).is('a') && !$(e.target).parent().is('a')) {
						e.preventDefault();

						F[ current.closeClick ? 'close' : 'next' ]();
					}
				});
			}

			// Create a close button
			if (current.closeBtn) {
				$(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb', function(e) {
					e.preventDefault();

					F.close();
				});
			}

			// Create navigation arrows
			if (current.arrows && F.group.length > 1) {
				if (current.loop || current.index > 0) {
					$(current.tpl.prev).appendTo(F.outer).bind('click.fb', F.prev);
				}

				if (current.loop || current.index < F.group.length - 1) {
					$(current.tpl.next).appendTo(F.outer).bind('click.fb', F.next);
				}
			}

			F.trigger('afterShow');

			// Stop the slideshow if this is the last item
			if (!current.loop && current.index === current.group.length - 1) {
				F.play( false );

			} else if (F.opts.autoPlay && !F.player.isActive) {
				F.opts.autoPlay = false;

				F.play();
			}
		},

		_afterZoomOut: function ( obj ) {
			obj = obj || F.current;

			$('.fancybox-wrap').trigger('onReset').remove();

			$.extend(F, {
				group  : {},
				opts   : {},
				router : false,
				current   : null,
				isActive  : false,
				isOpened  : false,
				isOpen    : false,
				isClosing : false,
				wrap   : null,
				skin   : null,
				outer  : null,
				inner  : null
			});

			F.trigger('afterClose', obj);
		}
	});

	/*
	 *	Default transitions
	 */

	F.transitions = {
		getOrigPosition: function () {
			var current  = F.current,
				element  = current.element,
				orig     = current.orig,
				pos      = {},
				width    = 50,
				height   = 50,
				hPadding = current.hPadding,
				wPadding = current.wPadding,
				viewport = F.getViewport();

			if (!orig && current.isDom && element.is(':visible')) {
				orig = element.find('img:first');

				if (!orig.length) {
					orig = element;
				}
			}

			if (isQuery(orig)) {
				pos = orig.offset();

				if (orig.is('img')) {
					width  = orig.outerWidth();
					height = orig.outerHeight();
				}

			} else {
				pos.top  = viewport.y + (viewport.h - height) * current.topRatio;
				pos.left = viewport.x + (viewport.w - width)  * current.leftRatio;
			}

			if (F.wrap.css('position') === 'fixed' || current.locked) {
				pos.top  -= viewport.y;
				pos.left -= viewport.x;
			}

			pos = {
				top     : getValue(pos.top  - hPadding * current.topRatio),
				left    : getValue(pos.left - wPadding * current.leftRatio),
				width   : getValue(width  + wPadding),
				height  : getValue(height + hPadding)
			};

			return pos;
		},

		step: function (now, fx) {
			var ratio,
				padding,
				value,
				prop       = fx.prop,
				current    = F.current,
				wrapSpace  = current.wrapSpace,
				skinSpace  = current.skinSpace;

			if (prop === 'width' || prop === 'height') {
				ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);

				if (F.isClosing) {
					ratio = 1 - ratio;
				}

				padding = prop === 'width' ? current.wPadding : current.hPadding;
				value   = now - padding;

				F.skin[ prop ](  getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) ) );
				F.inner[ prop ]( getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) - (skinSpace * ratio) ) );
			}
		},

		zoomIn: function () {
			var current  = F.current,
				startPos = current.pos,
				effect   = current.openEffect,
				elastic  = effect === 'elastic',
				endPos   = $.extend({opacity : 1}, startPos);

			// Remove "position" property that breaks older IE
			delete endPos.position;

			if (elastic) {
				startPos = this.getOrigPosition();

				if (current.openOpacity) {
					startPos.opacity = 0.1;
				}

			} else if (effect === 'fade') {
				startPos.opacity = 0.1;
			}

			F.wrap.css(startPos).animate(endPos, {
				duration : effect === 'none' ? 0 : current.openSpeed,
				easing   : current.openEasing,
				step     : elastic ? this.step : null,
				complete : F._afterZoomIn
			});
		},

		zoomOut: function () {
			var current  = F.current,
				effect   = current.closeEffect,
				elastic  = effect === 'elastic',
				endPos   = {opacity : 0.1};

			if (elastic) {
				endPos = this.getOrigPosition();

				if (current.closeOpacity) {
					endPos.opacity = 0.1;
				}
			}

			F.wrap.animate(endPos, {
				duration : effect === 'none' ? 0 : current.closeSpeed,
				easing   : current.closeEasing,
				step     : elastic ? this.step : null,
				complete : F._afterZoomOut
			});
		},

		changeIn: function () {
			var current   = F.current,
				effect    = current.nextEffect,
				startPos  = current.pos,
				endPos    = { opacity : 1 },
				direction = F.direction,
				distance  = 200,
				field;

			startPos.opacity = 0.1;

			if (effect === 'elastic') {
				field = direction === 'down' || direction === 'up' ? 'top' : 'left';

				if (direction === 'down' || direction === 'right') {
					startPos[ field ] = getValue(getScalar(startPos[ field ]) - distance);
					endPos[ field ]   = '+=' + distance + 'px';

				} else {
					startPos[ field ] = getValue(getScalar(startPos[ field ]) + distance);
					endPos[ field ]   = '-=' + distance + 'px';
				}
			}

			// Workaround for http://bugs.jquery.com/ticket/12273
			if (effect === 'none') {
				F._afterZoomIn();

			} else {
				F.wrap.css(startPos).animate(endPos, {
					duration : current.nextSpeed,
					easing   : current.nextEasing,
					complete : F._afterZoomIn
				});
			}
		},

		changeOut: function () {
			var previous  = F.previous,
				effect    = previous.prevEffect,
				endPos    = { opacity : 0.1 },
				direction = F.direction,
				distance  = 200;

			if (effect === 'elastic') {
				endPos[ direction === 'down' || direction === 'up' ? 'top' : 'left' ] = ( direction === 'up' || direction === 'left' ? '-' : '+' ) + '=' + distance + 'px';
			}

			previous.wrap.animate(endPos, {
				duration : effect === 'none' ? 0 : previous.prevSpeed,
				easing   : previous.prevEasing,
				complete : function () {
					$(this).trigger('onReset').remove();
				}
			});
		}
	};

	/*
	 *	Overlay helper
	 */

	F.helpers.overlay = {
		defaults : {
			closeClick : true,      // if true, fancyBox will be closed when user clicks on the overlay
			speedOut   : 200,       // duration of fadeOut animation
			showEarly  : true,      // indicates if should be opened immediately or wait until the content is ready
			css        : {},        // custom CSS properties
			locked     : !isTouch,  // if true, the content will be locked into overlay
			fixed      : true       // if false, the overlay CSS position property will not be set to "fixed"
		},

		overlay : null,      // current handle
		fixed   : false,     // indicates if the overlay has position "fixed"
		el      : $('html'), // element that contains "the lock"

		// Public methods
		create : function(opts) {
			opts = $.extend({}, this.defaults, opts);

			if (this.overlay) {
				this.close();
			}

			this.overlay = $('<div class="fancybox-overlay"></div>').appendTo( F.coming ? F.coming.parent : opts.parent );
			this.fixed   = false;

			if (opts.fixed && F.defaults.fixed) {
				this.overlay.addClass('fancybox-overlay-fixed');

				this.fixed = true;
			}
		},

		open : function(opts) {
			var that = this;

			opts = $.extend({}, this.defaults, opts);

			if (this.overlay) {
				this.overlay.unbind('.overlay').width('auto').height('auto');

			} else {
				this.create(opts);
			}

			if (!this.fixed) {
				W.bind('resize.overlay', $.proxy( this.update, this) );

				this.update();
			}

			if (opts.closeClick) {
				this.overlay.bind('click.overlay', function(e) {
					if ($(e.target).hasClass('fancybox-overlay')) {
						if (F.isActive) {
							F.close();
						} else {
							that.close();
						}

						return false;
					}
				});
			}

			this.overlay.css( opts.css ).show();
		},

		close : function() {
			var scrollV, scrollH;

			W.unbind('resize.overlay');

			if (this.el.hasClass('fancybox-lock')) {
				$('.fancybox-margin').removeClass('fancybox-margin');

				scrollV = W.scrollTop();
				scrollH = W.scrollLeft();

				this.el.removeClass('fancybox-lock');

				W.scrollTop( scrollV ).scrollLeft( scrollH );
			}

			$('.fancybox-overlay').remove().hide();

			$.extend(this, {
				overlay : null,
				fixed   : false
			});
		},

		// Private, callbacks

		update : function () {
			var width = '100%', offsetWidth;

			// Reset width/height so it will not mess
			this.overlay.width(width).height('100%');

			// jQuery does not return reliable result for IE
			if (IE) {
				offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);

				if (D.width() > offsetWidth) {
					width = D.width();
				}

			} else if (D.width() > W.width()) {
				width = D.width();
			}

			this.overlay.width(width).height(D.height());
		},

		// This is where we can manipulate DOM, because later it would cause iframes to reload
		onReady : function (opts, obj) {
			var overlay = this.overlay;

			$('.fancybox-overlay').stop(true, true);

			if (!overlay) {
				this.create(opts);
			}

			if (opts.locked && this.fixed && obj.fixed) {
				if (!overlay) {
					this.margin = D.height() > W.height() ? $('html').css('margin-right').replace("px", "") : false;
				}

				obj.locked = this.overlay.append( obj.wrap );
				obj.fixed  = false;
			}

			if (opts.showEarly === true) {
				this.beforeShow.apply(this, arguments);
			}
		},

		beforeShow : function(opts, obj) {
			var scrollV, scrollH;

			if (obj.locked) {
				if (this.margin !== false) {
					$('*').filter(function(){
						return ($(this).css('position') === 'fixed' && !$(this).hasClass("fancybox-overlay") && !$(this).hasClass("fancybox-wrap") );
					}).addClass('fancybox-margin');

					this.el.addClass('fancybox-margin');
				}

				scrollV = W.scrollTop();
				scrollH = W.scrollLeft();

				this.el.addClass('fancybox-lock');

				W.scrollTop( scrollV ).scrollLeft( scrollH );
			}

			this.open(opts);
		},

		onUpdate : function() {
			if (!this.fixed) {
				this.update();
			}
		},

		afterClose: function (opts) {
			// Remove overlay if exists and fancyBox is not opening
			// (e.g., it is not being open using afterClose callback)
			//if (this.overlay && !F.isActive) {
			if (this.overlay && !F.coming) {
				this.overlay.fadeOut(opts.speedOut, $.proxy( this.close, this ));
			}
		}
	};

	/*
	 *	Title helper
	 */

	F.helpers.title = {
		defaults : {
			type     : 'float', // 'float', 'inside', 'outside' or 'over',
			position : 'bottom' // 'top' or 'bottom'
		},

		beforeShow: function (opts) {
			var current = F.current,
				text    = current.title,
				type    = opts.type,
				title,
				target;

			if ($.isFunction(text)) {
				text = text.call(current.element, current);
			}

			if (!isString(text) || $.trim(text) === '') {
				return;
			}

			title = $('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '</div>');

			switch (type) {
				case 'inside':
					target = F.skin;
				break;

				case 'outside':
					target = F.wrap;
				break;

				case 'over':
					target = F.inner;
				break;

				default: // 'float'
					target = F.skin;

					title.appendTo('body');

					if (IE) {
						title.width( title.width() );
					}

					title.wrapInner('<span class="child"></span>');

					//Increase bottom margin so this title will also fit into viewport
					F.current.margin[2] += Math.abs( getScalar(title.css('margin-bottom')) );
				break;
			}

			title[ (opts.position === 'top' ? 'prependTo'  : 'appendTo') ](target);
		}
	};

	// jQuery plugin initialization
	$.fn.fancybox = function (options) {
		var index,
			that     = $(this),
			selector = this.selector || '',
			run      = function(e) {
				var what = $(this).blur(), idx = index, relType, relVal;

				if (!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is('.fancybox-wrap')) {
					relType = options.groupAttr || 'data-fancybox-group';
					relVal  = what.attr(relType);

					if (!relVal) {
						relType = 'rel';
						relVal  = what.get(0)[ relType ];
					}

					if (relVal && relVal !== '' && relVal !== 'nofollow') {
						what = selector.length ? $(selector) : that;
						what = what.filter('[' + relType + '="' + relVal + '"]');
						idx  = what.index(this);
					}

					options.index = idx;

					// Stop an event from bubbling if everything is fine
					if (F.open(what, options) !== false) {
						e.preventDefault();
					}
				}
			};

		options = options || {};
		index   = options.index || 0;

		if (!selector || options.live === false) {
			that.unbind('click.fb-start').bind('click.fb-start', run);

		} else {
			D.undelegate(selector, 'click.fb-start').delegate(selector + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', run);
		}

		this.filter('[data-fancybox-start=1]').trigger('click');

		return this;
	};

	// Tests that need a body at doc ready
	D.ready(function() {
		var w1, w2;

		if ( $.scrollbarWidth === undefined ) {
			// http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
			$.scrollbarWidth = function() {
				var parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
					child  = parent.children(),
					width  = child.innerWidth() - child.height( 99 ).innerWidth();

				parent.remove();

				return width;
			};
		}

		if ( $.SUPPORT.fixedPosition === undefined ) {
			$.SUPPORT.fixedPosition = (function() {
				var elem  = $('<div style="position:fixed;top:20px;"></div>').appendTo('body'),
					fixed = ( elem[0].offsetTop === 20 || elem[0].offsetTop === 15 );

				elem.remove();

				return fixed;
			}());
		}

		$.extend(F.defaults, {
			scrollbarWidth : $.scrollbarWidth(),
			fixed  : $.SUPPORT.fixedPosition,
			parent : $('body')
		});

		//Get real width of page scroll-bar
		w1 = $(window).width();

		H.addClass('fancybox-lock-test');

		w2 = $(window).width();

		H.removeClass('fancybox-lock-test');

		$("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
	});

}(window, document, jQuery));
$(document).ready(function(){

	//FastClick.attach(document.body);

	//Remove hover elements on touch devices
	if(isTouchDevice()) {
		
		$('.hover-show').hide();
		$('.hover-show').removeClass('hover-show');
		$('.hover-hide').removeClass('hover-hide');
	} else {
		$("body").addClass('no-touch');
	}

	//Fix quicksearch for ios devices
	$('.user-btn.search').click(function () {
		$('#quick-search-field').focus();
	});
	
	//Highlight category tiles on mobile
	var $selectedTile = null;
	if (isTouchDevice()) {
		$(".category-tile").click(function () {
			console.log("clicked mobile tile!");
			if (!$selectedTile || $(this)[0] !== $selectedTile[0]) {
				if ($selectedTile) {
					$selectedTile.find('.icons').fadeOut(300);
					$selectedTile.find('.title').fadeIn(300);
					$selectedTile.find('.overlay').removeClass('hover');
				}
				$(this).find('.icons').fadeIn(300);
				$(this).find('.title').fadeOut(300);
				$(this).find('.overlay').addClass('hover');
				$selectedTile = $(this);
			}
		});
	}
});
function popupWindow(url, name) {
	"use strict";
	window.open(url, name, "width=500, height=350m menubar=no, toolbar=no");
}
//App modules

//GOOD VERSION
angular.module('ra.core',       ['ngAnimate', 'duScroll', 'ngSanitize', 'angucomplete']);

angular.module('ra.tag',        ['ra.core', 'ngStorage']);
angular.module('ra.manage',     ['ra.core', 'angularFileUpload', 'datePicker']);
angular.module('ra.comments',   ['ra.core', 'hm.readmore']);
angular.module('ra.news',       ['ra.core', 'ra.comments', 'youtube-embed', 'monospaced.elastic']);
angular.module('ra.photosHome', ['ra.core']);
angular.module('ra.myVideo',    ['ra.core']);
angular.module('ra.photos',     ['ra.core', 'ra.comments']); //Haven't split out modules yet*/

/**
 * Created by jordan on 29/11/2016.
 */
angular.module('ra.core')
    .filter('ordinalDate', ['$filter', function($filter) {
        var suffixes = ["th", "st", "nd", "rd"];
        return function(input, format, timezone) {
            if(input && format) {
                var dtfilter = $filter('date')(input, format, timezone);
                var day = parseInt($filter('date')(input, 'dd'));
                var relevantDigits = (day < 30) ? day % 20 : day % 30;

                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return dtfilter.replace('oo', suffix);
            } else {
                return "";
            }

        };
    }])
    .filter('highlight', ['$sce', function($sce) {
        return function(text, phrase) {
            if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
                '<span class="highlighted">$1</span>');

            return $sce.trustAsHtml(text)
        }
    }])
    .filter('percentage', ['$filter', function ($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }]);
/*
 * angular-elastic v2.5.1
 * (c) 2014 Monospaced http://monospaced.com
 * License: MIT
 */

if (typeof module !== 'undefined' &&
    typeof exports !== 'undefined' &&
    module.exports === exports){
  module.exports = 'monospaced.elastic';
}

angular.module('monospaced.elastic', [])

  .constant('msdElasticConfig', {
    append: ''
  })

  .directive('msdElastic', [
    '$timeout', '$window', 'msdElasticConfig',
    function($timeout, $window, config) {
      'use strict';

      return {
        require: 'ngModel',
        restrict: 'A, C',
        link: function(scope, element, attrs, ngModel) {

          // cache a reference to the DOM element
          var ta = element[0],
              $ta = element;

          // ensure the element is a textarea, and browser is capable
          if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
            return;
          }

          // set these properties before measuring dimensions
          $ta.css({
            'overflow': 'hidden',
            'overflow-y': 'hidden',
            'word-wrap': 'break-word'
          });

          // force text reflow
          var text = ta.value;
          ta.value = '';
          ta.value = text;

          var append = attrs.msdElastic ? attrs.msdElastic.replace(/\\n/g, '\n') : config.append,
              $win = angular.element($window),
              mirrorInitStyle = 'position: absolute; top: -999px; right: auto; bottom: auto;' +
                                'left: 0; overflow: hidden; -webkit-box-sizing: content-box;' +
                                '-moz-box-sizing: content-box; box-sizing: content-box;' +
                                'min-height: 0 !important; height: 0 !important; padding: 0;' +
                                'word-wrap: break-word; border: 0;',
              $mirror = angular.element('<textarea aria-hidden="true" tabindex="-1" ' +
                                        'style="' + mirrorInitStyle + '"/>').data('elastic', true),
              mirror = $mirror[0],
              taStyle = getComputedStyle(ta),
              resize = taStyle.getPropertyValue('resize'),
              borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
                          taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box',
              boxOuter = !borderBox ? {width: 0, height: 0} : {
                            width:  parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-right'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-left'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-left-width'), 10),
                            height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-top'), 10) +
                                    parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
                                    parseInt(taStyle.getPropertyValue('border-bottom-width'), 10)
                          },
              minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10),
              heightValue = parseInt(taStyle.getPropertyValue('height'), 10),
              minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height,
              maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10),
              mirrored,
              active,
              copyStyle = ['font-family',
                           'font-size',
                           'font-weight',
                           'font-style',
                           'letter-spacing',
                           'line-height',
                           'text-transform',
                           'word-spacing',
                           'text-indent'];

          // exit if elastic already applied (or is the mirror element)
          if ($ta.data('elastic')) {
            return;
          }

          // Opera returns max-height of -1 if not set
          maxHeight = maxHeight && maxHeight > 0 ? maxHeight : 9e4;

          // append mirror to the DOM
          if (mirror.parentNode !== document.body) {
            angular.element(document.body).append(mirror);
          }

          // set resize and apply elastic
          $ta.css({
            'resize': (resize === 'none' || resize === 'vertical') ? 'none' : 'horizontal'
          }).data('elastic', true);

          /*
           * methods
           */

          function initMirror() {
            var mirrorStyle = mirrorInitStyle;

            mirrored = ta;
            // copy the essential styles from the textarea to the mirror
            taStyle = getComputedStyle(ta);
            angular.forEach(copyStyle, function(val) {
              mirrorStyle += val + ':' + taStyle.getPropertyValue(val) + ';';
            });
            mirror.setAttribute('style', mirrorStyle);
          }

          function adjust() {
            var taHeight,
                taComputedStyleWidth,
                mirrorHeight,
                width,
                overflow;

            if (mirrored !== ta) {
              initMirror();
            }

            // active flag prevents actions in function from calling adjust again
            if (!active) {
              active = true;

              mirror.value = ta.value + append; // optional whitespace to improve animation
              mirror.style.overflowY = ta.style.overflowY;

              taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);

              taComputedStyleWidth = getComputedStyle(ta).getPropertyValue('width');

              // ensure getComputedStyle has returned a readable 'used value' pixel width
              if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
                // update mirror width in case the textarea width has changed
                width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
                mirror.style.width = width + 'px';
              }

              mirrorHeight = mirror.scrollHeight;

              if (mirrorHeight > maxHeight) {
                mirrorHeight = maxHeight;
                overflow = 'scroll';
              } else if (mirrorHeight < minHeight) {
                mirrorHeight = minHeight;
              }
              mirrorHeight += boxOuter.height;
              ta.style.overflowY = overflow || 'hidden';

              if (taHeight !== mirrorHeight) {
                scope.$emit('elastic:resize', $ta, taHeight, mirrorHeight);
                ta.style.height = mirrorHeight + 'px';
              }

              // small delay to prevent an infinite loop
              $timeout(function() {
                active = false;
              }, 1, false);

            }
          }

          function forceAdjust() {
            active = false;
            adjust();
          }

          /*
           * initialise
           */

          // listen
          if ('onpropertychange' in ta && 'oninput' in ta) {
            // IE9
            ta['oninput'] = ta.onkeyup = adjust;
          } else {
            ta['oninput'] = adjust;
          }

          $win.bind('resize', forceAdjust);

          scope.$watch(function() {
            return ngModel.$modelValue;
          }, function(newValue) {
            forceAdjust();
          });

          scope.$on('elastic:adjust', function() {
            initMirror();
            forceAdjust();
          });

          $timeout(adjust, 0, false);

          /*
           * destroy
           */

          scope.$on('$destroy', function() {
            $mirror.remove();
            $win.unbind('resize', forceAdjust);
          });
        }
      };
    }
  ]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.comments')
.controller('EventDetailsCtrl', ['$scope','commentService', 'photoService',
	function($scope, commentService, photoService) {
		var vm = this;

		var unbind = $scope.$watch('vm.data', function() {
			photoService.currentParticipant = vm.data.participant;
			unbind();
		});
		
}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.comments')
.controller('commentCtrl', ['$scope', '$sce', 'commentService', 'showAuthEvent',
function($scope, $sce, commentService, showAuthEvent) {

	$scope.isSignedIn = false;
	
	(function() {
		$(".btn.leave-review").click(function() {
			$('html, body').animate({
				scrollTop: $("#leave-feedback").offset().top
			}, 300);
		});
	}());
	 
	var validateStars = function() {
		if(!$scope.review.rating) {
			$(".rating-error").show();
			return false;
		} else {
			$(".rating-error").hide();
			return true;
		}
	};
	
	var save = function(next) {
		//Angular was lagging, used jQuery instead
		$("#submit-review").hide();
		$("#submitting-wait").show();

		commentService.saveReview($scope.review)
			.then(function(response) {
				$("#submit-review").show();
				$("#submitting-wait").hide();
				
				if(next) {
					next();
				}
				
				if(response.success) {
					$scope.reviewSaved = true;
				}
				else {
					alert(response.message);
				}
			});

		//initYotpo();
	};
	
	$scope.reviewSaved = false;
	
	$scope.saveReview = function() {
		if(validateStars() && $('.event-comment-form').parsley().validate()) {
			if($scope.isSignedIn) {
				save();
			} else {
				showAuthEvent.broadcast('Register or sign up to save your review!',
				save, {instantSignup:false});
			} 
		}
	};

	$scope.$watch('routeParams', function () {
		$scope.isSignedIn = true;
	});

}]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('articleCommentForm', ['commentService', 'showAuthEvent', 'userService',
        function(commentService, showAuthEvent, userService) {
        return {
            templateUrl: 'articleCommentForm.html',
            restrict: 'E',
            scope: {
                article: '=',
                refreshComments: '&'
            },
            link: function($scope, $element) {
                $scope.userData = userService.data;

                var $textareaHolder = $element.find(".textarea-holder");
                
                var initForm = function() {
                    $scope.isLoading = false;
                    $scope.comment = {
                        text: '',
                        articleId: $scope.article._id,
                    };
                };
                
                var saveComment = function() {
                    $scope.isLoading = true;
                    commentService.save('article', $scope.comment)
                        .then(function(result) {
                            $scope.refreshComments()
                                .then(function() {
                                    $scope.article.numComments++;
                                    initForm();
                                });
                        },
                        function(err) {
                            console.log(err);
                            alert(err.error);
                            $scope.isLoading = false;
                        });
                };


                //Scroll to comment form
                $scope.scrollToForm = function() {
                    if(isMobileOrTablet()) {
                        $(window).scrollTop($textareaHolder.offset().top - 10);
                    }
                };
                
                $scope.isLoading = false;
                
                $scope.postComment = function() {
                    console.log("Post!");
                    if($scope.userData.user) {
                        saveComment();
                    } else {
                        showAuthEvent.broadcast('Register or sign up to save your comment!', saveComment, {
                            instantSignup:false, 
                            skipCompleteMessage:true
                        });
                    }
                };

                initForm();
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('comment', ['hideArticleMenusEvent', 'showArticleMenusEvent', 'commentService', 'userService',
        function(hideArticleMenusEvent, showArticleMenusEvent, commentService, userService) {
        return {
            templateUrl: 'comment.html',
            restrict: 'E',
            scope: {
                comment: '=',
            },
            link: function($scope, element) {
                var self = this;
                var $menu;
                var $showComment;
                var $removeComment;
                var $reportComment;
                var $comment;
                var $isRemoved;
                var $isShown;

                $scope.userData = userService.data;
                
                if($scope.userData.user) {
                    $scope.canModify = $scope.userData.user.role=="admin" || $scope.comment.user == $scope.userData.user._id;
                } else {
                    $scope.canModify = false;
                }
                
                var updateOptionsMenu = function() {
                    if($scope.canModify) {
                        $reportComment.hide();
                        
                        if($scope.comment.visible) {
                            $removeComment.show();
                            $showComment.hide();
                        } else {
                            $removeComment.hide();
                            $showComment.show();
                        }
                    } else {
                        $showComment.hide();
                        $removeComment.hide();
                        $reportComment.show();
                    }
                };
                
                var updateVisibility = function() {
                    if($scope.comment.isRemoved && !$scope.comment.visible) {
                        $isRemoved.show();
                    } else {
                        $isRemoved.hide();
                    }

                    if($scope.comment.isRemoved && $scope.comment.visible) {
                        $isShown.show();
                    } else {
                        $isShown.hide();
                    }
                };
                

                $scope.showMenu = function() {
                    $menu.show();
                    console.log($menu);
                    showArticleMenusEvent.broadcast();
                };

                $scope.hideMenu = function() {
                    $menu.hide();
                    hideArticleMenusEvent.broadcast();
                };
                
                $scope.toggleVisibility = function() {
                    $scope.comment.isRemoving = false;
                    commentService.toggleVisibility($scope.comment._id)
                        .then(function() {
                            $scope.comment.isRemoving = false;
                            $scope.comment.isRemoved = !$scope.comment.isRemoved;
                            $scope.comment.visible = !$scope.comment.visible;
                            
                            $comment.toggleClass("isRemoved");
                            updateOptionsMenu();
                            updateVisibility();
                            hideArticleMenusEvent.broadcast();
                        },
                        function() {
                            alert("Could not toggle comment visibility");
                        });
                    href='/api/comments/toggle/{{comment._id}}', target="_blank"
                };
                
                $scope.$watch('::comment', function() {
                    $showComment = element.find(".show-comment");
                    $removeComment = element.find(".remove-comment");
                    $reportComment = element.find(".report-comment");
                    $menu = element.find(".options-menu");
                    $comment = element.find(".comment");
                    $isRemoved = element.find(".is-removed");
                    $isShown = element.find(".is-shown");
                    
                    if($scope.comment.highlight) {
                        $comment.addClass('highlight');
                    }
                    
                    updateOptionsMenu();
                    updateVisibility();
                });

                hideArticleMenusEvent.listen(function() {
                    $menu.hide();
                });
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Functions as a re-usable controller for the comment list and comment form
 */
angular.module('ra.comments')
    .directive('commentModule', ['commentService', 'userService',
        function(commentService, userService) {
        return {
            templateUrl: 'commentModule.html',
            restrict: 'E',
            scope: {
                eventId: '@',
                csrf: '@',
            },
            link: function($scope) {
                commentService.getUserAndRating($scope.eventId)
                    .then(function(data) {
                        userService.data.user = data.user;
                        $scope.rating = data.rating;
                    });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('eventCommentButtons', ['commentService', 'showAuthEvent', 'userService',
        function(commentService, showAuthEvent, userService) {
        return {
            templateUrl: 'eventCommentButtons.html',
            restrict: 'E',
            scope: {
                comment: '=',
            },
            link: function($scope) {
                $scope.userData = userService.data;
                $scope.eventReplyFormVisible = false;

                //Marks comments as helpful where they match the given ids
                var populateCommentHelpful = function() {
                    var commentIds = $scope.userData.user.helpfuls;
                    
                    if(commentIds.indexOf($scope.comment._id) !== -1) {
                        $scope.comment.markedHelpful = true;
                    } else {
                        $scope.comment.markedHelpful = false;
                    }
                };

                //Updates the comment Ids in the helpful array to keep in sync with the real values
                var updateHelpfulsArray = function(commentId) {
                    console.log($scope.userData.user);
                    if($scope.userData.user) {
                        if(!$scope.userData.user.helpfuls) {
                            $scope.userData.user.helpfuls = [];
                        }
                        var index = $scope.userData.user.helpfuls.indexOf(commentId);
                        if(index === -1) {
                            $scope.userData.user.helpfuls.push(commentId);
                        }
                        else {
                            $scope.userData.user.helpfuls.splice(index, 1);
                        }
                    }
                };
                
                var savetoggleHelpful = function(comment) {
                    commentService.toggleHelpful(comment.event, comment._id)
                        .then(function(newHelpful)
                        {
                            comment.helpful = newHelpful;
                            comment.markedHelpful = !comment.markedHelpful;
                            updateHelpfulsArray(comment._id);
                        })
                };
                
                
                /**
                 * Hides visible comments, shows hidden comments
                 * @param comment
                 */
                $scope.toggleVisibility = function(comment) {
                    comment.isRemoving = true;
                    commentService.toggleVisibility(comment._id)
                        .then(function() {
                            comment.isRemoving = false;
                            comment.isRemoved = !comment.isRemoved;
                            comment.visible = !comment.visible;
                        },
                        function(err) {
                            comment.isRemoving = false;
                        });

                };

                $scope.toggleHelpful = function(comment) {
                    if($scope.userData.user) {
                        savetoggleHelpful(comment);
                    } else {
                        showAuthEvent.broadcast('Register or sign up to mark posts as helpful!', function() {
                            savetoggleHelpful(comment);
                        }, {instantSignup:false});
                    }
                };


                
                $scope.showEventReplyForm = function() {
                    $scope.eventReplyFormVisible = true;
                };
                $scope.hideEventReplyForm = function() {
                    $scope.eventReplyFormVisible = false;
                };

                if($scope.userData.user) {
                    populateCommentHelpful();
                }
                
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('eventCommentForm', ['commentService', '$anchorScroll', '$location', 'showAuthEvent', 'refreshCommentsEvent', '$document', 'userService',
        function(commentService, $anchorScroll, $location, showAuthEvent, refreshCommentsEvent, $document, userService) {
        return {
            templateUrl: 'eventCommentForm.html',
            restrict: 'E',
            scope: {
                eventId: '=',
                csrf: '=',
            },
            link: function($scope, element) {
                
                $scope.isSaved = false;
                $scope.userData = userService.data;
                
                $scope.comment = {
                    title: '',
                    text: '',
                    rating: 0,
                    eventId: $scope.eventId,
                    csrf: $scope.csrf
                };
                
                
                var save = function() {
                    $scope.isSaving = true;

                    commentService.save('event', $scope.comment)
                        .then(function(result) {
                            $scope.isSaving = false;
                            
                            if(result && result.success) {
                                $scope.isSaved = true;
                                refreshCommentsEvent.broadcast('recent', true);
                            }
                        })
                };
                
                var validateStars = function() {
                    if(!$scope.comment.rating) {
                        $(".rating-error").show();
                        return false;
                    } else {
                        $(".rating-error").hide();
                        return true;
                    }
                };
                
                $scope.saveComment = function() {
                    console.log(element);
                    if(validateStars() && $(element).find('.event-comment-form').parsley().validate()) {
                        if($scope.userData.user) {
                            save();
                        } else {
                            showAuthEvent.broadcast('Register or sign up to save your review!', save, {
                                instantSignup: false,
                            });
                        }
                    }
                    
                };
                
                //Scroll to page bottom, wait for strava and all other plugins to load
                if(window.location.hash == "#/leave-comment") {
                    setTimeout(function() {
                        $(window).scrollTop(99999); 
                    }, 1000)
                } else if(window.location.hash == "#/event-comment-list") {
                    var eventCommentList = angular.element(document.getElementById('event-comment-list'));
                    $document.scrollToElementAnimated(eventCommentList);
                }
                
                
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('eventCommentList', ['$document', '$location', 'commentService', 'refreshCommentsEvent', 'userService',
        function($document, $location, commentService, refreshCommentsEvent, userService) {
        return {
            templateUrl: 'eventCommentList.html',
            restrict: 'E',
            scope: {
                id: '=',
                type: '=',
                rating: '=?',
                commentsOnInit: '='
            },
            link: function($scope) {
                $scope.userData = userService.data;
                
                var DEFAULT_ORDER = 'recent';
                $scope.MIN_RATINGS = 3;
                $scope.moreComments = true;
                $scope.numMoreComments = 0;
                $scope.page = 0;
                $scope.loadingMoreComments = false;
                
                $scope.order = DEFAULT_ORDER;

                /**
                 * Get new comments
                 * @returns {*|Promise.<T>}
                 */
                $scope.refreshComments = function() {
                    $scope.page = 0;
                    $scope.comments = [];

                    return $scope.loadComments();
                };


                $scope.loadComments = function() {
                    $scope.loadingMoreComments = true;
                    
                    return commentService.getComments('event', $scope.id, $scope.page, $scope.order)
                        .then(function(data) {
                            $scope.loadingMoreComments = false;
                            $scope.comments = $scope.comments.concat(data.comments);
                            $scope.moreComments = (data.comments.length == data.commentsPerPage);
                            $scope.page++;
                            
                            $scope.$watch('rating', function () {
                                $scope.numMoreComments = Math.max(0, $scope.rating.numRatings - $scope.comments.length);
                            });
                            
                            
                        },
                        function(err) {
                            $scope.loadingMoreComments = false;
                        })
                };
                
                /**
                 * Change comment order and refresh
                 * @param order
                 */
                $scope.changeOrder = function(order) {
                    if(order != $scope.order)  {
                        $scope.order = order;
                        $scope.refreshComments(order);
                    }
                    
                };
                
                /**
                 * Scroll to 'leave review' form
                 */
                $scope.scrollToForm = function() {
                    var leaveComment = angular.element(document.getElementById('leave-comment'));
                    $document.scrollToElementAnimated(leaveComment);
                };

                refreshCommentsEvent.listen(function(order, highlightFirst) {
                    $scope.refreshComments(order)
                        .then(function() {
                            if(highlightFirst) {
                                console.log("highlighting");
                                $scope.comments[0].highlight = true;
                            }
                        })
                });
                
                if($scope.commentsOnInit) {
                    $scope.refreshComments();
                }
                
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('eventReplyForm', ['commentService', 'userService',
        function(commentService, userService) {
        return {
            templateUrl: 'eventReplyForm.html',
            restrict: 'E',
            scope: {
                comment: '=',
            },
            link: function($scope, element, attrs) {
                $scope.userData = userService.data;
                
                $scope.isSaved = false;
                $scope.isSaving = false;
                $scope.formData = {
                    text: ""
                };

                //Creates a fake reply to look like it's been submitted
                var mockReply = function(commentData) {
                    commentData.firstName = $scope.userData.user.firstName;
                    commentData.lastName = $scope.userData.user.lastName;
                    $scope.comment.children.push(commentData);
                };
                
                $scope.saveReply = function() {
                    if($(element).find('.event-comment-form').parsley().validate()) {
                        $scope.isSaving = true; 
                        $scope.formData.commentId = $scope.comment._id;
                        
                        commentService.reply($scope.formData)
                            .then(function(result) {
                                if(result && result.success) {
                                    $scope.isSaving = false;
                                    $scope.isSaved = true;
                                    mockReply($scope.formData);
                                    $scope.formData = {};
                                }
                                //Else an alert will show
                            })
                    }
                }
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('menuCover', ['hideArticleMenusEvent', 'showArticleMenusEvent',
        function(hideArticleMenusEvent, showArticleMenusEvent) {
        return {
            templateUrl: 'menuCover.html',
            restrict: 'E',
            scope: {},
            link: function($scope) {
                $scope.menuCoverVisible = false;

                $scope.hideMenus = function() {
                    $scope.menuCoverVisible = false;
                    hideArticleMenusEvent.broadcast();
                };

                showArticleMenusEvent.listen(function() {
                    $scope.menuCoverVisible = true;
                });

                hideArticleMenusEvent.listen(function() {
                    $scope.menuCoverVisible = false;
                })
            }
        };
    }]); 
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('ratingPicker', [
        function() {
        return {
            templateUrl: 'ratingPicker.html',
            restrict: 'E',
            scope: {
                ngModel: '=',
                max: '=',
                step: '='
            },
            link: function($scope) {
                $scope.labelRating = null;
                
                $scope.hoverStart = function(rating) {
                    $scope.labelRating = rating;
                };
                
                $scope.setRating = function(rating) {
                    console.log(rating);
                    $scope.ngModel = rating;
                    $scope.labelRating = rating;
                };
                
                $scope.hoverEnd = function() {
                    $scope.labelRating = $scope.ngModel;
                };
                
                $scope.boxes = [];
                for(var i=$scope.step; i<$scope.max+$scope.step; i+=$scope.step) {
                    $scope.boxes.push(i);
                }
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.comments')
    .directive('stars', [function() {
        return {
            templateUrl: 'stars.html',
            restrict: 'E',
            scope: {
                rating: '=',
                outOf: '=',
                size: '=?',
            },
            link:function($scope) {
                /**
                 * Width of star image in px
                 * @type {number}
                 */
                var DEFAULT_SIZE = 25;
                
                
                
                $scope.$watch('rating', function() {
                    if(!$scope.size) {
                        $scope.size = DEFAULT_SIZE;
                    }
                    $scope.rating = Math.round($scope.rating * 100) / 100;
                    
                    $scope.mainWidth = $scope.size*$scope.outOf + "px";
                    $scope.starsWidth = $scope.size*$scope.rating + "px";
                    $scope.starHeight = $scope.size + "px";
                    $scope.backgroundSize = $scope.size + "px " + 2*$scope.size + "px";
                });
            }
        };
    }]);
//User object
angular.module('ra.comments')
.service('hideArticleMenusEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'hideArticleMenus';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.comments')
.service('showArticleMenusEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showArticleMenus';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.comments')
	.service('commentService', ['Event', 'ajaxService',
		function (Event, ajaxService) {

		var service = {};
			
		service.save = function(type, formData) {
			return ajaxService.request('/api/comments/'+type+'/save', formData);
		};

		service.reply = function(formData) {
			return ajaxService.request('/api/comments/reply', formData);
		};
			
		service.getComments = function(type, id, page, order) {
			return ajaxService.request('/api/comments/get/'+type+'/' + id + '/' + page + '/' + order, {});
		};

		service.getUserAndRating = function(eventId) {
			return ajaxService.request('/api/comments/userAndRating/' + eventId, {});
		};

		service.toggleHelpful = function(eventId, commentId) {
			return ajaxService.request('/api/comments/helpful', {commentId: commentId, eventId: eventId});
		};

		service.toggleVisibility = function(commentId) {
			return ajaxService.request('/api/comments/toggle', {commentId: commentId});
		};
			
		return service;
	}]);
 

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
    .controller('authCtrl', ['$scope', 'showAuthEvent', '$rootScope', 'authService', '$timeout', '$sce', 'userService', 'signOnCompleteEvent',
    function($scope, showAuthEvent, $rootScope, authService, $timeout, $sce, userService, signOnCompleteEvent) {

        
        $scope.showSignUpWindow = false;
        $scope.showSignOnWindow = false;
        $scope.details = {
            receiveEmails: true,
            instantSignup: false,
            interestedIn: null
        };
        $scope.isSaving = false;
        $scope.error = '';
        $scope.infoMessage = '';
        $scope.magicLinkSent = false;
        $scope.magicLinkSentEmail = '';
        $scope.showPasswordLogin = false;
        $rootScope.showMagicLinkHelp = false;

        $rootScope.openMagicLinkHelp = function(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            $rootScope.showMagicLinkHelp = true;
            angular.element(document.body).addClass('magic-link-help-open');
        };

        $rootScope.hideMagicLinkHelp = function(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            $rootScope.showMagicLinkHelp = false;
            angular.element(document.body).removeClass('magic-link-help-open');
        };

        $rootScope.onMagicLinkHelpOverlayClick = function(e) {
            if (e && e.target === e.currentTarget) {
                $rootScope.hideMagicLinkHelp(e);
            }
        };

        $scope.openMagicLinkHelp = $rootScope.openMagicLinkHelp;
        $scope.hideMagicLinkHelp = $rootScope.hideMagicLinkHelp;

        var self = this;
        self.options = null;
        self.onAuthComplete = null;
        $scope.userData = userService.data;
        
        /** Same-origin return path for post-login / post-sign-up redirects (path + query + hash). */
        var getPostAuthReturnUrl = function() {
            return window.location.pathname + window.location.search + (window.location.hash || '');
        };
        
        //Populates options based on self.options
        var populateSignUp = function() {
            $scope.details.email = self.options.email;
            var firstName="", lastName="";
            if(self.options.name) {
                var names = self.options.name.split(' ');
                $scope.details.firstName = names[0];
                names.shift();
                $scope.details.lastName = names.join(' ');
            }
        };
        
        var authSuccess = function(user) {
            userService.data.user = user;
            $scope.hide();
            if(self.options.skipCompleteMessage) {
                if(self.onAuthComplete) {
                    self.onAuthComplete();
                }
            } else {
                signOnCompleteEvent.broadcast(function() {
                    if(self.onAuthComplete) {
                        self.onAuthComplete();
                    }
                });
            }
        };
        
        var authError = function(err) {
            $scope.isSaving = false;
            $scope.infoMessage = '';
            var msg = err && (err.error || err.message || err.detail);
            if (msg) {
                $scope.fadeInError(msg);
            }
        };
        
        $scope.fadeInAlert = function(message, alertType) {
            $scope.hideError();
            $scope.alertType = alertType || 'danger';
            $timeout(function() {
                $scope.error = $sce.trustAsHtml(message);
            }, 500);
        };
        
        $scope.fadeInError = function(message) {
            $scope.fadeInAlert(message, 'danger');
        };
        
        $scope.hideError = function() {
            $scope.error = null;
            $scope.alertType = 'danger';
            $scope.infoMessage = '';
        };
        
        $scope.show = function(errorMessage) 
        {
            $('popup-window').each(function() {$(this).addClass('hide')});
            var type = (self.options && self.options.alertType) ? self.options.alertType : 'danger';
            if (errorMessage) {
                $scope.fadeInAlert(errorMessage, type);
            } else {
                $scope.hideError();
            }
            $scope.showPasswordLogin = false;
            $scope.magicLinkSent = false;
            $scope.magicLinkSentEmail = '';
            $rootScope.showMagicLinkHelp = false;
            angular.element(document.body).removeClass('magic-link-help-open');
            $scope.showSignUpWindow = false;
            $scope.showSignOnWindow = true;
            
            $rootScope.bodyClass = 'locked';
            $rootScope.bodyStyle = 'height:' + $( window ).height() + 'px';
            $scope.offsetTop = $(window).scrollTop();
            
            setTimeout(function() {
                var el = document.getElementById('link-email-modal') || document.getElementById('email');
                if (el) { try { el.focus(); } catch (err) {} }
            }, 300);
        };

        $scope.showSignUp = function(e) {
            return $scope.showSignOn(e);
        };

        
        $scope.showSignOn = function(e) {
            e.preventDefault();
            $scope.showSignUpWindow = false;
            $scope.showSignOnWindow = true;
            $scope.showPasswordLogin = false;

            setTimeout(function() {
                var el = document.getElementById('link-email-modal') || document.getElementById('email');
                if (el) { try { el.focus(); } catch (err) {} }
            }, 300);
        };
        
        $scope.hide = function() {
            $scope.hideError();
            $scope.magicLinkSent = false;
            $scope.magicLinkSentEmail = '';
            $rootScope.showMagicLinkHelp = false;
            angular.element(document.body).removeClass('magic-link-help-open');
            $scope.showSignUpWindow = false;
            $scope.showSignOnWindow = false;
            $rootScope.bodyClass = '';
            $rootScope.bodyStyle = '';
            $('popup-window').each(function() {$(this).removeClass('hide')});
        };
        
        $scope.togglePasswordLogin = function(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            $scope.showPasswordLogin = !$scope.showPasswordLogin;
            $timeout(function() {
                if ($scope.showPasswordLogin) {
                    var el = document.getElementById('email');
                    if (el) { try { el.focus(); } catch (err) {} }
                } else {
                    var el2 = document.getElementById('link-email-modal');
                    if (el2) { try { el2.focus(); } catch (err2) {} }
                }
            }, 0);
        };

        $scope.requestLoginLink = function(e) {
            e.preventDefault();
            $scope.hideError();
            $scope.details.from = getPostAuthReturnUrl();
            if (!$scope.details.email) {
                $scope.fadeInError('Please enter your email address.');
                return;
            }
            $scope.isSaving = true;
            return authService.requestLoginLink($scope.details, function(err) { throw new Error(err); })
                .then(function(data) {
                    $scope.isSaving = false;
                    $scope.magicLinkSent = true;
                    $scope.magicLinkSentEmail = $scope.details.email || '';
                    $scope.infoMessage = '';
                }, authError);
        };

        $scope.signOn = function(e) {
            e.preventDefault();
            $scope.hideError();
            $scope.isSaving = true;
            $scope.details.from = getPostAuthReturnUrl();

            return authService.signOn($scope.details, function(err) {throw new Error(err);})
                .then(authSuccess, authError);
        };
        
        $scope.signUp = function(e) {
            e.preventDefault();
            $scope.details['g-recaptcha-response'] = $('#g-recaptcha-response').val();
            $scope.details.from = getPostAuthReturnUrl();
            $scope.hideError();
            
            $scope.isSaving = true;

            return authService.signUp($scope.details, function(err) {throw new Error(err);})
                .then(function(data) {
                    $scope.isSaving = false;
                    var payload = data && data.data !== undefined ? data.data : data;
                    if (payload && payload.loginLinkSent) {
                        var m = payload.message && String(payload.message).trim();
                        $scope.infoMessage = m || 'Check your email for a sign-in link. If you don\'t see it, check your spam folder.';
                        return;
                    }
                    authSuccess(payload);
                }, authError);
        };
        
        showAuthEvent.listen(function(message, onAuthComplete, options) {
            self.options = options ? options : {};
            self.onAuthComplete = onAuthComplete;
            
            if(self.options.interestedIn) {
                $scope.details.interestedIn = self.options.interestedIn;    
            } 
            if(self.options.instantSignup) {
                $scope.details.instantSignup = self.options.instantSignup;
            }

            populateSignUp();
            $scope.show(message);
        })
    }]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('continentCtrl', ['$scope', 'eventService', 'continentFilterService', 'filterEventService', '$timeout',
	function($scope, eventService, continentFilterService, filterEventService, $timeout) {
	
	var nextPage = 1;
	$scope.isLoading = true;
	$scope.isMoreResults = true;
	$scope.hideInitialResults = false;
	
	$scope.filters = []; 
	//Filtered events
	$scope.events = [];
	//Extra events for pagination.  Doesn't clear the initial result set
	$scope.moreEvents = [];
	
	//Load in more events
	$scope.loadMore = function() {
		var filterItems = continentFilterService.getSelectedFilterItems(nextPage);
		$scope.isLoading = true;

		eventService.getContinentEvents(filterItems)
			.then(function(data)
			{
				$scope.moreEvents = $scope.moreEvents.concat(data.events);
				nextPage++;
				$scope.isLoading = false;
				if(data.events.length < data.resultsPerPage) {
					$scope.isMoreResults = false;
				}
				
			});
	};

	var resetPagination = function() {
		nextPage = 1;
		$scope.moreEvents = [];
		$scope.isLoading = false;
		$scope.hideInitialResults = true;
	};
	


	//Subscribe to filter item events
	filterEventService.listen(function() {
		var filterItems = continentFilterService.getSelectedFilterItems(0);
		//Cycling only: 
		//$scope.type = filterItems.type[0];
		$scope.isLoading = true;
		
		eventService.getContinentEvents(filterItems)
			.then(function(data)
			{
				
				$scope.events = data.events;
				resetPagination();
				if(data.events.length < data.resultsPerPage) {
					$scope.isMoreResults = false;
				} else {
					$scope.isMoreResults = true;
				}

				return true;	
			})
	});

	//Main code to run when params are loaded in via ng-init
	$scope.$watch('routeParams', function () {
		$scope.continent = $scope.routeParams.continent;
		$scope.type = $scope.routeParams.type;
		//Hide more results if there isn't a full result set
		if(parseInt($scope.routeParams.numEvents) < parseInt($scope.routeParams.perPage)) {
			$scope.isMoreResults = false;
		}
		
		
		/** @namespace $scope.routeParams */
		continentFilterService.getFilters($scope.routeParams.continent.key, $scope.routeParams.type)
			.then(function(filters)
			{
				$scope.filters = filters;
				$(".event-filter").animate({opacity:1}, 200);
				$scope.isLoading = false;
			})
			.catch(function(error)
			{
				console.log(error);
			});
	});
}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core') 
.controller('eventLightboxCtrl', ['$scope', 'eventLightboxService', '$sce',
	function($scope, eventLightboxService, $sce) {

	$scope.lightbox = eventLightboxService;
	$scope.locationString = "";
	$scope.event = null;
	$scope.visible = false;
		
	$scope.currentImage = 0;
		
	var populateLightbox = function(data) {
		$scope.currentImage = 0;

		$scope.event = data;


		if(typeof(data.entryCost) == 'string') {
			$scope.event.entryCost = $sce.trustAsHtml(data.entryCost);
		}
		if(typeof(data.distanceInfo) == 'string') {
			$scope.event.distanceInfo = $sce.trustAsHtml(data.distanceInfo);
		}

		//Add images to array, based on galleryOrder
		$scope.event.images = [];
		if($scope.event.galleryOrder) {
			var indices = $scope.event.galleryOrder.split(',');
			for(i=0; i<indices.length; i++) {
				if($scope.event._gallery && $scope.event._gallery[indices[i]]) {
					$scope.event.images.push($scope.event._gallery[indices[i]]);
				}
			}
		}

		var addressElements = [
			data.location.street1,
			data.location.suburb,
			data.location.state
		];
		addressElements = addressElements.filter(function(x) {return x != null;});
		$scope.locationString = addressElements.join(', ');
	};
		
	$scope.clearEvent = function() {
		eventLightboxService.clearEvent();
		$scope.event = null;
	};
		
	$scope.hideLightbox = function() {
		eventLightboxService.clearEvent();
		$scope.visible = false;
	};
		
	$scope.nextImage = function() {
		$scope.currentImage++;
		$scope.currentImage = $scope.currentImage % $scope.event.images.length;
	};

	$scope.prevImage = function() {
		$scope.currentImage--;
		$scope.currentImage = $scope.currentImage % $scope.event.images.length;
		if($scope.currentImage < 0) {
			$scope.currentImage += $scope.event.images.length;
		}
	};
		
	//Watch for changes in eventlightbox event
	$scope.$watch(function(){
		return eventLightboxService.getEvent();
	}, function (newValue) {
		if(newValue) {
			
			populateLightbox(newValue);
			$scope.visible = true;
			//$(".image-holder img").css('position', 'absolute');
			setTimeout(function() {
				$(".image-holder img").fadeIn(300);
			}, 150);
		}
		
		
		
	});
		
	

}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('eventsCtrl', ['$scope', 'mapFilterService', 'mapService', 'filterEventService', 'photoService', 'requireLoginService',
	function($scope, mapFilterService, mapService, filterEventService, photoService, requireLoginService) {

	$scope.filters = [];
		
		//Main code to run when params are loaded in via ng-init
	$scope.$watch('routeParams', function () {
		console.log($scope.routeParams);


		$scope.panLocation = $scope.routeParams.mapLocation;
		$scope.sponsors = $scope.routeParams.sponsors;

		mapFilterService.getFilters()
			.then(function(filters)
			{
				$scope.filters = filters;
				$(".map-filter").animate({opacity:1}, 200);
			})
			.catch(function(error)
			{
				console.log(error);
			});
	});
		
	$scope.mapGoTo = function(address) {
		if(address) {
			mapService.goTo(address)
		}
	};
		
	//Initialize map
	mapService.init($('.event-map'),
		function(map) {
			if($scope.panLocation) {
				$scope.mapGoTo($scope.panLocation);
			}
			//Load events after the map has completed loading, and shifted to the user's location
			map.addListener('bounds_changed', function() {
				mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				google.maps.event.clearListeners(map, 'bounds_changed');

				map.addListener('zoom_changed', function() {
					mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				});

				map.addListener('dragend', function() {
					mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				});
			});
		});

	//Subscribe to filter item events
	filterEventService.listen(function() {
		var filterItems = mapFilterService.getSelectedFilterItems(null);
		console.log(filterItems);
		$scope.isLoading = true;

		mapService.getEvents(filterItems)
			.then(function(data)
			{
				$scope.events = data.events;
				if(data.events.length < data.resultsPerPage) {
					$scope.isMoreResults = false;
				} else {
					$scope.isMoreResults = true;
				}

			});
	});
	
	/* homepage event search */
		
	//Load in first photo
	$scope.$watch('routeParams', function (routeParams) {
		$scope.events = routeParams.events;
		photoService.currentParticipant = routeParams.participant;
	});

	requireLoginService.init($scope);

	}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('filmCtrl', ['$scope',
	function($scope) {

	

		
}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('indexCtrl', ['$scope', 'mapFilterService', 'mapService', 'filterEventService',
	function($scope, mapFilterService, mapService, filterEventService) {

	$scope.filters = [];
		
		//Main code to run when params are loaded in via ng-init
	$scope.$watch('routeParams', function () {


		$scope.panLocation = $scope.routeParams.mapLocation;
		
		mapFilterService.getFilters()
			.then(function(filters)
			{
				$scope.filters = filters;
				$(".map-filter").animate({opacity:1}, 200);
			})
			.catch(function(error)
			{
				console.log(error);
			});
	});
		
	$scope.mapGoTo = function(address) {
		if(address) {
			mapService.goTo(address)
		}
	};
		
	//Initialize map
	mapService.init($('.event-map'),
		function(map) {
			if($scope.panLocation) {
				$scope.mapGoTo($scope.panLocation);
			}
			//Load events after the map has completed loading, and shifted to the user's location
			map.addListener('bounds_changed', function() {
				mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				google.maps.event.clearListeners(map, 'bounds_changed');

				map.addListener('zoom_changed', function() {
					mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				});

				map.addListener('dragend', function() {
					mapService.getEvents(mapFilterService.getSelectedFilterItems(null));
				});
			});
		});

	//Subscribe to filter item events
	filterEventService.listen(function() {
		var filterItems = mapFilterService.getSelectedFilterItems(null);
		$scope.isLoading = true;

		mapService.getEvents(filterItems)
			.then(function(data)
			{
				$scope.events = data.events;
				if(data.events.length < data.resultsPerPage) {
					$scope.isMoreResults = false;
				} else {
					$scope.isMoreResults = true;
				}

			});
	});

	}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('NewsCtrl', ['$scope', 'newsService', 'userService', 'autoplayService', 'showAuthEvent', 'newSignUpCompleteEvent',
	function($scope, newsService, userService, autoplayService, showAuthEvent, newSignUpCompleteEvent) {
		var news = this;

		news.newsService = newsService;
		
		var showSignup = function(data) {
			var options = {email:data.email, name:data.name, skipCompleteMessage: true};
			showAuthEvent.broadcast(null, function() {
				newSignUpCompleteEvent.broadcast();
			}, options);
		};
		
		var query = queryString();
		if(query.type) {
			news.newsService.options.type = query.type;
		}
		if(query.refine) {
			news.newsService.options.refine = query.refine;
		}
		if(query.category) {
			news.newsService.options.category = query.category;
		}

		window.onpopstate = function(event) {
			//Check for browsers that call onpopstate on page load
			if(event.state) {
				window.location.reload();
			}
		};

		$scope.$watch('news.data', function(newVal) {
			console.log($scope.news.data);
			newsService.articles = newVal.articleData.articles;
			newsService.categories = newVal.categories;
			newsService.init(newVal.articleData.articles);

			userService.data.user = newVal.user;
			
			if($scope.news.data.signUp && !userService.data.user) {
				showSignup($scope.news.data.signUp);
			}

			autoplayService.init();
		});
}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
    .controller('photosCtrl', ['$scope', '$rootScope', 'photoService', 'userService', 'showAuthEvent', 'requireLoginService', 'showSelfieEvent',
    function($scope, $rootScope, photoService, userService, showAuthEvent, requireLoginService, showSelfieEvent) {

        //Load in first photo
        $scope.$watch('routeParams', function (routeParams) {
            if (routeParams) {
                $rootScope.routeParams = routeParams;
                var eventKey = (routeParams.event && routeParams.event.key) ? routeParams.event.key : '';
                var url = '/api/participants/search?eventKey=' + encodeURIComponent(eventKey) + '&search=';
                $scope.participantSearchUrl = url;
                $rootScope.participantSearchUrl = url;
            }
            userService.data.user = routeParams.user;
            $scope.sponsors = routeParams.sponsors;
            photoService.init(routeParams);
            $(".facial-rec").css('opacity', 1);
        });

        $scope.userData = userService.data;
        $scope.showSignUp = function() {
            return showAuthEvent.broadcast("Sign in to view your photos", null, {showSignOn:true, instantSignup: false, interestedIn: photoService.event.type});
        };
        $scope.photoService = photoService;
        
        $scope.showSelfie = function() {
            showSelfieEvent.broadcast($scope.photoService.currentBib);
        }
        
		 requireLoginService.init($scope);
        
    }]);
 

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('quickSearchCtrl', ['$scope', 'eventService', '$timeout',
	function($scope, eventService, $timeout) {
		
		var KEY_UP = 38;
		var KEY_DOWN = 40;
		var KEY_ENTER = 13;
		var KEY_ESCAPE = 27;
		
		$scope.search = "";
		$scope.searchResults = [];
		$scope.selectedIndex = null;
		
		$scope.shouldShowSearch = false;
		$scope.showTooShort = false;
		$scope.showResults = false;
		$scope.showLoading = false;
		$scope.showSearchPane = false;
		
		$scope.encode = function(str) {
			return encodeURIComponent(str);
		};
		
		var selectNextResult = function() {
			if($scope.searchResults.length) {
				if($scope.selectedIndex == null) {
					$scope.selectedIndex = 0;
				} else {
					$scope.selectedIndex = mod($scope.selectedIndex + 1, $scope.searchResults.length);
				}
			}
		};

		var selectPrevResult = function() {
			console.log('prev');
			if($scope.searchResults.length) {
				if($scope.selectedIndex == null) {
					$scope.selectedIndex = $scope.searchResults.length - 1;
				} else {
					$scope.selectedIndex = mod($scope.selectedIndex - 1, $scope.searchResults.length);
				}
			}
		};
		
		$scope.showSearch = function() {
			$scope.shouldShowSearch = true;
			$("#header .quick-search, #header .cover").hide();
			$("#header .quick-search, #header .cover").fadeIn(200,function() {
				$("#quick-search-field").focus();
			});
			
		};
		
		$scope.hideSearch = function() {
			$scope.selectedIndex = null;
			$("#header .quick-search, #header .cover").fadeOut(200, function() {
				$scope.shouldShowSearch = false;
			});
			
		};
		
		$scope.quickSearchEvents = function(keyEvent) {
			//Process up/down key press
			if(keyEvent.which == KEY_DOWN) {
				keyEvent.preventDefault();
				selectNextResult();
			}
			else if (keyEvent.which == KEY_UP) {
				keyEvent.preventDefault();
				selectPrevResult();
			}
			else if (keyEvent.which == KEY_ENTER) {
				keyEvent.preventDefault();

				if($scope.searchResults.length && $scope.selectedIndex != null) {
					window.location.href = '/event/' + $scope.searchResults[$scope.selectedIndex].key;
				}
				
			}
			else if(keyEvent.which == KEY_ESCAPE) {
				$scope.hideSearch();
			}
			else {
				$scope.selectedIndex = null;
				$timeout(function() {
					var search = $scope.search;
					search = search.replace(/[^\w\s-]/g,'');
					if (search.length >= 3) {
						
						if(!$scope.inProgress) {
							$scope.inProgress = true;

							eventService.getEventQuickSearch(search)
								.then(function (events) {
									$scope.searchResults = events;
									//$scope.showLoading = false;
									$scope.showResults = true;
									$scope.showSearchPane = true;
									$timeout(function() {
										$scope.inProgress = false;
									}, 300);
								})
						}
						
					} else {
						$scope.showSearchPane = false;
					}
					
				}, 1);
			}
		};
	}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('submitCtrl', ['$scope',
	function($scope) {

	$scope.visibleForm = null;
	$scope.TYPE = {
		EVENT:0,
		FILM:1
	};
		
	$scope.showForm = function(type) {
		if(type == $scope.TYPE.EVENT) {
		} else {
			
		}
		$scope.visibleForm = type;
	};

		
}]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive("centsToMoney", function() {
        return {
            template: '<span></span>',
            scope: {
                amount: "@"
            },
            link: function($scope, $element) {
                $scope.$watch('amount', function() {
                    var amount = '$'+($scope.amount/100).toFixed(2);
                    $element.html(amount);
                })
            }
        }
    });
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('cover', ['hideCoverEvent', 'showCoverEvent',
        function(hideCoverEvent, showCoverEvent) {
        return {
            template: '<div class="ra-cover"></div>',
            restrict: 'E',
            scope: {
                hideOnClick:'=?',
                onHide: '&?'
            },
            link: function($scope, $element) {
                var $cover = $element.find('.ra-cover');
                
                $cover.fadeIn(300);
                
                if($scope.hideOnClick) {
                    $cover.click(function() {
                        if($scope.onHide) {
                            $scope.onHide();
                        }
                    })
                }
            }
        };
    }]);

/**
 * Created by jordan on 29/11/2016.
 */
angular.module('ra.core').directive('disableArrows', function() {

    function disableArrows(event) {
        if (event.keyCode === 38 || event.keyCode === 40) {
            event.preventDefault();
        }
    }

    return {
        link: function(scope, element, attrs) {
            element.on('keydown', disableArrows);
        }
    };
});
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('dotdotdot', ['$sce', '$timeout', 
        function($sce, $timeout) {
            return {
                restrict: 'A',
                scope: {
                    height: '@?'
                },
                link: function($scope, element, attributes) {
                    $scope.$watch(function() {
                        var params = {watch: true};
                        if($scope.height) {
                            params.height = parseInt($scope.height);
                        }
                        $(element).dotdotdot(params);
                    });
                }
            };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('emailShare', ['emailShareService', 'photoService', 'showEmailShareEvent',
        function(emailShareService, photoService, showEmailShareEvent) {
        return {
            templateUrl: 'emailShare.html',
            restrict: 'E',
            scope: {
                eventId: '@',
                participantId: '=',
            },
            link: function($scope) {
                
                var init = function() {
                    $scope.formData = {};
                    $scope.formData.email = '';
                    $scope.photoId = '';
                    
                    $scope.$broadcast("hidePopup");
                    $scope.hasSubmitted = false;
                    $scope.isLoading = false; 
                    $scope.isCompleted = false;
                };
                
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };
                
                $scope.hide = function() {
                    init();
                };
                
                $scope.send = function() {
                    $scope.hasSubmitted = true;
                    if($scope.form.$valid) {
                        $scope.isLoading = true;
                        
                        return emailShareService.send($scope.formData.email, $scope.eventId, $scope.photoId, photoService.currentParticipant._id)
                            .then(function() {
                                $scope.isCompleted = true;
                                $scope.isLoading = false;
                            },
                            function(err) {
                                $scope.isLoading = false;
                                alert("We had a problem sharing your photo.  Please check the email and try again");
                            })
                    }
                };

                showEmailShareEvent.listen(function(photoId) {
                    $scope.photoId = photoId;
                    $scope.show();
                });
                init();
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('eventMap', ['$sce', '$timeout', 
        function($sce, $timeout) {
        return {
            templateUrl: 'eventMap.html',
            restrict: 'E',
            scope: {
                mapData: '=',
            },
            link: function($scope) {

                var DEFAULT_TRIATHLON_LEG = 'swim';
                
                $scope.legInfo = {};
                $scope.showMapHolder = false;
                $scope.triathlonMode = false;
                $scope.showDistanceSelect = false;
                $scope.selectedLeg = DEFAULT_TRIATHLON_LEG;
                $scope.legNames = "";
                
                //Initialize the map
                function initMap(mapData) {

                    if(mapData.eventType === 'Triathlon') {
                        $scope.selectedLeg = DEFAULT_TRIATHLON_LEG;
                        $scope.triathlonMode = true;
                        $scope.legNames = "";
                    }
                    else {
                        //Get starting map
                        $scope.selectedLeg = (mapData.startingMap ? mapData.startingMap : 1) - 1;
                        if(!mapData.legs[$scope.selectedLeg]) {
                            $scope.selectedLeg = 0;
                        }

                        if(mapData.legs[1]) {
                            $scope.showDistanceSelect = true;
                        }

                        angular.forEach(mapData.legs, function(value, key) {
                            if(key!=0) {
                                $scope.legNames += ' / ';
                            }
                            $scope.legNames += value.distance + "km";
                        });
                    }

                    $scope.legInfo = mapData.legs[$scope.selectedLeg];

                    $timeout(function() {
                        updateMap($scope.selectedLeg, $scope.legInfo);
                    }, 200);
                }

                function updateMap(legName, legInfo) {
                    if(legInfo && legInfo.kml && legInfo.kml.url) {
                        $scope.showMapHolder = true;
                        var mapDiv = 'map-'+legName;
                        RideMap.create(legInfo.kml.url, legInfo.distance, mapDiv);
                    }
                }

                $scope.showLeg = function(leg) {
                    $scope.selectedLeg = leg;
                    $scope.legInfo = $scope.mapData.legs[leg];
                    $timeout(function() {
                        updateMap(leg, $scope.legInfo);
                    }, 200);
                };

                if(typeof($scope.mapData.text) == 'string') {
                    $scope.mapData.text = $sce.trustAsHtml($scope.mapData.text);
                }

                initMap($scope.mapData);
            } 
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('findEvent', ['$sce', '$timeout',
        function($sce, $timeout) {
            return {
                templateUrl: 'findEvent.html',
                restrict: 'E',
                scope: {
                    events: '='
                },
                link: function($scope, $element) {
                    
                    var $eventSelect = $element.find("#event");

                    $scope.formData = {
                        search: {},
                        event: "",
                        searchStr: "",
                    };

                    // Initialize dropdown state
                    $scope.eventSearch = '';
                    $scope.showEventDropdown = false;
                    $scope.eventSelected = false;
                    $scope.previousScrollPosition = 0;

                    $scope.unValidate = function() {
                        $eventSelect.removeClass("hasError");
                    };

                    $scope.selectEvent = function(event) {
                        $scope.formData.event = event;
                        $scope.eventSearch = event.name;
                        $scope.showEventDropdown = false;
                        $scope.eventSelected = true;
                        $scope.unValidate();
                        
                        // Blur the input field
                        $timeout(function() {
                            $element.find('#event').blur();
                        }, 50);
                        
                        // Restore previous scroll position on mobile
                        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                        
                        if (isIOS || isMobile) {
                            $timeout(function() {
                                window.scrollTo({
                                    top: $scope.previousScrollPosition,
                                    behavior: 'smooth'
                                });
                            }, 150);
                        }
                    };

                    $scope.onEventSearchFocus = function() {
                        // Save current scroll position before any scrolling
                        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                        
                        if (isMobile) {
                            $scope.previousScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                        }
                        
                        if ($scope.eventSelected) {
                            $scope.eventSearch = '';
                            $scope.eventSelected = false;
                            $scope.formData.event = "";
                        }
                        $scope.showEventDropdown = true;
                        
                        // Handle iOS mobile scroll positioning
                        if (isMobile) {
                            $timeout(function() {
                                var eventInput = $element.find('#event')[0];
                                if (eventInput) {
                                    var rect = eventInput.getBoundingClientRect();
                                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                                    var targetPosition = scrollTop + rect.top - 60; // 20px from top
                                    
                                    window.scrollTo({
                                        top: targetPosition,
                                        behavior: 'smooth'
                                    });
                                }
                            }, 100);
                        }
                    };

                    $scope.onEventSearchChange = function() {
                        if (!$scope.formData.event) {
                            return;
                        }

                        if ($scope.eventSearch !== $scope.formData.event.name) {
                            $scope.formData.event = "";
                            $scope.eventSelected = false;
                        }
                    };

                    $scope.hideDropdown = function() {
                        $timeout(function() {
                            $scope.showEventDropdown = false;
                        }, 150);
                    };  
 
                    $scope.validateSubmit = function() {
                        $timeout(function() {
                            if(!$scope.formData.event) {
                                $eventSelect.addClass("hasError");
                                return false;
                            }
                            window.location.href = $scope.formData.event.url;
                            return false;
                        }, 100);
                    };        
                
                    var checkQueryEvent = $scope.$watch('events', function() {
                        var query = queryString();
                        if(query.event && $scope.events) {
                            var matching = $scope.events.filter(function(x) { return x.key === query.event; });
                            if(matching.length > 0) {
                                $scope.selectEvent(matching[0]);
                            }
                        }
                        
                        checkQueryEvent();
                    });

                    // Listen for event selection from tiles
                    $scope.$on('selectEventFromTile', function(event, selectedEvent) {
                        if (selectedEvent && $scope.events) {
                            var matching = $scope.events.filter(function(x) { return x.key === selectedEvent.key; });
                            if(matching.length > 0) {
                                $scope.selectEvent(matching[0]);
                                
                                // Add highlight effect to the select holder
                                var selectHolder = $element.find('.select-holder').first();
                                selectHolder.addClass('highlight');

                                $scope.formData.searchStr = "";
                                
                                // Remove highlight class after 3 seconds
                                $timeout(function() {
                                    selectHolder.removeClass('highlight');
                                }, 1000);
                            }
                        }
                    });
                    
                }
            };
        }]);

angular.module('ra.core')
    .directive('fullscreenBlock', ['$compile', 
    function ($compile) {
        
    var jqLite = angular.element;
    var link = function (scope, element, attrs, controller, transcludeFn) {

    };
    // This function helps to find the first parent element which contains the
    // 'fullscreen-block' attribute. The function can be replaced with JQuery
    // `closest()` method if JQuery library is used.
    var closest = function (element) {
        return (jqLite(element).parent().attr('fullscreen-block') !== undefined) ?
            jqLite(element).parent() :
            closest(jqLite(element).parent());
    };
    var controller = function ($scope) {
        // handles the ng-click event
        $scope.fullscreenMode = function (event) {
            var modalWrapper = '<modal-wrapper></modal-wrapper>';
            jqLite(closest(event.target)).wrap(modalWrapper);
            $compile(modalWrapper)($scope);
        };
    };
    return {
        link: link,
        transclude: true,
        templateUrl: 'fullscreenBlock.html',
        controller: ['$scope', controller]
    }
}]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
.directive('imageOnload', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('load', function() {
                alert('image is loaded');
            });
            element.bind('error', function(){
                alert('image could not be loaded');
            });
        }
    };
});
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('loadMore', ['$document', '$location', 'commentService', 'refreshCommentsEvent',
        function($document, $location, commentService, refreshCommentsEvent) {
        return {
            templateUrl: 'loadMore.html',
            restrict: 'E',
            scope: {
                comments: '='
            },
            link: function($scope) {
                $scope.moreComments = true;
                $scope.numMoreComments = 0;
                $scope.page = 0;
            }
        };
    }]);
/**
 * Plays magic-link mail or wand motion once when the element is linked (e.g. after ng-if shows confirmation).
 */
angular.module('ra.core')
    .directive('magicLinkMotion', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var motion = null;
                var variant = attrs.magicLinkMotion || 'mail';
                var playDelay = parseInt(attrs.magicLinkMotionDelay, 10);
                if (isNaN(playDelay) || playDelay < 0) {
                    playDelay = 0;
                }
                var cancelled = false;

                function runMotion() {
                    if (cancelled || !motion) {
                        return;
                    }
                    if (variant === 'wand') {
                        motion.wand();
                    } else {
                        motion.mail();
                    }
                }

                function start(attempt) {
                    if (cancelled) {
                        return;
                    }
                    if (!window.createMagicLinkMotion) {
                        if (attempt < 40) {
                            $timeout(function() { start(attempt + 1); }, 50);
                        }
                        return;
                    }
                    if (motion) {
                        motion.destroy();
                    }
                    motion = window.createMagicLinkMotion(element[0]);
                    $timeout(function() {
                        window.requestAnimationFrame(function() {
                            window.requestAnimationFrame(runMotion);
                        });
                    }, playDelay);
                }

                start(0);

                scope.$on('$destroy', function() {
                    cancelled = true;
                    if (motion) {
                        motion.destroy();
                        motion = null;
                    }
                });
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('mobileMenu', ['enableWrapperCoverEvent', '$timeout', 'toggleMobileMenuEvent', 'closeWrapperCoverEvent',
        function(enableWrapperCoverEvent, $timeout, toggleMobileMenuEvent, closeWrapperCoverEvent) {
        return {
            templateUrl: 'mobileMenu.html',
            restrict: 'E',
            scope: {},
            link: function($scope, $element) {
                var MENU_TRANSITION_TIME = 500;

                var mobileMenuVisible = false;
                var menuChanging = false;
                
                var $mobileMenu = $(".pull-menu");
                
                $scope.showMobileMenu = function() {
                    enableWrapperCoverEvent.broadcast($scope.hideMobileMenu);

                    if(!mobileMenuVisible && !menuChanging) {
                        mobileMenuVisible = true;
                        menuChanging = true;
                        $mobileMenu.show();

                        var width = $mobileMenu.width() + "px";
                        $("#wrapper, #header").css({
                            "left": width
                        });

                        $timeout(function() {
                            menuChanging = false;
                        }, MENU_TRANSITION_TIME);

                        return true;
                    } else {
                        return false;
                    }

                };

                $scope.hideMobileMenu = function() {
                    if(mobileMenuVisible && !menuChanging) {

                        closeWrapperCoverEvent.broadcast();
                        menuChanging = true;
                        $("#wrapper, #header").css({
                            "left": ""
                        });

                        $timeout(function() {
                            $mobileMenu.hide();
                            menuChanging = false;
                            mobileMenuVisible = false;
                        }, MENU_TRANSITION_TIME);

                        return true;
                    } else {
                        return false;
                    }
                };

                toggleMobileMenuEvent.listen(function() {
                    if(!mobileMenuVisible) {
                        $scope.showMobileMenu();
                    } else {
                        $scope.hideMobileMenu();
                    }
                });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.core')
    .directive('mobileMenuBtn', ['toggleMobileMenuEvent',
        function(toggleMobileMenuEvent) {
        return {
            templateUrl: 'mobileMenuBtn.html',
            restrict: 'E',
            replace:true,
            scope: {
            },
            
            link: function($scope, $element) {
                $scope.toggleMenu = function() {
                    toggleMobileMenuEvent.broadcast();
                }
            }
        };
    }]); 
/**
 * Created by jordan on 2/08/2016.
 */
angular.module('ra.core')
    .directive('modalWrapper',["$compile", "$document",
    function ($compile, $document) {

        /*
         * The modal window template
         */
        var template =
            '<div id="modal-fullscreen" class="modal modal-fullscreen"' +
            'style="background: white">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" ng-click="close()">&times;</button>' +
            '</div>' +
            '<div class="modal-body row" style="margin: 0; display: flex;"></div>' +
            '</div>';
        var chart;
        /*
         * The link function.
         */
        var link = function (scope, element) {
            scope.open();
            // watches if modal is opened
            scope.$watch('showModal', function (newVal) {
                var modalEl = $('modal-wrapper');
                var fullscreenIcon = modalEl.find('[name="fullscreen"]');
                // if modal is opened
                if (newVal) {
                    // hides the fullscreen icon for the modal
                    fullscreenIcon.addClass("ng-hide");
                    // inserts content from the page to the body of modal element.
                    // JQuery's `insertBefore()` method can be used as well.
                    modalEl[0].parentNode.insertBefore(element[0], modalEl[0]);
                    // shows content a fullscreen view
                    var content = modalEl.children();
                    // puts the element inside the modal
                    $(".modal-body").append(content);
                    // removes the <modal-wrapper> tag
                    modalEl.remove();
                    // makes the modal visible
                    $('#modal-fullscreen').show();
                    // if modal is closed
                } else if (!newVal) {
                    // shows the 'fullscreen' button after the modal is closed
                    fullscreenIcon.removeClass("ng-hide");
                    // looks up the element
                    var modalBody = modalEl.find(".modal-body").children();
                    // inserts content from modal back to the page.
                    // JQuery's `insertBefore()` method can be used as well.
                    modalEl[0].parentNode.insertBefore(modalBody[0], modalEl[0]);
                    // removes the modal
                    modalEl.remove();
                }

            })
        };
        /*
         * The controller function.
         */
        var controller = function ($scope) {
            $scope.open = function () {
                $scope.showModal = true;
            };
            $scope.close = function () {
                $scope.showModal = false;
            };
            // closes the modal when the back button is clicked
            $scope.$on('$locationChangeStart', function(event) {
                if ($scope.showModal) {
                    event.preventDefault();
                    $scope.close();
                }
            });
        };
        return {
            restrict: 'E',
            scope: {},
            template: template,
            link: link,
            controller: controller
        }
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Popup window directive
 * Due to transclusion,need to pass formCtrl if you want to use a form
 * You must set formCtrl
 */
angular.module('ra.core')
    .directive('popupWindow', ['showCoverEvent', 'hideCoverEvent', '$compile',
        function(showCoverEvent, hideCoverEvent, $compile) {
        return {
            template: '' +
                '<div class="popup-form" ng-style="{top:top+\'px\'}">' +
                    '<div class="inner">' +
                        '<div class="close" ng-click="hide()"></div>' +
                        '<ng-transclude></ng-transclude>' + 
                    '</div>' +
                '</div>',
            restrict: 'E',
            transclude: true,
            scope: {
                formCtrl: '=?',
                onClose: '&?',
                hideOnCoverClick: '=?',
                state: '=?'
            },
            link: function($scope, $element) {
                var cover = undefined;
                var coverScope = undefined;
                
                //Used if you require a form inside the popup window
                var connectForm = function() {
                    if($element.find('input')) {
                        var input1 = $element.find('input').eq(0);
                        $scope.formCtrl = input1.controller('form');
                    }

                };

                var $popupForm = $element.find('.popup-form');
                
                var createCover = function() {
                    if(cover) {
                        return;
                    }
                    coverScope = $scope.$new();
                    coverScope.hideOnClick = $scope.hideOnCoverClick;
                    coverScope.onHide = $scope.hide;
                    cover = $compile('<cover hide-on-click="hideOnClick" on-hide="onHide()"></cover>')(coverScope);
                    $element.prepend(cover);
                };
                
                var removeCover = function() {
                    if(cover) {
                        coverScope.$destroy();
                        coverScope = undefined;
                        cover.remove();
                        cover = undefined;
                    }
                }

                var init = function() {
                    $scope.top = 0;
                    $popupForm.hide();
                    removeCover();
                    // hideCoverEvent.broadcast();
                };

                $scope.show = function() {
                    $scope.top = $(document).scrollTop() + 40;
                    $popupForm.fadeIn(300);
                    // showCoverEvent.broadcast();
                    createCover();
                };
                

                $scope.hide = function() {
                    if ($scope.onClose) {
                        var result = $scope.onClose();
                        if (result === false) {
                            return;
                        }
                    }
                    init();
                };

                //Call $broadcast('showPopup') to show the popup
                $scope.$on('showPopup', function() {
                   $scope.show();
                });

                //Call $broadcast('hidePopup') to hide the popup
                $scope.$on('hidePopup', function() {
                    $scope.hide();
                });

                init();
                connectForm();
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.core')
    .directive('settingsMenu', ['toggleSettingsMenuEvent', 'enableWrapperCoverEvent', 'closeWrapperCoverEvent',
        function(toggleSettingsMenuEvent, enableWrapperCoverEvent, closeWrapperCoverEvent) {
            return {
                templateUrl: 'settingsMenu.html',
                restrict: 'E',
                transclude: true,
                scope: {
  
                },
                link: function($scope, $element) {
                    var isVisible = false;
                    
                    $scope.toggle = function() {
                        if(!isVisible) {
                            $element.show();
                            $("#header").addClass('in-front');
                            enableWrapperCoverEvent.broadcast(toggleSettingsMenuEvent.broadcast);
                            isVisible = true;
                        } else {
                            $element.hide();
                            $("#header").removeClass('in-front');
                            closeWrapperCoverEvent.broadcast();
                            isVisible = false;
                        }
                    };
                    
                    $element.hide();
                    
                    toggleSettingsMenuEvent.listen(function() {
                        $scope.toggle();
                    });
                }
            };
        }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.core')
    .directive('settingsMenuBtn', ['toggleSettingsMenuEvent',
        function(toggleSettingsMenuEvent) {
        return {
            templateUrl: 'settingsMenuBtn.html',
            restrict: 'E',
            replace:true,
            scope: {
            },
            
            link: function($scope, $element) {
                $scope.toggleMenu = function() {
                    toggleSettingsMenuEvent.broadcast();
                };

                toggleSettingsMenuEvent.listen(function() {
                    if($element.hasClass('on')) {
                        $element.removeClass('on');
                    } else {
                        $element.addClass('on'); 
                    }
                })
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('signUpComplete', ['newSignUpCompleteEvent',
        function(newSignUpCompleteEvent) {
            return {
                replace: true,
                templateUrl: 'signUpComplete.html',
                restrict: 'E',
                scope: {
                   
                },
                link: function($scope, $element) {
                    
                    newSignUpCompleteEvent.listen(function() {
                        $element.show();
                    });
                    
                    $scope.close = function() {
                        $element.hide();
                    }
                }
            };
        }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('sponsorHero', ['clickService',
        function(clickService) {
        return {
            templateUrl: 'sponsorHero.html',
            restrict: 'E',
            scope: {
                sponsors:'=',
            },
            link: function($scope) {
                $scope.sponsorClick = function(sponsor) {
                    var data = {
                        modelId: sponsor._id,
                        list: 'SponsorHero'
                    };

                    clickService.add(data);
                    window.open(sponsor.link,'_blank');
                };

                $(document).ready(function() {
                    var gallery = new FilmGallery();
                });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('wrapperCover', ['enableWrapperCoverEvent', 'closeWrapperCoverEvent',
        function(enableWrapperCoverEvent, closeWrapperCoverEvent) {
        return {
            templateUrl: 'wrapperCover.html',
            restrict: 'E',
            scope: {
                mapData: '=',
            },
            link: function($scope, $element) {
                var $wrapperCover = $element.find(".wrapper-cover");
                $scope.callback = null;
                
                $scope.closeWrapper = function() {
                    if($scope.callback) {
                        var shouldClose = $scope.callback();
                        if(shouldClose) {
                            $scope.callback = null;
                            $wrapperCover.hide();
                        }
                        
                        
                    } else {
                        $wrapperCover.hide();
                    }
                };
                
                $scope.showWrapper = function() {
                    $wrapperCover.show();
                };
                
                enableWrapperCoverEvent.listen(function(callback) {
                    $scope.showWrapper();
                    $scope.callback = callback;
                });

                closeWrapperCoverEvent.listen(function(callback) {
                    $wrapperCover.hide();
                    $scope.callback = null;
                });
            } 
        };
    }]);
//User object
angular.module('ra.core')
.service('animatePhotoButtonEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'animatePhotoButton';
		
	service.broadcast = function() {
		console.log("broad");
		$rootScope.$broadcast(eventName);
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			console.log("list");
			callback();
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('closePhotoBoxEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'closePhotoBox';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('closeWrapperCoverEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'closeWrapperCover';

	/**
	 * Closes the wrapper cover without invoking onClose
	 */
	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function () {
			callback();
		});
	};

	return service;
}]);
 

//Show fancybox event
angular.module('ra.core')
.service('couponAppliedEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'couponApplied';

	/**
	 * Broadcast to listeners with href
	 * @param coupon
	 */
	service.broadcast = function(coupon) {
		$rootScope.$broadcast(eventName, {coupon:coupon});
	};
		
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.coupon);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('currencyChangeEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'currencyChange';

	service.broadcast = function(currencyCode) {
		$rootScope.$broadcast(eventName, {currency: currencyCode});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.currency);
		});
	};

	return service;
}]);

//User object
angular.module('ra.core')
.service('enableWrapperCoverEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'enableWrapperCover';

	/**
	 * Shows the wrapper, and calls onClose() when the wrapper is clicked on.
	 * If onClose returns true, the wrapper will be closed
	 * @param onClose(shouldCloseWrapper))
	 */
	service.broadcast = function(onClose) {
		$rootScope.$broadcast(eventName, {onClose:onClose});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.onClose);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('fancyboxHiddenEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'fancyboxHidden';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//Show fancybox event
angular.module('ra.core')
.service('fancyboxShownEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showFancybox';

	/**
	 * Broadcast to listeners with href
	 * @param href
	 */
	service.broadcast = function(href) {
		$rootScope.$broadcast(eventName, {href:href});
	};
		
	service.listen = function($scope, href, callback) {
		$scope.$on(eventName, function (event, data) {
			if(data.href == href) {
				callback();
			}
			
		});
	};

	return service;
}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('filterEventService', ['$rootScope', function ($rootScope) {

		var service = {};
		service.broadcast = function() {
			$rootScope.$broadcast('filter-change');
		};
		
		service.listen = function(onChange) {
			$rootScope.$on('filter-change', onChange);
		};

		return service;
	}]);
 

//User object
angular.module('ra.core')
	.service('galleryTabChangeEvent', ['$rootScope', function ($rootScope) {

		var service = {};
		var eventName = 'galleryTabChange';

		service.broadcast = function(tab) {
			$rootScope.$broadcast(eventName, {tab: tab});
		};
		service.listen = function(callback) {
			$rootScope.$on(eventName, function (event, data) {
				callback(data.tab);
			});
		};

		return service;
	}]);


//User object
angular.module('ra.core')
.service('getMyPhotosEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'getMyPhotos';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//Hides all comments from all articles, except the caller (Performance optimization)
//When calling from an article, call with parameter 'this'.
angular.module('ra.core')
    .service('hideCommentsEvent', ['$rootScope', function ($rootScope) {

        var service = {};
        var eventName = 'hideComments';

        service.broadcast = function(caller) {
            $rootScope.$broadcast(eventName, {caller:caller});
        };
        service.listen = function(callback) {
            $rootScope.$on(eventName, function (event, data) {
                callback(data.caller);
            });
        };

        return service;
    }]);
 

//User object
angular.module('ra.core')
.service('hideCoverEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'hideCover';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('hidePurchaseProcessingEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'hidePurchaseProcessing';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('newSignUpCompleteEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'newSignUpComplete';
		
	service.broadcast = function() {
		$rootScope.$broadcast(eventName);
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('photosLoadingEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'photosLoading';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
		var first = true;
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('refreshCommentsEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'refreshComments';

	service.broadcast = function(order, highlightFirst) {
		$rootScope.$broadcast(eventName, {order:order, highlightFirst:highlightFirst});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.order, data.highlightFirst);
		});
	};

	return service;
}]);
 

//Show fancybox event
angular.module('ra.core')
.service('refreshPaidMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'refreshPaidMenu';

	/**
	 * Broadcast to listeners with href
	 * @param href
	 */
	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};

		service.listen = function(callback) {
			$rootScope.$on(eventName, function (event, data) {
				callback();
			});
		};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showAddPhotoMessageEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showAddPhotoMessage';

	service.broadcast = function(photo) {
		$rootScope.$broadcast(eventName, {photo:photo});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.photo);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('showAddressFormEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showAddressFormEvent';

	service.broadcast = function(purchaseOption, onComplete) {
		$rootScope.$broadcast(eventName, {purchaseOption: purchaseOption, onComplete: onComplete});
	};
	service.listen = function(callback) {
		
		$rootScope.$on(eventName, function (event, data) {
			callback(data.purchaseOption, data.onComplete);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showArticleFormEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showArticleForm';

	service.broadcast = function(url) {
		$rootScope.$broadcast(eventName, {url:url});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.url);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showAuthEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showAuth';

	/**
	 * Shows the signup lightbox with 'message' message displayed at the top
	 * When signup is complete, onAuthComplete(newCsrf) is called, with a new csrf token
	 * @param {string} message - Message to show above the sign up window
	 * @param {function} onAuthComplete(next) - Code to run when sign up / sign in is complete
	 * @param {object} [options]
	 * @param {string} [options.name] - Pre-populate name field
	 * @param {string} [options.email] - Pre-populate email field
	 * @param {boolean} [options.showSignOn] - If true, show sign in instead of sign up. Defaults to false.
	 * @param {boolean} [options.skipCompleteMessage] - Don't show the welcome message at the end
	 * @param {boolean} [options.instantSignup] - Is an 'instant' sign up (i.e. at point of sale). Default is false.
	 * @param {boolean} [options.interestedIn] - Set interest. Default is set in authCtrl.
	 */
	service.broadcast = function(message, onAuthComplete, options) {
		$rootScope.$broadcast(eventName, {message:message, onAuthComplete: onAuthComplete, options:options});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.message, data.onAuthComplete, data.options);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('showCheckoutEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showCheckout';

	service.broadcast = function(description, client_secret, email, price, onSuccess, onFailure, paymentAmount, paymentCurrency) {
		$rootScope.$broadcast(eventName, {
			description: description,
			client_secret: client_secret,
			email: email,
			price: price,
			onSuccess: onSuccess,
			onFailure: onFailure,
			paymentAmount: paymentAmount,
			paymentCurrency: paymentCurrency,
		});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(
				data.description,
				data.client_secret,
				data.email,
				data.price,
				data.onSuccess,
				data.onFailure,
				data.paymentAmount,
				data.paymentCurrency
			);
		});
	};

	return service;
}]);


angular.module('ra.core')
.service('showCouponFormEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showCouponForm';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showCoverEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showCover';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showDownloadAllEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showDownloadAll';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('showEmailShareEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showEmailShare';

	service.broadcast = function(photoId) {
		$rootScope.$broadcast(eventName, {photoId: photoId});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.photoId);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('showFancyMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showFancyMenuEvent';

	service.broadcast = function(photo, type) {
		$rootScope.$broadcast(eventName, {photo:photo, type:type});
	};
	service.listen = function(callback) {
		
		$rootScope.$on(eventName, function (event, data) {
			callback(data.photo, data.type);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showPackageAddedEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showPackageAdded';

		/**
		 * Broadcast an 'added to package' message.
		 * @param [url]
		 */
	service.broadcast = function(url) {
		$rootScope.$broadcast(eventName, {url: url});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.url);
		});
	};

	return service;
}]);
 

angular.module('ra.core')
.service('showPrintMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showPrintMenu';

	service.broadcast = function(photo) {
		$rootScope.$broadcast(eventName, {photo: photo});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.photo);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showPurchaseCompleteEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showPurchaseComplete';

		/**
		 * Broadcast a 'purchase complete' message.
		 * @param message
		 * @param [url]
		 * @param buttonAfterBuy
		 * @param [promptDownloadAll]
		 */
	service.broadcast = function(message, url, buttonAfterBuy, promptDownloadAll) {
		$rootScope.$broadcast(eventName, {
			message: message,
			url: url,
			buttonAfterBuy: buttonAfterBuy,
			promptDownloadAll: promptDownloadAll
		});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.message, data.url, data.buttonAfterBuy, data.promptDownloadAll);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showPurchaseErrorEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showPurchaseError';

	service.broadcast = function(message) {
		$rootScope.$broadcast(eventName, {message: message});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.message);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('showPurchaseProcessingEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'showPurchaseProcessing';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

angular.module('ra.core')
	.service('showSelfieEvent', ['$rootScope', function ($rootScope) {

		var service = {};
		var eventName = 'showSelfie';

		service.broadcast = function(bib) {
			$rootScope.$broadcast(eventName, {bib: bib});
		};
		service.listen = function(callback) {
			$rootScope.$on(eventName, function (event, data) {
				callback(data.bib);
			});
		};

		return service;
	}]);
 

angular.module('ra.core')
.service('signOnCompleteEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'signOnComplete';

	service.broadcast = function(onClose) {
		$rootScope.$broadcast(eventName, {onClose:onClose});
	};
	service.listen = function(callback) {
		
		$rootScope.$on(eventName, function (event, data) {
			callback(data.onClose);
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('toggleMobileMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'toggleMobileMenu';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('toggleNewsMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'toggleNewsMenu';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('toggleSettingsMenuEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'toggleSettingsMenu';

	service.broadcast = function() {
		$rootScope.$broadcast(eventName, {});
	};
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback();
		});
	};

	return service;
}]);
 

//User object
angular.module('ra.core')
.service('updatePhotosEvent', ['$rootScope', function ($rootScope) {

	var service = {};
	var eventName = 'updatePhotos';

	service.broadcast = function(photoGroups) {
		$rootScope.$broadcast(eventName, {photoGroups:photoGroups});
	};
		var first = true;
	service.listen = function(callback) {
		$rootScope.$on(eventName, function (event, data) {
			callback(data.photoGroups);
		});
	};

	return service;
}]);
 

/**
 * Defines a search filter item:
 * Consists of checkbox, radio button or heading
 */
angular.module('ra.core')
.factory('Event',	 [function() {
		
	function Event(eventData) {
		
		this.name = null;
		
		if(eventData) {
			this.setData(eventData);
		}
	}
		
	Event.prototype = {
		setData: function(data) {
			angular.extend(this, data);
		}

	};

	return Event;

}]).directive('continentTile', function() {
		return {
			templateUrl: 'continentTile.html'
		};
	});
/**
 * Wraps around google map marker - holds additional info about the event:
 */
angular.module('ra.core')
	.factory('EventMarker',	 ['$filter', 'eventLightboxService', '$rootScope', function($filter, eventLightboxService, $rootScope) {
		
		var IMAGE_CYCLING = "/img/home/marker-cycling.png";
		var IMAGE_RUNNING = "/img/home/marker-running.png";
		var IMAGE_TRIATHLON = "/img/home/marker-triathlon.png";
		var IMAGE_IRON_MAN = "/img/home/marker-iron-man.png";
		var MAX_MARKERS = 50;		//Maximum markers to display
		var MARKER_HEIGHT = 64;		//Size (px) of marker
		var MARKER_WIDTH = 50;

		var MARKER_HEIGHT_MOBILE = 43;
		var MARKER_WIDTH_MOBILE = 34;

		/**
		 * Creates a hover window with basic event information
		 * @param markerData
		 * @param marker
		 */
		var createHoverWindow = function(markerData, marker) {
			var eventDate = markerData.eventDate ? markerData.eventDate : "";
			eventDate = $filter('ordinalDate')(eventDate, 'MMM doo');
			
			var addressElements = [
				markerData.location.street1,
				markerData.location.suburb,
				markerData.location.state
			];
			addressElements = addressElements.filter(function(x) {return x != null;});
			var location = addressElements.join(', ');
			
			setEventHandlers(markerData, marker);

			
		};
		
		//Sets touch handlers depending on if we are using a touch or mouse device
		var setEventHandlers = function(markerData, marker) {
			var eventHoverWindow = new google.maps.InfoWindow({
				content:
				"<div unselectable='on' style='text-align:center; margin-left:20px; -webkit-user-select: none; -moz-user-select: none; " +
				"-ms-user-select: none; -o-user-select: none; user-select: none;' onclick='javascript:alert();'>" +
				markerData.name + " >" +
				"</div>",
				disableAutoPan : true
			});
			
			if(!isTouchDevice()) {
				google.maps.event.addListener(marker.googleMarker, 'mouseover', function() {
					eventHoverWindow.open(markerData.map, this);
					$(".gm-style-iw").next("div").hide();
				});

				google.maps.event.addListener(marker.googleMarker, 'mouseout', function() {
					eventHoverWindow.close();
				});
			} else {
				/*google.maps.event.addListener(marker.googleMarker, 'click', function() {
					eventHoverWindow.open(markerData.map, this);
					$(".gm-style-iw").next("div").hide();
				});*/
			}
		};

		
		var createGoogleMarker = function(mapData) {

			var imagePath;
			
			if(mapData.showIronManIcon) {
				imagePath = IMAGE_IRON_MAN;
			} else if(mapData.type == 'Cycling') {
				imagePath = IMAGE_CYCLING;
			} else if(mapData.type == 'Running') {
				imagePath = IMAGE_RUNNING;
			} else if(mapData.type == 'Triathlon') {
				imagePath = IMAGE_TRIATHLON;
			}
			
			var markerWidth, markerHeight;
			if($(window).width() > Config.MOBILE_WIDTH) {
				markerWidth = MARKER_WIDTH;
				markerHeight = MARKER_HEIGHT;
			} else {
				markerWidth = MARKER_WIDTH_MOBILE;
				markerHeight = MARKER_HEIGHT_MOBILE;
			}
			
			var image = {
				url: imagePath,
				size: new google.maps.Size(markerWidth, markerHeight),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(markerWidth/2, markerHeight),
				scaledSize: new google.maps.Size(markerWidth, markerHeight)
			};

			
			var googleMarker = new google.maps.Marker({
				position: mapData.pos,
				map: mapData.map,
				icon: image,
				title: ""
			});
			return googleMarker;
		};

		/**
		 * Shows the popup for an event
		 */
		var setClickHandler = function(marker) {
			marker.googleMarker.addListener('click', function() {
				eventLightboxService.setEvent(marker);
				$rootScope.$apply();
			});
			
		};

		

		/**
		 * Create a new Event Marker
		 * @param mapData
		 * @param {google.maps.LatLng} mapData.pos
		 * @param {google.maps.map} mapData.map
		 * @param {string} mapData.name
		 * @param {function} mapData.onClick
		 * @constructor
		 */
		function EventMarker(mapData) {
			var self = this;
			this.name = null;
			this.location = null;

			if(mapData) {
				this.setData(mapData);
			}

			this.googleMarker = createGoogleMarker(mapData);
			createHoverWindow(mapData, this);
			setClickHandler(this);
		}

		EventMarker.prototype = {
			setData: function(data) {
				angular.extend(this, data);
			}
		};

		return EventMarker;

	}]);
/**
 * Defines a search item filter
 * Contains details about the filter, as well as an array of filter items to display
 */
angular.module('ra.core')
.factory('Filter', ["FilterItem", 'filterEventService', 
		function(FilterItem, filterEventService) {
		
	function Filter(eventData) {
		this.name = null;
		this.label = null;
		this.items = [];
		this.class = "";


		if(eventData) {
			this.setData(eventData);
		}
	}


	Filter.prototype = {
		setData: function(data) {
			angular.extend(this, data);
		},

		/**
		 * Selects/deselects a checkbox/radio button
		 * Broadcasts a 'filterChanged' event
		 * @param item
		 */
		select: function(item) {
			if (item.template == FilterItem.TEMPLATE_RADIO) {
				//Only do something if radio box is not already selected
				if(!item.selected) {
					this.items.forEach(function (item) {
						item.selected = false;
					});
					item.selected = true;
					filterEventService.broadcast();
				}

				

			} else if (item.template == FilterItem.TEMPLATE_CHECKBOX) {
				item.selected = !item.selected;
				filterEventService.broadcast();
			}

			
			
		},

		/**
		 * Gets the selected array of items for this filter
		 */
		getSelected: function() {
			var selectedItems = [];
			this.items.map(function(x) {
				if(x.selected) {
					selectedItems.push(x.name);
				}
			});
			
			return selectedItems;
		}
	};

	return Filter;

}]).directive('filter', function() {
	return {
		restrict: 'E',
		templateUrl: 'filter.html'
	};
});
/**
 * Defines a search filter item:
 * Consists of checkbox, radio button or heading
 */
angular.module('ra.core')
.factory('FilterItem',	 [function() {
		
	function FilterItem(eventData) {
		
		this.name = null;
		this.template = FilterItem.TEMPLATE_CHECKBOX;
		this.label = null;
		this.selected = false;

		if(eventData) {
			this.setData(eventData);
		}
	}
		
	FilterItem.prototype = {
		setData: function(data) {
			angular.extend(this, data);
		}

	};
		
	

	FilterItem.TEMPLATE_RADIO = 'radioItem.html';
	FilterItem.TEMPLATE_CHECKBOX = 'checkboxItem.html';
	FilterItem.TEMPLATE_HEADING = 'headingItem.html';

	return FilterItem;

}]);
//User object
angular.module('ra.core')
	.service('ajaxService', ['configService', '$http', '$q',
		function (configService, $http, $q) { 

			/**
			 * Creates a group in the dev console for debugging
			 * @param  {string} name - Name of group
			 * @param  {string[]} messages - Array of messages in group
			 */
			var consoleGroup = function(name, messages, isError) {

				console.groupCollapsed(name);
				for(var i=0; i<messages.length; i++) {
					if(isError) {
						console.error(messages[i]);
					} else {
						console.log(messages[i]);
					}

				}
				console.groupEnd();
			};
			
			var service = {};
			service.request = function(page, data, onError) {

				var xhr, timeout;

				return $http.post(page, data)
					.then(function(response) 
					{
						clearTimeout(timeout);

						window.lastResponse = response;

						//Log to console
						if(configService.version.build == "Debug") {
							console.log("triggered ajax_" + page );
							consoleGroup(page, [data, response]);
						}

						return response.data;
						
					},
					function(response) {
						return $q.reject(response.data);
					}
					/*, function(response) {
						clearTimeout(timeout);
						if(configService.version.build == "Debug") {
							consoleGroup(page + " ERROR", [data, response, page + ' Error', response.statusText], true);
						}
						switch (response.status) {
							case 404:
								alert("Page Not Found");
								break;
							case 401:
								alert("Login Failed");
								break;
							case 400:
							case 422:
								var payload = response.data;
								var jsonResponse = payload.data;
								var message = jsonResponse.message;
								if(jsonResponse.error) {
									message = jsonResponse.error + "<br/><br/>" +message;
								}
								alert(message);
								break;

							default:
								if(onError) {
									if(response.data && response.data.detail) {
										onError(response.data.detail);
									} else if(response.data.error) {
										onError(response.data.error);
									}
								}else{
									throw new Error("An unknown error occurred");
								}
								break;
						}
					}*/);
			};

			service.get = function(page) {
				return $http.get(page)
					.then(function(response) {
						window.lastResponse = response;
						if(configService.version.build == "Debug") {
							console.log("triggered ajax_get_" + page);
							consoleGroup(page, [response]);
						}
						return response.data;
					}, function(response) {
						return $q.reject(response.data);
					});
			};

			return service;
		}]);


/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('articleService', ['ajaxService',
	function (ajaxService) {

		var service = {};


		/**
		 * Gets articles from server
		 * @param data
		 * @param {string} data.type
		 * @param {string} data.refine
		 * @param {string[]} data.categories
		 * @param {int} data.page
		 */
		service.get = function(data) {
			return ajaxService.request('/api/news/articles/', data, false);
		};

		/**
		 * Submits an article
		 * @param data
		 * @param {string} data.link
		 * @param {string} data.category
		 * @param {string} data.type
		 * @param {string} data.name
		 * @param {string} data.description
		 * @param {string} data.from
		 * @param {string} data.imageUrl
		 * @param {boolean} data.trending (Admin only)
		 */
		service.submit = function(data) {
			return ajaxService.request('/api/news/submit/', data, false);
		};
		
		/**
		 * Submits an article
		 * @param data
		 * @param {string} data.articleId
		 **/
		
		service.toggleTrending = function(data) {
			return ajaxService.request('/api/news/toggle-trending/', data, false);
		};
		
		/**
		 * Submits an article
		 * @param data
		 * @param {string} data.link
		 */
		service.scrapePreviewArticle = function(data) {
			return ajaxService.request('/api/news/scrape-preview-article/', data, false);
		};
		

		/**
		 * Adds a click to an article
		 * @param data
		 * @param {string} data.articleId
		 * @returns {*}
		 */
		service.addClick = function(data) {
			return ajaxService.request('/api/news/add-click/', data, false);
		};

		/**
		 * Adds a like to an article
		 * @param data
		 * @param {string} data.articleId
		 * @returns {*}
		 */
		service.like = function(data) {
			return ajaxService.request('/api/news/like/', data, false);
		};

		/**
		 * Adds a dislike to an article
		 * @param data
		 * @param {string} data.articleId
		 * @returns {*}
		 */
		service.dislike = function(data) {
			return ajaxService.request('/api/news/dislike/', data, false);
		};
		
		
		return service;

	}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('authService', ['ajaxService',
		function (ajaxService) {

		var service = {};

		/**
		 * signUp
		 * userData {}: {firstName, lastName, email, password, g-recaptcha-response, _csrf}
		 * onError {function}: called when there is an error, containing a string description of the error.  
		 */
		service.signUp = function(userData, onError) {
			return ajaxService.request('/api/user/sign-up/', userData, onError);
		};

		/**
		 * signIn
		 * userData {}: {email, password, _csrf}
		 * onError {function}: called when there is an error, containing a string description of the error.
		 */
		service.signOn = function(userData, onError) {
			return ajaxService.request('/api/user/sign-on/', userData, onError);
		};

		service.requestLoginLink = function(userData, onError) {
			return ajaxService.request('/api/user/request-login-link/', userData, onError);
		};

			return service;
	}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('clickService', ['ajaxService',
	function (ajaxService) {

		var service = {};
		
		/**
		 * 
		 * @param data
		 * @param {ObjectId} data.modelId - object Id
		 * @param {string} data.list - Keystone list to update
		 */
		service.add = function(data) {
			return ajaxService.request('/api/clicks/add', data);
		}
			
		return service;
	}]);
 

//User object
angular.module('ra.core')
	.service('emailShareService', ['ajaxService',
		function (ajaxService) {
			
		var service = {};

		service.send = function(email, eventId, photoId, participantId) {
			var formData = {
				photoId: photoId,
				eventId: eventId,
				email: email,
				participantId: participantId
			};
			return ajaxService.request('/api/share/photo/', formData, false);
		};
	
		return service;
	}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('eventService', ['Event', 'ajaxService',
		function (Event, ajaxService) {

		var service = {};

		/**
		 * Gets events given the filterdata received
		 * @param {object} filterData
		 * @param {Array} filterData.sort - Array of 1 sort order
		 * @param {Array} filterData.type - Array of 1 event type
		 * @param {Array} filterData.regions - Array of regions
		 * 
		 */
		service.getContinentEvents = function(filterData) {
			return ajaxService.request('/api/events/continent-events/', filterData, false);
		};
			
		service.getMapEvents = function(filterData) {
			return ajaxService.request('/api/events/map-events/', filterData, false);
		};

		service.getEventQuickSearch = function(search) {
			var data = {search:search};
			return ajaxService.request('/api/events/quick-search/', data, false);
		};

			return service;
	}]);
 

//User object
angular.module('ra.core')
  .service('faceService', ['$http', function ($http) {

    var service = {};
    
    function base64ToBlob(base64Data) {
      var parts = base64Data.split(';base64,');
      var contentType = parts[0].split(':')[1];
      var byteCharacters = atob(parts[1]);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], {type: contentType});
    }
 

    service.matchFace = function(event, photoBase64) {
      var blob = base64ToBlob(photoBase64);
      var formData = new FormData();
      formData.append('photo', blob, 'photo.png');


      return $http.post(`/api/face-preview/${event}`, formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function(response) {
        console.log(response);
        return response.data.photos;
      });
    }
    
    service.saveToGallery = function(event, photoBase64, bib) {
      var blob = base64ToBlob(photoBase64);
      var formData = new FormData();
      formData.append('photo', blob, 'photo.png');
      
      return $http.post(`/api/save-to-gallery/${event}/${bib}`, formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function(response) {
        console.log(response);
      });
    }

    return service;
  }]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.core')
	.service('filterService', ['Filter', 'FilterItem', 'ajaxService', 
		function (Filter, FilterItem, ajaxService) {

		var service = {};
		service.filters = [];


		/**
		 * Creates a filterItem list from an array of countries
		 * @param countries
		 * @returns {Array}
		 */
		var createRegionItemList = function(countries) {
			var items = [];

			for(var i=0; i<countries.length; i++) {
				var country = countries[i];
				items.push(new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:country.name, name:country.id ? country.id : country._id}));
			}

			return items;
		};

		service.getFilterData = function(continent) {
			data = {};
			return ajaxService.request('/api/filters/filter-regions/' + continent, data, false);
		};

		/**
		 * Gets all filters and selected data as an array
		 * @returns {{}}
		 */
		service.getSelectedFilterItems = function(page) {
			var filterData = {};
			filterData.page = page;

			service.filters.forEach(function(filter) {
				filterData[filter.name] = filter.getSelected();
			});
			return filterData;
		};

		/**
		 * Creates a country checkbox list
		 * @param locations - Locations JSON response
		 */
		service.createRegionFilter = function(locations) {
			var countryFilter =
				new Filter({
					label: "Locations",
					name: "regions",
					items: []
				});


			//Add stand-alone countries
			countryFilter.items = countryFilter.items.concat(createRegionItemList(locations.countries));

			//Add country-regions
			Object.keys(locations.countryRegions).forEach(function(key) {
				countryFilter.items.push(new FilterItem({template:FilterItem.TEMPLATE_HEADING, label:key}));
				countryFilter.items = countryFilter.items.concat(createRegionItemList(locations.countryRegions[key]));
			});

			return countryFilter;
		};

		/** Needed for child classes to access parent property
		 * 
		 * @param filters
		 */
		service.setFilters = function(filters) {
			service.filters = filters;
		};
			
		return service;
	}]);
 

//Initializes the map, and controls user events and API requests
angular.module('ra.core')
.service('mapService', ['eventService', 'mapMarkerService', 'EventMarker', 
		function (eventService, mapMarkerService, EventMarker) {

	var AUSTRALIA_LAT_LNG = new google.maps.LatLng(-29.2726842, 133.9304383);
	var REGION_BIAS = 'AU';
	var MAX_ZOOM_LEVEL = 15;
	var MIN_ZOOM_LEVEL = 3;
	var map;
	var service = {};
			
	service.getEvents = function(filterData) {
		if(!filterData) {
			filterData = {};
		}
		var latLngBounds = map.getBounds();
		
		filterData.minLat = latLngBounds.getSouthWest().lat();
		filterData.maxLat = latLngBounds.getNorthEast().lat();
		filterData.minLng = latLngBounds.getSouthWest().lng();
		filterData.maxLng = latLngBounds.getNorthEast().lng();
		
		
		return eventService.getMapEvents(filterData)
			.then(function(response) 
			{
				mapMarkerService.plotEvents(map, response.events, EventMarker);
				return response;
			})
			.catch(function(error)
			{
				console.log(error);
			});
	};
			
	
	service.goTo = function(address) {
		var geocoder = new google.maps.Geocoder();
		
		geocoder.geocode({'address': address, 'region':REGION_BIAS}, function(results, status) {
			if (status === google.maps.GeocoderStatus.OK) {
				console.log(results);
				map.panTo(results[0].geometry.location);
				map.fitBounds(results[0].geometry.viewport);
			} else {
				alert('Could not find your location. Please double check the address.');
			}
		});
	};

	service.init = function($map, onInit) {
		function initialize() {
			var mapOptions = {
				zoom: 4,
				center: AUSTRALIA_LAT_LNG,
				scrollwheel: false,
				mapTypeControl: false,
			};
			map = new google.maps.Map($map[0],
				mapOptions);

			// Limit the zoom level
			google.maps.event.addListener(map, 'zoom_changed', function() {
				if (map.getZoom() < MIN_ZOOM_LEVEL) {
					map.setZoom(MIN_ZOOM_LEVEL);
				} else if(map.getZoom() > MAX_ZOOM_LEVEL) {
					map.setZoom(MAX_ZOOM_LEVEL);
				}
					
			});

			// Try HTML5 geolocation.
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					var pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};

					map.setCenter(pos);
					map.setZoom(5);
				}, function () {
					
				});
			} else {
				// Browser doesn't support Geolocation - Show default location
			}
			
			onInit(map);
		}
		
		google.maps.event.addDomListener(window, 'load', initialize);
	};
		
	
 
	return service;
}]);
 

//User object
angular.module('ra.core')
    .service('photoRepo', ['ajaxService', function (ajaxService) {

        var service = {};
        /**
         * Gets photos after a specific time
         * @param hour - Hours (in 24hr)
         * @param minute
         * @param second
         * @param eventId - Event ID
         * @param page (optional) - Page number starting at 0
         * @param leg
         */
        service.getPhotosAfter = function(hour, minute, second, eventId, page, leg) {
            if(!page) {
                page = 0;
            }
            var data = {
                hour:hour,
                minute:minute,
                second:second,
                page:page,
                leg:leg
            };
            console.log('getPhotosAfter called with data:', data);
            return ajaxService.request('/api/photos/'+eventId+'/time', data, false);
        };

        service.getPhotosForLeg = function(eventId, page, leg) {
            if(!page) {
                page = 0;
            }
            var data = {
                page:page,
                leg:leg
            };
            return ajaxService.request('/api/photos/'+eventId+'/leg', data, false);
        };

        /**
         * @param eventId
         * @param {string} bibList - Comma separated bibs
         * @param {string} [participantId] - Optional participant id for private events (e.g. validation link)
         * @returns {*}
         */
        service.getMyPhotos = function(eventId, bibList, participantId) {
            var query = participantId ? { participant: participantId } : {};
            return ajaxService.request('/api/photos/'+eventId+'/mine/' + bibList, query, false);
        };

        /**
         * Removes bibs from photo
         * @param photoId
         * @param eventId
         * @param bib
         * @returns {*}
         */
        service.removeBib = function(photoId, eventId, bib) {
            const data = {
                photoId: photoId,
                eventId: eventId,
                bib: bib
            };
            return ajaxService.request('/api/photo-actions/remove-bib/', data, false);
        };
        
        service.agree = function(email, eventId) {
          const data = {
            email: email,
            eventId: eventId
          };
          return ajaxService.request('/api/photos/agree', data, false);
        };
        
        service.downloadAllPhotos = function(event, bib, participant) {
          var url = '/api/download-all/' + event + "/" + bib;
          if(participant) {
            url += "/" + participant;
          }
          return ajaxService.request(url, {}, false);
        };

        service.downloadAllPhotosStatus = function(event, bib, participant) {
          var url = '/api/download-all-status/' + event + "/" + bib;
          if(participant) {
            url += "/" + participant;
          }
          return ajaxService.get(url);
        };

        return service;
    }]);
 

/**
 * Created by jordan on 24/09/2015.
 */

angular.module('ra.core')
.service('purchaseService', ['ajaxService',
	function (ajaxService) {

	var service = {};


	/**
	 * Gets the types purchased for an item ID
	 * @param {Object} data
	 * @param {string} data.eventId
	 * @param {string} data.type - Type label from ItemTypes
	 * @returns {Promise<boolean>} - True if the item has been purchased already
	 */
	service.purchasedTypes = function(data) {
		return ajaxService.request('/api/purchase/purchased-types', data)
			.then(function(result) {
				return result;
			})
	};

	/**
	 * Determine if current user has purchased an item
	 * @param {Object} data
	 * @param {string} data.itemId
	 * @param {string} [data.eventId] - Only needed for bibPhotos
	 * @param {string} [data.participantId] - Only needed for CommPhotos
	 * @param {string} data.type - Type label from ItemTypes
	 * @param {string} data.stripeToken - Stripe token

	 * @returns {Promise<boolean>} - True if the item was purchased successfully
	 */
	service.purchase = function(data) {
		return ajaxService.request('/api/purchase/purchase-item', data);
	};

	/**
	 * Authorize a new payment session
	 * @param data
	 * @returns {*}
	 */
	service.createIntent = function(data) {
		return ajaxService.request('/api/purchase/session', data);
	};

	/**
	 * Create Item/Payment records after Stripe confirms payment (also done via webhook on prod).
	 * @param {{ paymentIntentId: string }} data
	 */
	service.fulfill = function(data) {
		return ajaxService.request('/api/purchase/fulfill', data);
	};


	/**
	 * Adds an item to package
	 * @param {Object} data
	 * @param {string} data.itemId
	 * @param {string} data.eventId
	 * @param {string} [data.participantId] - Only needed for CommPhotos
	 * @param {string} data.type - Type label from ItemTypes
	 * @returns {Promise<boolean>} - True if the item was purchased successfully
	 */
	service.addToPackage = function(data) {
		return ajaxService.request('/api/package/add', data);
	};

	service.updateAddress = function(data) {
		return ajaxService.request('/api/purchase/update-address', data);
	};

	return service;
}]);


//Handles the creation and management of map markers
angular.module('ra.core')
	.service('addPhotoService', ['ajaxService',
		function (ajaxService) {

		var service = {};
		/**
		 * Add a set of events to the map, with the specified marker type
		 * @param data
		 * @param data.eventId
		 * @param data.eventKey
		 * @param data.photoId
		 * @param {string} data.bibs - Comma separated list of bibs
		 */
		service.addPhotoEmail = function(data) {
			return ajaxService.request('/api/photos/add-photo-email', data, false);
		};
			
		return service;
	}]);
 

//User object
angular.module('ra.core')
.service('configService', [function () {

	var service = {};
	service.version = {};
	service.version.build = "Debug";

	return service;
}]);
 

//User object
angular.module('ra.core')
	.service('continentFilterService', ['filterService', 'Filter', 'FilterItem',
		function (filterService, Filter, FilterItem) {

		/**
		 * Inherit filterService
		 * @type {filterService}
		 */
		var service = Object.create(filterService);


		/**
		 * If no regions chosen, default to choosing all regions
		 * @param filterItems - Filter data
		 */
		var addAllRegionsIfEmpty = function(filterItems) {
			if(filterItems.regions.length == 0) {
				//Get region filter
				var regionFilter = service.filters.filter(function(x) {return x.name == 'regions'})[0];
				//Get all region ids
				filterItems.regions = regionFilter.items.map(function(x) {return x.name});
				//Remove null entries
				filterItems.regions = filterItems.regions.filter(function(x) {return x!= null});
			}
			return filterItems;
		};
			
		/**
		 * Gets region data from server and populates a new filter object
		 * @param continent - continent key
		 * @param type - event type
		 */
		service.getFilters = function(continent, type) {
			return service.getFilterData(continent)
				.then(function(response)
				{
					console.log(service);
					service.setFilters(service.createFilters(response, type));
					return service.filters;
				});
		};

		/**
		 * Gets all filters and selected data as an array
		 * @returns {{}}
		 */
		service.getSelectedFilterItems = function(page) {
			var filterData = {};
			filterData.page = page;

			service.filters.forEach(function(filter) {
				filterData[filter.name] = filter.getSelected();
			});
			filterData = addAllRegionsIfEmpty(filterData);
			return filterData;
		};


			/**
		 * Creates continent search page filters
		 * @param locations - ajax result
		 * @param eventType - which event checkbox to tick
		 * @returns {*[]}
		 */
		service.createFilters = function(locations, eventType) {
			var query = queryString();
			var sort = query.sort;
			
			service.setFilters([
				new Filter({
					label: "Sort By",
					name: "sort",
					class: "black",
					items: [
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Rating', name:'-rating', selected:(sort == "-rating")}),
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Date', name:'eventDate', selected:(sort == "eventDate" || !sort)}),
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Name (A-Z)', name:'name', selected:(sort == "name")}),
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Name (Z-A)', name:'-name', selected:(sort == "-name")})
					]
				}),

				new Filter({
					label: "Event Type",
					name: "type",
					items: [
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Cycling', name:'Cycling', selected:(eventType == "Cycling" || !eventType)}),
						new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Running', name:'Running', selected:eventType == "Running"}),
						//new FilterItem({template:FilterItem.TEMPLATE_RADIO, label:'Triathlon', name:'Triathlon', selected:eventType == "Triathlon"})
					]
				})
			]);

			service.setFilters(service.filters.concat(service.createRegionFilter(locations)));
			return service.filters;
		};

		return service;
	}]);
 

/**
 * Singleton Coupon service
 * Holds the last coupon activated on this page
 */

angular.module('ra.core')
.service('couponService', ['ajaxService', 'couponAppliedEvent',
		function (ajaxService, couponAppliedEvent) {

	var service = {};
	service.coupon = null;

	/**
	 *
	 * @param data
	 * @param data.code
	 * @param data.eventId
	 * @returns {*}
	 */
	service.getCoupon = function(data) {
		return ajaxService.request('/api/coupons/get/', data, false)
			.then(function(coupon) {
				service.coupon = coupon;
				couponAppliedEvent.broadcast(coupon);
				return coupon;
			})
	};

	/**
	 * If a coupon exists, applies the discount to price and returns it.
	 * Otherwise, returns the full price
	 * @param price
	 */
	service.discountIfCoupon = function(price) {
		if(price === null) {
			return null;
		}
		if(!service.coupon) {
			return price;
		}
		else {
			var discountedAmount;
			if(service.coupon.percentDiscount) {
				discountedAmount = (1-service.coupon.percentDiscount) * price;
			} else if(service.coupon.amountDiscount) {
				discountedAmount = Math.max(0, price - service.coupon.amountDiscount);
			}
			return Math.round(discountedAmount);
		}
	};

	return service;
}]);


/**
 * Currency Service
 * Manages selected currency state and available currencies
 */
angular.module('ra.core')
.service('currencyService', ['currencyChangeEvent', 'ajaxService',
    function (currencyChangeEvent, ajaxService) {

    var service = {};
    
    // Available currencies configuration
    var AVAILABLE_CURRENCIES = {
        'AUD': {
            code: 'AUD',
            symbol: '$',
            name: 'Australian Dollar',
            country: 'Australia'
        },
        'SGD': {
            code: 'SGD',
            symbol: '$',
            name: 'Singapore Dollar',
            country: 'Singapore'
        }
    };
    
    // Currently selected currency (defaults to null, will be set from event)
    var selectedCurrency = null;
    
    /**
     * Initialize currency service with event's default currency
     * @param {string} defaultCurrency - Event's default currency code
     */
    service.initialize = function(defaultCurrency) {
        var newCurrency = (defaultCurrency || 'AUD').toUpperCase();
        if (!selectedCurrency || selectedCurrency !== newCurrency) {
            selectedCurrency = newCurrency;
            // Broadcast the currency so listeners can update
            currencyChangeEvent.broadcast(selectedCurrency);
        }
    };
    
    /**
     * Get currently selected currency
     * @returns {string} Currency code
     */
    service.getSelectedCurrency = function() {
        return selectedCurrency || 'AUD';
    };
    
    /**
     * Set selected currency and broadcast change event
     * @param {string} currencyCode - Currency code to select
     */
    service.setSelectedCurrency = function(currencyCode) {
        var code = currencyCode.toUpperCase();
        if (AVAILABLE_CURRENCIES[code]) {
            selectedCurrency = code;
            currencyChangeEvent.broadcast(code);
        } else {
            console.warn('Invalid currency code:', currencyCode);
        }
    };
    
    /**
     * Get available currencies
     * @returns {Object} Object with currency codes as keys
     */
    service.getAvailableCurrencies = function() {
        return AVAILABLE_CURRENCIES;
    };
    
    /**
     * Get currency information
     * @param {string} currencyCode - Currency code
     * @returns {Object|null} Currency info or null if not found
     */
    service.getCurrencyInfo = function(currencyCode) {
        return AVAILABLE_CURRENCIES[currencyCode.toUpperCase()] || null;
    };
    
    /**
     * Convert price from one currency to another
     * @param {number} amountInCents - Amount in cents
     * @param {string} fromCurrency - Source currency code
     * @param {string} toCurrency - Target currency code
     * @returns {Promise<number>} Converted amount in cents
     */
    service.convertPrice = function(amountInCents, fromCurrency, toCurrency) {
        if (fromCurrency.toUpperCase() === toCurrency.toUpperCase()) {
            return Promise.resolve(amountInCents);
        }
        
        return ajaxService.request('/api/currency/convert', {
            amount: amountInCents,
            fromCurrency: fromCurrency,
            toCurrency: toCurrency
        }, true)
        .then(function(response) {
            return response.amount;
        })
        .catch(function(err) {
            console.error('Error converting price:', err);
            // Fallback to original amount if conversion fails
            return amountInCents;
        });
    };
    
    /**
     * Format price with currency symbol
     * @param {number} amountInCents - Amount in cents
     * @param {string} currencyCode - Currency code
     * @returns {string} Formatted price string
     */
    service.formatPrice = function(amountInCents, currencyCode) {
        var currency = service.getCurrencyInfo(currencyCode || selectedCurrency);
        if (!currency) {
            return '$' + (amountInCents / 100).toFixed(2);
        }
        var amount = (amountInCents / 100).toFixed(2);
        return currency.symbol + amount;
    };
    
    return service;
}]);

/**
 * Created by jordan on 27/09/2015.
 */
//Holds the event to be displayed in the lightbox
angular.module('ra.core')
	.service('eventLightboxService', [function () {
	
		var self = this;
		self.event = null;
		var listeners = [];
		
		var service = {};
		
		service.getEvent = function() {
			return self.event;
		};
		
		service.clearEvent = function() {
			self.event = null;
		};

		/**
		 * Sets the lightbox to a new event - this causes the lightbox to show
		 * @param event
		 */
		service.setEvent = function(event) {
			self.event = event;
		};

		return service;
	}]);
 

//Singleton fancybox object
angular.module('ra.core')
	.service('fancyService', ['fancyboxHiddenEvent', 'fancyboxShownEvent', 'showFancyMenuEvent', 'photoService',
	function (fancyboxHiddenEvent, fancyboxShownEvent, showFancyMenuEvent, photoService) {
		var service = {};
		
		var hasStarted = false;
		
		service.event = null;
		service.fancyboxConfig = null;
		
		service.setup = function(event) {
			service.event = event;
			service.fancyboxConfig = fancyboxSharePhotoConfig();

			service.update();
		};
		
		service.update = function() {
			
			
			if(!service.fancyboxConfig) {
				throw new Error("You must call fancyboxService.setup before update!");
			}
			
			if((service.event.isPaid || photoService.showPrintMenu) && $(window).width() < Config.MOBILE_WIDTH) {
				service.fancyboxConfig.maxHeight = 360;
			}
			
			if(photoService.showPrintMenu) {
				service.fancyboxConfig.maxWidth = 900;
			} else {
				delete service.fancyboxConfig.maxWidth;
			}

			//Causes title bar to show
			if(!service.event.isPaid && !photoService.showPrintMenu) {
				service.fancyboxConfig.title = "&nbsp";
			} else {
				service.fancyboxConfig.title = null;
			}

			service.fancyboxConfig.afterLoad = function(current, previous) {
				//Shows fancybox at top on mobile devices
				if((service.event.isPaid || photoService.showPrintMenu) && $(window).width() < Config.MOBILE_WIDTH) {
					var marginTop = -($(window).height()-current.height)/2;
					$(".fancybox-wrap").css({'margin-top':marginTop+'px'});
				}

				//Broadcast to that particular photo that it is showing
				fancyboxShownEvent.broadcast(current.href);


				//Make fancybox show in middle
				if(service.event.isPaid || photoService.showPrintMenu) {
					$(".fancybox-wrap").addClass("paid");
				}
			};

			service.fancyboxConfig.onNext = function() {
				fancyboxHiddenEvent.broadcast();
			};

			service.fancyboxConfig.onPrev = function() {
				fancyboxHiddenEvent.broadcast();
			};

			service.fancyboxConfig.beforeClose = function() {
				fancyboxHiddenEvent.broadcast();
			};
			
			// $('.fancy-photo').fancybox(service.fancyboxConfig);
		};
		
		//Closes and opens fancybox (useful if you need to change the UI)
		service.reload = function() {
			service.fancyboxConfig.href = $.fancybox.current.href;
			$.fancybox.close(true);

			fancyboxHiddenEvent.broadcast();
			service.update();
			
			$.fancybox.open(service.fancyboxConfig);
			delete service.fancyboxConfig.href;
		};
	
		return service;
	}]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//Holds the user object (or lack thereof)
angular.module('ra.core')
    .service('magnifyService', [
        function () {

            var service = {};
            service._instance = null;
            
            var didAddPopup = false;

            function isSmallTouchDevice() {
                var isTouch = (('ontouchstart' in window) ||
                    (navigator.maxTouchPoints > 0) ||
                    (navigator.msMaxTouchPoints > 0));

                var isLarge = $(window).width() > 1600;

                if(isTouch && !isLarge) {
                    return true;
                }
            }
            
            function remove() {
                if(service._instance && service._instance.glass) {
                    service._instance.glass.removeEventListener("mousemove", moveMagnifier);
                    service._instance.glass.removeEventListener("mouseout", hideGlass);
                    service._instance.img.removeEventListener("mousemove", moveMagnifier);
                    service._instance.glass.remove();
                }
                service._instance = null;
            }

            function moveMagnifier(e) {
                var bw = 3;
                var w = service._instance.glass.offsetWidth / 2;
                var h = service._instance.glass.offsetHeight / 2;
                
                var pos, x, y;
                /* Prevent any other actions that may occur when moving over the image */
                e.preventDefault();
                /* Get the cursor's x and y positions: */
                pos = getCursorPos(e);
                x = pos.x;
                y = pos.y;
                /* Prevent the magnifier glass from being positioned outside the image: */
                var inBounds = true;
                if (x > service._instance.img.width - (w / service._instance.zoom)) {
                    x = service._instance.img.width - (w / service._instance.zoom);
                    inBounds = false;
                }
                if (x < w / service._instance.zoom) {
                    x = w / service._instance.zoom;
                    inBounds = false;
                }
                if (y > service._instance.img.height - (h / service._instance.zoom)) {
                    y = service._instance.img.height - (h / service._instance.zoom);
                    inBounds = false;
                }
                if (y < h / service._instance.zoom) {
                    y = h / service._instance.zoom;
                    inBounds = false;
                }

                if(!inBounds && service._instance.isVisible) {
                    hideGlass();
                } else if(inBounds && !service._instance.isVisible) {
                    showGlass();
                }

                var offsetX = 0;
                var offsetY = 0;
                var style = getComputedStyle(service._instance.img);
                if(style.position === "absolute") {
                    offsetY = 0.5 * (service._instance.img.parentElement.offsetHeight - service._instance.img.offsetHeight);
                    offsetX = 0.5 *(service._instance.img.parentElement.offsetWidth - service._instance.img.offsetWidth);
                }

                /* Set the position of the magnifier glass: */
                service._instance.glass.style.left = (x - w + offsetX) + "px";
                service._instance.glass.style.top = (y - h + offsetY) + "px";
                
                /* Display what the magnifier glass "sees": */
                service._instance.glass.style.backgroundPosition = "-" + ((x * service._instance.zoom) - w + bw) + "px -" + ((y * service._instance.zoom) - h + bw) + "px";
            }

            function hideGlass() {
                service._instance.isVisible = false;
                service._instance.glass.classList.add("invisible");
            }

            function getCursorPos(e) {
                var a, x = 0, y = 0;
                e = e || window.event;
                /* Get the x and y positions of the image: */
                a = service._instance.img.getBoundingClientRect();
                /* Calculate the cursor's x and y coordinates, relative to the image: */
                x = e.pageX - a.left;
                y = e.pageY - a.top;
                /* Consider any page scrolling: */
                x = x - window.pageXOffset;
                y = y - window.pageYOffset;
                return {x : x, y : y};
            }

            function showGlass() {
                service._instance.isVisible = true;
                service._instance.glass.classList.remove("invisible");
            }
            
            /**
             * Shows a magnifier over the cursor to magnify an image
             * @param $image - Image class to magnify
             * @param zoom - Amount to zoom (eg. 1.0 is no zoom, 2.0 is double zoom)
             * @param bigImageUrl - Path to big image to show
             */
            function magnify($image, zoom, bigImageUrl) {
                if(service._instance) {
                    remove();
                }
                service._instance = {
                    isVisible: false,
                    zoom: zoom,
                    $image: $image,
                    bigImageUrl: bigImageUrl
                };
                
                service._instance.img = $($image)[0];

                if(!bigImageUrl || !service._instance.img) {
                    return;
                }

                if(isSmallTouchDevice() && !didAddPopup) {
                    didAddPopup = true;
                    $(".menu-paid .inner").prepend("<div class='magnifier-popup hide'>Tap photo to zoom</div>");
                    setTimeout(function() {
                        $(".magnifier-popup").fadeIn();

                        setTimeout(function() {
                            $(".magnifier-popup").fadeOut();
                        }, 7000);
                    }, 500);

                }

                /* Create magnifier glass: */
                service._instance.glass = document.createElement("DIV");
                service._instance.glass.setAttribute("class", "img-magnifier-glass invisible");

                /* Insert magnifier glass: */
                service._instance.img.parentElement.insertBefore(service._instance.glass, service._instance.img);

                /* Set background properties for the magnifier glass: */
                service._instance.glass.style.backgroundImage = "url('" + bigImageUrl + "')";
                service._instance.glass.style.backgroundRepeat = "no-repeat";
                service._instance.glass.style.zIndex = 2;
                service._instance.glass.style.backgroundSize = (service._instance.img.width * service._instance.zoom) + "px " + (service._instance.img.height * service._instance.zoom) + "px";

                /* Execute a function when someone moves the magnifier glass over the image: */
                service._instance.glass.addEventListener("mousemove", moveMagnifier);
                service._instance.glass.addEventListener("mouseout", hideGlass);
                service._instance.img.addEventListener("mousemove", moveMagnifier);
            }

            service.magnify = magnify;

            return service;

        }]);


//User object
angular.module('ra.core')
	.service('mapFilterService', ['filterService', 'Filter', 'FilterItem', '$q',
		function (filterService, Filter, FilterItem, $q) {

		/**
		 * Inherit filterService
		 * @type {filterService}
		 */
		var service = Object.create(filterService);

		/**
		 * Populates a new filter object
		 * Use $q to return a promise - this is consistent with other calls to getFilters
		 */
		service.getFilters = function() {
			return new $q(function(resolve, reject) {
				resolve(service.createFilters());
			});
		};
			
			/**
		 * Creates continent search page filters
		 * @returns {*[]}
		 */
		service.createFilters = function() {
			service.setFilters([
				new Filter({
					label: "Event Type",
					name: "types",
					class: "white",
					items: [
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Cycling', name:'Cycling'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Running', name:'Running'}),
						//new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Triathlon', name:'Triathlon'})
					]
				}), 

				new Filter({
					label: "Difficulty",
					name: "difficulties",
					class: "white",
					items: [
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Easy', name:'Easy'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Intermediate', name:'Intermediate'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Hard', name:'Hard'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Epic', name:'Epic'})
					]
				}),

				new Filter({
					label: "Month",
					name: "months",
					class: "white",
					items: [
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Jan-Feb', name:'0'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Mar-Apr', name:'2'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'May-Jun', name:'4'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Jul-Aug', name:'6'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Sep-Oct', name:'8'}),
						new FilterItem({template:FilterItem.TEMPLATE_CHECKBOX, label:'Nov-Dec', name:'10'})
					]
				})
			]);

			return service.filters;
		};
			
		return service;
	}]);
 

//Handles the creation and management of map markers
angular.module('ra.core')
	.service('mapMarkerService', ['eventService',
		function (eventService) {

		var markers = [];
		var infoWindow = null;
		
		var service = {};

		/**
		 * Add a set of events to the map, with the specified marker type
		 * @param map
		 * @param events
		 * @param markerType - Marker model to use
		 */
		service.plotEvents = function(map, events, markerType) {
			
			service.clearMarkers();
			
			for(var i=0; i<events.length; i++) {
				var event = events[i];
				
				if(event.location && event.location.geo) {
					var lng = event.location.geo[0];
					var lat = event.location.geo[1];

					event.pos = new google.maps.LatLng(lat, lng);
					event.map = map;

					markers.push(new markerType(event));
				}
			}
		};

		/**
		 * Update the singleton info window.
		 * Ensures only 1 window displayed at a time
		 * @param infoWindow
		 */
		service.updateInfoWindow = function(infoWindow) {
			if(this.infoWindow) {
				this.infoWindow.setMap(null);
			}
			this.infoWindow = infoWindow;
		};

		/**
		 * Clear all markers in the array from the map
		 */
		service.clearMarkers = function() {
			for(var i=0; i<markers.length; i++) {
				markers[i].googleMarker.setMap(null);
			}
			markers = [];
		};



			return service;
	}]);
 

/**
 * Created by jordan on 27/09/2015.
 */
//Holds photo related information
angular.module('ra.core')
    .service('photoService', ['photoRepo', 'updatePhotosEvent', 'photosLoadingEvent',
    function (photoRepo, updatePhotosEvent, photosLoadingEvent) {
        
        var self = this;
        self.eventId = null;
        
        var service = {};

        service.legs = [];
        service.bibs = [];
        
        //Last call to getTimePhotos
        self.timePhotos = {};

        service.photoGroups = [];
        service.currentBib = null;
        service.currentParticipant = null;
        service.currentLeg = null;
        service.selectedTab = null;
        service.participantIds = [];
        service.participantSummaries = [];
        
        service.ownsCollection = false;
        service.showLoading = false;
        service.showMyPhotos = null;
        service.isPrivate = false;
        service.isOrganiserOrAdmin = false;

        service.showPrintMenu = false;
        /** Secured-event modal: All Photos first page from server, no API load */
        service.securedPreviewBackdrop = false;

        /** Full My Photos list from API; gallery shows a growing slice (myPhotosPageSize at a time). */
        service.allMyPhotos = [];
        service.myPhotosVisibleCount = 0;
        service.photosPerPage = 40;
        service.myPhotosPageSize = 200;

        function broadcastMyPhotosSlice() {
            service.photoGroups = [service.allMyPhotos.slice(0, service.myPhotosVisibleCount)];
            updatePhotosEvent.broadcast(service.photoGroups);
        }

        /**
         * Populate bibs for the "Choose bib" list.
         * Normal users: only bibs from server-resolved participants (routeParams.bibs).
         * Admins/organisers: may also include bib from query string (?bib=…) for deep-linking.
         * @param routeParams
         */
        var populateBibs = function(routeParams) {
            if (routeParams.isOrganiserOrAdmin) {
                var query = queryString();
                if (typeof query.bib === 'string') {
                    service.bibs = [query.bib];
                } else if (typeof query.bib === 'object') {
                    service.bibs = query.bib;
                } else {
                    service.bibs = [];
                }
                routeParams.bibs.forEach(function(bib) {
                    if (service.bibs.indexOf(bib) === -1) {
                        service.bibs.push(bib);
                    }
                });
            } else {
                service.bibs = routeParams.bibs || [];
            }
        };
        

        /**
         * Shows photos SECONDS_BEFORE the specified time
         * Uses data in self.timePhotos
         * @param page
         */
        service.getTimePhotos = function(page) {
            var datetime = moment(self.timePhotos.time, "h:mm:ss a").subtract(self.timePhotos.offset, 'seconds');
            if(datetime && datetime.isValid()) {
                photosLoadingEvent.broadcast();
                var hour = datetime.hours();
                var minute = datetime.minutes();
                var second = datetime.seconds();
                return photoRepo.getPhotosAfter(hour, minute, second, self.eventId, page, self.timePhotos.legId)
            }
            else {
                return Promise.resolve(false);
            }
        };
        
        service.nextTimePhotos = function() {
            self.timePhotos.currentPages.max++;
            return service.getTimePhotos(self.timePhotos.currentPages.max)
                .then(function(result) {
                    if(result) {
                        service.photoGroups.push(result.photos);
                        updatePhotosEvent.broadcast(service.photoGroups);
                        if(result.photos.length == 0) {
                            $(".more.later").hide();
                        }
                        
                        return result.photos;
                    }
                });
        };
        
        service.prevTimePhotos = function() {
            self.timePhotos.currentPages.min--;
            return service.getTimePhotos(self.timePhotos.currentPages.min)
                .then(function(result) {
                    if(result) {
                        service.photoGroups.unshift(result.photos);
                        updatePhotosEvent.broadcast(service.photoGroups);
                        return result.photos;
                    }
                });
        };

        service.resetTimePhotos = function(legId, offset, time, participant) {
            self.timePhotos = {
                legId:legId,
                offset: offset,
                time:time,
                currentPages: {min:0, max:0}
            };
            
            service.currentParticipant = participant;
            return service.getTimePhotos(0)
                .then(function(result) {
                    service.photoGroups = [result.photos];
                    updatePhotosEvent.broadcast(service.photoGroups);
                    $(".more").fadeIn(400);
                });
            
        };

        service.hasMoreMyPhotos = function() {
            return service.allMyPhotos.length > service.myPhotosVisibleCount;
        };

        service.loadMoreMyPhotos = function() {
            if (!service.hasMoreMyPhotos()) {
                return Promise.resolve([]);
            }
            var previousCount = service.myPhotosVisibleCount;
            service.myPhotosVisibleCount = Math.min(
                service.myPhotosVisibleCount + service.myPhotosPageSize,
                service.allMyPhotos.length
            );
            if (service.myPhotosVisibleCount === previousCount) {
                return Promise.resolve([]);
            }
            broadcastMyPhotosSlice();
            return Promise.resolve(service.allMyPhotos.slice(previousCount, service.myPhotosVisibleCount));
        };

        service.getMyPhotos = function (bibs) {
            if(bibs) {
                photosLoadingEvent.broadcast();
                var bib = Array.isArray(bibs) ? bibs[0] : bibs;
                var index = service.bibs.indexOf(bib);
                var participantId = (service.participantIds && index >= 0 && service.participantIds[index]) ? service.participantIds[index] : null;

                return photoRepo.getMyPhotos(self.eventId, bibs, participantId)
                    .then(function(result)
                    {
                        service.currentParticipant = result.participant;
                        service.ownsCollection = result.ownsCollection;
                        service.showSelfie = result.participant && !result.participant.didAddSelfie;
                        service.currentBib = bibs;
                        service.allMyPhotos = result.photos || [];
                        service.myPhotosVisibleCount = Math.min(service.myPhotosPageSize, service.allMyPhotos.length);
                        broadcastMyPhotosSlice();
                    });
            } else {
                service.allMyPhotos = [];
                service.myPhotosVisibleCount = 0;
                service.photoGroups = [];
                service.showLoading = false;
                service.currentBib = null;
                service.currentParticipant = null;
                service.ownsCollection = false;
                service.showSelfie = false;
                updatePhotosEvent.broadcast(service.photoGroups);

                return Promise.resolve();
            }
        };
        
        service.shouldShowCollection = function() { 
            return this.selectedTab == "myPhotos" && this.ownsCollection && service.event.isPaid; 
        };
        
        service.init = function(routeParams) {
            service.showMyPhotos = routeParams.showMyPhotos;
            service.isPrivate = routeParams.isPrivate;
            service.isOrganiserOrAdmin = routeParams.isOrganiserOrAdmin === true;
            populateBibs(routeParams);
            service.participantIds = routeParams.participantIds || [];
            service.participantSummaries = routeParams.participantSummaries || [];
            service.currentBib = service.bibs[0];
            service.event = routeParams.event;
            service.photoButton = routeParams.photoButton;
            self.eventId = routeParams.eventId;
            if (routeParams.photosPerPage) {
                service.photosPerPage = routeParams.photosPerPage;
            }

            service.legs = routeParams.legs;

            service.securedPreviewBackdrop = routeParams.securedPreviewBackdrop === true;
            if (routeParams.securedPreviewPhotos && routeParams.securedPreviewPhotos.length) {
                service.photoGroups = [routeParams.securedPreviewPhotos];
                updatePhotosEvent.broadcast(service.photoGroups);
            }
            service.selectedTab = service.securedPreviewBackdrop ? 'allPhotos' : 'myPhotos';
        };
        
        service.removeBib = function(photoId, eventId, bibs) {
            return photoRepo.removeBib(photoId, eventId, bibs);
        };
        
        service.downloadAllPhotos = function (event, bib, participant) {
            return photoRepo.downloadAllPhotos(event, bib, participant);
        };

        service.downloadAllPhotosStatus = function (event, bib, participant) {
            return photoRepo.downloadAllPhotosStatus(event, bib, participant);
        };

        return service;
    }]);
 

/**
 * Created by jordan on 27/09/2015.
 */
//Requires user to login if skipSignOn is activated
angular.module('ra.core')
	.service('requireLoginService', ['photoService', 'showAuthEvent',
		function (photoService, showAuthEvent) {

			var service = {};
			
			service.init = function($scope) {
				//Fixme - refactor - Free event trigger
				$('body').on('showSignUpTrigger', function(e, afterSignUp) {
					if ($scope.userData.user || photoService.event.skipSignOn) {
						return afterSignUp();
					} else {
						$(".fancybox-overlay, .fancybox-wrap").addClass('hide-behind-login');
						$(".auth-ctrl").addClass('auth-ctrl-above-fancybox');
						$(".auth-ctrl").appendTo("body");
						var options = {
							interestedIn: photoService.event.type,
							instantSignup: true,
							alertType: 'success'
						};
						showAuthEvent.broadcast('Please create an account or sign in <br/>to get your photos.', function () {
							$(".fancybox-overlay, .fancybox-wrap").removeClass('hide-behind-login');
							afterSignUp();
						}, options);
					}
				});
			};
		
			return service;
		}]);
 

/**
 * Created by jordan on 24/09/2015.
 */

angular.module('ra.core')
    .service('timeIntervalService', [
        function () {
            var MAX_TIMES = 40;

            var service = {};

            /**
             * Floors a time to the nearest interval mins
             * e.g. roundTime(8:33, 15 -> 8:30) 
             * @param {moment} time
             * @returns {moment}
             */
            function roundTime(time, interval) {
                var newMins = Math.floor(time.minute()/interval)*interval;
                return time.minutes(newMins).seconds(0);
            }
            
            service.getTimes = function(startTime, endTime, interval, format) {
                var times = [];
                
                var start = new moment(startTime);
                var end = new moment(endTime);
                
                var time = new moment(startTime);
                time = roundTime(time, interval);
                
                while(time.isBefore(end) && times.length < MAX_TIMES) {
                    times.push(time.utc().format(format));
                    time.add(interval, 'minutes');
                }
                
                return times;
            };

            return service;
        }]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//Holds the user object (or lack thereof)
angular.module('ra.core')
	.service('userService', ['ajaxService',
	function (ajaxService) {

		var service = {};
		
		//Place variables in data so that they are updated without using $scope.$watch
		service.data = {
			user:null
		};
		
		return service;
	}]);
 

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.manage')
.controller('VisionCtrl', ['$scope',
	function($scope) {
		var vision = this;
		vision.event = "";
	
		//Load in first photo
		$scope.$watch('vision.routeParams', function (routeParams) {
			vision.event = routeParams.event;
		});
	}]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.manage')
    .controller('manageCtrl', ['$scope', 'ajaxService',
    function($scope, ajaxService) {

        /** Keystone apiError often sets error to the literal "error"; human text is in detail. */
        function messageFromAjaxErr(err) {
            if (!err) {
                return '';
            }
            var msg = err.detail || err.message;
            if (msg != null && msg !== '') {
                return typeof msg === 'string' ? msg : String(msg);
            }
            if (err.error && err.error !== 'error') {
                return String(err.error);
            }
            return '';
        }

        $scope.formData = $scope.formData || {};
        $scope.formData.participantSearch = null;
        $scope.formData.participantSearchStr = '';

        $scope.galleries = null;
        $scope.searchQuery = '';
        $scope.galleriesLoading = false;
        $scope.pages = { tagged: 1, untagged: 1, hidden: 1, myPhotos: 1 };

        $scope.galleryCountLabel = function(gallery) {
            if (!gallery) {
                return 0;
            }
            if (gallery.totalHasMore) {
                return gallery.first + '\u2013' + gallery.last + '+';
            }
            return gallery.total;
        };

        $scope.initManagePage = function(eventKey, eventId, isAdmin, purchaseReceiptCount, galleriesBootstrap) {
            $scope.initPurchaseReceiptResend(eventKey, purchaseReceiptCount);
            $scope.eventId = eventId;
            $scope.isAdmin = !!isAdmin;
            $scope.galleries = galleriesBootstrap || {};
            $scope.searchQuery = '';
            $scope.pages = { tagged: 1, untagged: 1, hidden: 1, myPhotos: 1 };
        };

        $scope.loadPhotoGalleries = function() {
            if (!$scope.eventKey) {
                return;
            }
            $scope.galleriesLoading = true;
            var url = '/api/manage/' + encodeURIComponent($scope.eventKey) + '/photos/galleries';
            var body = {
                search: $scope.searchQuery,
                taggedPage: $scope.pages.tagged,
                untaggedPage: $scope.pages.untagged,
                hiddenPage: $scope.pages.hidden,
                myPhotosPage: $scope.pages.myPhotos
            };
            return ajaxService.request(url, body)
                .then(function(result) {
                    if (result && result.galleries) {
                        $scope.galleries = result.galleries;
                    }
                })
                .catch(function(err) {
                    alert(messageFromAjaxErr(err) || 'Could not load photos.');
                })
                .finally(function() {
                    $scope.galleriesLoading = false;
                });
        };

        $scope.runPhotoSearch = function() {
            $scope.pages = { tagged: 1, untagged: 1, hidden: 1, myPhotos: 1 };
            return $scope.loadPhotoGalleries();
        };

        $scope.clearPhotoSearch = function() {
            $scope.searchQuery = '';
            $scope.pages = { tagged: 1, untagged: 1, hidden: 1, myPhotos: 1 };
            return $scope.loadPhotoGalleries();
        };

        $scope.setGalleryPage = function(galleryKey, page) {
            if (page === '...' || page === false || page == null) {
                return;
            }
            $scope.pages[galleryKey] = page;
            return $scope.loadPhotoGalleries();
        };

        $scope.initPurchaseReceiptResend = function(eventKey, purchaseReceiptCount) {
            $scope.eventKey = eventKey;
            $scope.purchaseReceiptCount = typeof purchaseReceiptCount === 'number' ? purchaseReceiptCount : 0;
            $scope.participantReceiptResendBusy = false;
            $scope.allPurchaseReceiptResendBusy = false;
            $scope.participantSearchUrl = '/api/participants/search?eventKey=' + encodeURIComponent(eventKey) + '&search=';
        };

        $scope.submitAllPurchaseReceiptResend = function() {
            if ($scope.allPurchaseReceiptResendBusy || $scope.participantReceiptResendBusy) {
                return;
            }
            if (!$scope.purchaseReceiptCount) {
                alert('There are no purchase receipts to resend for this event.');
                return;
            }
            if (!confirm('Are you sure you want to resend purchase emails to ' + $scope.purchaseReceiptCount + ' participants?')) {
                return;
            }
            $scope.allPurchaseReceiptResendBusy = true;
            var url = '/api/manage/' + encodeURIComponent($scope.eventKey) + '/purchase-receipts/resend-all';
            ajaxService.request(url, {})
                .then(function(result) {
                    if (result && result.message) {
                        alert(result.message);
                    } else {
                        alert('Receipt emails sent.');
                    }
                })
                .catch(function(err) {
                    alert(messageFromAjaxErr(err) || 'Request failed.');
                })
                .finally(function() {
                    $scope.allPurchaseReceiptResendBusy = false;
                });
        };

        $scope.submitParticipantReceiptResend = function() {
            if ($scope.participantReceiptResendBusy || $scope.allPurchaseReceiptResendBusy) {
                return;
            }
            var hid = document.getElementById('participantIdForReceipt');
            var id = hid ? hid.value : '';
            if (!id) {
                alert('Please select a participant from the search.');
                return;
            }
            if (!confirm('Resend receipt email(s) for this participant?')) {
                return;
            }
            $scope.participantReceiptResendBusy = true;
            var url = '/api/manage/' + encodeURIComponent($scope.eventKey) + '/purchase-receipts/resend-participant';
            ajaxService.request(url, { participantId: id })
                .then(function(result) {
                    if (result && result.message) {
                        alert(result.message);
                    } else {
                        alert('Receipt emails sent.');
                    }
                })
                .catch(function(err) {
                    alert(messageFromAjaxErr(err) || 'Request failed.');
                })
                .finally(function() {
                    $scope.participantReceiptResendBusy = false;
                });
        };

        $scope.onParticipantReceiptChosen = function() {
            var sel = $scope.formData.participantSearch;
            var id = sel && (sel._id || (sel.originalObject && sel.originalObject._id));
            var hid = document.getElementById('participantIdForReceipt');
            if (hid) {
                hid.value = id ? String(id) : '';
            }
        };

        $scope.deletePhoto = function(photoId) {
            var data = {photoId:photoId};
            var r = confirm("Are you sure you wish to delete this photo?");
            if (r == true) {
                ajaxService.request('/api/manage/photos/delete/', data, false)
                    .then(function(result) {
                       if(result.success) {
                           $(".photo-"+photoId).fadeOut(300);
                       } else {
                           alert("Could not delete photo - " + result.error);
                       }
                    });
            }
        };

    }]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.manage')
	.controller('uploadCtrl', ['$scope', 'FileUploader', 'undoService',
		function($scope, FileUploader, undoService) {

			if (!$scope.data) {
				$scope.data = { event: {}, legs: [] };
			}
			if (!$scope.data.event) {
				$scope.data.event = {};
			}
			if (!$scope.data.legs) {
				$scope.data.legs = [];
			}

			function syncCanUploadPhotos() {
				if (!$scope.data || !$scope.data.event) {
					return;
				}
				$scope.data.canUploadPhotos = !$scope.data.event.isPaid || !!$scope.data.event.watermarkPath;
			}

			var uploader = $scope.uploader = new FileUploader();

			var OVERLAY_UPDATE_URL = '/manage/overlay/update';
			$scope.overlayFormPending = false;
			$scope.overlaySubmitIntent = 'save';

			$scope.setOverlaySubmitIntent = function(intent) {
				if ($scope.overlayFormPending) {
					return;
				}
				$scope.overlaySubmitIntent = intent;
			};

			$scope.onOverlayClearMousedown = function($event) {
				if ($scope.overlayFormPending) {
					$event.preventDefault();
					return;
				}
				$scope.overlaySubmitIntent = 'clear';
				var el = $event.target;
				var form = el && el.form;
				if (!form) {
					return;
				}
				var fileInputs = form.querySelectorAll('input[type="file"]');
				for (var i = 0; i < fileInputs.length; i++) {
					fileInputs[i].value = '';
				}
			};

			/**
			 * POST watermark form via fetch; server returns JSON (no full-page redirect).
			 */
			$scope.submitOverlayForm = function($event) {
				$event.preventDefault();
				if ($scope.overlayFormPending) {
					return;
				}
				var form = $event.currentTarget;
				if (!form || form.nodeName !== 'FORM') {
					form = ($event.target && $event.target.form) || null;
				}
				if (!form) {
					return;
				}
				$scope.overlayFormPending = true;
				var fd = new FormData(form);
				var raw = $event.originalEvent || $event;
				var sub = raw.submitter;
				if (sub && sub.name) {
					fd.append(sub.name, sub.value || '');
				} else if ($scope.overlaySubmitIntent === 'clear') {
					fd.append('clearOverlay', 'Clear');
				}
				$scope.overlaySubmitIntent = 'save';
				fetch(OVERLAY_UPDATE_URL, {
					method: 'POST',
					body: fd,
					credentials: 'same-origin',
					headers: { 'Accept': 'application/json' }
				}).then(function(res) {
					return res.text().then(function(text) {
						var body;
						try {
							body = text ? JSON.parse(text) : {};
						} catch (e) {
							throw new Error(text || res.statusText || 'Invalid response');
						}
						if (!res.ok) {
							var msg = body.detail || body.error;
							if (typeof msg !== 'string') {
								msg = res.statusText || 'Request failed';
							}
							throw new Error(msg);
						}
						return body;
					});
				}).then(function(body) {
					if (!body.ok) {
						throw new Error(body.error || 'Request failed');
					}
					if (body.watermarkPath !== undefined) {
						$scope.data.event.watermarkPath = body.watermarkPath;
					}
					syncCanUploadPhotos();
					$scope.overlayFormPending = false;
					if (!$scope.$$phase) {
						$scope.$apply();
					}
				}).catch(function(err) {
					alert(err.message || String(err));
					$scope.overlayFormPending = false;
					if (!$scope.$$phase) {
						$scope.$apply();
					}
				});
			};

			var uploadFailed = false;

			var unsuccessfulFile = null;
			var failedFiles = [];
			var didCancel = false;

			//Time upload started - recorded as batch start
			var undoData = undoService.data;

			$scope.skipTagging = "off";
			$scope.batchSize = 6;
			$scope.offset = {
				seconds: 0,
				minutes: 0,
				sign: "+"
			};

			function parseBatchSize(value) {
				var n = parseInt(value, 10);
				if (isNaN(n) || n < 1) {
					return 1;
				}
				return n;
			}

			function syncBatchSizeFromView() {
				var input = document.getElementById('uploadBatchSize');
				if (input && input.value !== '') {
					$scope.batchSize = parseBatchSize(input.value);
					return $scope.batchSize;
				}
				$scope.batchSize = parseBatchSize($scope.batchSize);
				return $scope.batchSize;
			}

			$scope.onBatchSizeChange = function() {
				syncBatchSizeFromView();
			};

			$scope.updateAllowTagging = function(legId) {
				var leg = $scope.data.legs.find(function(x) { return x._id === legId });
				if(leg) {
					$scope.skipTagging = leg.timeMatchOnly ? "on" : "off";
				}
			};

			$scope.getOffsetSeconds = function() {
				var seconds = $scope.offset.seconds;
				var minutes = $scope.offset.minutes;

				var offset = seconds + minutes * 60;
				if($scope.offset.sign === "-") {
					offset = -offset;
				}
				return offset;
			};

			$scope.leg = "";
			$scope.disableLeg = false;
			$scope.uploadSessionActive = false;

			function pendingNotUploading() {
				return uploader.getNotUploadedItems().filter(function(item) {
					return !item.isUploading;
				});
			}

			function inFlightUploadCount() {
				return uploader.queue.filter(function(item) {
					return item.isUploading;
				}).length;
			}

			function finishUploadSession() {
				uploader.isUploading = false;
				$scope.uploadSessionActive = false;
				uploader.onCompleteAll();
			}

			function scheduleNextUploads() {
				if (didCancel) {
					finishUploadSession();
					return;
				}

				var inFlight = inFlightUploadCount();
				var pending = pendingNotUploading();

				if (pending.length === 0 && inFlight === 0) {
					finishUploadSession();
					return;
				}

				var slots = Math.min(syncBatchSizeFromView() - inFlight, pending.length);
				for (var i = 0; i < slots; i++) {
					startUploadItem(pending[i]);
				}
			}

			function startUploadItem(item) {
				if (!item || item.isUploading || item.isUploaded || didCancel) {
					return;
				}
				item._prepareToUploading();
				uploader.isUploading = true;
				uploader._onBeforeUploadItem(item);
				uploadManualItem(item).then(function() {
					scheduleNextUploads();
				}, function() {
					scheduleNextUploads();
				});
			}

			function completeUploadItem(item, response, status) {
				item._onComplete(response, status, {});
				uploader.isUploading = false;
				uploader.progress = uploader._getTotalProgress();
				uploader._render();
			}

			$scope.beginUpload = function() {
				if ($scope.uploadSessionActive || uploader.isUploading) {
					return;
				}
				syncBatchSizeFromView();
				$scope.uploadSessionActive = true;
				//Photo with no leg will show in "My Photos"
				if(document.getElementById("selectLeg").selectedIndex === 1) {
					$scope.uploadSessionActive = false;
					alert("You must choose a leg.");
					return;
				}
				if (!uploader.getNotUploadedItems().length) {
					$scope.uploadSessionActive = false;
					return;
				}
				didCancel = false;
				uploader.numComplete = 0;
				undoService.addNewBatchTime();
				$scope.disableLeg = true;
				unsuccessfulFile = null;
				uploadFailed = false;
				failedFiles = [];
				scheduleNextUploads();
			};

			$scope.cancelAll = function() {
				didCancel = true;
				uploadFailed = true;
				uploader.cancelAll();
				$scope.uploadSessionActive = false;
				$scope.disableLeg = false;
			};

			undoService.onUndo = $scope.cancelAll;

			// ng-init on the same element runs after this controller; reconcile if missing.
			$scope.$evalAsync(function() {
				if (typeof $scope.data.canUploadPhotos !== 'boolean') {
					syncCanUploadPhotos();
				}
			});

			$scope.$watch('data', function() {
				undoData.event = $scope.data._id;
			});

			$scope.$watch('uploader.progress', function () {
				$scope.progress = isNaN(uploader.progress) ? 0 : uploader.progress;
			});

			/**
			 * Refreshes the uploader queue, stopping all uploads
			 * Better than uploader.replaceAll and cancelAll which don't work properly
			 */
			var refreshQueue = function() {
				var oldQueue = uploader.queue.slice();
				oldQueue = oldQueue.map(function(fileItem) {return fileItem.file});
				uploader.clearQueue();
				uploader.addToQueue(oldQueue);
			};

			var addFailedFile = function(file) {
				failedFiles.push(file.name);
			};

			var UPLOAD_INIT_URL = '/api/manage/photos/upload-init/';

			function parseJsonResponse(res, text) {
				var body;
				try {
					body = text ? JSON.parse(text) : {};
				} catch (e) {
					throw new Error(text || res.statusText || 'Invalid response');
				}
				if (!res.ok) {
					var msg = body.error || body.detail || res.statusText || 'Request failed';
					throw new Error(msg);
				}
				return body;
			}

			function putToPresignedUrl(url, body, contentType) {
				return fetch(url, {
					method: 'PUT',
					body: body,
					headers: { 'Content-Type': contentType }
				}).then(function(res) {
					if (!res.ok) {
						throw new Error('S3 upload failed (' + res.status + ')');
					}
				});
			}

			function uploadManualItem(item) {
				var file = item._file;

				return fetch(UPLOAD_INIT_URL, {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						eventId: $scope.data._id,
						offset: $scope.getOffsetSeconds(),
						leg: $scope.leg,
						skipTagging: $scope.skipTagging,
						batchTime: undoData.batchStartTimes[undoData.batchStartTimes.length - 1],
						originalName: file.name,
						contentLength: file.size
					})
				}).then(function(res) {
					return res.text().then(function(text) {
						return parseJsonResponse(res, text);
					});
				}).then(function(session) {
					uploader._onProgressItem(item, 20);
					var manifestBody = JSON.stringify(session.manifestPayload);
					return putToPresignedUrl(session.manifest.url, manifestBody, 'application/json')
						.then(function() {
							uploader._onProgressItem(item, 50);
							return putToPresignedUrl(session.photo.url, file, 'image/jpeg');
						});
				}).then(function() {
					uploader._onSuccessItem(item, {}, 202, {});
					completeUploadItem(item, {}, 202);
				}).catch(function(err) {
					var errorResponse = { success: false, error: err.message || String(err) };
					uploader._onErrorItem(item, errorResponse, 0, {});
					completeUploadItem(item, errorResponse, 0);
				});
			}

			uploader.uploadItem = function(item) {
				if ($scope.uploadSessionActive) {
					return;
				}
				startUploadItem(uploader.getIndexOfItem(item) >= 0 ? uploader.queue[uploader.getIndexOfItem(item)] : item);
			};

			// CALLBACKS
			uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
				alert("The file must be a valid image");
			};
			uploader.onErrorItem = function(fileItem, response, status, headers) {
				if(response.success !== true) {
					uploadFailed = true;
					addFailedFile(fileItem.file);
				}
			};
			uploader.onCompleteAll = function() {

				if(!failedFiles.length && !didCancel) {
					alert("All photos queued for processing!");
				} else if(didCancel) {
					alert("Cancelled upload.");
				}
				else {
					alert("Upload complete. "+failedFiles.length+" photos failed: " + failedFiles.join(', '));
				}
				$scope.disableLeg = false;
			};

			// -------------------------------
			var controller = $scope.controller = {
				isImage: function(item) {
					var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
					return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
				}
			};
		}]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.manage')
    .directive('undoBtn', ['undoService',
        function(undoService) {
            return {
                templateUrl: 'undoBtn.html',
                restrict: 'E',
                scope: {},
                link: function ($scope, $element) {
                    $scope.undoData = undoService.data;
                    $scope.isLoading = false;
                    $scope.isComplete = false;
                    
                    var loadingMsg = $element.find("#loadingMsg");
                    var completeMsg = $element.find("#completeMsg");
                    var deleteBtn = $element.find("#deleteBtn");
                    
                    
                    var hide = function() {
                        loadingMsg.hide();
                        completeMsg.hide();
                        deleteBtn.hide();
                    };
                    
                    var showDeleteIfAvailable = function() {
                        if($scope.undoData.batchStartTimes.length) {
                            deleteBtn.show();
                        }
                    };
                    
                    $scope.undo = function() {
                        var shouldUndo = confirm("Are you sure you wish to delete the last uploaded batch of photos?");
                        if(shouldUndo) {
                            hide();
                            loadingMsg.show();
                            return undoService.undo()
                                .then(function() {
                                    hide();
                                    completeMsg.show();
                                    showDeleteIfAvailable();
                                },
                                function(err) {
                                    $scope.isLoading = false;
                                    console.log(err);
                                    alert(err.detail);
                                });
                        }
                    };
                    
                    hide();
                    $scope.$watch('undoData.batchStartTimes.length', function() {
                        showDeleteIfAvailable();
                    });
                }
            }
        }
    ]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.manage')
    .directive('viewCountsForm', [
        function() {
            return {
                templateUrl: 'viewCountsForm.html',
                restrict: 'E',
                scope: {
                    fromDate: '@',
                    toDate: '@',
                    format: '@'
                },
                link: function ($scope, $element) {
                    
                    var getDate = function(date) {
                        console.log(date);
                        if(typeof date == "string") {
                            return moment(date, $scope.format).valueOf();
                        } else if(typeof date == "object") {
                            return date.valueOf();
                        } else {
                            throw new Error("Invalid date");
                        }
                    };
                    
                    $scope.form = {
                        fromDate: moment(parseInt($scope.fromDate)),
                        toDate: moment(parseInt($scope.toDate)),
                    };
                    
                    $scope.submitForm = function($event) {
                        $event.preventDefault();
                        
                        var fromDate = getDate($scope.form.fromDate);
                        var toDate = getDate($scope.form.toDate);

                        window.location.href = '?fromDate='+fromDate+'&toDate='+toDate;
                        
                    }
                }
            }
        }
    ]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.manage')
    .directive('visionStatus', ['visionService', '$interval',
        function(visionService, $interval) {
            return {
                templateUrl: 'visionStatus.html',
                restrict: 'E',
                scope: {
                    event: '=',
                },
                link: function ($scope, $element) {
					$scope.legs = [];
					$scope.exclude = [];
					$scope.eventVisionExclude = '';
					var firstUpdate = true;
					var pollIntervalMs = 10000;
					var pollHandle = null;
					
                	var update = function() {
						return visionService.legStatus($scope.event)
							.then(function (result) {
									$scope.legs = result.legs;
									if(firstUpdate) {
										$scope.eventVisionExclude = result.eventVisionExclude || '';
									}
									var anyInProgress = false;
									$scope.legs.forEach(function(leg, index) {
										if(leg.visionInProgress) {
											leg.tagBtnTitle = "Queueing...";
											anyInProgress = true;
										} else {
											leg.tagBtnTitle = "Tag";
										}
										if(firstUpdate) {
											$scope.exclude[index] = leg.visionExclude;
										}
									});
									firstUpdate = false;
									if (pollHandle && anyInProgress && pollIntervalMs !== 3000) {
										$interval.cancel(pollHandle);
										pollIntervalMs = 3000;
										pollHandle = $interval(update, pollIntervalMs);
									} else if (pollHandle && !anyInProgress && pollIntervalMs !== 10000) {
										$interval.cancel(pollHandle);
										pollIntervalMs = 10000;
										pollHandle = $interval(update, pollIntervalMs);
									}
								},
								function (err) {
									console.log(err.stack);
								});
					};
                	
                	$scope.tagLeg = async function(leg, exclude) {
						var check = visionService.validateVisionExcludeSyntax(exclude);
						if (!check.valid) {
							alert(check.error);
							return;
						}
						try {
							var result = await visionService.tagLeg(leg._id, exclude);
							if (result && result.accepted) {
								update();
							}
						} catch (err) {
							alert("We could not begin tagging this leg.  Please try again.");
						}
					};

					$scope.saveEventVisionExclude = function() {
						var check = visionService.validateVisionExcludeSyntax($scope.eventVisionExclude);
						if (!check.valid) {
							alert(check.error);
							return;
						}
						var formatted = visionService.formatVisionExcludeSyntax($scope.eventVisionExclude);
						$scope.eventVisionExclude = formatted;
						return visionService.saveEventVisionExclude($scope.event, formatted)
							.then(function() {
								alert('Saved event-wide excludes.');
							},
							function() {
								alert('Could not save event-wide excludes.');
							});
					};
                	
                	$scope.debugReset = function(leg) {
						const result = confirm("Are you sure you want to reset this leg?");
						if(result) {
							return visionService.debugReset(leg._id)
								.then(function() {
										alert("Successfully cleared leg");
									},
									function(err) {
										console.error(err);
										// ajaxService rejects with response.data — nginx 504s are HTML, not for alert()
										var msg = typeof err === 'string' && err && !/<html/i.test(err)
											? err
											: 'The server timed out or could not reset this leg. Please try again.';
										alert(msg);
									})
						}
					};
                	
                	$scope.manualTag = function(leg) {
						return visionService.manualTag(leg._id)
							.then(function(result) {
									var n = (result && (result.modifiedCount || result.nModified)) || 0;
									if (n) {
										alert('Queued ' + n + ' photo(s) for manual tagging. Open Tag Photos for this event to review them.');
									} else {
										alert('No photos were changed. Photos with no bibs that are already untagged are already in the Tag Photos queue.');
									}
									update();
								},
								function() {
									alert("We could not manual tag this leg.  Please try again.");
								});
					};
					
					var unbind = $scope.$watch('event', function(event) {
						pollHandle = $interval(update, pollIntervalMs);
						update();
						unbind();
					});
					
					
                }
            }
        }
    ]);

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.manage')
    .service('managePhotoRepo', ['ajaxService',
        function (ajaxService) {

            var service = {};

            /**
             * undo
             * data.eventId
             * data.batchTime
             */
            service.undo = function(data) {
                return ajaxService.request('/api/manage/photos/undo/'+data.eventId+'/'+data.batchTime, data);
            };

            return service;
        }]);
 

/**
 * Created by jordan on 24/09/2015.
 */
//User object
angular.module('ra.manage')
    .service('undoService', ['managePhotoRepo',
        function (managePhotoRepo) {

            var service = {};
            
            service.data = {
                event:'',
                batchStartTimes: [],
                lastBatchTime: "",
            };
            service.onUndo = null;
            
            var updateLastBatchTime = function() {
                service.data.lastBatchTime = new moment(service.data.batchStartTimes[service.data.batchStartTimes-1]).format('hh:mm:ssa');
            };
            
            var removeLastBatchTime = function() {
                service.data.batchStartTimes.pop();
                updateLastBatchTime();
            };
            
            service.addNewBatchTime = function() {
                var newTime = Date.now();
                service.data.batchStartTimes.push(newTime);
                updateLastBatchTime();
                
                return newTime;
            };
            
            service.undo = function() {
                if(service.onUndo) {
                    service.onUndo();
                }
                var data = {
                    eventId:service.data.event,
                    batchTime:service.data.batchStartTimes[service.data.batchStartTimes.length-1]
                };
                return managePhotoRepo.undo(data)
                    .then(function() {
                        removeLastBatchTime();
                    });
            };

            return service;
        }]);
 

/**
 * Created by jordan on 29/05/2018.
 */
angular.module('ra.manage')
	.service('visionService', ['ajaxService', function(ajaxService) {
		var service = {};

		function validateVisionExcludeSyntax(raw) {
			if (raw == null) {
				return { valid: true };
			}
			var s = String(raw).trim();
			if (s === '') {
				return { valid: true };
			}
			var items = s.split(',');
			for (var i = 0; i < items.length; i++) {
				var part = items[i].trim();
				if (part === '') {
					return { valid: false, error: 'Remove empty entries (double commas or a comma at the start/end).' };
				}
				if (/^\d+$/.test(part)) {
					continue;
				}
				if (/^\d+\s*-\s*\d+$/.test(part)) {
					continue;
				}
				return {
					valid: false,
					error: 'Invalid entry "' + part + '". Use digits only for bibs, separate items with commas, and use a single hyphen for a range (e.g. 3,12,100-200 or 201-120).',
				};
			}
			return { valid: true };
		}

		function formatVisionExcludeSyntax(raw) {
			if (raw == null) {
				return '';
			}
			var s = String(raw).trim();
			if (s === '') {
				return '';
			}
			var formatted = [];
			var items = s.split(',');
			for (var i = 0; i < items.length; i++) {
				var part = items[i].trim();
				var rangeMatch = part.match(/^(\d+)\s*-\s*(\d+)$/);
				if (rangeMatch) {
					formatted.push(rangeMatch[1] + '-' + rangeMatch[2]);
				} else {
					formatted.push(part);
				}
			}
			return formatted.join(', ');
		}

		service.validateVisionExcludeSyntax = validateVisionExcludeSyntax;
		service.formatVisionExcludeSyntax = formatVisionExcludeSyntax;
		service.legStatus = function(eventId) {
			return ajaxService.request('/api/vision/leg-status/', {eventId: eventId}, false);
		};

		service.tagLeg = function(legId, visionExclude) {
			return ajaxService.request('/api/vision/tag-leg/', {legId: legId, visionExclude: visionExclude}, false);
		};

		service.saveEventVisionExclude = function(eventId, visionExcludeEvent) {
			return ajaxService.request('/api/vision/event-exclude/', {eventId: eventId, visionExcludeEvent: visionExcludeEvent}, false);
		};

		service.manualTag = function(legId) {
			return ajaxService.request('/api/vision/manual-tag/', {legId: legId}, false);
		};

		service.debugReset = function(legId) {
			return ajaxService.request('/api/misc/debug-reset/', {legId: legId}, false);
		};  
		
		return service;
	}]);
/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.myVideo')
.controller('MyVideoCtrl', ['$scope', 'shouldShowVideoEvent', 'requireLoginService', 'showAuthEvent', 'userService',
    function($scope, shouldShowVideoEvent, requireLoginService, showAuthEvent, userService) {
        var vm = this;

        function showVideo(channel, token) {
            var videoHolder = document.getElementById('video-holder');
            var script = document.createElement('script');
            script.setAttribute('data-channel', channel);
            script.setAttribute('data-token', token);
            script.id = 'irw-iframe-loader';
            script.src = 'https://irewind.com/vue/loaders/loader-general.js';

            videoHolder.appendChild(script);
        }
        
        $scope.$watch('routeParams', function (routeParams) {
            userService.data.user = routeParams.user;
            $scope.requireSignOn = routeParams.event.videoRequiresSignOn && !routeParams.user;

            if($scope.requireSignOn) {

                var options = {
                    interestedIn: 'Running',
                    instantSignup: true
                };
                showAuthEvent.broadcast('Please sign up or log in to see your participant video.', function() {
                    window.location.reload();
                }, options);
            }
        });
        
        shouldShowVideoEvent.listen(function(videoData) {
            $scope.videoData = videoData;
            showVideo(videoData.channel, videoData.token); 
        });
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.myVideo')
    .directive('videoPopup', ['shouldShowVideoEvent', 'myVideoService', '$timeout',
        function(shouldShowVideoEvent, myVideoService, $timeout) {
        return {
            templateUrl: 'videoPopup.html',
            restrict: 'E',
            scope: {
                eventId: '@',           // Event ID
                agreementText: '@',     // If set, shows a checkbox with the agreement text and requires user to tick
                agreementLink: '@',     // Shows a clickable link at the end of the agreement
                value: '@',             // Default value for email field.  If not specified, it is set to the email query paramter
                bibDisabled: '='   // If true, user cannot enter a bib (must be email only)
            },
            link: function($scope) {
                var self = this;
                $scope.isLoading = false;
                $scope.apiRejected = false;

                $scope.formData = {
                    bib: $scope.value,
                    agreement: !$scope.agreementText,
                };

                $scope.show = function() {
                    $scope.$broadcast("showPopup"); 
                };

                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };
                
                $scope.send = function() {
                    $scope.apiRejected = false;
                    $scope.hasSubmitted = true;
                    if($scope.form.$valid) {
                        $scope.isLoading = true;

                        myVideoService.getVideoData($scope.eventId, $scope.formData.bib)
                            .then(function(data) {
                                shouldShowVideoEvent.broadcast(data);

                                // Add delay to give video time to load
                                $scope.isLoading = false;
                                $scope.loadingVideo = true;
                                $timeout(function() {
                                    $scope.loadingVideo = false;
                                    $scope.hide();
                                }, 4000);
                            }, function(err) { 
                                $scope.isLoading = false;
                                $scope.apiRejected = true;
                            });
                    }
                };

                const urlParams = new URLSearchParams(window.location.search);
                const purchased = urlParams.get('purchased');
                if(purchased) {
                    const bib = urlParams.get('bib');
                    $scope.formData.bib = bib;
                    setTimeout(function() {
                        $scope.send();
                    }, 1);
                
                } else if(!$scope.formData.bib) {
                    const email = urlParams.get('email');
                    if(email) {
                        $scope.formData.bib = email;
                    }
                }
                
                const irwtoken = urlParams.get('irwtoken');
                const irwchannel = urlParams.get('irwchannel');
                if(irwchannel && irwtoken) {
                    shouldShowVideoEvent.broadcast({
                        channel: irwchannel, 
                        token: irwtoken
                    });
                } else {
                    $scope.show();
                }
                
            }
        };
    }]);

/**
 * Created by jordan on 24/09/2015.
 */
angular.module('ra.myVideo')
    .service('myVideoService', ['ajaxService',
        function (ajaxService) {

            var service = {};

            service.getVideoData = function(event, bib, onError) {
                return ajaxService.request('/api/my-video/'+event+'/'+bib, {});
            };
            

            return service;
        }]);
 

angular.module('ra.myVideo')
    .service('shouldShowVideoEvent', ['$rootScope', function ($rootScope) {

        var service = {};
        var eventName = 'shouldShowVideo';

        service.broadcast = function(videoData) {
            $rootScope.$broadcast(eventName, {videoData:videoData});
        };
        service.listen = function(callback) {
            $rootScope.$on(eventName, function (event, data) {
                callback(data.videoData);
            });
        };

        return service;
    }]);
 

/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.news')
    .directive('article', ['hideArticleMenusEvent', 'showArticleMenusEvent', 'commentService', 'articleService', 'userService', 'showAuthEvent', 'hideCommentsEvent',
        function(hideArticleMenusEvent, showArticleMenusEvent, commentService, articleService, userService, showAuthEvent, hideCommentsEvent) {
        return {
            templateUrl: 'article.html',
            restrict: 'E',
            scope: {
                article: '=',
            },
            link: function($scope, $element) {
                
                var commentsPage;
                var didClickMoreComments = false;
                
                $scope.userData = userService.data;
                $scope.numRemainingComments = null;
                $scope.comments = null;
                
                var $menu;
                var $commentsLoading;
                var $commentBtn;
                var $allComments;
                var $commentFormHolder;
                var $makeTrending;
                var $makeNotTrending;

                var updateJudgement = function(judgement) {
                    $scope.article.likes = judgement.likes;
                    $scope.article.dislikes = judgement.dislikes;
                    $scope.article.likedByYou = judgement.likedByYou;
                    $scope.article.dislikedByYou = judgement.dislikedByYou;

                };
                 
                var like = function() {
                    return articleService.like({articleId:$scope.article._id})
                        .then(function(judgement) {
                            updateJudgement(judgement);
                        });
                };
                
                var dislike = function() {
                    return articleService.dislike({articleId:$scope.article._id})
                        .then(function(judgement) {
                            updateJudgement(judgement);
                        })
                };


                $scope.showMenu = function() {
                    $menu.show();
                    showArticleMenusEvent.broadcast();
                };
                $scope.hideMenu = function() {
                    $menu.hide();
                    hideArticleMenusEvent.broadcast();
                };

                /**
                 * Refreshes comments, and moves to the new top comment, highlighting it
                 */
                $scope.refreshCommentAndHighlight = function() {
                    $scope.resetComments();

                    return $scope.getComments()
                        .then(function() {
                            if($scope.comments.length) {
                                AngularFunc.scrollToMiddle($($element).find('.replies'));
                                $scope.comments[0].highlight = true;
                            }
                        });
                };

                $scope.addClick = function() {
                    return articleService.addClick({articleId:$scope.article._id});
                };
                
                $scope.resetComments = function() {
                    //We have already loaded the first page with the article
                    commentsPage = 0;
                    $scope.comments = [];
                    $commentsLoading.hide();
                    $commentBtn.show();
                    $scope.numRemainingComments = $scope.article.numComments;
                };
                
                $scope.like = function() {
                    if($scope.userData.user) {
                        like();
                    } else {
                        showAuthEvent.broadcast('Register or sign up to save your comment!', like);
                    }
                    
                };

                $scope.dislike = function() {
                    if($scope.userData.user) {
                        dislike();
                    } else {
                        showAuthEvent.broadcast('Register or sign up to save your comment!', dislike);
                    }
                };
                
                $scope.goToLink = function() {
                    $scope.addClick();
                    window.open($scope.article.link, '_blank');
                };
                
                $scope.toggleTrending = function() {
                    return articleService.toggleTrending({articleId: $scope.article._id})
                        .then(function() {
                            $scope.article.trending = !$scope.article.trending;
                            if($scope.article.trending) {
                                $makeTrending.hide();
                                $makeNotTrending.show();
                                
                            } else {
                                $makeTrending.show();
                                $makeNotTrending.hide();
                            }
                        });
                };

                $scope.getComments = function() {
                    if(!didClickMoreComments) {
                        $scope.resetComments();
                        didClickMoreComments = true;
                    }
                    $commentsLoading.show();
                    $commentBtn.hide();
                    $commentFormHolder.show();
                    //hideCommentsEvent.broadcast($scope);
                    
                    return commentService.getComments('article', $scope.article._id, commentsPage, 'recent')
                        .then(function(result) {
                            $scope.numRemainingComments -= result.comments.length;
                            $scope.comments = $scope.comments.concat(result.comments);
                            commentsPage++;
                            $commentsLoading.hide();
                            
                            if($scope.numRemainingComments < 0) {
                                $scope.numRemainingComments = 0;
                            }
                            
                            if($scope.numRemainingComments !== 0) {
                                $commentBtn.show();
                            } else {
                                $allComments.show();
                            }
                        },
                        function() {
                            $commentsLoading.hide();
                            $commentBtn.show();
                            //alert("Could not refresh comments. Please try reloading the page.");
                        });
                };
                
                hideCommentsEvent.listen(function(caller) {

                   if($scope.$id !== caller.$id) {
                       $scope.resetComments();
                   }
                });

                hideArticleMenusEvent.listen(function() {
                    $menu.hide();
                });
                
                $scope.$watch('::article', function() {
                    
                    $menu = $element.find('.options-menu');
                    $commentsLoading = $element.find(".loading-comments");
                    $commentBtn = $element.find(".comment-btn");
                    $allComments = $element.find(".all-comments");
                    $commentFormHolder = $element.find(".comment-form-holder");
                    $makeTrending = $element.find(".make-trending");
                    $makeNotTrending = $element.find(".make-not-trending");
                    
                    if($scope.article.caption) {
                       /* $scope.article.comment = {
                            visible: true,
                            firstName: $scope.article.createdBy.name.first,
                            lastName: $scope.article.createdBy.name.last,
                            text: $scope.article.caption,
                            fromNow: $scope.article.publishedDate
                        };*/
                    }
                    
                    if(!$scope.article.numComments) {
                        $scope.article.numComments = 0;
                    }
                    
                    if($scope.article.trending) {
                        $makeTrending.hide();
                    } else {
                        $makeNotTrending.hide();
                    }

                    //$scope.resetComments();
                    $scope.comments = $scope.article.comments;
                    $scope.numRemainingComments = $scope.article.numComments - $scope.article.comments.length;
                    
                });

                
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('articleForm', ['newsService','showArticleFormEvent', '$timeout', 'articleService', 'userService',
        function(newsService, showArticleFormEvent, $timeout, articleService, userService) {
        return {
            templateUrl: 'articleForm.html',
            restrict: 'E',
            scope: {
                categories: '=',
                maxDescription: '=',
            },
            
            link: function($scope, $element) {
                $scope.PANELS = {
                    FORM: 1,
                    ERROR: 2,
                    DUPLICATE: 3,
                    PREVIEW: 4
                };
                $scope.currentPanel = null;

                $scope.userData = userService.data;
                $scope.newsService = newsService;
                $scope.isVisible = false;
                
                var $shareButton = $element.find(".share-btn");
                var $shareLoading = $element.find(".share-loading");
                
                var $submitButton = $element.find(".submit-btn");
                var $submitLoading = $element.find(".submit-loading");
                
                var initForm = function() {
                    $submitButton.show();
                    $submitLoading.hide();

                    $shareButton.show();
                    $shareLoading.hide();
                    
                    $scope.previewData = {};
                    $scope.formData = {
                        caption: '',
                        link: '',
                        description: '',
                        name: '',
                        trending: false,
                    };
                    $scope.setPanel($scope.PANELS.FORM);
                    $scope.selectedCategory = null;
                    $scope.articleFormSubmitted = false;
                    $scope.submitFormSubmitted = false;
                };
                
                var addPreviewDataToForm = function(previewData){
                    $scope.previewData = previewData;
                    $scope.formData.description = previewData.description;
                    $scope.formData.name = previewData.name;
                };
                
                
                
                var handleError = function(err) {
                    $submitButton.show();
                    $submitLoading.hide(); 

                    $shareButton.show();
                    $shareLoading.hide();
                    
                    if(err.error == "You must be logged in to perform this action") {
                        alert("Please log in to submit a link");
                    } else if(err.detail == "Article already exists") {
                        $scope.setPanel($scope.PANELS.DUPLICATE);
                    } else {
                        $scope.setPanel($scope.PANELS.ERROR);
                    }
                };


                $scope.selectCategory = function(category) {
                    $scope.selectedCategory = category;
                };
                
                $scope.close = function() {
                    $scope.isVisible = false;
                };
                
                $scope.show = function() {
                    $scope.isVisible = true;
                };
                
                $scope.setPanel = function(panel) {
                    $scope.currentPanel = panel;
                };
                
                $scope.submit = function() {
                    $scope.submitFormSubmitted = true;

                    
                    if($scope.submitForm.$valid && $scope.selectedCategory) {
                        $submitButton.hide();
                        $submitLoading.show();
                        
                        $scope.formData.category = $scope.selectedCategory._id;
                        $scope.formData.type = newsService.options.type;
                        $scope.formData.from = $scope.previewData.from;
                        $scope.formData.imageUrl = $scope.previewData.imageUrl;
                        
                        return articleService.submit($scope.formData)
                            .then(function(result) {
                                if(result.hideFromMainFeed) {
                                    newsService.options.category = result.category[0];
                                } else {
                                    newsService.options.category = "";
                                }
                                
                                $submitButton.show();
                                $submitLoading.hide();
                                $scope.close();

                                newsService.options.refine = "recent";
                                newsService.init();
                                newsService.updateUrl();
                                //newsService.setRefine("recent");
                                
                                newsService.getArticles()
                                    .then(function() {
                                        $(".article").first().addClass("highlight");
                                    })
                            },
                            handleError);
                    }
                };
                
                $scope.preview = function() {
                    $scope.articleFormSubmitted = true;
                    
                    if($scope.articleForm.$valid && $scope.selectedCategory) {
                        
                        $shareButton.hide();
                        $shareLoading.show();
                        
                        return articleService.scrapePreviewArticle({link: $scope.formData.link})
                            .then(function(previewData) {
                                $shareButton.show();
                                $shareLoading.hide();
                                
                                addPreviewDataToForm(previewData);
                                
                                $scope.setPanel($scope.PANELS.PREVIEW);
                            },
                            handleError);
                        
                    } else {
                        console.log($scope.articleForm);
                    }
                };

                showArticleFormEvent.listen(function(link) {
                    initForm();
                    $scope.formData.link = link;
                    $scope.show();
                    setTimeout(function() {$('#shareLink').focus();}, 200);
                })
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('articleList', ['$window',
        function($window) {
        return {
            templateUrl: 'articleList.html',
            restrict: 'E',
            scope: {
                articles: '=',
                user: '=',
                isLoading: '='
            },
            
            
            
            link: function($scope, element) {
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('articleWidget', ['showArticleFormEvent', 'userService', 'showAuthEvent',
        function(showArticleFormEvent, userService, showAuthEvent) {
        return {
            templateUrl: 'articleWidget.html',
            restrict: 'E',
            scope: {
        
            },
            link: function($scope, $element) { 
                $scope.formData = {
                    link: ''
                };
                $scope.buttonText = '+';
                $scope.userData = userService.data;
                
                var showSignup = function() {
                    showAuthEvent.broadcast('Register or sign up to post a link!', signOnComplete, {type:'Cycling', instantSignup:false});
                };

                var showArticleForm = function() {
                    showArticleFormEvent.broadcast($scope.formData.link);
                    $scope.formData.link = '';
                };

                var signOnComplete = function() {
                    $(".widget-text").css({cursor:''});
                    setPlaceholderText();
                    showArticleFormEvent.broadcast($scope.formData.link);
                };
                
                var setPlaceholderText = function() {
                    if(!$scope.userData.user) {
                        if ($(window).width() < window.Config.SMALL_MOBILE_WIDTH) {
                            $scope.placeholder = "Sign in to share";
                        } else {
                            $scope.placeholder = "Sign in or create an account to share links";
                        }

                        $(".widget-text").css({cursor:'pointer'});
                    }
                    else {
                        if($(window).width() < window.Config.SMALL_MOBILE_WIDTH) {
                            $scope.placeholder = "Enter your link";
                        } else {
                            $scope.placeholder = "Don't be afraid to contribute.  Add your link here.";
                        }
                    }
                };
                
                $scope.detectEnter = function(e) {
                    console.log(e);
                }
                
                $scope.addBtnClick = function() {
                    if(!$scope.userData.user) {
                        showSignup();
                    } else {
                        showArticleForm();
                    }
                };
                
                $scope.textFieldClick = function() {
                    if(!$scope.userData.user) {
                        showSignup();
                    } 
                };
                
                $scope.$watch('userData', function() {
                    setPlaceholderText();
                });

                
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.news')
    .directive('iframeContent', ['$sce',
        function($sce) {
        return {
            replace: true,
            templateUrl: 'iframeContent.html',
            restrict: 'E',
            scope: {
                article: '=',
                addClick: '&',
            },
            link: function($scope, $element) {
                var $iframe = $element.find('iframe');
                
                //Watch for first click
                var listenToClick = function() {
                    if(document.activeElement === $iframe[0]) {
                        $scope.addClick({articleId:$scope.article._id});

                        window.removeEventListener('blur', listenToClick);
                    }
                };
                var listener = window.addEventListener('blur', listenToClick);
                
                $scope.src = $sce.trustAsResourceUrl($scope.article.iframeSrc);
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('moreNews', ['newsService', '$window', 'autoplayService',
        function(newsService, $window, autoplayService) {
        return {
            templateUrl: 'moreNews.html',
            restrict: 'E',
            scope: {
            },
            
            link: function($scope, element) {
                var LOAD_MORE_SCROLL = 1300;
                var MAX_ARTICLES = 30;
                
                $scope.isLoading = false;
                $scope.newsService = newsService;
                
                $scope.moreNews = function() {
                    $scope.isLoading = true;
                    
                    newsService.getArticles()
                        .then(function() {
                            $scope.isLoading = false;
                        },
                        function() {
                            $scope.isLoading = false;
                        });
                };
                
                $scope.nextPage = function() {
                    $(window).scrollTop(120);
                    $(".next-page-btn").fadeOut(300);
                    autoplayService.clear();
                    newsService.nextPage();
                };

                angular.element($window).bind("scroll", function(e) {
                    if(newsService.articles.length >= MAX_ARTICLES) {
                        $(".next-page-btn").fadeIn(300);
                    } else {
                        var offset = window.AngularFunc.windowOffset(element[0], window.AngularFunc.OFFSET.BOTTOM);
                        if(offset > -LOAD_MORE_SCROLL) {
                            if(newsService.moreArticles && !$scope.isLoading && !newsService.isLoading) {
                                $scope.moreNews();
                            }
                        }
                    }
                    
                    
                });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('newsMenu', ['newsService', '$timeout', 'toggleNewsMenuEvent', 'enableWrapperCoverEvent', 'closeWrapperCoverEvent',
        function(newsService, $timeout, toggleNewsMenuEvent, enableWrapperCoverEvent, closeWrapperCoverEvent) {
            return {
                templateUrl: 'newsMenu.html',
                restrict: 'E',
                scope: {
                    categories: '='
                },
                link: function($scope, $element) {
                    var FIX_HEIGHT = 117;
                    var REFRESH_HEIGHT = 115;
                    var MENU_TRANSITION_TIME = 500;

                    var $body = $("body");
                    var $newsCategories = $(".news-categories");
                    var $window = $(window);
                    var $refineHolder = $('.refine-holder');
                    
                    var footerHeight = $("#footer").height();
                    var isFixed = false;
                    var mobileMenuVisible = false;
                    var menuChanging = false;
                    
                    $scope.newsService = newsService;
                    
                    var $newsMenu = $element.find(".news-menu");

                    var returnToTop = function() {
                        if($(window).scrollTop() > REFRESH_HEIGHT) {
                            $(window).scrollTop(REFRESH_HEIGHT);
                        }
                    };
                    
                    $scope.setType = function(type) {
                        $newsCategories.hide();
                        newsService.setType(type);
                        $newsCategories.fadeIn(300);
                        returnToTop();
                        $scope.hideMobileMenu();
                    };
                    
                    $scope.setRefine = function(refine) {
                        newsService.setRefine(refine);
                        returnToTop();
                        $scope.hideMobileMenu();
                    };

                    $scope.setCategory = function(category) {
                        newsService.setCategory(category);
                        returnToTop();
                        $scope.hideMobileMenu();
                    };

                    /**
                     * Attempt to close the menu
                     * @returns {boolean} - Whether the menu closed or not
                     */
                    $scope.showMobileMenu = function() {
                        enableWrapperCoverEvent.broadcast($scope.hideMobileMenu);
                        
                        if(!mobileMenuVisible && !menuChanging) {
                            mobileMenuVisible = true;
                            menuChanging = true;

                            $refineHolder.detach();
                            $refineHolder.show();
                            $("body").prepend($refineHolder);
                            var width = -$refineHolder.width() + "px";
                            $("#wrapper").css({
                                "transform": "translate3d( "+width+", 0, 0 )",
                                "-webkit-transform": "translate3d( "+width+", 0, 0 )"
                            });
                            $(window).scrollTop(0);
                            
                            $timeout(function() {
                                menuChanging = false;
                            }, MENU_TRANSITION_TIME);
                            
                            return true;
                        } else {
                            return false;
                        }
                    };

                    $scope.hideMobileMenu = function() {
                        if(mobileMenuVisible && !menuChanging) {
                            closeWrapperCoverEvent.broadcast();
                            menuChanging = true;
                            $("#wrapper").css({
                                "transform": "",
                                "-webkit-transform": ""
                            });

                            $timeout(function() {
                                $refineHolder.detach();
                                $(".article-list").after($refineHolder);
                                $refineHolder.hide();
                                menuChanging = false;
                                mobileMenuVisible = false;
                            }, MENU_TRANSITION_TIME);
                            
                            return true;
                        } else {
                            return false;
                        }
                        
                    };
                    
                    //Scroll with page, but not onto the footer
                    
                    $window.on("scroll", function(e) {

                        var scrollAmount = $window.scrollTop();
                        if (scrollAmount > FIX_HEIGHT && !isFixed) {
                            $newsMenu.addClass("fixed");
                            isFixed = true;
                        } else if(scrollAmount < FIX_HEIGHT && isFixed) {
                            $newsMenu.removeClass("fixed");
                            isFixed = false;
                        }
                        
                        var footerOverlapHeight = $body.height() - footerHeight;
                        var menuBottomHeight = scrollAmount + $newsMenu.height() + 100;
                        if(menuBottomHeight > footerOverlapHeight) {
                            var top = -(menuBottomHeight-footerOverlapHeight);
                            $newsMenu.css({top:top+"px"});
                        } else {
                            $newsMenu.css({top:""});
                        }

                    });

                    toggleNewsMenuEvent.listen(function() {
                        if(!mobileMenuVisible) {
                            $scope.showMobileMenu();
                        } else {
                            $scope.hideMobileMenu();
                        }
                    });
                    
                    $(window).resize(function() {
                        if($(window).width() > Config.DESKTOP_WIDTH) {
                            $scope.hideMobileMenu();
                            $refineHolder.show();
                        } else {
                            if(!mobileMenuVisible) {
                                $refineHolder.hide();
                            }
                        }
                    })
                    
                }
            };
        }]);
/**
 * Created by jordan on 20/05/2016.
 */

angular.module('ra.news')
    .directive('newsMenuBtn', ['toggleNewsMenuEvent',
        function(toggleNewsMenuEvent) {
        return {
            templateUrl: 'newsMenuBtn.html',
            restrict: 'E',
            replace:true,
            scope: {
            },
            
            link: function($scope, $element) {
                $scope.toggleMenu = function() {
                    toggleNewsMenuEvent.broadcast();
                }
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.news')
    .directive('textContent', [
        function() {
        return {
            replace: true,
            templateUrl: 'textContent.html',
            restrict: 'E',
            scope: {
                article: '=',
                addClick: '&',
            },
            link: function($scope, element) {
                $scope.goToLink = function() {
                    $scope.addClick();
                    window.open($scope.article.link, '_blank');
                };
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.news')
    .directive('vimeoContent', ['$window', 'autoplayService', '$timeout', 'articleService', '$sce',
        function($window, autoplayService, $timeout, articleService, $sce) {
        return {
            templateUrl: 'vimeoContent.html',
            restrict: 'E',
            scope: {
                article: '=',
                addClick: '&',
            },
            link: function($scope, $element) {
                var HEIGHT_WIDTH_RATIO = 0.5625;
                var RACEATLAS_RED = "#deff95";

                //Scroll distance at which videos auto play
                var AUTOPLAY_OFFSET = 240;
                //Distance at which videos stop completely
                var UNLOAD_OFFSET_ABOVE = 1000;
                var DEBOUNCE = 150;
                
                
                var hasBuffered = false;

                var $vimeoContent = $element.find('.vimeo-content');
                var $iframe = $element.find('iframe');
                var $image = $element.find('.img');
                var $playButton = $element.find('.play-video');
                
                var player;
                var didAddClick = false;
                var videoTitle = "";
                var nativeFullscreenClicked = false;
                var isPlaying = false;
                var playImmediately = false;
                
                $scope.src = $sce.trustAsResourceUrl("https://player.vimeo.com/video/" + $scope.article.embedId);
                $scope.inStateChange = false;
                
                
                $scope.addClickOnce = function() {
                    if(!didAddClick) {
                        didAddClick = true;
                        $scope.addClick({articleId:$scope.article._id});
                    }
                };
                
                var mute = function() {
                    if(player) {
                        player.getVolume()
                            .then(function(volume) {
                                if(volume !== 0) {
                                    autoplayService.lastVolume = volume;
                                    player.setVolume(0);
                                }
                            })
                    }
                    
                };

                var unMute = function() {
                    player.setVolume(autoplayService.lastVolume);
                    console.log("unmuted to " + autoplayService.lastVolume);
                };
                
                var play = function() {
                    if(player) {
                        player.play();
                    }
                };
                
                var pause = function() {
                    if(player) {
                        player.pause();
                    }
                };
                
                var buffer = function() {
                    //Move the video to the current screen, so it auto loads
                    if(!hasBuffered) {
                        if(!playImmediately) {
                            $iframe.addClass('load-fix');
                            $timeout(function() {
                                $iframe.removeClass('load-fix');
                            }, 100);
                            mute();
                        }
                        play();
                        
                        //Initial buffer
                        player.on('progress', stopBuffering);
                    }
                    
                };
                
                var stopBuffering = function() {
                    if(!hasBuffered) {
                        hasBuffered = true;
                        player.off('play', stopBuffering);
                        $scope.autoplayVideo();
                        
                        
                        player.on('play', function() {
                            isPlaying = true;
                        });
                        player.on('pause', function() {
                            isPlaying = false;
                        });
                        //All players change volume at the same time
                        player.on('volumechange', function(volumeData) {
                            if(volumeData.volume !== 0) {
                                autoplayService.lastVolume = volumeData.volume;
                                autoplayService.lastScope.addClickOnce();
                            }
                            
                            
                        });
                        player.off('progress', stopBuffering);
                    }
                };
                
                var init = function() {
                    if(isMobileOrTablet()) {
                        $image.addClass("fade-out");
                        $playButton.hide();
                    }
                    resizeHeight();
                    
                    $iframe.on('load', function() {
                        resizeHeight();
                        player = new Vimeo.Player($iframe[0]);
                        
                        player.getVideoTitle()  
                            .then(function(title) {
                                videoTitle = title;
                                console.log("Loading (Vimeo) " + videoTitle);
                            });

                        player.setColor(RACEATLAS_RED);

                        if(!isMobileOrTablet()) {
                            autoplayService.add($scope);
                            buffer();
                        } else {
                            player.on('play', function() {
                                $scope.addClickOnce();
                            })
                        }

                        player.on('ended', function() {
                            $scope.addClickOnce();
                        })
                    });
                };
                
                var resizeHeight = function() {
                    $vimeoContent.height($vimeoContent.width()*HEIGHT_WIDTH_RATIO);
                }; 
                
                $scope.autoplayVideo = function() {
                    if(player) {

                        if(!$scope.inStateChange) {
                            //Allow more state changes after DEBOUNCE ms
                            setTimeout(function() {
                                $scope.inStateChange = false;
                            }, DEBOUNCE);

                            var offset = window.AngularFunc.windowOffset($element[0], window.AngularFunc.OFFSET.CENTER);

                            if($iframe.height() > 500 || $iframe.width() > 932) {
                                //autoplayService registers a scroll event on fullscreen click, triggering this
                                unMute();
                                play();
                                $scope.addClickOnce();
                                
                                nativeFullscreenClicked = true;
                                autoplayService.isFullScreen = true;
                                console.log(videoTitle + " is fullscreen");

                                return true;
                            }

                            else if(Math.abs(offset) < AUTOPLAY_OFFSET) {
                                $image.addClass("fade-out");
                                $playButton.hide();
                                
                                
                                if(!isPlaying) {
                                    $scope.inStateChange = true;
                                    

                                    if(nativeFullscreenClicked) {
                                        autoplayService.isFullScreen = false;
                                        console.log(videoTitle + " is not fullscreen");
                                        nativeFullscreenClicked = false;
                                    } else {
                                        play();
                                        console.log("Playing " + videoTitle);
                                    }

                                    //Mute if we're playing the next video
                                    if(autoplayService.lastScope !== $scope) {
                                        mute();
                                    }
                                    
                                    
                                    
                                    
                                }
                                if(!autoplayService.isFullScreen) {
                                    autoplayService.lastScope = $scope;
                                }
                               
                                return true;


                            } else if(offset > UNLOAD_OFFSET_ABOVE) {
                                if(!$scope.isUnloaded) {
                                    $scope.inStateChange = true;
                                    //Unload videos we've scrolled past       
                                    //Check if youtube video is buffering

                                    if(!isPlaying) {
                                        $scope.destroy();
                                        $image.addClass("fade-out");
                                        $scope.isUnloaded = true;
                                        autoplayService.remove($scope);
                                        console.log("Stopped " + videoTitle);
                                    }
                                }



                            } else if(isPlaying) {
                                
                                //Detect full screen (Triggers a scroll event, with a large 'offset')
                                //BETWEEN AUTOPLAY_OFFSET and UNLOAD_OFFSET_ABOVE
                                if(!nativeFullscreenClicked) {
                                    $scope.inStateChange = true;
                                    pause();
                                    console.log("Pausing " + videoTitle);
                                }
                                return false;
                                
                            }
                        }
                    }
                };

                $scope.destroy = function() {
                    if(player) {
                        player.unload();
                    }
                    console.log("Unloading " + videoTitle);
                    autoplayService.remove($scope);
                };
                
                $scope.clickPlay = function() {
                    if(player) {
                        unMute();
                        stopBuffering();
                    } else {
                        playImmediately = true;
                    }
                    $scope.addClickOnce();
                    $image.addClass("fade-out");
                    $playButton.hide();
                };
                
                
                $(window).resize(function(){
                    resizeHeight();
                });
                
                init();
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.news')
    .directive('youtubeContent', ['$window', 'autoplayService', '$timeout', 'articleService',
        function($window, autoplayService, $timeout, articleService) {
        return {
            templateUrl: 'youtubeContent.html',
            restrict: 'E',
            scope: {
                article: '=',
                addClick: '&',
            },
            link: function($scope, $element) {
                var HEIGHT_WIDTH_RATIO = 0.5625;
                
                //Scroll distance at which videos auto play
                var AUTOPLAY_OFFSET = 240;
                //Distance at which videos stop completely
                var UNLOAD_OFFSET_ABOVE = 1000;
                var DEBOUNCE = 150;
                
                $scope.showImage = true;
                $scope.playBtnVisible = true;
                $scope.isFullScreen = false;
                $scope.youtubeVars = {};
                $scope.keepPlaying = false;
                $scope.inStateChange = false;
                $scope.isUnloaded = false;
                
                //Whether we have tracked a 'view' from this user and this video yet
                var hasClicked = false;
                
                var nativeFullscreenClicked = false;
                var videoIsInit = false;
                
                var $youtubeContent = $element.find('.youtube-content');

                var addClickOnce = function() {
                    if(!hasClicked) {
                        hasClicked = true;
                        return articleService.addClick({articleId:$scope.article._id});
                    }
                };

                
                var resizeHeight = function() {
                    $youtubeContent.height($youtubeContent.width()*HEIGHT_WIDTH_RATIO);
                };
                
                function preloadVideo() {
                    var player = $scope.article.youtubePlayer;


                    player.addEventListener('onReady', function() {
                        player.mute();
                        player.playVideo();
                    });

                    player.addEventListener('onStateChange',
                        function(e) {
                            var state = e.data;
                            if(state == window.YT.PlayerState.PLAYING) {
                                $scope.playBtnVisible = false;
                                if(!videoIsInit) {
                                    videoIsInit = true;
                                    console.log("Video buffering complete");
                                    $scope.autoplayVideo();
                                }
                            }
                            else if(state == window.YT.PlayerState.BUFFERING) {
                                $scope.playBtnVisible = false;
                            }
                            else {
                                $scope.playBtnVisible = true;
                            }
                            
                            if(!hasClicked && !player.isMuted()) {
                                addClickOnce();
                            }
                            
                            $scope.$digest();
                        }
                    );
                }

                $scope.autoplayVideo = function() {

                    if($scope.article.youtubePlayer) {

                        if(!$scope.inStateChange) {
                            //Allow more state changes after DEBOUNCE ms
                            setTimeout(function() {
                                $scope.inStateChange = false;
                            }, DEBOUNCE);

                            var offset = window.AngularFunc.windowOffset($element[0], window.AngularFunc.OFFSET.CENTER);
                            var player = $scope.article.youtubePlayer;
                            var videoTitle = "unknown";
                            if(typeof(player.getVideoData) == "function") {
                                videoTitle = player.getVideoData().title;
                            }

                            var $iframe = $($element).find('iframe');
                            
                            if($iframe.height() > 500 || $iframe.width() > 932) {
                                //autoplayService registers a scroll event on fullscreen click, triggering this
                                player.unMute();

                                nativeFullscreenClicked = true;
                                addClickOnce();
                                console.log(player.getPlayerState());
                                console.log(videoTitle + " is fullscreen");
                                
                                return true;
                            }
                            
                            else if(Math.abs(offset) < AUTOPLAY_OFFSET) {
                                $scope.inStateChange = true;
                                $scope.showImage = false;

                                if(nativeFullscreenClicked) {
                                    console.log(videoTitle + " is not fullscreen");
                                    nativeFullscreenClicked = false;
                                }

                                if (player.getPlayerState &&
                                    player.getPlayerState() !== window.YT.PlayerState.PLAYING &&
                                    player.isMuted()) {

                                    player.playVideo();
                                    console.log("Playing " + videoTitle);
                                    return true;
                                }


                            } else if(offset > UNLOAD_OFFSET_ABOVE) {
                                if(!$scope.isUnloaded) {
                                    $scope.inStateChange = true;
                                    //Unload videos we've scrolled past       
                                    //Check if youtube video is buffering

                                    if(player.getPlayerState() !== window.YT.PlayerState.PLAYING) {
                                        player.stopVideo();
                                        //player.destroy();
                                        $scope.showImage = true;
                                        $scope.isUnloaded = true;
                                        autoplayService.remove($scope);
                                        console.log("Stopped " + videoTitle);
                                    }
                                }



                            } else if(player.getPlayerState &&
                                player.getPlayerState() === window.YT.PlayerState.PLAYING &&
                                player.isMuted() &&
                                !$scope.isFullScreen)
                            {
                                
                                //Detect full screen (Triggers a scroll event, with a large 'offset')
                                 if(!nativeFullscreenClicked) {
                                    $scope.inStateChange = true;
                                    player.mute();
                                    player.pauseVideo();
                                    console.log("Pausing " + videoTitle);
                                }
                                return false;
                            }
                        }

                    }
                    
                };
                
                var mobileInit = function() {
                    var player = $scope.article.youtubePlayer;
                    
                    $scope.showImage = false;
                    $scope.playBtnVisible = false;
                    player.addEventListener('onStateChange', function(e) {
                        console.log(e.data);
                        var state = e.data;
                        if(state == window.YT.PlayerState.PLAYING) {
                            addClickOnce();
                        }
                    });
                }
                
                $scope.destroy = function() {
                    var videoTitle = "unknown";
                    if(typeof(player.getVideoData) == "function") {
                        videoTitle = player.getVideoData().title;
                    }
                    
                    console.log("Destroyed " + videoTitle);
                    var player = $scope.article.youtubePlayer;
                    autoplayService.removeYoutubeContent($scope);
                    player.destroy();
                };

                /*$scope.youtubePopOut = function() {
                    addClickOnce();
                    if(!$scope.isFullScreen) {
                        $scope.playVideo();
                        $scope.isFullScreen = true;
                    }
                };*/
                
                /*$scope.youtubePopIn = function() {
                    if($scope.isFullScreen) {
                        var player = $scope.article.youtubePlayer;
                        player.mute();
                        $scope.isFullScreen = false;
                    }
                };*/
                
                $scope.playVideo = function() {
                    $scope.showImage = false;
                    $scope.playBtnVisible = false;
                    var player = $scope.article.youtubePlayer;
                    player.unMute();
                    player.playVideo();
                };

                $scope.$watch('article', function(article) {
                    if(article.embedId) {
                        var stopInit = $scope.$watch('article.youtubePlayer', function() {
                            if(article.youtubePlayer) {
                                if(!isMobileOrTablet()) {
                                    preloadVideo();
                                    autoplayService.add($scope);
                                } else {
                                    mobileInit();
                                }

                                $timeout(resizeHeight, 200);
                                stopInit();
                            }
                        });

                        
                    }
                });

                $(window).resize(function(){
                    resizeHeight();
                });
                
            }
        };
    }]);
/**
 * Created by jordan on 27/09/2015.
 */
//Plays/pauses videos on scroll events
angular.module('ra.news')
	.service('autoplayService', ['$window', function ($window) {
	
		var self = this;
		//$scope values for Vimeo, YouTube etc.
		//Each $scope should have a .autoplayVideo() function
		var contentScopes = [];
		
		var service = {};
		
		//Scope of the last played Vimeo video
		service.lastScope = null;
		//Fix for a bug - fullscreen places the video at the position of the first video, which would cause lastScope to be incorrect.
		service.isFullScreen = false;
		service.lastVolume = 0;
		
		service.init = function() {
			$(window).scrollTop(1);
			angular.element($window).bind("scroll", function(e) {
				if($(window).scrollTop() == 0) {
					$(window).scrollTop(1);
				}
				contentScopes.forEach(function(playerScope) {
					playerScope.autoplayVideo();
				});
			});
		};
		
		//Clears all youtube content scopes.
		service.clear = function() {
			contentScopes = [];
		};
		
		service.add = function(playerScope) {
			contentScopes.push(playerScope);
		};
		
		service.remove = function(playerScope) {
			var index = contentScopes.indexOf(playerScope);
			if(index !== -1) {
				contentScopes.splice(index, 1);
			}
		};
		return service;
	}]);
 

/**
 * Holds the article list, and all the preferences associated with it
 */
angular.module('ra.news')
	.service('newsService', ['articleService', 
	function (articleService) {
		
		var DEFAULT_TYPE = 'Cycling';
		var DEFAULT_REFINE = 'trending'; 
		var DEFAULT_CATEGORY = '';
	
		var self = this;
		var service = {};
		
		service.articles = [];
		service.moreArticles = true;
		service.user = {};
		service.isLoading = true;

		service.options = {
			type: DEFAULT_TYPE,
			refine: DEFAULT_REFINE,
			category: DEFAULT_CATEGORY,
			paginationValue: null
		};
		
		
		
		service.updateUrl = function() {
			var url = window.location.pathname + '?type=' + service.options.type + '&refine=' + service.options.refine;
			if(service.options.category) {
				url += '&category=' + service.options.category;
			}
			window.history.pushState('News Feed', '', url);
		};

		service.init = function(articles) {
			
			if(!articles || !articles.length) {
				service.articles = [];
				service.moreArticles = false;
				service.options.paginationValue = null;
			}
			else {
				service.articles = articles;
				var lastArticle = articles[articles.length-1];
				service.options.paginationValue = lastArticle.date;
			}
			
			service.isLoading = false;
			service.moreArticles = true;
		};

		service.setType = function(type) {
			if(service.options.type !== type) {
				service.init();
				service.options.type = type;
				service.getArticles();
				service.options.category = "";
				service.updateUrl();
			}
		};

		service.setRefine = function(refine) {
			if(service.options.refine !== refine) {
				service.init();
				service.options.refine = refine;
				service.getArticles();
				service.updateUrl();
			}
		};

		service.setCategory = function(category) {
			service.init();
			if(service.options.category !== category) {
				service.options.category = category;
			} else {
				service.options.category = "";
			}
			service.getArticles();
			service.updateUrl();
		};
		/**
		 * Gets articles by paginationValue
		 * @returns {*}
		 */
		service.getArticles = function() {
			service.isLoading = true;
			return articleService.get(service.options)
				.then(function(result) {
					service.articles = service.articles.concat(result.articles);
					service.isLoading = false;
					
					if(result.articles.length) {
						var lastArticle = result.articles[result.articles.length-1];
						service.options.paginationValue = lastArticle.date;
						
						if(result.articles.length < result.pageSize) {
							service.moreArticles = false;
						}
					} else {
						service.moreArticles = false;
					}
					
				},
				function() {
					service.isLoading = false;
				})
		};
		
		service.nextPage = function() {
			service.articles = [];
			return service.getArticles();
		};

		return service;
	}]);
 

/**
 * Created by jordan on 23/11/2016.
 */
/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.photosHome')
    .controller('homeCtrl', ['$scope', 'photoService', 'requireLoginService', '$timeout',
        function($scope, photoService, requireLoginService, $timeout) { 

            
            //Load in first photo
            $scope.$watch('routeParams', function (routeParams) {
                $scope.events = routeParams.events;
                photoService.currentParticipant = routeParams.participant;
            }); 

			requireLoginService.init($scope); 

            $scope.selectEventFromTile = function(eventKey) {
                // Scroll to the find-event section
                var findEventElement = document.querySelector('find-event');
                if (findEventElement) {
                    findEventElement.scrollIntoView({ behavior: 'smooth' });
                }

                // Find the event object by key
                var selectedEvent = null;
                if ($scope.events) {
                    selectedEvent = $scope.events.find(function(event) {
                        return event.key === eventKey;
                    });
                }

                if (selectedEvent) {
                    // Broadcast event to find-event directive
                    $scope.$broadcast('selectEventFromTile', selectedEvent);
                }
            };

        }]);

/**
 * Created by jordan on 21/08/2015.
 */
angular.module('ra.core')
.controller('tagCtrl', ['$scope', 'tagService', '$timeout', 'imagePreloadService',
function($scope, tagService, $timeout, imagePreloadService) {

	var MAX_TAGS = 15;
	var TAG_TIME = 90000;

	var tagTimer = null;


	//How many photos we've done so far
	$scope.historyLevel = 0;

	//How far back we went
	$scope.backLevel = 0;

	$scope.TAG_EMPTY = 0;
	$scope.TAG_VERIFYING = 1;
	$scope.TAG_VERIFIED = 2;
	$scope.TAG_INVALID = 3;
	$scope.TAG_SAVED = 4;
	$scope.isTagged = false;

	$scope.fancyboxIsOpen = false;
	$scope.photo = {};
	$scope.nextPhotoId = null;
	var eventId = null;

	$scope.tags = [];
	$scope.tagCount = null;
	$scope.saveText = "Save";

	/*$scope.getMoneyEarned = function() {
		var amount;
		if(!$scope.tagCount) {
			amount = 0;
		} else {
			amount = 0.04 * $scope.tagCount;
		}
		return amount.toFixed(2);
	};*/

	function focusNextEmptyField() {
		for(var i=0; i<MAX_TAGS; i++) {
			if(!$('input#tag' + i).val()) {
				$('input#tag' + i).focus();
				break;
			}
		}
	}

	/**
	 * Populate tags array, from existing tags (assumed saved) or from a blank set
	 * @param tags
	 */
	function initTags(tags) {
		$scope.tags = [];
		$scope.photo.hasSavedTages = false;

		if(!tags) {
			tags = [];
		}

		for(var i=0; i<MAX_TAGS; i++) {
			var tagValue, tagStatus;
			if(tags[i]) {
				tagValue = tags[i];
				tagStatus = $scope.TAG_SAVED;
				$scope.photo.hasSavedTages = true;
			} else {
				tagValue = "";
				tagStatus = $scope.TAG_EMPTY;
			}
			$scope.tags.push({value:tagValue, status:tagStatus});
		}

		//Set key shortcuts
		$timeout(function() {


			$('input.tag').unbind('keyup');
			$('input.tag').keyup(function(keyEvent) {
				var KEY_ENTER = 13;
				var KEY_DOWN = 40;
				var KEY_UP = 38;
				var KEY_ESCAPE = 27;
				var KEY_CTRL = 17;
				var KEY_HOME = 36;

				//Submit
				if (keyEvent.which === KEY_ENTER && !$scope.isTagged) {
					$scope.saveAndNext();
				}

				if (keyEvent.which === KEY_CTRL) {
					if($scope.fancyboxIsOpen) {
						$scope.closeFancybox();
					} else {
						$scope.fancyboxPhoto($scope.photo.imageOriginal);
					}

				}

				//Next tag/submit
				if (keyEvent.which === KEY_DOWN) {
					var currentTag = parseInt($(this).attr('data-tagNum'));
					var nextTag = currentTag + 1;
					if(nextTag < MAX_TAGS) {
						var $nextField = $('input#tag'+nextTag);
						$nextField.focus();
						$nextField.select();
					}
				}

				//Next tag/submit
				if (keyEvent.which === KEY_HOME) {
					$scope.previousPhoto();
				}

				//Prev tag
				else if(keyEvent.which === KEY_UP) {
					var currentTag = parseInt($(this).attr('data-tagNum'));
					var prevTag = currentTag - 1;
					if(prevTag >= 0) {
						var $prevField = $('input#tag'+prevTag);
						$prevField.focus();
						$prevField.select();
					}
				}

				//No tags
				else if(keyEvent.which === KEY_ESCAPE && !$scope.isTagged) {
					$scope.noTagsAndNext();
				}
			});

			focusNextEmptyField();
		}, 300);
	}

	function onlyUnique(value, index, self) {
		return self.indexOf(value) === index;
	}

	/**
	 * @returns {Array} of valid, unique tags
	 */
	function getValidTags() {
		//Get only nonempty, unique tags
		return $scope.tags
			.filter(function(x) { return x.value; })
			.map(function(x) { return x.value; })
			.filter(onlyUnique);
	}

	function restartTagTimer() {
		cancelTagTimer();

		tagTimer = $timeout(function() {
			alert("This photo is no longer valid.  Press Ok to refresh the page and load a new photo");
			window.location.reload();
		}, TAG_TIME);
	}

	function cancelTagTimer() {
		if(tagTimer) {
			$timeout.cancel(tagTimer);
			tagTimer = null;
		}
	}

	//Goes to the next photo, either going forward through history or loading a new one
	var nextPhoto = function(photoId, eventId, pushState) {
		$scope.historyLevel++;
		if($scope.backLevel > 0) {
			$scope.backLevel--;
			window.history.forward();
		} else {
			loadPhoto(photoId, eventId, pushState);
		}
	};


	/**
	 * Gets the photo if photoId is set, or the next available untagged photo.
	 * @param photoId
	 * @param eventId
	 * @param pushState - Whether to add a new state in browser history
	 */
	var loadPhoto = function(photoId, eventId, pushState) {
		tagService.getNextPhoto(photoId, eventId)
			.then(function(photoData) {
				restartTagTimer();
				if(photoData.currentPhoto) {
					$scope.isTagged = false;
					$scope.photo = photoData.currentPhoto;
					$scope.nextPhotoId = photoData.nextPhoto ? photoData.nextPhoto._id : null;
					var nextPhotoImage = photoData.nextPhoto ? photoData.nextPhoto.imageLarge : null;

					initTags($scope.photo.bibs);
					photoId = $scope.photo._id;

					//Change url
					if(pushState) {
						//window.history.pushState({photoId: photoId, eventId: eventId}, photoId, '/tag/' + eventId + '/' + photoId);
					}
				}
				if(nextPhotoImage) {
					imagePreloadService.preload(nextPhotoImage)
						.load(function(event) {
							//Finished preloading
						});

				}
			}, function(err)
			{
				if(err.detail) {
					cancelTagTimer();
					alert(err.detail);
				}
				else {
					alert("Could not find the photo with ID " + photoId);
				}

			});

		tagService.getNumUntagged(eventId)
			.then(function(numUntagged)
			{
				$scope.numUntagged = numUntagged;
			});
	};

	/**
	 * Verifies all unverified tags
	 * Returns a promise that resolves true if the tags are correct, otherwise false,
	 */
	var verifyRemainingTags = function() {
		var promises = [];
		angular.forEach($scope.tags, function(tag) {
			if(tag.status != $scope.TAG_VERIFIED) {
				promises.push($scope.verifyTag(tag));
			}
		});

		return Promise.all(promises)
			.then(function() {
				var hasValidTags = false;

				//Check for invalid tags
				for(var i=0; i<$scope.tags.length; i++) {
					var tag = $scope.tags[i];
					if(tag.status == $scope.TAG_INVALID) {
						var r = confirm("Some tags were not found on the system.  Please confirm that you are certain the tags are correct.");
						return r;
					}
					if(tag.status == $scope.TAG_VERIFIED) {
						hasValidTags = true;
					}
				}

				//Check tags exist
				if(!hasValidTags) {
					alert("Before saving, please add some tags and ensure they have been verified.");
					return false;
				}

				return true;
			})
	};

	$scope.previousPhoto = function() {
		if($scope.historyLevel) {
			$scope.saveTags()
				.then(function() {
					$scope.historyLevel--;
					$scope.backLevel++;
					window.history.back();
				})
		}
	};

	$scope.fancyboxPhoto = function(url) {
		$scope.fancyboxIsOpen = true;
		$.fancybox(url, {autoSize:false, fitToView:false, closeClick:true, openEffect:'none',
			afterClose:function() {
				$scope.fancyboxIsOpen = false;
			},
			afterShow: function() {
				$(".fancybox-wrap").scrollTop($(".fancybox-image").height()/2 - $(window).height()/2);
			}
		});
	};

	$scope.closeFancybox = function() {
		$.fancybox.close(true);
	};

	/**
	 * Verify tags.  Returns a promise with the result of the tag
	 * @param tag
	 */
	$scope.verifyTag = function(tag) {
		if(tag.value == "") {
			tag.status = $scope.TAG_EMPTY;
			return Promise.resolve();
		} else {
			tag.status = $scope.TAG_VERIFYING;
			return tagService.verify(tag.value, eventId)
				.then(function(isValid) {
					if(isValid) {
						tag.status = $scope.TAG_VERIFIED;
						return true;
					} else {
						tag.status = $scope.TAG_INVALID;
						return false;
					}
				});
		}
	};

	$scope.clear = function(tag) {
		tag.value = "";
		tag.status = $scope.TAG_EMPTY;
	};

	$scope.saveTags = function() {
		return verifyRemainingTags()
			.then(function(allVerified) {
				if(allVerified) {
					return getValidTags();
				} else {
					throw new Error("Not all tags are correctly verified");
				}
			})
			.then(function(tags)
			{
				$scope.saveText = "Saving...";
				return tagService.save(tags, eventId, $scope.photo._id);
				//save
			})
			.then(function(tags) {
				initTags(tags);
				$scope.saveText = "Saved!";
				$scope.$apply();
				return true;
			},
			function(err) {
				$scope.saveText = "Save";
				alert(err.detail);
				console.log("Could not tag photos");
				return false;
			});
	};

	$scope.addTagCount = function() {
		if($scope.backLevel === 0 && !$scope.isTagged) {
			$scope.isTagged = true;
			$scope.tagCount = tagService.addTagCount(eventId);
		}
	};
	
	$scope.deleteTag = function(tag) {
		return tagService.deleteTag(eventId, $scope.photo._id, tag.value)
			.then(function() {
				tag.value = ""; 
				tag.status = $scope.TAG_EMPTY;
			},
			function(err) {
				alert(err.detail);
			});
	}
	
	$scope.noTagsAndNext = function() {
		var result = confirm("Are you sure that you wish to mark this photo as 'No Tags'?");
		if(result) {
			return tagService.markNoTags(eventId, $scope.photo._id)
				.then(function() {
					$scope.addTagCount();
					nextPhoto($scope.nextPhotoId, eventId, true);
				},
				function(err) {
					alert(err.detail);
				})
		}
	};

	$scope.hidePhoto = function() {
		var result = confirm("Are you sure that you wish to hide this photo?");
		if(result) {
			return tagService.hidePhoto(eventId, $scope.photo._id)
				.then(function() {
						$scope.addTagCount();
						nextPhoto($scope.nextPhotoId, eventId, true);
					},
					function(err) {
						alert(err.detail);
					})
		}
	};

	$scope.saveAndNext = function() {

		$scope.saveTags()
			.then(function(didSave) {
				if(didSave) {
					$scope.addTagCount();
					nextPhoto($scope.nextPhotoId, eventId, true);
					$scope.saveText = "Save";
				}

			}, function(err) {
				alert(err.detail);
			});
	};


	//Load in first photo
	$scope.$watch('routeParams', function () {
		eventId = $scope.routeParams.eventId;
		loadPhoto($scope.routeParams.photoId, eventId, true);

		$scope.tagCount = tagService.getTagCount(eventId);
	});

	//Load previous photo if we go back
	window.onpopstate = function(event) {
		loadPhoto(event.state.photoId, event.state.eventId, false);
	};

}]);

/**
 * Created by jordan on 24/09/2015.
 */

angular.module('ra.core')
    .service('tagService', ['ajaxService', '$localStorage',
        function (ajaxService, $localStorage) {

            var service = {};


            /**
             * Gets next photo
             * @param photoId
             * @param eventId
             * @returns {object} photoData
             * @returns {object} photoData.currentPhoto
             * @returns {object} photoData.nextPhoto
             */
            service.getNextPhoto = function(photoId, eventId) {
                var data = {photoId: photoId, eventId: eventId};
                return ajaxService.request('/api/tag/next-photo/', data, false);
            };

            service.verify = function(tag, eventId) {
                var data = {tag: tag, eventId: eventId};
                return ajaxService.request('/api/tag/verify/', data, false);
            };

            service.save = function(tags, eventId, photoId) {
                var data = {tags: tags, eventId: eventId, photoId: photoId};
                return ajaxService.request('/api/tag/save/', data, false);
            };

            service.markNoTags = function(eventId, photoId) {
                var data = {eventId: eventId, photoId: photoId};
                return ajaxService.request('/api/tag/mark-no-tags/', data, false);
            };

            service.deleteTag = function(eventId, photoId, tag) {
                var data = {eventId: eventId, photoId: photoId, tag: tag};
                return ajaxService.request('/api/tag/delete/', data, false);
            };

            service.hidePhoto = function(eventId, photoId) {
                var data = {eventId: eventId, photoId: photoId};
                return ajaxService.request('/api/tag/hide-photo/', data, false);
            };

            service.getNumUntagged = function(eventId) {
                var data = {eventId: eventId};
                return ajaxService.request('/api/tag/num-untagged/', data, false);
            };

            /**
             * Saves a tag count to localstorage, either incrementing or adding a new entry to tagCounts[]
             * @param eventId
             */
            service.addTagCount = function(eventId) {
                if(!$localStorage.tagCounts) {
                    $localStorage.tagCounts = {};
                }

                if($localStorage[eventId]) {
                    $localStorage[eventId]++;
                } else {
                    $localStorage[eventId] = 1;
                }

                return $localStorage[eventId];
            };

            service.getTagCount = function(eventId) {
                if($localStorage.tagCounts) {
                    return $localStorage[eventId];
                } else {
                    return 0;
                }
            };

            return service;
        }]);


//User object
angular.module('ra.core')
	.service('imagePreloadService', [
		function () {
			
		var service = {};

		service.preload = function( src ) {
			return $(new Image()).prop("src", src);
		};
	
		return service;
	}]);
 

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('addPhotoMessage', ['showAddPhotoMessageEvent', 'photoService', 'userService', 'addPhotoService',
        function(showAddPhotoMessageEvent, photoService, userService, addPhotoService) {
        return {
            templateUrl: 'addPhotoMessage.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {

                $scope.PANELS = {
                    FORM: 0,
                    SUCCESS: 1,
                };

                var init = function() {
                    $scope.formData = {
                        bibs: '',
                    };
                    if(photoService.bibs) {
                        $scope.formData.bibs = photoService.bibs.join(', ');
                    }

                    $scope.hasSubmitted = false;
                    $scope.currentPanel = $scope.PANELS.FORM;
                    $scope.isLoading = false;
                };

                $scope.send = function() {
                    $scope.hasSubmitted = true;

                    if($scope.form.$valid) {
                        $scope.isLoading = true;

                        $scope.formData.eventId = photoService.event._id;
                        $scope.formData.eventKey = photoService.event.key;
                        $scope.formData.photoId = $scope.photo._id;

                        return addPhotoService.addPhotoEmail($scope.formData)
                            .then(function() {
                                $scope.currentPanel = $scope.PANELS.SUCCESS;
                            },
                            function(err) {
                                $scope.isLoading = false;
                                alert(err);
                            });

                    }
                    return false;
                };

                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };

                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };

                showAddPhotoMessageEvent.listen(function(photo) {
                    init();
                    $scope.photo = photo;
                    $scope.show();
                });


            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('addressForm', ['userService', 'showAddressFormEvent', 'purchaseService',
        function(userService, showAddressFormEvent, purchaseService) {
            return {
                templateUrl: 'addressForm.html',
                restrict: 'E',
                scope: {
                    
                },
                link: function($scope, $element) {

                    $scope.formData = {};

                    $scope.hasSubmitted = false;
                    $scope.isLoading = false;
                    
                    $scope.onComplete = null;
                    var self = this;

                    $scope.show = function() {
                        $scope.$broadcast("showPopup");
                    };

                    $scope.hide = function() {
                        $scope.$broadcast("hidePopup");
                    };
                    
                    $scope.updateAddress = function() {
                        $scope.hasSubmitted = true;
                        $scope.isLoading = true;
                        $scope.error = null;

                        return purchaseService.updateAddress($scope.formData)
                            .then(function() {
                                    userService.data.user.street = $scope.formData.street;
                                    userService.data.user.suburb = $scope.formData.suburb;
                                    userService.data.user.postcode = $scope.formData.postcode;
                                    userService.data.user.state = $scope.formData.state;
                                
                                    $scope.isCompleted = true;
                                    $scope.isLoading = false;
                                    $scope.onComplete();
                                    $scope.hide();
                                },
                                function(result) {
                                    $scope.isLoading = false;
                                    $scope.error = result.error;
                                })
                    };

                    showAddressFormEvent.listen(function(purchaseOption, onComplete) {
                        $scope.purchaseOption = purchaseOption;
                        $scope.onComplete = onComplete;
                        
                        $scope.formData.street = userService.data.user.street;
                        $scope.formData.suburb = userService.data.user.suburb;
                        $scope.formData.postcode = userService.data.user.postcode;
                        $scope.formData.state = userService.data.user.state;
                        $scope.show();
                    });
                }
            };
        }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('agreePopup', ['$timeout', 'photoService', 'photoRepo', 'userService', '$rootScope',
        function($timeout, photoService, photoRepo, userService, $rootScope) {
        return {
            templateUrl: 'agreePopup.html',
            restrict: 'E',
            scope: {

            },
            link: function($scope) {
                
                var self = this;
                var onComplete = null;
                self.storageKey = null;
                
                $scope.isLoading = false;
                $scope.apiRejected = false;
                $scope.photoService = photoService;

                $scope.formData = {
                    bib: $scope.value,
                    agreement: false,
                };
                
                if(!$scope.formData.bib) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const email = urlParams.get('email');
                    if(email) {
                        $scope.formData.bib = email;
                    }
                }
                
                $scope.didAgree = function() {
                  return window.localStorage.getItem(self.storageKey);
                };
                

                $scope.show = function() {
                    $scope.$broadcast("showPopup"); 
                };

                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };
                
                $scope.send = function() {
                    $scope.apiRejected = false;
                    $scope.hasSubmitted = true;
                    if($scope.form.$valid) {
                        $scope.isLoading = true;

                        return photoRepo.agree($scope.formData.bib, photoService.event._id)
                          .then(function() {
                              window.localStorage.setItem(self.storageKey, true);
                              $scope.$broadcast("hidePopup");
                              self.onComplete();
                              $scope.isLoading = false;
                              $scope.hide();
                          }, function(e) {
                              console.error(e.message);
                              $scope.apiRejected = true;
                              $scope.isLoading = false;
                          });
                    }
                };

                /**
                 * Shows the agree popup if the user hasn't already agreed to it for this event
                 */
                $('body').on('showAgreeTrigger', function(e, onComplete) {
                    $timeout(function() {
                        self.storageKey = 'didAgreePhotos_' + photoService.event._id;
                        if(userService.data.user) {
                            $scope.formData.bib = userService.data.user.email;
                        }
                        if($scope.didAgree() || !photoService.event.agreementText) {
                            onComplete();
                        } else {
                            self.onComplete = onComplete;
                            $scope.$broadcast("showPopup");
                            $scope.show();
                        }
                    });
                    
                });
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('allPhotosForm', ['photoService', 'timeIntervalService',
        function(photoService, timeIntervalService) {
            return {
                templateUrl: 'allPhotosForm.html',
                restrict: 'E',
                scope: {
                    
                },
                link: function($scope, $element) {

                    $scope.securedPreviewBackdrop = photoService.securedPreviewBackdrop;
                    $scope.selectedLegTime = null;
                    $scope.selectedLeg = null;
                    //Periodic times for leg
                    $scope.legTimes = [];


                    var init = function() {
                        $scope.legs = photoService.legs;
                        $scope.selectedLeg = photoService.legs[0];
                        $scope.legTimes = createLegTimes($scope.selectedLeg);
                        $scope.selectedLegTime = $scope.legTimes.filter(function(x) {return x.disabled==false;})[0];
                        photoService.currentParticipant = $scope.selectedLeg.participant;
                    };

                    var createLegTimes = function(leg) {
                        var legTimes = [];

                        if(!leg.earliestPhoto || !leg.latestPhoto) {
                            legTimes.push({value:"No Photos Yet!", disabled:false});
                        }
                        else {
                            if(leg.time) {
                                legTimes.push({value:"My Time", disabled:true});
                                legTimes.push({value:leg.time, disabled:false});
                                legTimes.push({value:"======", disabled:true});
                            }

                            var times = timeIntervalService.getTimes(leg.earliestPhoto, leg.latestPhoto, leg.galleryInterval, "h:mm A");
                            for(var i=0; i<times.length; i++) {
                                var time = times[i];
                                legTimes.push({value:time, disabled:false});
                            }
                        }

                        return legTimes;
                    };


                    $scope.changeLeg = function() {
                        //TODO: Don't use magic variables
                        if($scope.timeOverlay) {

                            photoService.currentParticipant = $scope.selectedLeg.participant;
                            //window.participantTimeOverlay = $scope.selectedLeg.participantId;
                        }

                        $scope.legTimes = createLegTimes($scope.selectedLeg);
                        $scope.selectedLegTime = $scope.legTimes.filter(function(x) {return x.disabled==false;})[0];
                        $scope.resetTimePhotos();
                    };
                    
                    $scope.resetTimePhotos = function() {
                        return photoService.resetTimePhotos($scope.selectedLeg._id, $scope.selectedLeg.offset, $scope.selectedLegTime.value, $scope.selectedLeg.participant);
                    };

                    
                    $scope.$on('getAllPhotos', function(event, onComplete) {
                        init(); 
                        return $scope.resetTimePhotos()
                            .then(function() {
                                if(onComplete) {
                                    onComplete();
                                }
                            });
                    });

                }
            };
        }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 */

angular.module('ra.core')
    .directive('checkout', ['showCheckoutEvent', 'purchaseService', '$timeout', '$http',
        function(showCheckoutEvent, purchaseService, $timeout, $http) {
            return {
                templateUrl: 'checkout.html',
                restrict: 'E',
                scope: {
                    stripeKey: '@',
                    stripePurchaseFulfill: '@',
                    stripeMerchantCountry: '@',
                },
                link: function($scope, $element) {
                    $scope.description = "";
                    $scope.price = 0;
                    $scope.client_secret = null;
                    $scope.checkoutAmount = null;
                    $scope.checkoutCurrency = 'AUD';
                    $scope.email = "";
                    $scope.errorMessage = "";
                    $scope.isSubmitting = false;
                    $scope.onSuccess = null;
                    $scope.onFailure = null;

                    var stripeApi = null;
                    var elementsApi = null;
                    var cardElement = null;
                    var prButtonElement = null;
                    var paymentRequestApi = null;
                    var formSubmitBound = false;
                    var submitSlowHintTimeout = null;
                    var activePaymentMethod = 'card';
                    var SUBMIT_SLOW_HINT_MS = 60000;
                    var SUBMIT_SLOW_HINT =
                        'This is taking longer than usual. If your bank asked you to verify the payment, ' +
                        'complete that step in any popup or new window. Otherwise check your connection and try again.';

                    function paymentIntentIdFromClientSecret(secret) {
                        if (!secret || typeof secret !== 'string') {
                            return null;
                        }
                        var marker = '_secret_';
                        var idx = secret.indexOf(marker);
                        if (idx > 0) {
                            return secret.substring(0, idx);
                        }
                        return null;
                    }

                    function stripeErrorFields(stripeError) {
                        if (!stripeError) {
                            return {};
                        }
                        return {
                            message: stripeError.message,
                            stripeCode: stripeError.code,
                            stripeType: stripeError.type,
                            stripeDeclineCode: stripeError.decline_code,
                        };
                    }

                    function logPaymentError(phase, details, paymentMethod) {
                        details = details || {};
                        var payload = {
                            phase: phase,
                            message: details.message || null,
                            stripeCode: details.stripeCode || null,
                            stripeType: details.stripeType || null,
                            stripeDeclineCode: details.stripeDeclineCode || null,
                            paymentIntentId: details.paymentIntentId ||
                                paymentIntentIdFromClientSecret($scope.client_secret),
                            paymentIntentStatus: details.paymentIntentStatus || null,
                            currency: $scope.checkoutCurrency || null,
                            amount: $scope.checkoutAmount != null ? $scope.checkoutAmount : $scope.price,
                            checkoutDescription: $scope.description || null,
                            path: window.location && window.location.pathname,
                            paymentMethod: paymentMethod || activePaymentMethod || 'card',
                        };
                        if (typeof console !== 'undefined' && console.error) {
                            console.error('[checkout-payment] ' + JSON.stringify(payload));
                        }
                        $http.post('/api/purchase/checkout-log', payload).catch(function() {});
                    }

                    $scope.$on('$destroy', function() {
                        cancelSubmitSlowHint();
                    });

                    function cancelSubmitSlowHint() {
                        if (submitSlowHintTimeout) {
                            $timeout.cancel(submitSlowHintTimeout);
                            submitSlowHintTimeout = null;
                        }
                    }

                    function beginSubmitting(paymentMethod) {
                        if (paymentMethod) {
                            activePaymentMethod = paymentMethod;
                        }
                        cancelSubmitSlowHint();
                        $scope.isSubmitting = true;
                        $scope.errorMessage = '';
                        submitSlowHintTimeout = $timeout(function() {
                            submitSlowHintTimeout = null;
                            if ($scope.isSubmitting) {
                                $scope.errorMessage = SUBMIT_SLOW_HINT;
                                logPaymentError('confirm_slow', {
                                    message: SUBMIT_SLOW_HINT,
                                }, activePaymentMethod);
                            }
                        }, SUBMIT_SLOW_HINT_MS);
                    }

                    function endSubmitting() {
                        cancelSubmitSlowHint();
                        $scope.isSubmitting = false;
                    }

                    function confirmFailed(err, walletComplete, paymentMethod) {
                        endSubmitting();
                        $scope.errorMessage = (err && err.message) ||
                            'A network error occurred while confirming your payment. Please try again.';
                        logPaymentError('confirm_failed', {
                            message: $scope.errorMessage,
                        }, paymentMethod);
                        if (walletComplete) {
                            walletComplete('fail');
                        }
                    }

                    function handleConfirmResult(result, walletComplete, paymentMethod) {
                        endSubmitting();
                        if (result.error) {
                            $scope.errorMessage = result.error.message;
                            logPaymentError('confirm_stripe_error', stripeErrorFields(result.error), paymentMethod);
                            if (walletComplete) {
                                walletComplete('fail');
                            }
                            return;
                        }

                        var paymentIntent = result.paymentIntent;
                        if (!paymentIntent) {
                            $scope.errorMessage =
                                'Unexpected response from the payment provider. Please try again.';
                            logPaymentError('confirm_unexpected_response', {
                                message: $scope.errorMessage,
                            }, paymentMethod);
                            if (walletComplete) {
                                walletComplete('fail');
                            }
                            return;
                        }

                        if (paymentIntent.status === 'succeeded') {
                            if (walletComplete) {
                                walletComplete('success');
                            }
                            $scope.success(paymentIntent.id);
                            return;
                        }

                        if (paymentIntent.status === 'requires_action') {
                            beginSubmitting(paymentMethod);
                            stripeApi.confirmCardPayment($scope.client_secret)
                                .then(function(retryResult) {
                                    $scope.$evalAsync(function() {
                                        handleConfirmResult(retryResult, walletComplete, paymentMethod);
                                    });
                                })
                                .catch(function(err) {
                                    $scope.$evalAsync(function() {
                                        confirmFailed(err, walletComplete, paymentMethod);
                                    });
                                });
                            return;
                        }

                        if (paymentIntent.status === 'processing') {
                            if (walletComplete) {
                                walletComplete('success');
                            }
                            $scope.success(paymentIntent.id);
                            return;
                        }

                        if (walletComplete) {
                            walletComplete('fail');
                        }
                        $scope.errorMessage =
                            'Payment could not be completed. Please try again or use a different card.';
                        logPaymentError('confirm_incomplete_status', {
                            message: $scope.errorMessage,
                            paymentIntentId: paymentIntent.id,
                            paymentIntentStatus: paymentIntent.status,
                        }, paymentMethod);
                    }

                    function paymentRequestMerchantCountry() {
                        // Stripe: country is the merchant's Stripe account country, not the shopper's.
                        // Apple Pay is strict about this; wallet currency comes from the PaymentIntent.
                        var code = ($scope.stripeMerchantCountry || 'AU').toUpperCase();
                        return code.length === 2 ? code : 'AU';
                    }

                    function resetWalletUi() {
                        var prContainer = document.getElementById('payment-request-button');
                        var checkoutOr = document.getElementById('checkout-or');
                        if (prContainer) {
                            prContainer.style.display = '';
                            prContainer.innerHTML = '';
                        }
                        if (checkoutOr) {
                            checkoutOr.style.display = '';
                        }
                    }

                    function bindCardFormSubmit() {
                        if (formSubmitBound) {
                            return;
                        }
                        formSubmitBound = true;
                        var form = document.getElementById('payment-form');
                        form.addEventListener('submit', function(ev) {
                            ev.preventDefault();
                            if (!stripeApi || !cardElement) {
                                $scope.$evalAsync(function() {
                                    confirmFailed(
                                        { message: 'Payment form is not ready. Please close and reopen checkout.' },
                                        null,
                                        'card'
                                    );
                                });
                                return;
                            }
                            $scope.$evalAsync(function() {
                                beginSubmitting('card');
                            });
                            stripeApi.confirmCardPayment($scope.client_secret, {
                                payment_method: {
                                    card: cardElement,
                                }
                            }).then(function(result) {
                                $scope.$evalAsync(function() {
                                    handleConfirmResult(result, null, 'card');
                                });
                            }).catch(function(err) {
                                $scope.$evalAsync(function() {
                                    confirmFailed(err, null, 'card');
                                });
                            });
                        });
                    }

                    var init = function() {
                        $scope.$broadcast("showPopup");
                        resetWalletUi();

                        stripeApi = Stripe($scope.stripeKey);
                        elementsApi = stripeApi.elements();
                        bindCardFormSubmit();

                        var style = {
                            base: {
                                color: "#333333",
                                fontFamily: 'Helvetica, sans-serif',
                                fontSize: "16px",
                                "::placeholder": {
                                    color: "#777777"
                                },
                            },
                            invalid: {
                                fontFamily: 'Helvetica, sans-serif',
                                color: "red",
                                iconColor: "red"
                            }
                        };

                        if (cardElement) {
                            cardElement.unmount();
                            cardElement.destroy();
                        }

                        cardElement = elementsApi.create("card", { hidePostalCode: true, style: style });
                        cardElement.mount("#card-element");

                        cardElement.on('change', function(result) {
                            if(result.error) {
                                $scope.errorMessage = result.error.message;
                            } else {
                                $scope.errorMessage = "";
                            }
                            $scope.$apply();
                        });

                        // Apple Pay / Google Pay (Stripe Payment Request Button)
                        var currency = ($scope.checkoutCurrency || 'AUD').toLowerCase();
                        var country = paymentRequestMerchantCountry();
                        var amount = parseInt($scope.checkoutAmount != null ? $scope.checkoutAmount : $scope.price, 10);
                        if (!amount || isNaN(amount)) {
                            amount = parseInt($scope.price, 10) || 0;
                        }

                        if (prButtonElement) {
                            prButtonElement.unmount();
                            prButtonElement.destroy();
                        }

                        if (paymentRequestApi) {
                            paymentRequestApi.off('paymentmethod');
                        }

                        paymentRequestApi = stripeApi.paymentRequest({
                            country: country,
                            currency: currency,
                            total: {
                                label: $scope.description,
                                amount: amount,
                            },
                            requestPayerName: true,
                            requestPayerEmail: true,
                            // Chrome prefers Link in the PR button when a Link session exists;
                            // keep Link on the card Element below and show Google/Apple Pay here.
                            disableWallets: ['link'],
                        });

                        prButtonElement = elementsApi.create('paymentRequestButton', {
                            paymentRequest: paymentRequestApi,
                        });

                        paymentRequestApi.canMakePayment().then(function(result) {
                            if (result) {
                                prButtonElement.mount('#payment-request-button');
                            } else {
                                document.getElementById('payment-request-button').style.display = 'none';
                                document.getElementById('checkout-or').style.display = 'none';
                            }
                        });

                        paymentRequestApi.on('paymentmethod', function(ev) {
                            $scope.$evalAsync(function() {
                                beginSubmitting('wallet');
                            });

                            stripeApi.confirmCardPayment(
                                $scope.client_secret,
                                {payment_method: ev.paymentMethod.id},
                                {handleActions: false}
                            ).then(function(confirmResult) {
                                $scope.$evalAsync(function() {
                                    handleConfirmResult(confirmResult, function(status) {
                                        ev.complete(status);
                                    }, 'wallet');
                                });
                            }).catch(function(err) {
                                $scope.$evalAsync(function() {
                                    confirmFailed(err, function() {
                                        ev.complete('fail');
                                    }, 'wallet');
                                });
                            });
                        });
                    };

                    function stripePurchaseFulfillEnabled() {
                        var flag = $scope.stripePurchaseFulfill;
                        if (flag === false || flag === 'false' || flag === '0') {
                            return false;
                        }
                        return flag === true || flag === 'true' || flag === '1';
                    }

                    $scope.success = function(paymentIntentId) {
                        var afterFulfill = function() {
                            $scope.hide();
                            if ($scope.onSuccess) {
                                $scope.onSuccess();
                            }
                        };

                        if (!paymentIntentId || !stripePurchaseFulfillEnabled()) {
                            afterFulfill();
                            return;
                        }

                        purchaseService.fulfill({ paymentIntentId: paymentIntentId })
                            .then(afterFulfill, function(err) {
                                var detail = err && (err.message || err.detail || err);
                                logPaymentError('fulfill_failed', {
                                    message: detail,
                                    paymentIntentId: paymentIntentId,
                                }, activePaymentMethod);
                                $scope.failure(detail);
                            });
                    };

                    $scope.failure = function(errorDetail) {
                        $scope.hide();

                        if($scope.onFailure) {
                            $scope.onFailure(errorDetail);
                        }
                    };

                    $scope.hide = function() {
                        $scope.$broadcast("hidePopup");
                    };

                    showCheckoutEvent.listen(function(description, client_secret, email, price, onSuccess, onFailure, paymentAmount, paymentCurrency) {
                        $scope.description = description;
                        $scope.client_secret = client_secret;
                        $scope.email = email;
                        $scope.price = price;
                        $scope.checkoutAmount = paymentAmount;
                        $scope.checkoutCurrency = paymentCurrency || 'AUD';
                        $scope.onSuccess = onSuccess;
                        $scope.onFailure = onFailure;
                        init();
                    });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('couponBtn', ['couponAppliedEvent', 'showCouponFormEvent', 'couponService', 'userService', 'photoService', 'showAuthEvent',
        function(couponAppliedEvent, showCouponFormEvent, couponService, userService, photoService, showAuthEvent) { 
            return {
                templateUrl: 'couponBtn.html',
                restrict: 'E',
                replace:true,
                scope: {},
                link: function($scope, $element) {
                    var $enterCode = $element.find('.enter-code');
                    var $codeApplied = $element.find('.code-applied');

                    $scope.coupon = null;
					$scope.userData = userService.data;
                    
                    var init = function() {
                        $scope.coupon = couponService.coupon;
                        if($scope.coupon) {
                            $enterCode.hide();
                            $codeApplied.show();
                        } else {
                            $enterCode.show();
                            $codeApplied.hide();
                        }
                        
                    };
                    
                    $scope.showForm = function() {
                        if($scope.userData && $scope.userData.user) {
							showCouponFormEvent.broadcast();
                        } else {
							var options = {
								interestedIn: photoService.event.type,
								instantSignup: true
							};
							

							showAuthEvent.broadcast('Please login or create an account to use a coupon.', function() {
							}, options);    
                        }
                    };
                    
                    couponAppliedEvent.listen(function(coupon) {
                        $scope.coupon = coupon;
                        $enterCode.hide();
                        $codeApplied.show();
                    });
                    
                    init();
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('couponForm', ['couponService', 'showCouponFormEvent', 'photoService', '$timeout',
        function(couponService, showCouponFormEvent, photoService, $timeout) {
            return {
                templateUrl: 'couponForm.html',
                restrict: 'E',
                scope: {},
                link: function($scope, $element) {
                    $scope.PANELS = {
                        FORM: 0,
                        SUCCESS: 2,
                    };


                    var $invalidError = $element.find('.invalid-code');
                    $scope.formData = {};
                    $scope.invalidCode = false;
                    $scope.currentPanel = $scope.PANELS.FORM;

                    var init = function() {
                        $scope.couponMessage = photoService.event.couponMessage;
                        $scope.hasSubmitted = false;
                        $scope.formData.code = couponService.coupon ? couponService.coupon.code : "";
                        $scope.showFormPanel();
                        $scope.$broadcast("showPopup");
                        $invalidError.hide();
                    };

                    $scope.showFormPanel = function() {
                        $scope.currentPanel = $scope.PANELS.FORM;
                    };

                    $scope.hide = function() {
                        $scope.$broadcast("hidePopup");
                    };

                    $scope.submit = function() {
                        $scope.hasSubmitted = true;
                        if($scope.form.$valid) {
                            $scope.isLoading = true;

                            return couponService.getCoupon({eventId: photoService.event._id, code: $scope.formData.code})
                                .then(function(coupon) {
                                    $scope.coupon = coupon;
                                    $scope.currentPanel = $scope.PANELS.SUCCESS;
                                    $scope.isLoading = false;
                                },
                                function(err) {
                                    $scope.isLoading = false;
                                    $scope.invalidCode = true;
                                })
                        }
                    };
                    
                    $scope.onCodeChange = function() {
                        $scope.invalidCode = false;
                    };

                    showCouponFormEvent.listen(function() {
                       init();
                    });
                }
            };
        }]);

/**
 * Currency Button Directive
 * Displays current currency and opens currency selector on click
 */
angular.module('ra.core')
    .directive('currencyButton', ['currencyService', 'currencyChangeEvent', '$timeout',
        function(currencyService, currencyChangeEvent, $timeout) {
            return {
                template: [
                    '<div class="currency-button" ng-click="toggleSelector($event)" ng-if="currencyInfo">',
                    '  <div class="currency-display">',
                    '    <span class="currency-country-code">{{getCountryCode(currencyInfo.code)}}</span>',
                    '    <span class="currency-separator">/</span>',
                    '    <span class="currency-full">{{currencyInfo.code}} {{currencyInfo.symbol}}</span>',
                    '  </div>',
                    '</div>'
                ].join(''),
                restrict: 'E',
                scope: {},

                link: function($scope, $element) {
                    $scope.currencyInfo = null;
                    
                    // Get country code from currency code
                    $scope.getCountryCode = function(currencyCode) {
                        if (!currencyCode) return '';
                        var countryCodes = {
                            'AUD': 'AU',
                            'SGD': 'SG',
                            'USD': 'US',
                            'EUR': 'EU',
                            'GBP': 'GB'
                        };
                        return countryCodes[currencyCode] || currencyCode.substring(0, 2);
                    };
                    
                    // Update currency display
                    var updateCurrencyDisplay = function() {
                        var currencyCode = currencyService.getSelectedCurrency();
                        if (currencyCode) {
                            $scope.currencyInfo = currencyService.getCurrencyInfo(currencyCode);
                        }
                    };
                    
                    // Listen for currency changes (including initial broadcast from initialize)
                    currencyChangeEvent.listen(function(currencyCode) {
                        $timeout(function() {
                            updateCurrencyDisplay();
                        });
                    });
                    
                    // Initialize after Angular's first digest cycle
                    $timeout(function() {
                        updateCurrencyDisplay();
                    });
                    
                    // Open currency selector
                    $scope.toggleSelector = function($event) {
                        if ($event) {
                            $event.stopPropagation();
                        }
                        // Broadcast event to open selector
                        $scope.$root.$broadcast('toggleCurrencySelector', true);
                    };
                }
            };
        }]);

/**
 * Currency Selector Directive
 * Slide-out panel for selecting currency
 */
angular.module('ra.core')
    .directive('currencySelector', ['currencyService', 'currencyChangeEvent',
        function(currencyService, currencyChangeEvent) {
            return {
                template: [
                    '<div class="currency-selector" ng-class="{\'open\': isOpen}">',
                    '  <div class="currency-backdrop" ng-click="close()" ng-show="isOpen"></div>',
                    '  <div class="currency-panel">',
                    '    <div class="currency-header">',
                    '      <span class="currency-title">Select Currency</span>',
                    '      <span class="currency-close" ng-click="close()">&times;</span>',
                    '    </div>',
                    '    <div class="currency-list">',
                    '      <div class="currency-item" ng-repeat="currency in currencyList" ng-class="{\'selected\': currency.code === selectedCurrency}" ng-click="selectCurrency(currency.code)">',
                    '        <div class="currency-country">{{currency.country}}</div>',
                    '        <div class="currency-code">[{{currency.code}} {{currency.symbol}}]</div>',
                    '      </div>',
                    '    </div>',
                    '  </div>',
                    '</div>'
                ].join(''),
                restrict: 'E',
                replace: true,
                scope: {},
                link: function($scope, $element) {
                    $scope.isOpen = false;
                    $scope.currencies = currencyService.getAvailableCurrencies();
                    $scope.selectedCurrency = currencyService.getSelectedCurrency();
                    
                    // Get currency list as array for ng-repeat
                    $scope.currencyList = Object.keys($scope.currencies).map(function(key) {
                        return $scope.currencies[key];
                    });
                    
                    // Listen for toggle events
                    $scope.$on('toggleCurrencySelector', function(event, isOpen) {
                        $scope.isOpen = isOpen;
                        if (!$scope.$$phase && !$scope.$root.$$phase) {
                            $scope.$apply();
                        }
                    });
                    
                    // Listen for close events
                    $scope.$on('closeCurrencySelector', function() {
                        $scope.isOpen = false;
                        if (!$scope.$$phase && !$scope.$root.$$phase) {
                            $scope.$apply();
                        }
                    });
                    
                    // Listen for currency changes to update selected state
                    currencyChangeEvent.listen(function(currencyCode) {
                        $scope.selectedCurrency = currencyCode;
                    });
                    
                    // Select currency
                    $scope.selectCurrency = function(currencyCode) {
                        currencyService.setSelectedCurrency(currencyCode);
                        $scope.isOpen = false;
                    };
                    
                    // Close selector
                    $scope.close = function() {
                        $scope.isOpen = false;
                        $scope.$broadcast('closeCurrencySelector');
                    };
                    
                    // Close on outside click
                    $scope.$on('clickOutside', function() {
                        if ($scope.isOpen) {
                            $scope.close();
                        }
                    });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.core')
    .directive('downloadAll', ['showDownloadAllEvent', 'photoService', '$timeout',
        function(showDownloadAllEvent, photoService, $timeout) {
        return {
            templateUrl: 'downloadAll.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                var pollCancel = null;
                var jobStatus = null;
                var POLL_MS = 2000;
                var POLL_MAX_MS = 15 * 60 * 1000;

                $scope.show = function() {
                    $scope.$broadcast("showPopup"); 
                };

                $scope.hide = function() {
                    cancelPoll();
                    $scope.$broadcast("hidePopup");
                };

                function isReady(result) {
                    if (!result || result.status !== 'ready') {
                        return false;
                    }
                    if (result.photosZip) {
                        return true;
                    }
                    return result.photosZips && result.photosZips.length;
                }

                $scope.downloadPart = function(part) {
                    if (!part || !part.url) {
                        return;
                    }
                    var a = document.createElement('a');
                    a.href = part.url;
                    a.download = part.label ? (part.label + '.zip') : 'My NORTHSOUTH Photos.zip';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                };

                $scope.download = function() {
                  if ($scope.photosZips && $scope.photosZips.length) {
                    $scope.photosZips.forEach(function(part) {
                        $scope.downloadPart(part);
                    });
                    $scope.hide();
                    return;
                  }
                  if(!$scope.photosZip) {
                    return;
                  }
                  $scope.downloadPart({ url: $scope.photosZip, label: 'My NORTHSOUTH Photos' });
                  $scope.hide();
                };

                function cancelPoll() {
                    if (pollCancel) {
                        $timeout.cancel(pollCancel);
                        pollCancel = null;
                    }
                }

                function failDownload() {
                    cancelPoll();
                    alert("We couldn't download your photos, please try again later.");
                }

                function applyResult(result) {
                    if (!result) {
                        failDownload();
                        return;
                    }
                    if (isReady(result)) {
                        jobStatus = 'ready';
                        $scope.jobPending = false;
                        cancelPoll();
                        $scope.photosZip = result.photosZip;
                        $scope.photosZips = result.photosZips || null;
                        $scope.progress = null;
                        $scope.partLimitWarning = result.partLimitWarning || null;
                        return;
                    }
                    if (result.status === 'error') {
                        jobStatus = 'error';
                        $scope.jobPending = false;
                        failDownload();
                        return;
                    }
                    if (result.status === 'pending') {
                        jobStatus = 'pending';
                        $scope.jobPending = true;
                    }
                    if (result.partLimitWarning) {
                        $scope.partLimitWarning = result.partLimitWarning;
                    }
                    if (result.progress) {
                        $scope.progress = result.progress;
                    }
                    if (result.photosZips && result.photosZips.length) {
                        $scope.photosZips = result.photosZips;
                    }
                    // pending — keep polling
                }

                function stillPending() {
                    return jobStatus === 'pending';
                }

                function pollStatus(eventId, bib, participantId, startedAt) {
                    if (Date.now() - startedAt > POLL_MAX_MS) {
                        failDownload();
                        return;
                    }
                    pollCancel = $timeout(function() {
                        photoService.downloadAllPhotosStatus(eventId, bib, participantId)
                          .then(function(result) {
                              applyResult(result);
                              if (stillPending()) {
                                  pollStatus(eventId, bib, participantId, startedAt);
                              }
                          }, function() {
                              failDownload();
                          });
                    }, POLL_MS);
                }

                showDownloadAllEvent.listen(function() {
                    cancelPoll();
                    jobStatus = 'pending';
                    $scope.jobPending = true;
                    $scope.show();
                    $scope.photosZip = undefined;
                    $scope.photosZips = undefined;
                    $scope.progress = null;
                    $scope.partLimitWarning = null;
                    var participantId = photoService.currentParticipant ? photoService.currentParticipant._id : null;
                    var eventId = photoService.event._id;
                    var bib = photoService.currentBib;
                    return photoService.downloadAllPhotos(eventId, bib, participantId)
                      .then(function(result) {
                          applyResult(result);
                          if (stillPending() && result && result.status === 'pending') {
                              pollStatus(eventId, bib, participantId, Date.now());
                          } else if (stillPending()) {
                              failDownload();
                          }
                      }, function() {
                          failDownload();
                      });
                });

                $scope.$on('$destroy', cancelPoll);
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('fancyGallery', ['fancyService', 'photosLoadingEvent', 'updatePhotosEvent', 'photoService', '$timeout', 'galleryTabChangeEvent',
        function(fancyService, photosLoadingEvent, updatePhotosEvent, photoService, $timeout, galleryTabChangeEvent) {
            return {
                templateUrl: 'fancyGallery.html',
                restrict: 'E',
                scope: {
                    event: '=',
                    participantId: '=',
                },
                link: function($scope, $element) {
                    $scope.showLoading = false;
                    $scope.showNoPhotosError = true;

                    function syncLaterButton() {
                        if ($scope.securedPreviewBackdrop || !$scope.photoGroups || !$scope.photoGroups.length) {
                            return;
                        }
                        if ($scope.selectedTab === 'myPhotos') {
                            if (photoService.hasMoreMyPhotos()) {
                                $(".more.later").fadeIn(400);
                            } else {
                                $(".more.later").hide();
                            }
                        }
                    }

                    $scope.photoService = photoService;

                    $scope.showLater = function() {
                        $scope.loadingLater = true;

                        var loadPromise;
                        if (photoService.selectedTab === 'myPhotos') {
                            loadPromise = photoService.loadMoreMyPhotos();
                        } else {
                            loadPromise = photoService.nextTimePhotos()
                                .then(function(newPhotos) {
                                    return newPhotos || [];
                                });
                        }

                        loadPromise
                            .then(function(newPhotos) {
                                if (!newPhotos || !newPhotos.length) {
                                    $(".more.later").hide();
                                } else if (photoService.selectedTab === 'myPhotos' && !photoService.hasMoreMyPhotos()) {
                                    $(".more.later").hide();
                                }
                                $scope.loadingLater = false;
                            })
                            .catch(function() {
                                $scope.loadingLater = false;
                            });
                    };

                    $scope.galleryTabChangeEvent = galleryTabChangeEvent;

                    $scope.showVideoMenu = function() {
                      fancyService.reload();
                    }
                    
                    /**
                     * Show earlier photos, and scroll to previous earliest photo
                     */
                    $scope.showEarlier = function() {
                        var $firstPhoto = $('.photo').first();
                        var firstPhotoOffset = $firstPhoto.offset().top-$(window).scrollTop();

                        $scope.loadingEarlier = true;

                        photoService.prevTimePhotos()
                            .then(function(newPhotos) {
                                if(!newPhotos.length) {
                                    $(".more.earlier").hide();
                                }
                                //Wait until gallery has updated
                                $timeout(function() {
                                    $('html, body').animate({
                                        scrollTop: ($firstPhoto.offset().top - firstPhotoOffset)
                                    }, 1);
                                }, 1);

                                $scope.loadingEarlier = false;
                            });
                    };

                    fancyService.setup($scope.event);

                    photosLoadingEvent.listen(function() {
                        $scope.showLoading = true;
                    });
                    
                    $scope.securedPreviewBackdrop = photoService.securedPreviewBackdrop;

                    updatePhotosEvent.listen(function(photoGroups) {
                        $scope.photoGroups = photoGroups;
                        $scope.showLoading = false;
                        $scope.selectedTab =  photoService.selectedTab;
                        $scope.showNoPhotosError = !photoService.showSelfie;
                        $scope.securedPreviewBackdrop = photoService.securedPreviewBackdrop;
                        syncLaterButton();
                    });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Handles appending the fancy menu to fancybox and displaying it
 */
angular.module('ra.core')
    .directive('fancyMenuHolder', ['showFancyMenuEvent', 'fancyboxHiddenEvent', '$timeout', 'userService', '$window', 'photoService', 'fancyService', '$sce',
        function(showFancyMenuEvent, fancyboxHiddenEvent, $timeout, userService, $window, photoService, fancyService, $sce) {
            return {
                templateUrl: 'fancyMenuHolder.html',
                restrict: 'E',
                scope: {},
                link: function($scope, $element) {

                    $scope.userData = userService.data;

                    $scope.MENU_TYPES = {
                        PAID: 0,
                        FREE: 1
                    };

                    var $origParent = null;

                    //$scope.purchaseOptions = [];
                    $scope.purchased = [];

                    $scope.photo = null;
                    $scope.participantId = null;


                    var initFreeMenu = function() {
                        $('.menu-free').show();
                        $('.menu-paid').hide();
                        console.log($element.find('.share-icons'));
                        $element.find('.share-icons').html(
                            PhotoShareLinks.socialButtons(false, photoService.event.showPrintMenu)
                        );

                        var shareUrl = window.location.origin+'/event/'+photoService.event.key+'/share/'+$scope.photo._id;

                        if(photoService.currentParticipant._id) {
                            shareUrl += '/' + photoService.currentParticipant._id;
                        }

                        PhotoShareLinks.init(shareUrl, photoService.event.name, $scope.photo._id, photoService.event._id, photoService.currentParticipant._id);

                        $timeout(function() {
                            var thisElement = $element.detach();
                            $(".fancybox-title").html(thisElement);
                        }, 1);
                    };

                    var initPaidMenu = function() {
                        $('.menu-free').hide();

                        //TODO: Should this be part of paidmenu? Or should both menus use the same interface?
                        $timeout(function() {
                            var thisElement = $element.detach();
                            $(".fancybox-outer").append(thisElement);
                        }, 1);
                    };



                    var resetMenu = function() {
                        var thisElement = $element.detach();
                        $origParent.prepend(thisElement);
                    };



                    var appendMenu = function() {  
                        $origParent = $element.parent(); 

                        if(photoService.event.isPaid || photoService.showPrintMenu) {
                            initPaidMenu();
                        } else {
                            initFreeMenu();
                        }
                    };

                    $('.fancy-menu').on('showPrintMenu', function(e, photoId) {
                        photoService.showPrintMenu = true;
                        fancyService.reload();

                        // $scope.photo = photo;
                        // $scope.overlay1TimePath = photoService.event.overlay1TimePath;
                        // $scope.gravity = photoService.event.overlay1Gravity;
                    });

                    showFancyMenuEvent.listen(function(photo) {
                        $scope.photo = photo;
                        $scope.overlay1TimePath = photoService.event.overlay1TimePath;
                        $scope.portraitFrameImage = photoService.event.portraitFrameImage;

                        // $scope.landscapeFrameImage = photoService.event.landscapeFrameImage;
                        $scope.gravity = photoService.event.overlay1Gravity;
                        appendMenu();
                    });

                    fancyboxHiddenEvent.listen(function() {
                        resetMenu();
                    });

                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('fancyPhoto', ['fancyboxShownEvent', 'showFancyMenuEvent', 'photoService', '$sce',
        function(fancyboxShownEvent, showFancyMenuEvent, photoService, $sce) {
            return {
                templateUrl: 'fancyPhoto.html',
                restrict: 'E',
                replace:true,
                scope: {
                    photo: '=',
                },
                link: function($scope, $element) {

                    $scope.showPhotoBox = function() {
                        showFancyMenuEvent.broadcast($scope.photo, 'photo');
                    }
                    
                    $scope.href = $scope.photo.imagePreview;

                    $scope.getDateTaken = function() {
                        if(!$scope.photo.dateTaken) {
                            return "";
                        } else {
                            var date = new moment($scope.photo.dateTaken);
                            return date.utc().format('hh:mm:ss a');
                        }
                    };

                    if(photoService.shouldShowCollection()) {
                        $element.find(".download").css({display:'block'});
                    }

                    //Show the fancy menu with specific details of this photo
                    fancyboxShownEvent.listen($scope, $scope.href, function() {
                        showFancyMenuEvent.broadcast($scope.photo, 'photo');
                    });

                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.core')
    .directive('fancyVideo', ['showFancyMenuEvent', 'photoService',
        function(showFancyMenuEvent, photoService) {
            return {
                templateUrl: 'fancyVideo.html',
                restrict: 'E',
                replace: true,
                scope: {
                    event: '='
                },
                link: function($scope) {
                    $scope.openVideoMenu = function($event) {
                        if ($event && $event.stopPropagation) {
                            $event.stopPropagation();
                        }
                        showFancyMenuEvent.broadcast(null, 'video');
                    };

                    function refreshShowVideoTile() {
                        var event = $scope.event;
                        if (!event || !(event.videoPreview || event.videoTile)) {
                            $scope.showVideoTile = false;
                            return;
                        }
                        $scope.showVideoTile = photoService.selectedTab === 'myPhotos';
                    }

                    $scope.$watch('event', refreshShowVideoTile, true);
                    $scope.$watch(function() {
                        return photoService.selectedTab;
                    }, refreshShowVideoTile);
                    refreshShowVideoTile();
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Menu for paid photos
 */
angular.module('ra.core')
    .directive('freeMenu', ['photoService', 'showFancyMenuEvent', 'showEmailShareEvent', 'showPrintMenuEvent',
        function(photoService, showFancyMenuEvent, showEmailShareEvent, showPrintMenuEvent) {
            return {
                templateUrl: 'freeMenu.html',
                restrict: 'E',
                scope: {
                },
                link: function($scope, $element) {
                  var VIA = "Raceatlas";
                  $scope.photo = {};
                  $scope.photoService = photoService;
                  $scope.printMenu = false;

                  var addPhotoAction = function(photoId, actionType) {
                    var urlPrefix = window.location.protocol + "//" + window.location.host;
                    $.post(urlPrefix + "/api/photo-actions/add", {photoId: photoId, actionType: actionType}, function() {
                      console.log([urlPrefix + "/api/photo-actions/add", {photoId: photoId, actionType: actionType}]);
                    });

                  };
                  
                  var logEvent = function(eventAction, eventName, label) {
                    ga('send', 'event', eventName, eventAction, label);
                  };
                  // $scope.showTwitter = function(link, text, logName, logLabel) {
                  //   popupWindow("https://twitter.com/share?url=" + link + "&text= " + text + ":&via=" + VIA, 'Twitter');
                  //   logEvent('twitter-share', logName, logLabel);
                  // };
                  $scope.showFacebook = function() {
                    $('body').trigger('showSignUpTrigger', function() {
                      $('body').trigger('showAgreeTrigger', function () {
                        addPhotoAction($scope.photo._id, 'Facebook');

                        $scope.shareUrl = window.location.origin+'/event/'+photoService.event.key+'/share/'+$scope.photo._id;
                        popupWindow("http://www.facebook.com/share.php?u=" + $scope.shareUrl + "&href=" + $scope.shareUrl, 'Facebook');
                        logEvent('facebook-share', photoService.event.name, $scope.photo._id);
                      });
                    });
                  };
                  
                  $scope.showEmail = function(link, text) {
                    $('body').trigger('showSignUpTrigger', function() {
                      $('body').trigger('showAgreeTrigger', function() {
                        addPhotoAction($scope.photo._id, 'Email');
                        showEmailShareEvent.broadcast($scope.photo._id);
                        // window.location = "mailto:?subject=" + subject + "&body=" + body;
                        logEvent('email-share', photoService.event.name,  $scope.photo._id);
                      });
                    });
                  };
                  
                  $scope.download = function() {
                    $('body').trigger('showSignUpTrigger', function() {
                      $('body').trigger('showAgreeTrigger', function() {
                        var link = '/photos/serve/' + $scope.photo._id + '/' + photoService.event._id;
                        if(photoService.currentParticipant._id) {
                          link += '/' +photoService.currentParticipant._id;
                        }

                        if(isMobileOrTablet()) {
                          window.location.href = link;
                        } else {
                          window.open(link, '_blank');
                        }
                      });
                    });
                  }
                  
                  $scope.showPrintMenu = function() {
                    showPrintMenuEvent.broadcast($scope.photo);
                  }

                  showFancyMenuEvent.listen(function(photo, type) {
                    $scope.photo = photo;
                  });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
function insertUrlParam(key, value) {
    if (history.replaceState && key && value) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(key, value);
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({path: newurl}, '', newurl);
    }
}

function removeUrlParam(key) {
    if (history.replaceState && key) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(key);
        var qs = searchParams.toString();
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + (qs ? '?' + qs : '');
        window.history.replaceState({path: newurl}, '', newurl);
    }
}

angular.module('ra.core')
    .directive('myPhotosForm', ['photoService', 'getMyPhotosEvent', 'signOnCompleteEvent', '$http', '$rootScope',
        function(photoService, getMyPhotosEvent, signOnCompleteEvent, $http, $rootScope) {
            return {
                templateUrl: 'myPhotosForm.html',
                restrict: 'E',
                scope: {
                    
                },
                link: function($scope, $element) {

                    $scope.bibForm = {};
                    $scope.formData = $scope.formData || {};
                    $scope.formData.participantSearch = $scope.formData.participantSearch || {};
                    $scope.formData.participantSearchStr = $scope.formData.participantSearchStr || '';
                    var didApplyParticipantPrefill = false;

                    function applyParticipantSearchFromSummary(bib) {
                        if (bib == null || bib === '') {
                            return;
                        }
                        var summaries = photoService.participantSummaries;
                        if (!summaries || !summaries.length) {
                            return;
                        }
                        var bStr = String(bib);
                        var summary;
                        for (var i = 0; i < summaries.length; i++) {
                            var s = summaries[i];
                            if (s && (s.bib === bib || String(s.bib) === bStr)) {
                                summary = s;
                                break;
                            }
                        }
                        if (!summary) {
                            return;
                        }
                        var label = (summary.name && summary.name.trim()) ? summary.name.trim() : (summary.bib != null ? String(summary.bib) : '');
                        if (!label) {
                            return;
                        }
                        $scope.formData.participantSearchStr = label;
                        $scope.formData.participantSearch = {
                            bib: summary.bib,
                            name: summary.name || '',
                            _id: summary._id
                        };
                    }

                    var init = function() {
                        $scope.showMyPhotos = photoService.showMyPhotos;
                        $scope.bibForm.bib = photoService.currentBib;
                        $scope.bibs = photoService.bibs;
                        $scope.isPrivate = photoService.isPrivate;
                        $scope.isOrganiserOrAdmin = photoService.isOrganiserOrAdmin;
                        applyParticipantSearchFromSummary($scope.bibForm.bib);
					};

                    $scope.onParticipantChosen = function() {
                        if ($scope.formData.participantSearch && $scope.formData.participantSearch.bib != null) {
                            $scope.getMyPhotos($scope.formData.participantSearch.bib);
                        }
                    };

                    var PARTICIPANT_SEARCH_INPUT_ID = 'participantSearch_value';

                    function getParticipantSearchStr() {
                        var el = document.getElementById(PARTICIPANT_SEARCH_INPUT_ID);
                        if (el && typeof el.value === 'string') {
                            return el.value.trim();
                        }
                        return ($scope.formData.participantSearchStr || '').trim();
                    }

                    /**
                     * Default form submit (e.g. Enter) should not run bib load when the participant search field is focused;
                     * that would use the old bib. Enter in search runs participant search instead.
                     */
                    $scope.onBibFormSubmit = function($event) {
                        var ae = document.activeElement;
                        if (ae && ae.id === PARTICIPANT_SEARCH_INPUT_ID) {
                            if ($event && $event.preventDefault) {
                                $event.preventDefault();
                            }
                            $scope.triggerParticipantSearch();
                            return false;
                        }
                        return $scope.getMyPhotos($scope.bibForm.bib);
                    };

                    /**
                     * Run the same participant search as autocomplete and load the first match (public or organiser on private).
                     */
                    $scope.triggerParticipantSearch = function() {
                        var str = getParticipantSearchStr();
                        $scope.formData.participantSearchStr = str;
                        if (str.length < 3) {
                            return;
                        }
                        var base = $rootScope.participantSearchUrl;
                        if (!base) {
                            return;
                        }
                        $http.get(base + encodeURIComponent(str))
                            .then(function(res) {
                                var data = res.data || {};
                                var list = data.participants || [];
                                if (!list.length) {
                                    $scope.formData.participantSearch = {};
                                    $scope.bibForm.bib = null;
                                    removeUrlParam('bib');
                                    removeUrlParam('participant');
                                    photoService.getMyPhotos(null);
                                    return;
                                }
                                var p = list[0];
                                $scope.formData.participantSearch = p;
                                $scope.formData.participantSearchStr = p.name || '';
                                $scope.onParticipantChosen();
                            });
                    };
                    
                    $scope.getMyPhotos = function(bib) {
                        insertUrlParam('bib', bib);
                        $scope.bibForm.bib = bib;
                        return photoService.getMyPhotos(bib);
                    }; 

                    function applyParticipantPrefillFromRouteParams() {
                        if (didApplyParticipantPrefill) {
                            return;
                        }
                        if (!$scope.formData || ($scope.formData.participantSearchStr && $scope.formData.participantSearchStr.length)) {
                            return;
                        }
                        var rp = $rootScope && $rootScope.routeParams ? $rootScope.routeParams : null;
                        var prefill = rp && rp.participantPrefill ? rp.participantPrefill : null;
                        if (!prefill || prefill.bib == null) {
                            return;
                        }

                        didApplyParticipantPrefill = true;
                        $scope.formData.participantSearch = {
                            _id: prefill._id,
                            name: prefill.name,
                            bib: prefill.bib
                        };
                        $scope.formData.participantSearchStr = prefill.name || '';
                        $scope.onParticipantChosen();
                    }

                    signOnCompleteEvent.listen(function() {
                        return $scope.getMyPhotos($scope.bibForm.bib);
                    });

                    getMyPhotosEvent.listen(function() {
                        init();
                        applyParticipantPrefillFromRouteParams();
                        var bib = $scope.bibForm.bib || photoService.currentBib;
                        return $scope.getMyPhotos(bib);
                    });

                    // Covers initial deep-link load where getMyPhotosEvent may not have fired yet.
                    $scope.$watch(function() {
                        return $rootScope && $rootScope.routeParams ? $rootScope.routeParams.participantPrefill : null;
                    }, function() {
                        applyParticipantPrefillFromRouteParams();
                    });

                    /* Enter in angucomplete must not submit the bib form (would load stale bib); run participant search with live input value */
                    var onParticipantSearchKeydown = function(e) {
                        var t = e.target;
                        if (!t || t.id !== PARTICIPANT_SEARCH_INPUT_ID) {
                            return;
                        }
                        if (e.which !== 13 && e.keyCode !== 13) {
                            return;
                        }
                        e.preventDefault();
                        var val = t.value;
                        $scope.$apply(function() {
                            if (val != null) {
                                $scope.formData.participantSearchStr = val;
                            }
                            $scope.triggerParticipantSearch();
                        });
                    };
                    $element.on('keydown', onParticipantSearchKeydown);
                    $scope.$on('$destroy', function() {
                        $element.off('keydown', onParticipantSearchKeydown);
                    });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('packageAdded', ['showPackageAddedEvent',
        function(showPackageAddedEvent) {
        return {
            templateUrl: 'packageAdded.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };
                
                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };

                showPackageAddedEvent.listen(function(url) {
                    $scope.url = url;
                    $scope.show();
                });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Menu for paid photos
 */
angular.module('ra.core')
    .directive('paidMenu', [
        'showFancyMenuEvent',
        'photoService',
        'purchaseService',
        'getMyPhotosEvent',
        'userService',
        'showAddPhotoMessageEvent',
        'couponService',
        'couponAppliedEvent',
        'refreshPaidMenuEvent',
        'showPackageAddedEvent',
        'showAddressFormEvent',
        'fancyService',
        'showAuthEvent',
        'magnifyService',
        'fancyboxHiddenEvent',
        'closePhotoBoxEvent',
        'currencyService',
        'currencyChangeEvent',
        function(
         showFancyMenuEvent,
         photoService,
         purchaseService,
         getMyPhotosEvent,
         userService,
         showAddPhotoMessageEvent,
         couponService,
         couponAppliedEvent,
         refreshPaidMenuEvent,
         showPackageAddedEvent,
         showAddressFormEvent,
         fancyService,
         showAuthEvent,
         magnifyService,
         fancyboxHiddenEvent,
         closePhotoBoxEvent,
         currencyService,
         currencyChangeEvent) {
            return {
                templateUrl: 'paidMenu.html',
                restrict: 'E',
                scope: {
                },
                link: function($scope, $element) {

                    $scope.PANELS = {
                        PURCHASE: 0,
                        ALL_PHOTOS: 1,
                        LOADING: 2,
                        COMPLETE: 3,
                        PACKAGE: 4,
                        PRINT: 5
                    };
                    
                    $scope.currentPanel =  $scope.PANELS.PURCHASE;

                    $scope.userData = userService.data;

                    $scope.photoOption = 'OrigPhoto';
                    $scope.origUrl = null;
                    $scope.commUrl = null;
                    $scope.downloadUrl = null;

                    $scope.coupon = null;
                    $scope.packagePhotosRemaining = null;

                    var $addBtn = $element.find('#addToPackage');
                    var $addBtnLoading = $element.find("#adding");

                    var init = function(type) {
                        $scope.framePrintDesc = 'Your photo set in a deluxe<br/>3-photo frame made from recycled tires, in between two scenic course photos (see preview). Your name and event title and finishing time (if available) are displayed underneath. Only 30 available. Free Postage.';

                        $addBtn.removeClass('hide');
                        $addBtnLoading.addClass('hide');
                        $('.menu-paid').fadeIn(300);
                        $scope.$broadcast('initPurchaseOptions');

                        $scope.participant = photoService.currentParticipant;
                        if($scope.photo) {
                            $scope.origUrl = '/photos/serve/' + $scope.photo._id + '/' + $scope.event._id;
                            $scope.commUrl = '/photos/serve/' + $scope.photo._id + '/' + $scope.event._id + '/' + photoService.currentParticipant._id;
                        }
                        $scope.videoUrl = '/my-video/' + $scope.event.key + '?bib=' + $scope.currentBib + '&purchased=true';
                        $scope.downloadUrl = $scope.origUrl;
                        $scope.photoOption = null;

                        $scope.options = {
                            type:'OrigPhoto'
                        };
                        $scope.packageOptions = {
                            type:'OrigPhoto'
                        };
                        getPurchaseInfo();
                        $scope.hideDemos();
                        
                        if(type === 'video') {
                            $scope.noPreview = true;
                            // Sample tile opens with photo=null; hideDemos() above cleared the player.
                            setTimeout(function() {
                                $scope.showVideoDemo(true);
                            }, 400);
                        } else {
                            $scope.noPreview = false;
                            setTimeout(function() {
                                if($scope.photo) {
                                    magnifyService.magnify(".the-photo", 1.7, $scope.photo.imageZoom);
                                }
                            }, 300);
                        }
                    };


                    var getPurchaseInfo = function() {

                        if(photoService.shouldShowCollection() && $scope.photo) {
                            $scope.currentPanel = $scope.PANELS.COMPLETE;

                        } else {
                            $scope.currentPanel = $scope.PANELS.LOADING;
                            return purchaseService.purchasedTypes({itemId: $scope.photo ? $scope.photo._id : null, eventId: $scope.event._id, bibId: $scope.currentBib})
                                .then(function(result) {
                                    const numItems = $(".purchase-options table.outer").length;
                                    if(numItems >= 3) {
                                        $(".photo-box .popup-form>.inner").addClass("many-items");
                                    } else {
                                        $(".photo-box .popup-form>.inner").removeClass("many-items");
                                    }
                                    
                                    $scope.purchased = result.types;
                                    $scope.packagePhotosRemaining = result.packagePhotosRemaining;

                                    if(result.packagePhotosRemaining) {
                                        $scope.currentPanel = $scope.PANELS.PACKAGE;

                                    } else if(photoService.showPrintMenu) {
                                        $scope.currentPanel = $scope.PANELS.PRINT;

                                    } else {
                                        $scope.currentPanel = $scope.PANELS.PURCHASE;
                                    }

                                },  function(err) {
                                    alert("Could not load purchase options. Please refresh your browser");
                                })
                        }

                        $scope.changePhotoOption('OrigPhoto', true);
                    };

                    var updatePrices = function() {
                        var eventDefaultCurrency = (photoService.event.defaultCurrency || 'AUD').toUpperCase();
                        var selectedCurrency = currencyService.getSelectedCurrency();
                        
                        // Helper function to convert price if needed
                        var convertPrice = function(priceInCents) {
                            if (!priceInCents || priceInCents === null) {
                                return null;
                            }
                            if (selectedCurrency === eventDefaultCurrency) {
                                return priceInCents;
                            }
                            // For now, return original price - conversion will happen via API call
                            // The actual conversion will be done when displaying prices
                            return priceInCents;
                        };
                        
                        // Store original prices in event's default currency
                        var photoPriceBase = couponService.discountIfCoupon(photoService.event.photoPrice);
                        var photoPriceOriginalBase = photoService.event.photoPrice;
                        var bibPhotosPriceBase = couponService.discountIfCoupon(photoService.event.bibPhotosPrice);
                        var bibPhotosPriceOriginalBase = photoService.event.bibPhotosPrice;
                        var packagePhotosPriceBase = couponService.discountIfCoupon(photoService.event.packagePhotosPrice);
                        var packagePhotosPriceOriginalBase = photoService.event.packagePhotosPrice;
                        var videoPriceBase = couponService.discountIfCoupon(photoService.event.videoPrice);
                        var videoPriceOriginalBase = photoService.event.videoPrice;
                        var packageVideoPriceBase = couponService.discountIfCoupon(photoService.event.packageVideoPrice);
                        var packageVideoPriceOriginalBase = photoService.event.packageVideoPrice;
                        var printSmallPriceBase = couponService.discountIfCoupon(photoService.event.printSmallPrice);
                        var printSmallPriceOriginalBase = photoService.event.printSmallPrice;
                        var printMediumPriceBase = couponService.discountIfCoupon(photoService.event.printMediumPrice);
                        var printMediumPriceOriginalBase = photoService.event.printMediumPrice;
                        var printCommemorativePriceBase = couponService.discountIfCoupon(photoService.event.printCommemorativePrice);
                        var printCommemorativePriceOriginalBase = photoService.event.printCommemorativePrice;
                        var printFramePriceBase = couponService.discountIfCoupon(photoService.event.printFramePrice);
                        var printFramePriceOriginalBase = photoService.event.printFramePrice;
                        
                        // Convert prices if currency is different
                        if (selectedCurrency !== eventDefaultCurrency) {
                            // Convert all prices asynchronously
                            var conversionPromises = [];
                            
                            var convertAndSet = function(basePrice, originalBasePrice, priceVar, originalPriceVar) {
                                if (basePrice !== null) {
                                    conversionPromises.push(
                                        currencyService.convertPrice(basePrice, eventDefaultCurrency, selectedCurrency)
                                            .then(function(converted) {
                                                $scope[priceVar] = converted;
                                            })
                                    );
                                } else {
                                    $scope[priceVar] = null;
                                }
                                
                                if (originalBasePrice !== null) {
                                    conversionPromises.push(
                                        currencyService.convertPrice(originalBasePrice, eventDefaultCurrency, selectedCurrency)
                                            .then(function(converted) {
                                                $scope[originalPriceVar] = converted;
                                            })
                                    );
                                } else {
                                    $scope[originalPriceVar] = null;
                                }
                            };
                            
                            convertAndSet(photoPriceBase, photoPriceOriginalBase, 'photoPrice', 'photoPriceOriginal');
                            convertAndSet(bibPhotosPriceBase, bibPhotosPriceOriginalBase, 'bibPhotosPrice', 'bibPhotosPriceOriginal');
                            convertAndSet(packagePhotosPriceBase, packagePhotosPriceOriginalBase, 'packagePhotosPrice', 'packagePhotosPriceOriginal');
                            convertAndSet(videoPriceBase, videoPriceOriginalBase, 'videoPrice', 'videoPriceOriginal');
                            convertAndSet(packageVideoPriceBase, packageVideoPriceOriginalBase, 'packageVideoPrice', 'packageVideoPriceOriginal');
                            convertAndSet(printSmallPriceBase, printSmallPriceOriginalBase, 'printSmallPrice', 'printSmallPriceOriginal');
                            convertAndSet(printMediumPriceBase, printMediumPriceOriginalBase, 'printMediumPrice', 'printMediumPriceOriginal');
                            convertAndSet(printCommemorativePriceBase, printCommemorativePriceOriginalBase, 'printCommemorativePrice', 'printCommemorativePriceOriginal');
                            convertAndSet(printFramePriceBase, printFramePriceOriginalBase, 'printFramePrice', 'printFramePriceOriginal');
                            
                            Promise.all(conversionPromises).then(function() {
                                $scope.$apply();
                            });
                        } else {
                            // Same currency, use base prices
                            $scope.photoPrice = photoPriceBase;
                            $scope.photoPriceOriginal = photoPriceOriginalBase;
                            $scope.bibPhotosPrice = bibPhotosPriceBase;
                            $scope.bibPhotosPriceOriginal = bibPhotosPriceOriginalBase;
                            $scope.packagePhotosPrice = packagePhotosPriceBase;
                            $scope.packagePhotosPriceOriginal = packagePhotosPriceOriginalBase;
                            $scope.videoPrice = videoPriceBase;
                            $scope.videoPriceOriginal = videoPriceOriginalBase;
                            $scope.packageVideoPrice = packageVideoPriceBase;
                            $scope.packageVideoPriceOriginal = packageVideoPriceOriginalBase;
                            $scope.printSmallPrice = printSmallPriceBase;
                            $scope.printSmallPriceOriginal = printSmallPriceOriginalBase;
                            $scope.printMediumPrice = printMediumPriceBase;
                            $scope.printMediumPriceOriginal = printMediumPriceOriginalBase;
                            $scope.printCommemorativePrice = printCommemorativePriceBase;
                            $scope.printCommemorativePriceOriginal = printCommemorativePriceOriginalBase;
                            $scope.printFramePrice = printFramePriceBase;
                            $scope.printFramePriceOriginal = printFramePriceOriginalBase;
                        }
                    };


                    /**
                     * Show or hide the commemorative option on the photo
                     * @param value
                     * @param noTransition
                     */
                    $scope.changePhotoOption = function(value, noTransition) {
                        $scope.photoOption = value;

                        if(value == 'CommPhoto') {
                            $scope.downloadUrl = $scope.commUrl;
                            $scope.showCommDemo(noTransition);
                        } else {
                            $scope.downloadUrl = $scope.origUrl;
                            $scope.hideCommDemo(noTransition);
                            $scope.hideFrameDemo(noTransition);
                        }
                    };
                    
                    function mobileScrollTop() {
                        if($(window).width() < Config.MOBILE_WIDTH) {
                            $(window).scrollTop(0);
                        }
                    }

                    /**
                     * Shows commemorative overlay on the sample image
                     */
                    $scope.showCommDemo = function(noTransition) {
                        $scope.hideDemos();
                        mobileScrollTop();

                        var $commDemo = $('.comm-demo');

                        if($commDemo.css('display') == 'none') {
                            if(noTransition) {
                                $commDemo.css({display:'block'});
                            } else {
                                $('.the-photo').animate({opacity:0}, 500, function() {
                                    $commDemo.css({display:'block', opacity:0}).animate({opacity:1}, 500);
                                }).animate({opacity:1}, 500);
                            }
                        }

                    };
                    $scope.hideCommDemo = function() {
                        $('.comm-demo').hide();
                    };

                    $scope.showFrameDemo = function(noTransition) {
                        $scope.hideDemos();
                        mobileScrollTop();

                        var $frameDemo = $('.frame-demo');
                        if($frameDemo.css('display') == 'none') {
                            if(noTransition) {
                                $frameDemo.css({display:'block'});
                            } else {
                                $('.the-photo').animate({opacity:0}, 500);
                                $frameDemo.css({display:'block', opacity:0}).animate({opacity:1}, 500);
                            }

                            // $('.frame-demo .landscape').hide();
                            $('.frame-demo .portrait').hide();
                            // if($scope.photo.orientation === "landscape") {
                            //     $('.frame-demo .landscape').show();
                            // } else {
                                $('.frame-demo .portrait').show();
                            // }
                        }

                        setTimeout(function() {
                            magnifyService.magnify(".frame-demo-holder .portrait", 1.7, photoService.event.portraitFrameImage, 50);
                        }, 300);
                    };

                    $scope.hideFrameDemo = function() {
                        $('.frame-demo').hide();
                    };

                    $scope.showVideoDemo = function(noTransition) {
                        $scope.hideCommDemo();
                        $scope.hideFrameDemo();
                        mobileScrollTop();

                        var $photoBox = $('.photo-box').first();
                        var $videoDemo = $photoBox.find('.video-demo');
                        if(!$videoDemo.length) {
                            return;
                        }
                        if(noTransition) {
                            $videoDemo.css({display:'block'});
                        } else {
                            $photoBox.find('.the-photo').animate({opacity:0}, 500);
                            $videoDemo.css({display:'block', opacity:0}).animate({opacity:1}, 500);
                        }
                        var video = $videoDemo.find('video')[0];
                        if (!video || !photoService.event.videoPreview) {
                            return;
                        }
                        video.src = photoService.event.videoPreview;
                        video.load();
                        var playPromise = video.play();
                        if (playPromise && typeof playPromise.catch === 'function') {
                            playPromise.catch(function() {});
                        }
                        $(".fancybox-prev").hide();
                        $(".fancybox-next").hide();
                    };

                    $scope.hideVideoDemo = function() {
                        $('.photo-box .video-demo').hide();
                        var video = $('.photo-box .video-demo video')[0];
                        if(video)   {
                            video.pause();
                            video.removeAttribute('src'); // empty source
                            video.load();

                            $(".fancybox-prev").show();
                            $(".fancybox-next").show();
                        }
                    };
                    
                    $scope.hideDemos = function() {
                        $scope.hideCommDemo();
                        $scope.hideFrameDemo();
                        $scope.hideVideoDemo();

                        $('.the-photo').css({opacity:1});
                        if($scope.photo) {
                            magnifyService.magnify(".the-photo", 1.7, $scope.photo.imageZoom);
                        }
                    }

                    $scope.showAddPhotoForm = function() {
                        showAddPhotoMessageEvent.broadcast($scope.photo);
                    };

                    $scope.onAllPurchase = function() {
                        getMyPhotosEvent.broadcast();
                        photoService.ownsCollection = true;
                        init();
                        closePhotoBoxEvent.broadcast();
                        window.scrollTo(0, 0);
                    };

                    $scope.onPackagePurchase = function() {
                        init();
                    };

                    $scope.showAddressForm = function(purchaseOption, onComplete) {
                        showAddressFormEvent.broadcast(purchaseOption, onComplete);
                    };

                    $scope.addToPackage = function() {
                        $addBtn.addClass('hide');
                        $addBtnLoading.removeClass('hide');

                        var data = {
                            itemId:$scope.photo._id,
                            eventId:$scope.event._id,
                            participantId:$scope.participantId,
                            type:$scope.packageOptions.type,
                        };

                        return purchaseService.addToPackage(data)
                            .then(function() {
                                showPackageAddedEvent.broadcast($scope.downloadUrl);
                                $scope.close();
                            },
                            function() {
                                $addBtn.removeClass('hide');
                                $addBtnLoading.addClass('hide');
                                alert("We could not add to package.  Please refresh the page and try again.");
                            });
                    };

                    $scope.showFreeMenu = function() {
                        photoService.showPrintMenu = false;
                        showFancyMenuEvent.broadcast($scope.photo);
                    };


                    refreshPaidMenuEvent.listen(function() {
                        init();
                    });

                    fancyboxHiddenEvent.listen(function() {
                        $scope.hideDemos();
                    });

                    showFancyMenuEvent.listen(function(photo, type) {
                        if(photoService.event.isPaid || photoService.showPrintMenu) {
                            $scope.showPrintMenu = photoService.showPrintMenu;
                            $scope.photo = photo;
                            $scope.event = photoService.event;
                            $scope.participantId = photoService.currentParticipant
                                ? photoService.currentParticipant._id
                                : null;
                            $scope.overlay1TimePath = photoService.event.overlay1TimePath;
                            $scope.currentBib = photoService.currentBib;
                            $scope.myPhotosTabVisible = photoService.selectedTab == "myPhotos";
                            $scope.showCommemorative = photoService.event.showCommemorative;
                            $scope.showFramePrint = photoService.event.showFramePrint;
                            $scope.packagePhotosPrice = photoService.event.packagePhotosPrice;
                            $scope.showMyPhotos = photoService.showMyPhotos;
                            updatePrices();
                            init(type);
                        }
                    });

                    couponAppliedEvent.listen(function(coupon) {
                        updatePrices();
                    });

                    currencyChangeEvent.listen(function(currencyCode) {
                        updatePrices();
                    });

                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 * Key codes inlined (37=Left, 39=Right, 27=Escape) to avoid duplicate declaration when JS is concatenated.
 */
// Time until arrow keys can show next photo
const NEXT_PHOTO_DELAY = 500;

angular.module('ra.core')
  .directive('photoBox', ['fancyboxShownEvent', 'showFancyMenuEvent', 'photoService', 'updatePhotosEvent', 'getMyPhotosEvent', '$timeout', 'showPrintMenuEvent', 'refreshPaidMenuEvent', 'fancyboxHiddenEvent', 'closePhotoBoxEvent', 'currencyService',
    function(fancyboxShownEvent, showFancyMenuEvent, photoService, updatePhotosEvent, getMyPhotosEvent, $timeout, showPrintMenuEvent, refreshPaidMenuEvent, fancyboxHiddenEvent, closePhotoBoxEvent, currencyService) {
      return {
        templateUrl: 'photoBox.html',
        restrict: 'E',
        scope: {
        },
        link: function($scope, $element) {

          // Reset
          const SWIPE_THRESHOLD = 50;
          const SWIPE_TIME = 200;
          var touchStartX = 0;
          var touchEndX = 0;
          var touchStartTime ;
          var touchEndTime;
          
          
          $scope.photo = {};
          $scope.showPaidMenu = true;
          $scope.isLoading = false;
          $scope.photos = [];
          $scope.currentPhotoIndex = 0;

          var prevScroll = 0;

          function hideEventVideoPreview() {
            var $videoDemo = $element.find('.video-demo');
            $videoDemo.hide();
            var video = $videoDemo.find('video')[0];
            if (video) {
              video.pause();
              video.removeAttribute('src');
              video.load();
            }
          }

          function playEventVideoPreview() {
            var previewUrl = photoService.event && photoService.event.videoPreview;
            var $videoDemo = $element.find('.video-demo');
            var video = $videoDemo.find('video')[0];
            if (!previewUrl) {
              return;
            }
            if (!video) {
              return;
            }
            $videoDemo.css({ display: 'block', opacity: 1 });
            video.src = previewUrl;
            video.load();
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function() {});
            }
          }
          
          function scrollToActiveDot() {
            $timeout(function () {
              const dotsContainer = $element.find('.carousel-dots')[0];

              if (dotsContainer) {
                const scrollLeft = 16 * $scope.currentPhotoIndex - 32;
                dotsContainer.scrollTo({
                  left: scrollLeft,
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
          
          $scope.removeKeyListener = function() {
            angular.element(window).off('keydown', handleKeyPress);
          }
          
          function setup(photo) {
            $scope.showPaidMenu = photoService.event.isPaid || photoService.showPrintMenu;
            $scope.removeKeyListener();
            $scope.removeTouchListener();
            $scope.photo = photo;
            
            // Initialize currency service with event's default currency (fallback AUD for older events)
            if (photoService.event) {
              currencyService.initialize(photoService.event.defaultCurrency || 'AUD');
            }
            
            // Initialize photos array and current index
            $scope.photos = (photoService.photoGroups || []).reduce(function(acc, group) {
              return acc.concat(group || []);
            }, []);
            $scope.currentPhotoIndex = $scope.photos.findIndex(function(x) {
              return photo && photo._id === x._id;
            });
            
            // Scroll to active dot after DOM update
            scrollToActiveDot();
            
            if(photo) {
              $scope.overlay1TimePath = photoService.event.overlay1TimePath;
              $scope.portraitFrameImage = photoService.event.portraitFrameImage;

              // $scope.landscapeFrameImage = photoService.event.landscapeFrameImage;
              $scope.gravity = photoService.event.overlay1Gravity;
              return preload($scope.photo.imagePreview);
            } else {
              return Promise.resolve();
            }

          }
          
          function animateSlide(className) {
            const element = $element.find('.popup-form>.inner');
            if($scope.showPaidMenu) {
              $element.find('.main-photo').css('min-height', element.height() + 'px');
            }
            $timeout(function() {
              element.addClass(className);
            }, 1);
            $timeout(function() {
              element.removeClass('slide-in');
              element.removeClass('slide-out');
              $('.main-photo').css('min-height', '');
            }, 250);
          }
          
          function preload(src) {
            $scope.isLoading = true;
            return new Promise(function(resolve, reject) {
              const img = new Image();
              img.src = src;
              img.onload = function() {
                $timeout(function() {
                  $scope.isLoading = false;
                }, NEXT_PHOTO_DELAY);
                resolve();
              }
            });
          }
          
          function navigateToPhoto(direction) {
            if($scope.isLoading) {
              return;
            }
            
            var photoIndex = $scope.currentPhotoIndex;
            if(direction === 'prev') {
              photoIndex = photoIndex === 0 ? $scope.photos.length - 1 : photoIndex - 1;
            } else if(direction === 'next') {
              photoIndex = photoIndex === $scope.photos.length - 1 ? 0 : photoIndex + 1;
            }
            
            $scope.currentPhotoIndex = photoIndex;
            
            // Ensure DOM update before scrolling
            $scope.$applyAsync(function() {
              scrollToActiveDot();
            });
            
            const slideDirection = direction === 'prev' ? 'slide-out' : 'slide-in';
            
            preload($scope.photos[photoIndex].imagePreview)
              .then(function() {
                showFancyMenuEvent.broadcast($scope.photos[photoIndex]);
                animateSlide(slideDirection);
              });
          }

          $scope.prevPhoto = function() {
            navigateToPhoto('prev');
          }

          $scope.nextPhoto = function() {
            navigateToPhoto('next');
          } 
          
          $scope.goToPhoto = function(index) {
            if($scope.isLoading || index === $scope.currentPhotoIndex || index < 0 || index >= $scope.photos.length) {
              return;
            }
            
            $scope.currentPhotoIndex = index;
            
            // Use $scope.$applyAsync to ensure DOM update before scrolling
            $scope.$applyAsync(function() {
              scrollToActiveDot();
            });
            
            preload($scope.photos[index].imagePreview)
              .then(function() {
                showFancyMenuEvent.broadcast($scope.photos[index]);
                animateSlide('slide-in');
              });
          };
          
          $scope.removeTouchListener = function() {
            window.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('touchend', onTouchEnd);
          }

          function onTouchStart(event) {
            touchStartTime =  Date.now();
            touchStartX = event.changedTouches[0].screenX;
          }

          function onTouchEnd(event) {
            touchEndX = event.changedTouches[0].screenX;
            touchEndTime =  Date.now();
            handleSwipeGesture();
          }

          function handleSwipeGesture() {
            if(Math.abs(touchEndX - touchStartX) < SWIPE_THRESHOLD ||
              touchEndTime - touchStartTime > SWIPE_TIME) {
              return;
            }
            if (touchEndX <= touchStartX) {
              $scope.nextPhoto();
            }

            if (touchEndX >= touchStartX) {
              $scope.prevPhoto();
            }
          }
          
          $scope.addTouchListener = function() {
            var photoEl = $element[0].querySelector('.the-photo');
            if (!photoEl) {
              return;
            }
            photoEl.addEventListener('touchstart', onTouchStart, { passive: false });
            photoEl.addEventListener('touchend', onTouchEnd, { passive: false });
          }

          $scope.show = function() {
            $scope.$broadcast("showPopup");
            $scope.addTouchListener();
            angular.element(window).on('keydown', handleKeyPress);

            prevScroll = $(window).scrollTop();
            if($(window).width() < Config.MOBILE_WIDTH) {
              $(window).scrollTop(0);
            }
          };

          $scope.hide = function() {
            $scope.$broadcast("hidePopup");
            $scope.onClosePress();
          };
          
          $scope.onClosePress = function() {
            hideEventVideoPreview();
            $scope.removeKeyListener();
            
            angular.element(window).off('keydown', handleKeyPress);
            if($(window).width() < Config.MOBILE_WIDTH) {
              $(window).scrollTop(prevScroll);
            }

            fancyboxHiddenEvent.broadcast();
          }

          const handleKeyPress = function(event) {
            if (event.keyCode === 37) { // Left arrow
              $scope.prevPhoto();
            }
            if (event.keyCode === 39) { // Right arrow
              $scope.nextPhoto();
            }
            if (event.keyCode === 27) { // Escape
              $scope.hide();
            }
          };

          function openVideoSampleMenu() {
            hideEventVideoPreview();
            $scope.type = 'video';
            $scope.showPaidMenu = photoService.event.isPaid || photoService.showPrintMenu;
            $scope.removeKeyListener();
            $scope.removeTouchListener();
            $scope.photo = null;
            $scope.photos = (photoService.photoGroups || []).reduce(function(acc, group) {
              return acc.concat(group || []);
            }, []);
            $scope.currentPhotoIndex = -1;
            if (photoService.event) {
              currencyService.initialize(photoService.event.defaultCurrency || 'AUD');
            }
            $scope.$evalAsync(function() {
              $scope.show();
              $timeout(playEventVideoPreview, 450);
            });
          }

          showFancyMenuEvent.listen(function(photo, type) {
            if (type === 'video') {
              openVideoSampleMenu();
              return;
            }
            hideEventVideoPreview();
            $scope.type = type;
            setup(photo)
              .then(function() {
                $scope.$evalAsync(function() {
                  $scope.show();
                });
              });
          });

          showPrintMenuEvent.listen(function(photo) {
            photoService.showPrintMenu = true;
            showFancyMenuEvent.broadcast(photo);
            refreshPaidMenuEvent.broadcast();
          });

          closePhotoBoxEvent.listen(function() {
            $scope.hide();
          });
        }
      };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('photoButton', ['fancyboxShownEvent', 'showFancyMenuEvent', 'photoService', '$sce', 'updatePhotosEvent', 'getMyPhotosEvent', 'showDownloadAllEvent', 'animatePhotoButtonEvent',
        function(fancyboxShownEvent, showFancyMenuEvent, photoService, $sce, updatePhotosEvent, getMyPhotosEvent, showDownloadAllEvent, animatePhotoButtonEvent) {
            return {
                templateUrl: 'photoButton.html',
                restrict: 'E',
                replace:true, 
                scope: {
                },
                link: function($scope, $element) {
                    $scope.photoGroups = [];
                    $scope.text = "";
                    $scope.visible = false;
                    $scope.photoService = photoService;
                    
                    
                    $scope.openMenu = function() {
                        if(photoService.ownsCollection) {
                            // Download zip
                            showDownloadAllEvent.broadcast();
                        } else {
                            if($scope.photoGroups.length && $scope.photoGroups[0].length) {
                                showFancyMenuEvent.broadcast($scope.photoGroups[0][0], 'photo');
                            }
                        }
                    }

                    getMyPhotosEvent.listen(function() {
                        $scope.visible = false;
                    });
                    
                    updatePhotosEvent.listen(function(photoGroups) {
                        $scope.visible = photoService.selectedTab === "myPhotos" &&
                          photoService.photoButton && photoGroups.length &&
                          photoGroups[0].length;
                        
                        $scope.photoGroups = photoGroups;
                        
                        if(photoService.ownsCollection) {
                            $scope.text = "Download All Photos";
                        } else {
                            $scope.text = "Buy All Photos";
                        }
                    });

                    animatePhotoButtonEvent.listen(function() {
                        console.log("reanimate");
                        $element.removeClass("animated");
                        setTimeout(function() {
                            $element.addClass("animated");
                        }, 50);
                    });
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
function removeUrlParameter(key) {
    if (history.replaceState && key) {
        // Use timeout to fix infdig error on free events
        setTimeout(function() {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.delete(key);
            var query = searchParams.toString();
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname +
                (query ? '?' + query : '');
            window.history.replaceState({path: newurl}, '', newurl);
        }, 500);
    }
}

function normalizeQueryValue(value) {
    if (value == null || value === '') {
        return '';
    }
    if (Array.isArray(value)) {
        value = value[0];
    }
    return String(value).trim().toLowerCase();
}

function wantsAllPhotosTab(query) {
    var tab = normalizeQueryValue(query.tab);
    if (tab === 'allphotos' || tab === 'all') {
        return true;
    }
    var allPhotos = normalizeQueryValue(query.allPhotos);
    return allPhotos === '1' || allPhotos === 'true';
}
angular.module('ra.core')
    .directive('photoTabs', ['photoService', 'updatePhotosEvent', 'getMyPhotosEvent', 'galleryTabChangeEvent', '$timeout', '$rootScope',
        function(photoService, updatePhotosEvent, getMyPhotosEvent, galleryTabChangeEvent, $timeout, $rootScope) {
            return {
                templateUrl: 'photoTabs.html',
                restrict: 'E',
                scope: {
                },
                link: function($scope, $element) {


                    $scope.selectedTab = null; 


                    $scope.selectTab = function(tab) {
                        photoService.selectedTab = tab;

                        if(tab != $scope.selectedTab) {
                            $scope.selectedTab = tab;

                            $(".photos .photo, .photos .photo-wrap").remove();
                            if($scope.selectedTab == "allPhotos") {
                                removeUrlParameter('bib');
                                $("fancy-gallery").hide();
                                $("#choose-bib").hide();
                                $("#choose-leg").fadeIn(400);

                                $scope.$broadcast('getAllPhotos', function() {
                                    $(".photos").addClass("no-margin");
                                    $("fancy-gallery").show();
                                });


                            } else {
                                //myPhotos tab
                                $(".photos").removeClass("no-margin");
                                $("#choose-leg").hide();
								$("#choose-bib").fadeIn(400);
                                $(".more.earlier, .more.later").hide();
                                $("fancy-gallery").show();

                                getMyPhotosEvent.broadcast();

                            }
                        }

                    };

                    galleryTabChangeEvent.listen(function(tab) {
                       $scope.selectTab(tab);
                    });

                    updatePhotosEvent.listen(function(photoGroups) {
                        $scope.currentBib = photoService.currentBib;
                    });

                    function initTabsFromPhotoService() {
                        $scope.showMyPhotos = photoService.showMyPhotos;
                        $scope.isPrivate = photoService.isPrivate;
                        $scope.isOrganiserOrAdmin = photoService.isOrganiserOrAdmin;
                        $scope.securedPreviewBackdrop = photoService.securedPreviewBackdrop;

                        if (photoService.securedPreviewBackdrop && photoService.photoGroups && photoService.photoGroups.length) {
                            photoService.selectedTab = 'allPhotos';
                            $scope.selectedTab = 'allPhotos';
                            removeUrlParameter('bib');
                            $("#choose-bib").hide();
                            $("#choose-leg").hide();
                            $timeout(function() {
                                $(".photos").addClass("no-margin");
                                $("fancy-gallery").show();
                                updatePhotosEvent.broadcast(photoService.photoGroups);
                            }, 0);
                            return;
                        }

                        var query = queryString();
                        if (wantsAllPhotosTab(query)) {
                            $scope.selectTab('allPhotos');
                            removeUrlParameter('tab');
                            removeUrlParameter('allPhotos');
                        } else {
                            $scope.selectTab('myPhotos');
                        }
                    }

                    // Wait until photosCtrl has applied routeParams and photoService.init().
                    var unbind = $scope.$watch(function() {
                        return $rootScope.routeParams && $rootScope.routeParams.eventId;
                    }, function(eventId) {
                        if (!eventId) {
                            return;
                        }
                        initTabsFromPhotoService();
                        unbind();
                    });


                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
angular.module('ra.core')
    .directive('purchaseComplete', ['showPurchaseCompleteEvent', '$sce', 'animatePhotoButtonEvent', 'showDownloadAllEvent',
        function(showPurchaseCompleteEvent, $sce, animatePhotoButtonEvent, showDownloadAllEvent) {
        return {
            templateUrl: 'purchaseComplete.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                $scope.buttonAfterBuy = '';
                
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };
                
                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };
                
                $scope.close = function() {
                    $scope.hide();
                    animatePhotoButtonEvent.broadcast();
                };

                $scope.downloadAllPhotos = function() {
                    $scope.hide();
                    showDownloadAllEvent.broadcast();
                };

                showPurchaseCompleteEvent.listen(function(message, url, buttonAfterBuy, promptDownloadAll) {
                    $scope.url = url;
                    $scope.message = $sce.trustAsHtml(message);
                    $scope.buttonAfterBuy = buttonAfterBuy ? buttonAfterBuy : 'Download';
                    $scope.promptDownloadAll = !!promptDownloadAll;
                    $scope.show();
                });
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('purchaseError', ['showPurchaseErrorEvent', '$sce',
        function(showPurchaseErrorEvent, $sce) {
        return {
            templateUrl: 'purchaseError.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };

                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };

                showPurchaseErrorEvent.listen(function(message) {
                    $scope.message = $sce.trustAsHtml(message);
                    $scope.show();
                    $scope.$apply();
                });
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Table row purchase option
 * Shows an item alongside its description, and a Stripe Checkout button.
 * If the item is already purchased, the button runs onView() instead
 */
angular.module('ra.core')
    .directive('purchaseOption', ['$timeout', 'purchaseService', 'userService', 'showPurchaseErrorEvent', 'showPurchaseCompleteEvent', '$sce', 'showPurchaseProcessingEvent', 'hidePurchaseProcessingEvent', 'couponService', 'showAuthEvent', 'refreshPaidMenuEvent', 'photoService', 'showFancyMenuEvent', 'showCheckoutEvent', 'currencyService',
        function($timeout, purchaseService, userService, showPurchaseErrorEvent, showPurchaseCompleteEvent, $sce, showPurchaseProcessingEvent, hidePurchaseProcessingEvent, couponService, showAuthEvent, refreshPaidMenuEvent, photoService, showFancyMenuEvent, showCheckoutEvent, currencyService) {
            return {
                templateUrl: 'purchaseOption.html',
                restrict: 'EA',
                replace:true,
                scope: {
                    name: '@',
                    description: '@',
                    tooltip: '@',
                    type: '@',
                    itemId: '@',
                    eventId: '@',
                    participantId: '@?',
                    price: '@',
                    originalPrice: '@',
                    beforePurchase: '&?',   //Function to run before payment, must have onComplete parameter ie. -> beforePurchase(purchaseOption, onComplete)
                    onPurchase: '&?',       //Function to run after payment
                    onDemo: '&?',           //Demonstration run when clicking (View)
                    onDemoHide: '&?',       //Hide the demo
                    purchaseMessage: '@?',  //Message to show in dialogue after purchase
                    downloadUrl: '@?',      //Optional url to download photo (otherwise dialogue shows a close button)
                    hasPurchased:'=?',      //Set to true if the user has purchased already - they will see a green download button
                    alwaysBuy:'=?',         //Always show buy button
                    bordered: '@?',         //Show a border around this item
                    buttonAfterBuy: '@?',   //Button text to show after buying
                    badge: '@?',             //Optional label shown above the description (e.g. "Most popular")
                    promptDownloadAll: '@?'  //Show Download All Photos CTA in purchase-complete popup
                },
                link: function($scope, $element) {
                    var IMAGE = "/img/raceatlas-stripe.png";
                    var SITE = "Raceatlas";
                    // var handler;

                    $scope.description = $sce.trustAsHtml($scope.description);
                    $scope.userData = userService.data;
                    $scope.buttonAfterBuy = $scope.buttonAfterBuy ? $scope.buttonAfterBuy : 'Download';
                    $scope.promptDownloadAll = $scope.promptDownloadAll === 'true' || $scope.promptDownloadAll === true;

                    var checkout = function() {
                        var couponCode = couponService.coupon ? couponService.coupon.code : null;
                        var selectedCurrency = currencyService.getSelectedCurrency();

                        var data = {
                            type:$scope.type,
                            eventId:$scope.eventId,
                            itemId: $scope.itemId,
                            couponCode: couponCode,
                            participantId: $scope.participantId,
                            currency: selectedCurrency
                        };

                        purchaseService.createIntent(data)
                            .then(function(result) {
                                if (result.isFree) {
                                    $scope.purchaseSuccess();
                                } else {
                                    showCheckoutEvent.broadcast(
                                        $scope.name,
                                        result.client_secret,
                                        $scope.userData.user.email,
                                        $scope.price,
                                        $scope.purchaseSuccess,
                                        $scope.purchaseFailure,
                                        result.amount,
                                        result.currency
                                    );
                                }
                            }, function(err) {
                                $scope.purchaseFailure(err && (err.message || err.detail || err));
                            });
                    };
                    
                    $scope.click = function() {
                        if($scope.showDownload()) {
                            window.open($scope.downloadUrl);
                        } else {
                            $scope.showCheckoutOrSignOn();
                        }
                    };

                    $scope.showDemo = function($event) {
                        $event.stopPropagation();
                        $scope.onDemo();
                        // Hide all other show buttons
                        $(".show-demo").show();
                        $(".hide-demo").hide();


                        $element.find('.show-demo').hide();
                        setTimeout(function() {
                            $element.find('.hide-demo').show();
                        }, 500);
                    };

                    $scope.hideDemo = function($event) {
                        $event.stopPropagation();
                        if($scope.onDemoHide) {
                            $scope.onDemoHide();
                        }
                        $element.find('.show-demo').show();
                        $element.find('.hide-demo').hide();
                    };

                    $scope.purchaseFailure = function(errorDetail) {
                        var errorMessage =
                            "Unfortunately, we were unable to process your payment.  You have not been charged.  " +
                            "Please try again, or contact our support team via the chat at the bottom right of the screen.<br/>";
                        if(errorDetail) {
                            errorMessage += "<br/>" + errorDetail;
                        }
                        showPurchaseErrorEvent.broadcast(errorMessage);
                    };

                    $scope.purchaseSuccess = function() {
                        $timeout(function() {
                            // Delay to avoid positioning problems
                            showPurchaseProcessingEvent.broadcast();
                        }, 100);

                        $timeout(function() {
                            hidePurchaseProcessingEvent.broadcast();
                            showPurchaseCompleteEvent.broadcast(
                                $scope.purchaseMessage,
                                $scope.downloadUrl,
                                $scope.buttonAfterBuy,
                                $scope.promptDownloadAll
                            );

                            $scope.hasPurchased = !$scope.alwaysBuy;
                            if($scope.onPurchase) {
                                return $scope.onPurchase();
                            }
                        }, 3000);


                    };

                    /**
                     * Performs the purchase.
                     * If the item has a beforePurchase, this must be completed first
                     * @returns {undefined}
                     */
                    $scope.showCheckoutOrSignOn = function() {
                        if($scope.userData.user) {
                            if($scope.beforePurchase) {
                                $scope.beforePurchase($scope, function() {
                                    return checkout();
                                });
                            } else {
                                return checkout();
                            }
                        } else {

                            var options = {
                                interestedIn: photoService.event.type,
                                instantSignup: true,
                                alertType: 'success'
                            };

                            showAuthEvent.broadcast('Please create an account or sign in <br/>to get your photos.', function() {
                                //Refresh this photo's menu, or the whole page if we're on a collection
                                // if(photoService.selectedTab == "myPhotos") {
                                //     window.location.reload();
                                // } else {
                                //     refreshPaidMenuEvent.broadcast();
                                // }
                                refreshPaidMenuEvent.broadcast();

                                // $scope.hasPurchased is updated by refreshPaidMenuEvent, but we need to wait for the network request to complete
                                // Perform a similar request to stall until this is complete
                                var bib = photoService.selectedTab === "myPhotos" ? photoService.currentBib : null;
                                return purchaseService.purchasedTypes({itemId: $scope.itemId, eventId: $scope.eventId, bibId: bib})
                                  .then(function(result) {
                                      if(!$scope.hasPurchased && !result.packagePhotosRemaining && (!result.types || !Object.keys(result.types).length)) {
                                          $scope.showCheckoutOrSignOn();
                                      }
                                  });
                                
                                
                            }, options);
                        }

                    };


                    // unwrap functions
                    if($scope.onPurchase) {
                        $scope.onPurchase = $scope.onPurchase();
                    }
                    if($scope.beforePurchase) {
                        $scope.beforePurchase = $scope.beforePurchase();
                    }
                    if($scope.onDemo) {
                        $scope.onDemo = $scope.onDemo();
                    }
                    if($scope.onDemoHide) {
                        $scope.onDemoHide = $scope.onDemoHide();
                    }

                    // Event on change photo
                    $scope.$watch('itemId', function() {
                        //Reset commem. demo
                        if($scope.onDemo) {
                            $element.find('.show-demo').show();
                            $element.find('.hide-demo').hide();
                        }
                    });

                    $scope.showDownload = function() {
                        var role = $scope.userData.user ? $scope.userData.user.role : "";
                        var managesThis = (role === "organiser") && $scope.userData.user && $scope.userData.user.manages.includes($scope.eventId);

                        var result = !$scope.alwaysBuy &&
                        ($scope.hasPurchased ||
                            role === "admin" ||
                            role === "employee" ||
                            managesThis);
                        return result;
                    };

                    showFancyMenuEvent.listen(function() {
                        $scope.hideDemo();
                    });

                    //Listen for when to re-configure the checkout
                    $scope.$on('initPurchaseOptions', function (event, data) {});
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('purchaseProcessing', ['showPurchaseProcessingEvent', 'hidePurchaseProcessingEvent',
        function(showPurchaseProcessingEvent, hidePurchaseProcessingEvent) {
        return {
            templateUrl: 'purchaseProcessing.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };
                
                $scope.hide = function() {
                    $scope.$broadcast("hidePopup");
                };

                showPurchaseProcessingEvent.listen(function() {
                    $scope.show();
                });

                hidePurchaseProcessingEvent.listen(function() {
                    $scope.hide();
                });
            }
        };
    }]);
/**
 * Created by jordan on 20/05/2016.
 */
/**
 * Menu for paid photos
 */
angular.module('ra.core')
    .directive('removePhoto', [
        'photoService',
        'userService',
        'showAuthEvent',
        'showFancyMenuEvent',
        function(
         photoService,
         userService,
         showAuthEvent,
         showFancyMenuEvent) {
            return {
                templateUrl: 'removePhoto.html',
                restrict: 'E',
                scope: {
                    data: '=',
                },
                link: function($scope, $element) {
                    $scope.userData = userService.data;
                    
                    $scope.removePhoto = function() {
                        var options = {
                            interestedIn: photoService.event.type,
                            instantSignup: true
                        };
                        if(confirm("Are you sure you wish to remove this photo from My Photos?  You may not be able to add it back again.")) {
                            if($scope.userData.user) {
                                return removePhotoAfterSignIn();
                            } else {
                                showAuthEvent.broadcast('Please sign up or log in to remove this photo.', function() {
                                    $('popup-window').each(function() {$(this).removeClass('hide')});
                                    return removePhotoAfterSignIn();
                                }, options);
                            }
                            
                            
                        }
                    };
                    
                    function removePhotoAfterSignIn() {
                        photoService.removeBib($scope.photo._id, photoService.event._id, photoService.currentBib)
                            .then(function() {
                                window.location.reload();
                            }, function(response) {
                                alert(response.detail);
                            });
                    }

                    showFancyMenuEvent.listen(function(photo) {
                        $scope.visible = photoService.currentParticipant.bib;
                        $scope.photo = photo;
                    });
                }
            };
        }]);

/**
 * Secured event popup: shown when showSecuredPopup is true (private event, no participant).
 * User enters email and requests a validation link.
 */
angular.module('ra.core')
    .directive('securedEventPopup', ['$timeout', 'ajaxService', '$rootScope', '$window',
        function($timeout, ajaxService, $rootScope, $window) {
        return {
            templateUrl: 'securedEventPopup.html',
            restrict: 'E',
            scope: { routeParams: '=' },
            link: function($scope, $element) {
                function resetPopupState() {
                    $scope.redirecting = false;
                    $scope.sending = false;
                    $scope.submitted = false;
                    $scope.email = '';
                    $scope.lastSentEmail = '';
                    $scope.state.message = null;
                }

                $scope.email = '';
                $scope.lastSentEmail = '';
                $scope.sending = false;
                $scope.submitted = false;
                $scope.redirecting = false;
                $scope.state = { message: null }; // message: 'sent' | 'notFound'

                $scope.onSecuredPopupClose = function() {
                    $timeout(function() {
                        $window.location.href = '/';
                    }, 50);
                    return false;
                };

                function requestVerifyLink(email) {
                    var eventKey = $scope.routeParams && $scope.routeParams.event && $scope.routeParams.event.key;
                    if (!eventKey || !email) {
                        return;
                    }
                    $scope.sending = true;
                    var url = '/api/participants/verify-and-send-link?eventKey=' + encodeURIComponent(eventKey) + '&email=' + encodeURIComponent(email);
                    ajaxService.request(url, {}, false)
                        .then(function(data) {
                            $scope.sending = false;
                            var payload = data && data.data !== undefined ? data.data : data;
                            if (payload && payload.sent) {
                                $scope.state.message = 'sent';
                                $scope.lastSentEmail = email;
                            } else {
                                $scope.state.message = 'notFound';
                            }
                            $timeout(function() {}, 0);
                        })
                        .catch(function(err) {
                            $scope.sending = false;
                            $scope.state.message = 'notFound';
                            $timeout(function() {}, 0);
                        });
                }

                $scope.sendValidationLink = function() {
                    $scope.submitted = true;
                    $scope.state.message = null;
                    // Form lives in transcluded popup-window scope; get form controller from DOM when not on scope
                    var formEl = $element[0].querySelector && $element[0].querySelector('form');
                    var formCtrl = formEl && angular.element(formEl).controller('form');
                    var form = $scope.securedForm || formCtrl;
                    if (!form || form.$invalid) {
                        return;
                    }
                    // Email input lives in transcluded scope; read value from DOM so we have it when submitting
                    var emailInput = formEl && formEl.querySelector('input[name="email"], input[type="email"]');
                    var email = (emailInput && emailInput.value && emailInput.value.trim()) || $scope.email || '';
                    if (!email) {
                        return;
                    }
                    requestVerifyLink(email);
                };

                $scope.resendAccessLink = function() {
                    if (!$scope.lastSentEmail || $scope.sending) {
                        return;
                    }
                    requestVerifyLink($scope.lastSentEmail);
                };

                $scope.$watch('routeParams.showSecuredPopup', function(show) {
                    if (show) {
                        resetPopupState();
                        $timeout(function() {
                            $scope.$broadcast('showPopup');
                        }, 100);
                    }
                });

                // Browser back can restore this page from bfcache with stale scope flags.
                // If the secured popup is meant to be shown, always restore first-load state.
                function onPageShow() {
                    if ($scope.routeParams && $scope.routeParams.showSecuredPopup) {
                        resetPopupState();
                        $timeout(function() {
                            $scope.$broadcast('showPopup');
                        }, 0);
                    }
                }

                angular.element($window).on('pageshow', onPageShow);
                $scope.$on('$destroy', function() {
                    angular.element($window).off('pageshow', onPageShow);
                });
            }
        };
    }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('selfie', ['userService', 'showSelfieEvent', 'faceService', 'photoService', 'getMyPhotosEvent',
        function(userService, showSelfieEvent, faceService, photoService, getMyPhotosEvent) {
            return {
                templateUrl: 'selfie.html',
                restrict: 'E',
                scope: {
                    
                },
                link: function($scope, $element) {
                    
                    $scope.STATE = {
                        start: "start",
                        webcam: "webcam",
                        webcamHelp: "webcamHelp",
                        confirm: "confirm",
                        upload: "upload",
                        loading: "loading",
                        preview: "preview",
                        complete: "complete"
                    }
                    $scope.HEADING = {
                        start: "Add a Selfie",
                        webcam: "Allow Camera Access",
                        webcamHelp: "Selfie Guidelines",
                        confirm: "Add a Selfie",
                        upload: "Add a Selfie",
                        loading: "Add a Selfie",
                        preview: "Add a Selfie",
                        complete: "Add a Selfie"
                    };
                    
                    $scope.formData = {};
                    $scope.state = $scope.STATE.start;
                    $scope.webcamStream = null;
                    $scope.selfieImage = null;
                    $scope.previewPhotos = [];
                    $scope.backState = $scope.STATE.start;
                    var self = this;
                    
                    // Mobile device detection
                    $scope.isMobile = function() {
                        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    };
                    
                    $scope.isIOS = function() {
                        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    };
                    

                    $scope.show = function() {
                        $scope.$broadcast("showPopup");
                    };

                    $scope.hide = function() {
                        $scope.$broadcast("hidePopup");
                    };

                    showSelfieEvent.listen(function(purchaseOption, onComplete) {
                        $scope.show();
                    });
                    
                    $scope.uploadPhoto = function() {
                        
                    }
                    
                    $scope.webcamHelp = function() {
                        $scope.state = $scope.STATE.webcamHelp;
                    }

                    /**
                     * Open the webcam and show the results in .selfie-holder
                     * On iOS, use native camera instead of live stream
                     */
                    $scope.startWebcam = function() {
                        if ($scope.isIOS()) {
                            // For iOS, trigger native camera
                            $scope.state = $scope.STATE.webcam;
                            setTimeout(function() {
                                $scope.$apply(function() {
                                    $scope.showMobileCamera = true;
                                });
                            }, 1);
                        } else {
                            // For desktop/other browsers, use live webcam stream
                            $scope.state = $scope.STATE.webcam;
                            
                            setTimeout(function() {
                                var video = $element.find('#video')[0];

                                navigator.mediaDevices.getUserMedia({video: true})
                                  .then(function(stream) {
                                      $scope.webcamStream = stream;
                                      video.srcObject = stream;
                                      video.play();
                                  })
                                  .catch(function(err) {
                                      console.error("Could not start webcam: " + err);
                                      alert("We couldn't access your webcam. Please check your browser settings and permissions, or try uploading a photo instead.");
                                  });

                            }, 1);
                        }
                    }
                    
                    $scope.preview = function() {
                        
                    }
                    
                    $scope.uploadPhoto = function() {
                        document.getElementById('fileInput').click();
                    }

                    $scope.fileChanged = function(input) {
                        if (input.files && input.files[0]) {
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                $scope.$apply(function() {
                                    $scope.selfieImage = e.target.result;
                                    $scope.state = $scope.STATE.confirm;
                                    $scope.backState = $scope.STATE.upload;
                                });
                            };
                            reader.readAsDataURL(input.files[0]);
                        }
                    };
                    
                    $scope.mobileCameraChanged = function(input) {
                        if (input.files && input.files[0]) {
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                $scope.$apply(function() {
                                    $scope.selfieImage = e.target.result;
                                    $scope.state = $scope.STATE.confirm;
                                    $scope.backState = $scope.STATE.webcam;
                                    $scope.showMobileCamera = false;
                                });
                            };
                            reader.readAsDataURL(input.files[0]);
                        }
                    };
                    
                    $scope.triggerMobileCamera = function() {
                        document.getElementById('mobileCameraInput').click();
                    };
                    
                    function stopWebcam() {
                        if ($scope.webcamStream) {
                            $scope.webcamStream.getTracks().forEach(function(track) {
                                track.stop();
                            });
                            $scope.webcamStream = null;
                            var video = $element.find('#video')[0];
                            video.srcObject = null;
                        }
                    }
                    
                    $scope.restart = function() {
                        $scope.state = $scope.STATE.start;
                        stopWebcam();
                    }
                    
                    $scope.back = function() {
                        if($scope.backState === $scope.STATE.webcam) {
                            if($scope.isIOS()) {
                                $scope.state = $scope.STATE.start;
                            } else {
                                $scope.startWebcam();
                            }
                        } else {
                            $scope.restart();
                        }
                    }
                    
                    $scope.allowAccess = function () {
                        if($scope.isIOS()) {
                            $scope.triggerMobileCamera();
                        } else {
                            $scope.startWebcam();
                        }
                    }
                    
                    $scope.webcamConfirm = function() {
                        if(!$scope.webcamStream) {
                            return;
                        }
                        
                        $scope.backState = $scope.STATE.webcam;
                        $scope.state = $scope.STATE.confirm;

                        var video = $element.find('#video')[0];

                        // Create a canvas with the same dimensions as the video
                        var canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;

                        // Draw video frame to canvas
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        
                        // Get base64 image string (PNG)
                        $scope.selfieImage = canvas.toDataURL('image/png'); // or 'image/jpeg'

                        $scope.showFlash = true;
                        setTimeout(function() {
                            $scope.$apply(function() { $scope.showFlash = false; });
                        }, 300); // Flash duration in ms
                        
                        stopWebcam();
                    }
                    
                    $scope.upload = function() {
                        $scope.state = $scope.STATE.loading;
                        if(!$scope.selfieImage) {
                            throw new Error("No image to upload");
                        }
                        faceService.matchFace(photoService.event._id, $scope.selfieImage)
                          .then(photos => {
                              console.log(photos);
                              $scope.previewPhotos = photos;
                              $scope.state = $scope.STATE.preview;
                          }, error => {
                              console.error(error);
                              alert("There was an error processing your selfie. Please try again or upload a different photo.");
                              $scope.state = $scope.STATE.start;
                          });
                    }
                    
                    $scope.saveToGallery = function() {
                        $scope.state = $scope.STATE.loading;
                        if(!$scope.selfieImage) {
                            throw new Error("No image to upload");
                        }

                        faceService.saveToGallery(photoService.event._id, $scope.selfieImage, photoService.currentBib)
                          .then(() => {
                              getMyPhotosEvent.broadcast();
                              $scope.state = $scope.STATE.complete;
                          }, error => {
                              console.error(error);
                              alert("There was an error adding photos to your gallery. Please try again or upload a different photo.");
                              $scope.state = $scope.STATE.preview;
                          });
                    }
                    
                    $scope.endAndClose = function() {
                        window.scrollTo(0, 0);
                        $scope.$broadcast("hidePopup");
                        
                    }
                }
            };
        }]);

/**
 * Created by jordan on 20/05/2016.
 */
/**
 * NOT IN USE
 */
angular.module('ra.core')
    .directive('signOnComplete', ['signOnCompleteEvent', 'userService',
        function(signOnCompleteEvent, userService) {
        return {
            templateUrl: 'signOnComplete.html',
            restrict: 'E',
            scope: {
            },
            link: function($scope) {
                var self = this;
                $scope.userData = userService.data;
                self.onClose = null;
                
                $scope.show = function() {
                    $scope.$broadcast("showPopup");
                };
                
                $scope.hide = function() {
                    if(self.onClose) {
                        self.onClose();
                    }
                    $scope.$broadcast("hidePopup");
                    
                };

                signOnCompleteEvent.listen(function(onClose) {
                    self.onClose = onClose;
                    $scope.show();
                });
            }
        };
    }]);